webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Autocomplete_vue__ = __webpack_require__(272);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30b159aa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Autocomplete_vue__ = __webpack_require__(570);
function injectStyle (ssrContext) {
  __webpack_require__(569)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Autocomplete_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30b159aa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Autocomplete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__ = __webpack_require__(265);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["l"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["m"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["n"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["o"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["p"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["q"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["r"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["s"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["t"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["u"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["v"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["w"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["x"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["y"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["z"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["A"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["B"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["C"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["D"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["E"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["F"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["G"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["H"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["I"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["J"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["K"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["L"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["M"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["N"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["O"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["P"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["Q"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["R"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "S", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["S"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "T", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["T"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "U", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["U"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "V", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["V"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "W", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["W"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "X", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["X"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["Y"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["Z"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["_0"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["_1"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["_2"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["_3"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["_4"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["_5"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["_6"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["_7"]; });
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_common_vue__["default"],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35836b06_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Spinner_vue__ = __webpack_require__(572);
function injectStyle (ssrContext) {
  __webpack_require__(571)
}
var normalizeComponent = __webpack_require__(2)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35836b06_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Spinner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__ = __webpack_require__(102);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39197026_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__ = __webpack_require__(472);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39197026_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_input__ = __webpack_require__(382);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__form_input__["a" /* default */]);

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_file__ = __webpack_require__(389);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__form_file__["a" /* default */]);

/***/ }),
/* 75 */,
/* 76 */,
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modal__ = __webpack_require__(406);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__modal__["a" /* default */]);

/***/ }),
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__progress__ = __webpack_require__(428);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__progress__["a" /* default */]);

/***/ }),
/* 83 */,
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__table__ = __webpack_require__(433);



/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__table__["a" /* default */]);

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(464);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  coputed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapState */])({
    userStore: function userStore(state) {
      return state.userStore;
    }
  }))

});

/***/ }),
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nav__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components___ = __webpack_require__(98);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'full',
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_1__components___["e" /* Header */],
    Sidebar: __WEBPACK_IMPORTED_MODULE_1__components___["f" /* Sidebar */],
    AppAside: __WEBPACK_IMPORTED_MODULE_1__components___["a" /* Aside */],
    AppFooter: __WEBPACK_IMPORTED_MODULE_1__components___["d" /* Footer */],
    Breadcrumb: __WEBPACK_IMPORTED_MODULE_1__components___["b" /* Breadcrumb */]
  },
  data: function data() {
    return {
      nav: __WEBPACK_IMPORTED_MODULE_0__nav__["a" /* default */].items
    };
  },

  computed: {
    name: function name() {
      return this.$route.name;
    },
    list: function list() {
      return this.$route.matched;
    }
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Aside_vue__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Breadcrumb_vue__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Callout_vue__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Footer_vue__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Header_Header_vue__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Sidebar_Sidebar_vue__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch_vue__ = __webpack_require__(48);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Aside_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Breadcrumb_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__Callout_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__Footer_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__Header_Header_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__Sidebar_Sidebar_vue__["a"]; });
/* unused harmony reexport Switch */










/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Callout__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Switch__ = __webpack_require__(48);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-aside',
  components: {
    Callout: __WEBPACK_IMPORTED_MODULE_0__Callout__["a" /* default */],
    cSwitch: __WEBPACK_IMPORTED_MODULE_1__Switch__["a" /* default */]
  }
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__ = __webpack_require__(101);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46ade4be_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__ = __webpack_require__(471);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46ade4be_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    variant: {
      type: String
    }
  },
  computed: {
    classList: function classList() {
      return ['callout', this.calloutVariant];
    },
    calloutVariant: function calloutVariant() {
      return this.variant ? 'callout-' + this.variant : '';
    }
  }
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    value: {
      default: true
    },
    uncheckedValue: {
      default: false
    },
    checked: {
      default: false
    },
    type: {
      type: String,
      default: 'default'
    },
    variant: {
      type: String,
      default: ''
    },
    pill: {
      type: Boolean,
      default: false
    },
    on: {
      type: String,
      default: null
    },
    off: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: null
    }
  },
  computed: {
    classList: function classList() {
      return ['switch', this.switchType, this.switchVariant, this.switchPill, this.switchSize];
    },
    switchType: function switchType() {
      return this.type ? 'switch-' + this.type : 'switch-default';
    },
    switchVariant: function switchVariant() {
      return this.variant ? 'switch-' + this.variant : 'switch-secondary';
    },
    switchPill: function switchPill() {
      return !this.pill ? null : 'switch-pill';
    },
    switchSize: function switchSize() {
      return this.size ? 'switch-' + this.size : '';
    },
    isChecked: function isChecked() {
      return this.checked === this.value;
    },
    isOn: function isOn() {
      return !this.on ? null : true;
    }
  },
  methods: {
    handleChange: function handleChange(_ref) {
      var checked = _ref.target.checked;

      this.$emit('change', checked ? this.value : this.uncheckedValue);
    }
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    list: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    isLast: function isLast(index) {
      return index === this.list.length - 1;
    },
    showName: function showName(item) {
      if (item.meta && item.meta.label) {
        item = item.meta && item.meta.label;
      }
      if (item.name) {
        item = item.name;
      }
      return item;
    }
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-footer'
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HeaderDropdown_vue__ = __webpack_require__(479);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'c-header',
  components: {
    HeaderDropdown: __WEBPACK_IMPORTED_MODULE_0__HeaderDropdown_vue__["a" /* default */]
  },
  methods: {
    sidebarToggle: function sidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-hidden');
    },
    sidebarMinimize: function sidebarMinimize(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-minimized');
    },
    mobileSidebarToggle: function mobileSidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-mobile-show');
    },
    asideToggle: function asideToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('aside-menu-hidden');
    }
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'header-dropdown',
  data: function data() {
    return { itemsCount: 0 };
  },

  methods: {
    logout: function logout() {
      localStorage.clear();
      this.$router.push("/login");
    }
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarFooter__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarForm__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SidebarHeader__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SidebarMinimizer__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SidebarNavDivider__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SidebarNavDropdown__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SidebarNavLink__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SidebarNavTitle__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SidebarNavItem__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SidebarNavLabel__ = __webpack_require__(518);












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar',
  props: {
    navItems: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  components: {
    SidebarFooter: __WEBPACK_IMPORTED_MODULE_0__SidebarFooter__["a" /* default */],
    SidebarForm: __WEBPACK_IMPORTED_MODULE_1__SidebarForm__["a" /* default */],
    SidebarHeader: __WEBPACK_IMPORTED_MODULE_2__SidebarHeader__["a" /* default */],
    SidebarMinimizer: __WEBPACK_IMPORTED_MODULE_3__SidebarMinimizer__["a" /* default */],
    SidebarNavDivider: __WEBPACK_IMPORTED_MODULE_4__SidebarNavDivider__["a" /* default */],
    SidebarNavDropdown: __WEBPACK_IMPORTED_MODULE_5__SidebarNavDropdown__["a" /* default */],
    SidebarNavLink: __WEBPACK_IMPORTED_MODULE_6__SidebarNavLink__["a" /* default */],
    SidebarNavTitle: __WEBPACK_IMPORTED_MODULE_7__SidebarNavTitle__["a" /* default */],
    SidebarNavItem: __WEBPACK_IMPORTED_MODULE_8__SidebarNavItem__["a" /* default */],
    SidebarNavLabel: __WEBPACK_IMPORTED_MODULE_9__SidebarNavLabel__["a" /* default */]
  },
  methods: {
    handleClick: function handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle('open');
    }
  }
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-footer'
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-form'
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-header'
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-minimizer',
  methods: {
    sidebarMinimize: function sidebarMinimize() {
      document.body.classList.toggle('sidebar-minimized');
    },
    brandMinimize: function brandMinimize() {
      document.body.classList.toggle('brand-minimized');
    }
  }
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-divider',
  props: {
    classes: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList: function classList() {
      return ['divider'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : '';
    }
  }
});

/***/ }),
/* 113 */,
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleClick: function handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle('open');
    }
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLink_vue__ = __webpack_require__(116);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67792580_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLink_vue__ = __webpack_require__(514);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLink_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67792580_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLink_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-link',
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    badge: {
      type: Object,
      default: function _default() {}
    },
    variant: {
      type: String,
      default: ''
    },
    classes: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-link', this.linkVariant].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    linkVariant: function linkVariant() {
      return this.variant ? 'nav-link-' + this.variant : '';
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : [];
    },
    isExternalLink: function isExternalLink() {
      if (this.url.substring(0, 4) === 'http') {
        return true;
      } else {
        return false;
      }
    }
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String,
      default: ''
    },
    classes: {
      type: String,
      default: ''
    },
    wrapper: {
      type: Object,
      default: function _default() {}
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-title'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : '';
    }
  }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavItem_vue__ = __webpack_require__(119);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ed4d885_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavItem_vue__ = __webpack_require__(517);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ed4d885_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-item',
  props: {
    classes: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-item'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : '';
    }
  },
  methods: {
    hideMobile: function hideMobile() {
      if (document.body.classList.contains('sidebar-mobile-show')) {
        document.body.classList.toggle('sidebar-mobile-show');
      }
    }
  }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarNavItem__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SidebarNavLink__ = __webpack_require__(115);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-label',
  components: {
    SidebarNavItem: __WEBPACK_IMPORTED_MODULE_1__SidebarNavItem__["a" /* default */],
    SidebarNavLink: __WEBPACK_IMPORTED_MODULE_2__SidebarNavLink__["a" /* default */]
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: '#'
    },
    icon: {
      type: String,
      default: 'fa fa-circle'
    },
    classes: {
      type: String,
      default: ''
    },
    label: {
      type: Object,
      required: true,
      default: function _default() {}
    }
  },
  computed: {
    classList: function classList() {
      var classes = {
        navItem: ['hidden-cn'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.getClasses(this.classes))).join(' '),
        navLink: 'nav-label',
        icon: [this.icon ? this.icon : 'fa fa-circle', this.label.variant ? 'text-' + this.label.variant : '', this.label.class ? this.label.class : ''].join(' ')
      };
      return classes;
    }
  },
  methods: {
    getClasses: function getClasses(classes) {
      return classes ? classes.split(' ') : [];
    }
  }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dashboard_CardLine1ChartExample__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dashboard_CardLine2ChartExample__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dashboard_CardLine3ChartExample__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dashboard_CardBarChartExample__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dashboard_MainChartExample__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dashboard_SocialBoxChartExample__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dashboard_CalloutChartExample__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components___ = __webpack_require__(98);











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dashboard',
  components: {
    Callout: __WEBPACK_IMPORTED_MODULE_7__components___["c" /* Callout */],
    CardLine1ChartExample: __WEBPACK_IMPORTED_MODULE_0__dashboard_CardLine1ChartExample__["a" /* default */],
    CardLine2ChartExample: __WEBPACK_IMPORTED_MODULE_1__dashboard_CardLine2ChartExample__["a" /* default */],
    CardLine3ChartExample: __WEBPACK_IMPORTED_MODULE_2__dashboard_CardLine3ChartExample__["a" /* default */],
    CardBarChartExample: __WEBPACK_IMPORTED_MODULE_3__dashboard_CardBarChartExample__["a" /* default */],
    MainChartExample: __WEBPACK_IMPORTED_MODULE_4__dashboard_MainChartExample__["a" /* default */],
    SocialBoxChartExample: __WEBPACK_IMPORTED_MODULE_5__dashboard_SocialBoxChartExample__["a" /* default */],
    CalloutChartExample: __WEBPACK_IMPORTED_MODULE_6__dashboard_CalloutChartExample__["a" /* default */]
  },
  data: function data() {
    return {
      selected: 'Month',
      tableItems: [{
        avatar: { url: 'static/img/avatars/1.jpg', status: 'success' },
        user: { name: 'Yiorgos Avraamu', new: true, registered: 'Jan 1, 2015' },
        country: { name: 'USA', flag: 'us' },
        usage: { value: 50, period: 'Jun 11, 2015 - Jul 10, 2015' },
        payment: { name: 'Mastercard', icon: 'fa fa-cc-mastercard' },
        activity: '10 sec ago'
      }, {
        avatar: { url: 'static/img/avatars/2.jpg', status: 'danger' },
        user: { name: 'Avram Tarasios', new: false, registered: 'Jan 1, 2015' },
        country: { name: 'Brazil', flag: 'br' },
        usage: { value: 22, period: 'Jun 11, 2015 - Jul 10, 2015' },
        payment: { name: 'Visa', icon: 'fa fa-cc-visa' },
        activity: '5 minutes ago'
      }, {
        avatar: { url: 'static/img/avatars/4.jpg', status: '' },
        user: { name: 'Enéas Kwadwo', new: true, registered: 'Jan 1, 2015' },
        country: { name: 'France', flag: 'fr' },
        usage: { value: 98, period: 'Jun 11, 2015 - Jul 10, 2015' },
        payment: { name: 'PayPal', icon: 'fa fa-paypal' },
        activity: 'Last month'
      }, {
        avatar: { url: 'static/img/avatars/5.jpg', status: 'success' },
        user: { name: 'Agapetus Tadeáš', new: true, registered: 'Jan 1, 2015' },
        country: { name: 'Spain', flag: 'es' },
        usage: { value: 22, period: 'Jun 11, 2015 - Jul 10, 2015' },
        payment: { name: 'Google Wallet', icon: 'fa fa-google-wallet' },
        activity: 'Last week'
      }, {
        avatar: { url: 'static/img/avatars/6.jpg', status: 'danger' },
        user: { name: 'Friderik Dávid', new: true, registered: 'Jan 1, 2015' },
        country: { name: 'Poland', flag: 'pl' },
        usage: { value: 43, period: 'Jun 11, 2015 - Jul 10, 2015' },
        payment: { name: 'Amex', icon: 'fa fa-cc-amex' },
        activity: 'Last week'
      }],
      tableFields: {
        avatar: {
          label: '<i class="icon-people"></i>',
          class: 'text-center'
        },
        user: {
          label: 'User'
        },
        country: {
          label: 'Country',
          class: 'text-center'
        },
        usage: {
          label: 'Usage'
        },
        payment: {
          label: 'Payment method',
          class: 'text-center'
        },
        activity: {
          label: 'Activity'
        }
      }
    };
  },
  methods: {
    variant: function variant(value) {
      var $variant = void 0;
      if (value <= 25) {
        $variant = 'info';
      } else if (value > 25 && value <= 50) {
        $variant = 'success';
      } else if (value > 50 && value <= 75) {
        $variant = 'warning';
      } else if (value > 75 && value <= 100) {
        $variant = 'danger';
      }
      return $variant;
    },
    flag: function flag(value) {
      return 'flag-icon flag-icon-' + value;
    }
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(20);



var brandPrimary = '#20a8d8';
var datasets = [{
  label: 'My First dataset',
  backgroundColor: brandPrimary,
  borderColor: 'rgba(255,255,255,.55)',
  data: [65, 59, 84, 84, 51, 55, 40]
}];

/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* Line */],
  props: ['height'],
  mounted: function mounted() {
    this.renderChart({
      labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
      datasets: datasets
    }, {
      maintainAspectRatio: false,
      legend: {
        display: false
      },
      scales: {
        xAxes: [{
          gridLines: {
            color: 'transparent',
            zeroLineColor: 'transparent'
          },
          ticks: {
            fontSize: 2,
            fontColor: 'transparent'
          }
        }],
        yAxes: [{
          display: false,
          ticks: {
            display: false,
            min: Math.min.apply(Math, datasets[0].data) - 5,
            max: Math.max.apply(Math, datasets[0].data) + 5
          }
        }]
      },
      elements: {
        line: {
          borderWidth: 1
        },
        point: {
          radius: 4,
          hitRadius: 10,
          hoverRadius: 4
        }
      }
    });
  }
});

/***/ }),
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(20);



var brandInfo = '#63c2de';
var datasets = [{
  label: 'My First dataset',
  backgroundColor: brandInfo,
  borderColor: 'rgba(255,255,255,.55)',
  data: [1, 18, 9, 17, 34, 22, 11]
}];

/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* Line */],
  props: ['height'],
  mounted: function mounted() {
    this.renderChart({
      labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
      datasets: datasets
    }, {
      maintainAspectRatio: false,
      legend: {
        display: false
      },
      scales: {
        xAxes: [{
          gridLines: {
            color: 'transparent',
            zeroLineColor: 'transparent'
          },
          ticks: {
            fontSize: 2,
            fontColor: 'transparent'
          }

        }],
        yAxes: [{
          display: false,
          ticks: {
            display: false,
            min: Math.min.apply(Math, datasets[0].data) - 5,
            max: Math.max.apply(Math, datasets[0].data) + 5
          }
        }]
      },
      elements: {
        line: {
          tension: 0.00001,
          borderWidth: 1
        },
        point: {
          radius: 4,
          hitRadius: 10,
          hoverRadius: 4
        }
      }
    });
  }
});

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(20);



var datasets = [{
  label: 'My First dataset',
  backgroundColor: 'rgba(255,255,255,.2)',
  borderColor: 'rgba(255,255,255,.55)',
  data: [78, 81, 80, 45, 34, 12, 40]
}];

/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* Line */],
  props: ['height'],
  mounted: function mounted() {
    this.renderChart({
      labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
      datasets: datasets
    }, {
      maintainAspectRatio: false,
      legend: {
        display: false
      },
      scales: {
        xAxes: [{
          display: false
        }],
        yAxes: [{
          display: false
        }]
      },
      elements: {
        line: {
          borderWidth: 2
        },
        point: {
          radius: 0,
          hitRadius: 10,
          hoverRadius: 4
        }
      }
    });
  }
});

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(20);



var datasets = [{
  label: 'My First dataset',
  backgroundColor: 'rgba(255,255,255,.3)',
  borderColor: 'transparent',
  data: [78, 81, 80, 45, 34, 12, 40, 75, 34, 89, 32, 68, 54, 72, 18, 98]
}];

/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["a" /* Bar */],
  props: ['height'],
  mounted: function mounted() {
    this.renderChart({
      labels: ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
      datasets: datasets
    }, {
      maintainAspectRatio: false,
      legend: {
        display: false
      },
      scales: {
        xAxes: [{
          display: false,
          categoryPercentage: 1,
          barPercentage: 0.5
        }],
        yAxes: [{
          display: false
        }]
      }
    });
  }
});

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(20);



var brandSuccess = '#4dbd74';
var brandInfo = '#63c2de';
var brandDanger = '#f86c6b';

function convertHex(hex, opacity) {
  hex = hex.replace('#', '');
  var r = parseInt(hex.substring(0, 2), 16);
  var g = parseInt(hex.substring(2, 4), 16);
  var b = parseInt(hex.substring(4, 6), 16);

  var result = 'rgba(' + r + ',' + g + ',' + b + ',' + opacity / 100 + ')';
  return result;
}

function random(min, max) {
  return Math.floor(Math.random() * (max - min + 1) + min);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* Line */],
  props: ['height'],
  mounted: function mounted() {
    var elements = 27;
    var data1 = [];
    var data2 = [];
    var data3 = [];

    for (var i = 0; i <= elements; i++) {
      data1.push(random(50, 200));
      data2.push(random(80, 100));
      data3.push(65);
    }
    this.renderChart({
      labels: ['M', 'T', 'W', 'T', 'F', 'S', 'S', 'M', 'T', 'W', 'T', 'F', 'S', 'S', 'M', 'T', 'W', 'T', 'F', 'S', 'S', 'M', 'T', 'W', 'T', 'F', 'S', 'S'],
      datasets: [{
        label: 'My First dataset',
        backgroundColor: convertHex(brandInfo, 10),
        borderColor: brandInfo,
        pointHoverBackgroundColor: '#fff',
        borderWidth: 2,
        data: data1
      }, {
        label: 'My Second dataset',
        backgroundColor: 'transparent',
        borderColor: brandSuccess,
        pointHoverBackgroundColor: '#fff',
        borderWidth: 2,
        data: data2
      }, {
        label: 'My Third dataset',
        backgroundColor: 'transparent',
        borderColor: brandDanger,
        pointHoverBackgroundColor: '#fff',
        borderWidth: 1,
        borderDash: [8, 5],
        data: data3
      }]
    }, {
      maintainAspectRatio: false,
      legend: {
        display: false
      },
      scales: {
        xAxes: [{
          gridLines: {
            drawOnChartArea: false
          }
        }],
        yAxes: [{
          ticks: {
            beginAtZero: true,
            maxTicksLimit: 5,
            stepSize: Math.ceil(250 / 5),
            max: 250
          },
          gridLines: {
            display: true
          }
        }]
      },
      elements: {
        point: {
          radius: 0,
          hitRadius: 10,
          hoverRadius: 4,
          hoverBorderWidth: 3
        }
      }
    });
  }
});

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(20);



/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* Line */],
  props: ['data', 'height'],
  mounted: function mounted() {
    this.renderChart({
      labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
      datasets: [{
        backgroundColor: 'rgba(255,255,255,.1)',
        borderColor: 'rgba(255,255,255,.55)',
        pointHoverBackgroundColor: '#fff',
        borderWidth: 2,
        data: this.data
      }]
    }, {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false
      },
      scales: {
        xAxes: [{
          display: false
        }],
        yAxes: [{
          display: false
        }]
      },
      elements: {
        point: {
          radius: 0,
          hitRadius: 10,
          hoverRadius: 4,
          hoverBorderWidth: 3
        }
      }
    });
  }
});

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(20);



/* harmony default export */ __webpack_exports__["a"] = ({
  extends: __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["b" /* Line */],
  props: ['data', 'height', 'width', 'variant'],
  mounted: function mounted() {
    this.renderChart({
      labels: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      datasets: [{
        backgroundColor: 'transparent',
        borderColor: this.variant ? this.variant : '#c2cfd6',
        data: this.data
      }]
    }, {
      responsive: true,
      maintainAspectRatio: true,
      scales: {
        xAxes: [{
          display: false
        }],
        yAxes: [{
          display: false
        }]
      },
      elements: {
        line: {
          borderWidth: 2
        },
        point: {
          radius: 0,
          hitRadius: 10,
          hoverRadius: 4,
          hoverBorderWidth: 3
        }
      },
      legend: {
        display: false
      }
    });
  }
});

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__functions_common_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Login',
  data: function data() {
    return {
      credentials: {
        username: '',
        password: ''
      },
      loggingIn: false,
      error: '',
      rememberMe: false
    };
  },

  mounted: function mounted() {
    var email = document.cookie.match('(^|;)\\s*' + 'email' + '\\s*=\\s*([^;]+)');
    var password = document.cookie.match('(^|;)\\s*' + 'password' + '\\s*=\\s*([^;]+)');

    this.credentials.username = email ? email.pop() : '';
    this.credentials.password = password ? password.pop() : '';
  },
  methods: {
    logMeIn: function logMeIn() {
      var _this = this;

      var email = this.credentials.username.trim();
      var password = this.credentials.password.trim();

      localStorage.clear();
      if (this.rememberMe) {
        var d = new Date();
        d.setTime(d.getTime() + 180 * 24 * 60 * 60 * 1000);
        console.log(d);
        document.cookie = 'email=' + email + ';expires=' + d.toUTCString() + ':path=/';
        document.cookie = 'password=' + password + ';expires=' + d.toUTCString() + ':path=/';
      } else {
        document.cookie = 'email=; expires= Thu, 01 Jan 1970 00:00:00: UTC; path=/;';
        document.cookie = 'password=; expires= Thu, 01 Jan 1970 00:00:00: UTC; path=/;';
      }

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_0__functions_common_vue__["r" /* apiLogin */], {
        userId: email,
        password: password
      }).then(function (res) {
        if (res.data.data.access_token) {
          localStorage.access_token = res.data.data.access_token;
          localStorage.auth_acl = res.data.data.acl;
          location.reload();
          _this.$router.push('/dashboard');
        } else {
          _this.$router.push('/login');
        }
      }).catch(function (error) {
        return alert(error);
      });
    }
  }
});

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export apiBaseUrl */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return apiLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return apiAcl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return apiSupplierLookup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return apiPoSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return apiWarehouseLookup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return apiProductLookup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return apiPOSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return apiPoGet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return apiPOApprove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return apiPOLookup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return apiGRNSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return apiGROSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return apiLocationProductUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return apiGroSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return apiGroGet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return apiCountryLookup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return apiStockcard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return apiWtoSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return apiWtoSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return apiWtoGet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return apiWtoLookup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return apiWtoManualClose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return apiWtrSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return apiWtrSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return apiPodSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return apiSanSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return apiSanSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return apiSrfSearch; });
/* unused harmony export apiSrfGet */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return apiSrfLookup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return apiSrfSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return apiSrfClose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return apiSrfApprove; });
/* unused harmony export apiSrrSearch */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return apiSrrSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return apiEmployeeLookup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return apiPOManualClose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return apiSbrSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return apiWscSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return apiWscSave; });
/* unused harmony export apiSanClose */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return apiSanApprove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return apiSanGet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return apiWsiSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return apiGeneratePickingList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return apiMemberLookup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return apiPicklistGet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return apiGenerateDO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return apiPodUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return apiWscLookUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return apiGriSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return apiGriGet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return apiGriSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return apiBackOrdersSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return apiDeliveredOrdersSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return apiOutstandingOrdersSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return apiCourierLists; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return apiPoGrnTrackingReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return apiSrfDoListingReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return apiSrUsageListingReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return apiGriDetailsSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return apiReasonLookup; });
/* unused harmony export authUser */
/* unused harmony export authACL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return authHeader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);



var apiBaseUrl = 'https://nibsinventoryapi.elken.com/' || '';
var apiLogin = apiBaseUrl + 'user/login';
var apiAcl = apiBaseUrl + 'user/acl';
var apiSupplierLookup = apiBaseUrl + 'supplier/lookup';
var apiPoSearch = apiBaseUrl + 'po/search';
var apiWarehouseLookup = apiBaseUrl + 'warehouse/lookup';
var apiProductLookup = apiBaseUrl + 'product/lookup';
var apiPOSave = apiBaseUrl + 'po/save';
var apiPoGet = apiBaseUrl + 'po/get';
var apiPOApprove = apiBaseUrl + 'po/approve';
var apiPOLookup = apiBaseUrl + 'po/lookup';
var apiGRNSave = apiBaseUrl + 'grn/save';
var apiGROSave = apiBaseUrl + 'gro/save';
var apiLocationProductUrl = apiBaseUrl + 'product/location/lookup';
var apiGroSearch = apiBaseUrl + 'gro/search';
var apiGroGet = apiBaseUrl + 'gro/get';
var apiCountryLookup = apiBaseUrl + 'country/lookup';
var apiStockcard = apiBaseUrl + 'inventory/stockcards';
var apiWtoSave = apiBaseUrl + 'wto/save';
var apiWtoSearch = apiBaseUrl + 'wto/search';
var apiWtoGet = apiBaseUrl + 'wto/get';
var apiWtoLookup = apiBaseUrl + 'wto/lookup';
var apiWtoManualClose = apiBaseUrl + 'wto/manualclose';
var apiWtrSearch = apiBaseUrl + 'wtr/search';
var apiWtrSave = apiBaseUrl + 'wtr/save';
var apiPodSearch = apiBaseUrl + 'pod/search';
var apiSanSave = apiBaseUrl + 'san/save';
var apiSanSearch = apiBaseUrl + 'san/search';
var apiSrfSearch = apiBaseUrl + 'srf/search';
var apiSrfGet = apiBaseUrl + 'srf/get';
var apiSrfLookup = apiBaseUrl + 'srf/lookup';
var apiSrfSave = apiBaseUrl + 'srf/save';
var apiSrfClose = apiBaseUrl + 'srf/close';
var apiSrfApprove = apiBaseUrl + 'srf/approve';
var apiSrrSearch = apiBaseUrl + 'srr/search';
var apiSrrSave = apiBaseUrl + 'srr/save';
var apiEmployeeLookup = apiBaseUrl + 'employee/lookup';
var apiPOManualClose = apiBaseUrl + 'po/manualclose';
var apiSbrSearch = apiBaseUrl + 'sbr/search';
var apiWscSearch = apiBaseUrl + 'wsc/search';
var apiWscSave = apiBaseUrl + 'wsc/save';
var apiSanClose = apiBaseUrl + 'san/close';
var apiSanApprove = apiBaseUrl + 'san/approve';
var apiSanGet = apiBaseUrl + 'san/get';
var apiWsiSearch = apiBaseUrl + 'wsi/search';
var apiGeneratePickingList = apiBaseUrl + 'wsi/picklist/generate';
var apiMemberLookup = apiBaseUrl + 'member/lookup';
var apiPicklistGet = apiBaseUrl + 'wsi/picklist/get';
var apiGenerateDO = apiBaseUrl + 'wsi/packlist/generatedo';
var apiPodUpdate = apiBaseUrl + 'pod/update';
var apiWscLookUp = apiBaseUrl + 'wsc/lookup';
var apiGriSearch = apiBaseUrl + 'gri/search';
var apiGriGet = apiBaseUrl + 'gri/get';
var apiGriSave = apiBaseUrl + 'gri/save';
var apiBackOrdersSearch = apiBaseUrl + 'report/backorder';
var apiDeliveredOrdersSearch = apiBaseUrl + 'report/deliveredproducts';
var apiOutstandingOrdersSearch = apiBaseUrl + 'report/outstandingorders';
var apiCourierLists = apiBaseUrl + 'courier/retrieve';
var apiPoGrnTrackingReport = apiBaseUrl + 'report/po_grn_tracking';
var apiSrfDoListingReport = apiBaseUrl + 'report/srf_do_listing';
var apiSrUsageListingReport = apiBaseUrl + 'report/sr_usage_listing';
var apiGriDetailsSearch = apiBaseUrl + 'gri/details_search';
var apiReasonLookup = apiBaseUrl + 'reason/lookup';

function authUser(userName, userPassword) {
  localStorage.clear;
  try {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(apiLogin, {
      userId: userName,
      password: userPassword
    });
  } catch (e) {
    this.errors.push(e);
  }
}
function authACL(functionName) {
  if (!localStorage.access_token) {
    return 0;
  } else {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('/user/acl', {
      accessToken: localStorage.access_token,
      function: functionName
    }).then(function (res) {
      console.log('Check Auth ACL');
      console.log(res);
      localStorage.setItem('auth_code', res.data.code);
    }).catch(function (error) {
      return alert(error);
    });
  }
}
var authHeader = function authHeader() {
  var accessToken = localStorage.access_token;
  return {
    'headers': {
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + accessToken
    }
  };
};

/***/ }),
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__functions_common_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Autocomplete_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_json_excel__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pdfmake_build_pdfmake__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pdfmake_build_pdfmake___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pdfmake_build_pdfmake__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_vfs_fonts__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_vfs_fonts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_pdfmake_build_vfs_fonts__);










__WEBPACK_IMPORTED_MODULE_5_pdfmake_build_pdfmake___default.a.vfs = __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_vfs_fonts___default.a.pdfMake.vfs;
__WEBPACK_IMPORTED_MODULE_5_pdfmake_build_pdfmake___default.a.fonts = {
  "ukai": {
    normal: 'ukai.ttf',
    bold: 'ukai.ttf',
    italics: 'ukai.ttf',
    bolditalics: 'ukai.ttf'
  },
  "Roboto": {
    normal: 'Roboto-Regular.ttf',
    bold: 'Roboto-Medium.ttf',
    italics: 'Roboto-Italic.ttf',
    bolditalics: 'Roboto-Italic.ttf'
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  components: { supplierLookup: __WEBPACK_IMPORTED_MODULE_2__components_Autocomplete_vue__["a" /* default */], spinner: __WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue__["a" /* default */], exportExcel: __WEBPACK_IMPORTED_MODULE_4_vue_json_excel__["a" /* default */] },
  props: {
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      loading: false,
      filter: {
        po_num: '',
        supplier_id: '',
        date_start: '',
        date_end: '',
        po_status: '',
        fulfilment_status: ''
      },
      apiUrl: __WEBPACK_IMPORTED_MODULE_1__functions_common_vue__["U" /* apiSupplierLookup */],
      supplierId: '',
      seen: false,
      searchResults: [],
      searchResultsFields: [{ key: 'po_num', label: 'PO No' }, { key: 'po_date', label: 'Date' }, { key: 'supplier_name', label: 'Supplier' }, { key: 'location_id', label: 'Location Code' }, { key: 'location_name', label: 'Location' }, { key: 'author_shortname', label: 'Requestor' }, { key: 'po_status', label: 'PO Status' }, { key: 'po_status_date', label: 'Updated On' }, { key: 'po_approver_user_shortname', label: 'Updated By' }, { key: 'po_fulfilment_status', label: 'Fulfilment Status' }, { key: 'po_fulfilment_date', label: 'Updated On' }, { key: 'po_fulfilment_user_shortname', label: 'Updated By' }],
      currentPage: 1,
      perPage: 20,
      totalRows: 0,
      noResults: false,
      exportHeaders: {
        'PO No': 'po_num',
        'Date': 'po_date',
        'Supplier': 'supplier_name',
        'Location Code': 'location_id',
        'Location': 'location_name',
        'Requestor': 'author_shortname',
        'PO Status': 'po_status',
        'PO Status Last Updated On': 'po_status_date',
        'PO StatusUpdated By': 'po_approver_user_shortname',
        'Fulfilment Status': 'po_fulfilment_status',
        'Fulfilment Status Last Updated On': 'po_fulfilment_date',
        'Fulfilment Status Updated By': 'po_fulfilment_user_shortname'
      }
    };
  },
  created: function created() {
    var auth_header = localStorage.access_token;
    window.addEventListener('keyup', this.checkKey);
  },

  methods: {
    print: function print() {
      var rows = [];
      var row = [];
      var date = new Date();
      rows.push(['PO No', 'Date', 'Supplier', 'Location Code', 'Location', 'Requestor', 'PO Status', 'Last Updated On', 'By', 'Fulfilment Status', 'Last Updated On', 'By']);

      for (var key in this.searchResults) {
        var data = this.searchResults[key];
        row = [data.po_num, data.po_date, data.supplier_name, data.location_id, data.location_name, data.author_shortname, data.po_status, data.po_status_date, data.po_approver_user_shortname, data.po_fulfilment_status, data.po_fulfilment_date, data.po_fulfilment_user_shortname];
        rows.push(row);
      }
      var dd = {
        header: { text: 'Purchase Order List generated on' + " " + date, margin: [5, 10, 10, 20], alignment: 'center', fontSize: 7 },
        pageSize: 'A4',
        pageOrientation: 'landscape',
        defaultStyle: {
          font: 'ukai'
        },

        pageMargins: [30, 20, 30, 20],

        content: [{
          fontSize: 6,
          layout: 'lightHorizontalLines',
          table: {
            headerRows: 1,
            widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],

            body: rows

          }
        }]
      };

      __WEBPACK_IMPORTED_MODULE_5_pdfmake_build_pdfmake___default.a.createPdf(dd).open();
    },
    checkKey: function checkKey(e) {
      if (e.key == 'Enter') {}
    },
    searchPO: function searchPO() {
      var _this = this;

      this.loading = true;
      this.submitted = true;
      this.seen = true;
      var sf = ["po_num LIKE " + this.filter.po_num, "supplier_id = " + this.filter.supplier_id, "po_date >= " + this.filter.date_start, "po_date <= " + this.filter.date_end, "po_status = " + this.filter.po_status, "po_fulfilment_status = " + this.filter.fulfilment_status];

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__functions_common_vue__["B" /* apiPoSearch */], sf, Object(__WEBPACK_IMPORTED_MODULE_1__functions_common_vue__["_7" /* authHeader */])()).then(function (res) {
        return res;
      }).then(function (data) {
        var resultArray = [];
        var myData = data.data.data.list;

        for (var key in myData) {
          var date = myData[key].po_date;
          var date = new Date(date);
          var poStatusDate = myData[key].po_status_date;
          var poApprover = myData[key].po_approver_user_shortname;
          var fulfilmentStatusDate = myData[key].po_fulfilment_date;
          var fulfilmentUserShortname = myData[key].po_fulfilment_user_shortname;
          var poStatusDateResult;
          var fulfilmentStatusDateResult;
          var poApproverResult;
          if (poStatusDate == null) {
            poStatusDateResult = '-';
          } else {
            var psDate = new Date(poStatusDate);
            poStatusDateResult = "" + (psDate.getDate() > 9 ? '' : '0') + psDate.getDate() + '/' + (psDate.getMonth() + 1 > 9 ? '' : '0') + (psDate.getMonth() + 1) + '/' + psDate.getFullYear() + " " + (psDate.getHours() > 9 ? '' : '0') + psDate.getHours() + ":" + (psDate.getMinutes() > 9 ? '' : '0') + psDate.getMinutes() + ":" + (psDate.getSeconds() > 9 ? '' : '0') + psDate.getSeconds();
          }

          if (poApprover == null) {
            poApproverResult = '-';
          } else {
            poApproverResult = poApprover;
          }
          if (fulfilmentStatusDate == null) {
            fulfilmentStatusDateResult = '-';
          } else {
            var fsDate = new Date(fulfilmentStatusDate);
            fulfilmentStatusDateResult = "" + (fsDate.getDate() > 9 ? '' : '0') + fsDate.getDate() + '/' + (fsDate.getMonth() + 1 > 9 ? '' : '0') + (fsDate.getMonth() + 1) + '/' + fsDate.getFullYear() + " " + (fsDate.getHours() > 9 ? '' : '0') + fsDate.getHours() + ":" + (fsDate.getMinutes() > 9 ? '' : '0') + fsDate.getMinutes() + ":" + (fsDate.getSeconds() > 9 ? '' : '0') + fsDate.getSeconds();
          }

          if (fulfilmentUserShortname == null) {
            fulfilmentUserShortname = '-';
          }
          var result = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + (date.getMonth() + 1 > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear();
          myData[key].po_date = result;
          myData[key].po_status_date = poStatusDateResult;
          myData[key].po_approver_user_shortname = poApproverResult;
          myData[key].po_fulfilment_date = fulfilmentStatusDateResult;
          myData[key].po_fulfilment_user_shortname = fulfilmentUserShortname;
          resultArray.push(myData[key]);
          _this.loading = false;
        }
        _this.searchResults = resultArray;
        if (_this.searchResults.length == 0) {
          _this.loading = false;
          _this.noResults = true;
        }
      }).catch(function (error) {
        return console.log(error);
      });
    },
    setSupplierId: function setSupplierId(obj) {
      var id;

      if (obj !== null) id = obj.id;else id = '';

      this.filter.supplier_id = id;
    },
    getRowCount: function getRowCount(list) {
      return list.length;
    },
    rowClick: function rowClick(item, index) {
      this.$router.push({ name: 'Purchase Order (PO)', params: { poNum: item.po_num } });
    },
    newPO: function newPO() {
      this.$router.push({ name: 'Purchase Order (PO)', params: { poNum: '_new' } });
    }
  }
});

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);




/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    var _this = this;

    if (this.lookupId !== null && this.lookupId != '') {
      var newVal = this.lookupId;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.url, { params: { q: newVal, q2: this.q2 } }).then(function (response) {
        _this.open = false;

        if (response.data != null) {
          _this.list = response.data.data.list;
          _this.item = _this.list[0];
          if (_this.item !== undefined) {
            _this.lookupValue = _this.item.name;
            _this.selectedId = _this.item.id;
            _this.$emit('selected', _this.item);
          }
          _this.open = false;
        }
      });
    }

    this.lockEntry = this.disabled;
    this.isBasicLookup = this.basic;
  },
  props: ['url', 'lookupId', 'q2', 'selected', 'disabled', 'basic', 'get'],

  watch: {
    disabled: function disabled(newVal, oldVal) {
      this.lockEntry = newVal;
    },
    lookupId: function lookupId(newVal, oldVal) {
      var _this2 = this;

      if (newVal == null || newVal == "") {
        this.lookupValue = "";
        this.selectedId = null;
        this.item = null;
        this.list = [];
        this.current = -1;
        this.$emit('blur', this.item);
      } else {
        if (newVal != '') {

          var exactSearch = this.get;
          if (exactSearch === undefined) {
            exactSearch = 1;
          }

          __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.url, { params: { q: newVal, q2: this.q2, get: exactSearch } }).then(function (response) {
            _this2.isFirstLoad = false;
            _this2.open = false;

            _this2.list = response.data.data.list;
            if (_this2.list.length > 0) {
              _this2.item = _this2.list[0];
              if (_this2.item !== null) {
                _this2.selectedId = _this2.item.id;
                _this2.lookupValue = _this2.item.name;
                _this2.$emit('selected', _this2.item);
              }
            }
            _this2.open = false;
          });
        } else {
          this.item.id = "";
          this.item.name = "";
          this.selectedId = this.item.id;
          this.lookupValue = this.item.name;

          this.$emit('selected', this.item);
        }
      }
    }

  },
  data: function data() {
    return {
      lookupValue: '',
      isBasicLookup: false,
      list: [],
      open: true,
      selectedId: '',
      item: {},
      current: -1,
      lockEntry: false,
      isFirstLoad: true
    };
  },

  methods: {
    clear: function clear(val) {
      this.lookupValue = "";
      this.selectedId = null;
      this.item = { id: "", name: "" };
      this.list = [];
      this.current = -1;
    },
    search: function search() {
      var _this3 = this;

      var forceSearch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.list = [];
      if (this.lookupValue != '' || forceSearch) {
        this.open = true;
        this.current = -1;
        this.selectedId = '';

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.url, { params: { q: this.lookupValue, q2: this.q2 } }).then(function (response) {
          _this3.list = [];
          _this3.list = response.data.data.list;
          if (_this3.list.length == 0) {
            _this3.current = -1;
            _this3.selectedId = "";
            _this3.lookupValue = "";
            _this3.item = { id: "", name: "" };
            _this3.$emit('selected', _this3.item);
          } else {
            _this3.current = 0;
            _this3.item = _this3.list[_this3.current];
            _this3.open = true;
          }
        });
      } else {
        this.current = -1;
        this.selectedId = "";
        this.item = { id: "", name: "" };
        this.$emit('selected', this.item);
      }
    },
    blur: function blur() {
      var wasOpen = this.open;

      this.open = false;

      if (this.item !== null) {
        if (this.item.id == this.selectedId && this.item.name == this.lookupvalue) {} else if (this.lookupValue == '' && !wasOpen) {
          this.selectedId = "";
          this.lookupValue = "";
          this.item = { id: "", name: "" };
          this.$emit('selected', this.item);
        } else if (this.lookupValue == '' && wasOpen) {
          this.item = this.list[this.current];
          if (this.item !== undefined) {
            this.selectedId = this.item.id;
            this.lookupValue = this.item.name;
          } else {
            this.item = { id: "", name: "" };
            this.selectedId = this.item.id;
            this.lookupValue = this.item.name;
          }
          this.$emit('selected', this.item);
        } else if (this.current >= 0 && this.list.length > 0 && this.selectedId == "") {
          this.item = this.list[this.current];

          if (this.item !== undefined) {
            if (this.item.id !== undefined) {
              this.selectedId = this.item.id;
              this.lookupValue = this.item.name;
            }
          }

          this.$emit('selected', this.item);
        } else if (this.item.id == "" && this.lookupValue != '') {
          this.selectedId = "";
          this.lookupValue = "";
          this.item.id = this.selectedId;
          this.item.name = this.lookupValue;

          this.$emit('selected', this.item);
        } else if (this.item.id != this.selectedId || this.item.name != this.lookupValue) {

          this.current = -1;
          this.selectedId = "";
          this.lookupValue = "";
          this.item.id = this.selectedId;
          this.item.name = this.lookupValue;

          this.$emit('selected', this.item);
        }
      } else {
        this.lookupValue = "";
      }


      this.$emit('blur', this.item);
    },
    click: function click() {
      if (this.current < this.list.length - 1) {
        this.item = this.list[this.current];
        this.$emit('selected', this.item);
      }
    },
    MouseOver: function MouseOver(index) {
      this.current = index;
    },
    esc: function esc() {
      this.open = false;
    },
    enter: function enter() {
      if (this.list.length) {
        if (this.current >= 0) {
          this.item = this.list[this.current];
          this.selectedId = this.item.id;
          this.lookupValue = this.item.name;
          this.$emit('selected', this.item);
        }
        this.open = false;
      }
    },
    up: function up() {
      if (this.current > 0 && this.open) {
        this.current--;
      }
    },
    down: function down() {
      if (this.lookupValue == '' && !this.open) {
        this.search(true);
        this.current = 0;
      } else if (this.current < this.list.length - 1 && this.open) {
        this.current++;
      } else {
        this.search(true);
        this.current = 0;
      }
    },
    isActive: function isActive(index) {
      return index === this.current;
    }
  }
});

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__functions_common_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Autocomplete_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pdfmake_build_vfs_fonts__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pdfmake_build_vfs_fonts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_pdfmake_build_vfs_fonts__);













__WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake___default.a.vfs = __WEBPACK_IMPORTED_MODULE_4_pdfmake_build_vfs_fonts___default.a.pdfMake.vfs;
__WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake___default.a.fonts = {
    "ukai": {
        normal: 'ukai.ttf',
        bold: 'ukai.ttf',
        italics: 'ukai.ttf',
        bolditalics: 'ukai.ttf'
    },
    "Garuda": {
        normal: 'Garuda.ttf',
        bold: 'Garuda.ttf',
        italics: 'Garuda.ttf',
        bolditalics: 'Garuda.ttf'
    },
    "Hanumanb": {
        normal: 'Hanumanb.ttf',
        bold: 'Hanumanb.ttf',
        italics: 'Hanumanb.ttf',
        bolditalics: 'Hanumanb.ttf'
    }
};
/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'poDetails',
    components: { supplierLookup: __WEBPACK_IMPORTED_MODULE_2__components_Autocomplete_vue__["a" /* default */], warehouseLookup: __WEBPACK_IMPORTED_MODULE_2__components_Autocomplete_vue__["a" /* default */], productLookup: __WEBPACK_IMPORTED_MODULE_2__components_Autocomplete_vue__["a" /* default */], testLookup: __WEBPACK_IMPORTED_MODULE_2__components_Autocomplete_vue__["a" /* default */] },
    data: function data() {
        return {
            mbTitle: "",
            mbMsg: "",
            savedTitle: '',
            po_status: '',
            country_name: '',
            msgSaved: '',
            closeBtn: false,
            hideBtn: true,
            font: 'ukai',
            confirmBtnText: '',
            cancelBtnText: '',
            confirmMessage: 'test',
            lockEntry: false,
            poRef: '',
            parentData: '',
            supplierId: '',
            prevSupplierId: '',
            apiSupplierUrl: __WEBPACK_IMPORTED_MODULE_1__functions_common_vue__["U" /* apiSupplierLookup */],
            apiWarehouseUrl: __WEBPACK_IMPORTED_MODULE_1__functions_common_vue__["V" /* apiWarehouseLookup */],
            apiProductUrl: __WEBPACK_IMPORTED_MODULE_1__functions_common_vue__["E" /* apiProductLookup */],
            apiPOManualClose: __WEBPACK_IMPORTED_MODULE_1__functions_common_vue__["w" /* apiPOManualClose */],
            warehouseDisplay: '',
            modalShow: false,
            cancelModalShow: false,
            prevWhID: '',
            productId: '',
            countryId: '',
            poItemsCount: 1,
            currency_id: '',
            errorMessage: 'Error',
            isSuccess: true,
            poDocumentNo: '',
            noItemsFound: true,
            visible: true,
            isValid: true,
            selected: false,
            po_fulfilment_status: '',
            poData: {
                po_num: '',
                po_date: '', supplier_id: '', location_id: '', po_type: '-', po_category: '-', po_date_eta: '', remarks: '', currency_id: '',
                po_fulfilment_remarks: '',
                grns: [],
                po_items: [{ product_name: '', product_id: '', uom: '', qty: '', unit_price: '', amount_total: '' }], title: '',
                tax_amount: 0,
                tax_percent: 0,
                total_amount: 0,
                amount_total_rounding: 0
            }
        };
    },
    created: function created() {

        this.poRef = this.$route.params.poNum;
        if (this.poRef == '_new') {
            this.poRef = '';
            this.po_status = 'PENDING';
        }
        this.poData.po_num = this.poRef;

        if (this.poData.po_num == '') {
            this.poData.title = 'New Purchase Order';
            this.msgSaved = "created";
            this.confirmBtnText = 'Save Purchase Order';
            this.cancelBtnText = 'Cancel';
            this.lockEntry = false;
            this.noItemsFound = true;
        } else {
            this.poData.title = 'Purchase Order ' + this.poData.po_num;
            this.msgSaved = "saved";
            this.confirmBtnText = 'Confirm PO';
            this.cancelBtnText = ' Reject PO';
            this.lockEntry = true;
            this.noItemsFound = false;
        }
        if (this.poRef == '' && this.poData.po_date == '') {
            var curDate = new Date();
            curDate = curDate.toISOString().substr(0, 10);
            this.poData.po_date = curDate;
        } else {
            this.fetchPO(this.poRef);
        }
    },
    computed: {
        gstAmount: function gstAmount() {
            var _this = this;

            return this.poData.po_items.reduce(function (gstAmount) {
                return _this.poData.tax_percent * 1 / 100 * (_this.total * 1);
            }, 0);
        },
        totalAmount: function totalAmount() {
            var _this2 = this;

            return this.poData.po_items.reduce(function (totalAmount) {
                return _this2.total + _this2.gstAmount + _this2.poData.amount_total_rounding * 1;
            }, 0);
        },
        total: function total() {
            return this.poData.po_items.reduce(function (total, item) {
                return total + item.amount_total * 1;
            }, 0);
        }
    },
    methods: {
        printGRN: function printGRN(row) {
            var grn_num = row.grn_num;
            var r = [];
            var grnsItems = [];
            var groTotalAmount = 0;
            r = [{
                text: 'S/No',
                style: 'itemsHeader'
            }, {
                text: 'Product Code',
                style: ['itemsHeader'],
                alignment: 'left'
            }, {
                text: 'Description',
                style: ['itemsHeader'],
                alignment: 'left'
            }, {
                text: 'Qty',
                style: ['itemsHeader'],
                alignment: 'right'
            }];
            grnsItems.push(r);

            var items = row.grn_items;
            for (var key in items) {
                var data = items[key];
                var qty = (data.qty * 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                if (data.product_name == null) {
                    data.product_name = "";
                }
                r = [{
                    text: key * 1 + 1,
                    style: 'itemText'
                }, {
                    text: data.product_id,
                    style: 'itemText'
                }, {
                    text: data.product_name,
                    style: 'itemText'
                }, {
                    text: qty,
                    style: 'itemNumber'
                }];
                grnsItems.push(r);
            }

            var ddHeader = {
                columns: [[{
                    text: 'ELKEN ' + this.country_name + ' GOOD RECEIVED NOTE',
                    style: 'invoiceTitle',
                    width: '*'
                }, {
                    stack: [{
                        columns: [{
                            text: 'GRN #',
                            style: 'invoiceSubTitle',
                            width: 95

                        }, {
                            text: grn_num,
                            style: 'invoiceSubValue',
                            width: 100
                        }]
                    }, {
                        text: ' '
                    }, {
                        columns: [{
                            text: 'GRN Date',
                            style: 'invoiceSubTitle',
                            width: 95

                        }, {
                            text: row.grn_date_friendly,
                            style: 'invoiceSubValue',
                            width: 100
                        }]

                    }, {
                        text: ' '
                    }, {
                        columns: [{
                            text: 'Reference PO #',
                            style: 'invoiceSubTitle',
                            width: 95

                        }, {
                            text: row.po_num,
                            style: 'invoiceSubValue'
                        }]

                    }]
                }]]
            };

            var dd = {
                header: function header(pageNumber, pageCount) {
                    return {
                        margin: [0, 10, 0, 0],
                        columns: [{
                            text: '',
                            style: 'documentHeaderLeft'
                        }, {
                            text: grn_num,
                            style: 'documentHeaderCenter'
                        }, {
                            text: '',
                            style: 'documentHeaderRight'
                        }]
                    };
                },
                footer: function footer(pageNumber, pageCount) {
                    return {
                        margin: [0, 0, 0, 50],
                        columns: [{
                            text: '',
                            style: 'documentFooterLeft'
                        }, {
                            text: 'Page ' + pageNumber + " of " + pageCount,
                            style: 'documentFooterCenter'
                        }, {
                            text: '',
                            style: 'documentFooterRight'
                        }]
                    };
                },
                content: [ddHeader, '\n\n', {
                    layout: 'lightHorizontalLines',
                    table: {

                        headerRows: 1,
                        widths: [25, 68, '*', 45, 45],
                        body: grnsItems

                    } }, {
                    text: 'Remarks',
                    style: 'notesTitle'
                }, {
                    text: row.remarks,
                    style: 'notesText'
                }, {
                    columns: [{
                        stack: [{
                            text: 'Received By',
                            style: 'signaturePlaceholder'
                        }, {
                            text: '______________________________',
                            style: 'signaturePlaceholder'
                        }, {
                            text: 'Name  :',
                            style: 'signatureName'

                        }, {
                            text: 'Date  :',
                            style: 'signatureJobTitle'

                        }],
                        width: 160
                    }]
                }],
                styles: {
                    documentHeaderLeft: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'left'
                    },
                    documentHeaderCenter: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'center'
                    },
                    documentHeaderRight: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'right'
                    },

                    documentFooterLeft: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'left'
                    },
                    documentFooterCenter: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'center'
                    },
                    documentFooterRight: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'right'
                    },

                    invoiceTitle: {
                        fontSize: 20,
                        bold: true,
                        alignment: 'left',
                        margin: [0, 0, 0, 15]
                    },

                    invoiceSubTitle: {
                        fontSize: 10,
                        alignment: 'left'
                    },
                    invoiceSubValue: {
                        fontSize: 10,
                        alignment: 'left'
                    },

                    invoiceBillingTitle: {
                        fontSize: 14,
                        bold: true,
                        alignment: 'left',
                        margin: [0, 20, 0, 5]
                    },

                    invoiceBillingDetails: {
                        alignment: 'left'

                    },
                    invoiceBillingAddressTitle: {
                        margin: [0, 7, 0, 3],
                        bold: true
                    },
                    invoiceBillingAddress: {},

                    itemsHeader: {

                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        bold: true
                    },

                    itemTitle: {
                        bold: true
                    },
                    itemSubTitle: {
                        fontSize: 10
                    },
                    itemText: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        alignment: 'left'
                    },
                    itemNumber: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        alignment: 'right'
                    },
                    itemTotal: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right'
                    },

                    itemsFooterSubTitle: {
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right'
                    },
                    itemsFooterSubValue: {
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'center'
                    },
                    itemsFooterTotalTitle: {
                        fontSize: 11,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right'
                    },
                    itemsFooterTotalValue: {
                        fontSize: 11,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'center'
                    },
                    signaturePlaceholder: {
                        fontSize: 10,
                        margin: [0, 70, 0, 0]
                    },
                    signatureName: {
                        fontSize: 10,
                        margin: [0, 10, 0, 0],
                        bold: true,
                        alignment: 'left'
                    },
                    signatureJobTitle: {
                        fontSize: 10,
                        margin: [0, 20, 0, 0],
                        bold: true,
                        alignment: 'left'
                    },
                    notesTitle: {
                        fontSize: 10,
                        bold: true,
                        margin: [0, 30, 0, 3]
                    },
                    notesText: {
                        fontSize: 10
                    },
                    center: {
                        alignment: 'center'
                    }
                },
                defaultStyle: {
                    columnGap: 20,
                    font: this.font
                }
            };
            __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake___default.a.createPdf(dd).open();
        },
        print: function print() {
            var po_num = this.poData.po_num;
            var row = [];
            var date = new Date(this.poData.po_date);
            var poDate = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + (date.getMonth() + 1 > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear();
            var deliveryDate = '';
            var payment_terms = '-';

            if (this.poData.payment_terms != null) {
                payment_terms = this.poData.payment_terms;
            }

            if (this.poData.po_date_eta != null) {
                deliveryDate = new Date(this.poData.po_date_eta);
                deliveryDate = "" + (deliveryDate.getDate() > 9 ? '' : '0') + deliveryDate.getDate() + '/' + (deliveryDate.getMonth() + 1 > 9 ? '' : '0') + (deliveryDate.getMonth() + 1) + '/' + deliveryDate.getFullYear();
            } else {
                deliveryDate = '-';
            }
            if (this.poData.po_status == "APPROVED" && this.poData.po_status_date != null) {
                var poStatusDate = new Date(this.poData.po_status_date);
                poStatusDate = "" + (poStatusDate.getDate() > 9 ? '' : '0') + poStatusDate.getDate() + '/' + (poStatusDate.getMonth() + 1 > 9 ? '' : '0') + (poStatusDate.getMonth() + 1) + '/' + poStatusDate.getFullYear();
            } else {
                poStatusDate = "-";
            }
            var poApprover;
            if (this.poData.po_status == "APPROVED" && this.poData.approver_user_shortname != null) {
                poApprover = this.poData.approver_user_shortname;
            } else {
                poApprover = "-";
            }
            var poItems = [];
            var poTotalAmount = 0;
            row = [{ text: 'S/No', style: 'itemsHeader' }, { text: 'Product Code', style: ['itemsHeader'], alignment: 'left' }, { text: 'Description', style: ['itemsHeader'], alignment: 'left' }, { text: 'Unit Price', style: ['itemsHeader'], alignment: 'right' }, { text: 'Qty', style: ['itemsHeader'], alignment: 'right' }, { text: 'Amount', style: ['itemsHeader'], alignment: 'right' }];
            poItems.push(row);
            var items = this.poData.po_items;
            for (var key in items) {
                var data = items[key];
                poTotalAmount = poTotalAmount + data.amount_total * 1;
                var unit_price = (data.unit_price * 1).toFixed(2);
                unit_price = data.unit_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                var amount_total = (data.amount_total * 1).toFixed(2);
                amount_total = data.amount_total;
                var totalAmount = data.amount_total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                var qty = (data.qty * 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                if (data.product_name == null) {
                    data.product_name = "";
                }
                row = [{ text: key * 1 + 1, style: 'itemText' }, { text: data.product_id, style: 'itemText' }, { text: data.product_name, style: 'itemText' }, { text: unit_price, style: 'itemNumber' }, { text: qty, style: 'itemNumber' }, { text: totalAmount, style: 'itemTotal' }];
                poItems.push(row);
            }
            poTotalAmount = poTotalAmount.toFixed(2);
            poTotalAmount = poTotalAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            var ddHeader = {
                columns: [[{
                    text: 'ELKEN ' + this.country_name + ' PURCHASE ORDER',
                    style: 'invoiceTitle',
                    width: '*'
                }, {
                    stack: [{
                        columns: [{
                            text: 'Supplier',
                            style: 'invoiceSubTitle',
                            width: 90

                        }, {
                            text: this.poData.supplier_info,
                            style: 'invoiceSubValue',
                            width: 100

                        }, {
                            text: '', style: 'invoiceSubValue', width: 80
                        }, {
                            text: 'PO #',
                            style: 'invoiceSubTitle',
                            width: 90

                        }, {
                            text: po_num,
                            style: 'invoiceSubValue',
                            width: 100

                        }]
                    }, {
                        columns: [{
                            text: 'Purchaser',
                            style: 'invoiceSubTitle',
                            width: 90

                        }, {
                            text: this.poData.author_user_shortname,
                            style: 'invoiceSubValue',
                            width: 100

                        }, {
                            text: '', style: 'invoiceSubValue', width: 80
                        }, {
                            text: 'PO Date',
                            style: 'invoiceSubTitle',
                            width: 90

                        }, {
                            text: poDate,
                            style: 'invoiceSubValue',
                            width: 100

                        }]
                    }, {
                        columns: [{
                            text: 'Stock Location',
                            style: 'invoiceSubTitle',
                            width: 90

                        }, {
                            text: this.poData.location_info,
                            style: 'invoiceSubValue',
                            width: 100

                        }, {
                            text: '', style: 'invoiceSubValue', width: 80
                        }, {
                            text: 'Payment Terms',
                            style: 'invoiceSubTitle',
                            width: 90

                        }, {
                            text: payment_terms,
                            style: 'invoiceSubValue',
                            width: 100

                        }]
                    }, {
                        columns: [{
                            text: 'Delivery Date',
                            style: 'invoiceSubTitle',
                            width: 90

                        }, {
                            text: deliveryDate,
                            style: 'invoiceSubValue',
                            width: 100

                        }, {
                            text: '', style: 'invoiceSubValue', width: 80
                        }, {
                            text: 'Currency',
                            style: 'invoiceSubTitle',
                            width: 90

                        }, {
                            text: this.poData.currency_id,
                            style: 'invoiceSubValue',
                            width: 100

                        }]
                    }]
                }]]
            };

            var dd = {
                header: function header(pageNumber, pageCount) {
                    return {
                        margin: [0, 10, 0, 0],
                        columns: [{ text: '', style: 'documentHeaderLeft' }, { text: po_num, style: 'documentHeaderCenter' }, { text: '', style: 'documentHeaderRight' }]
                    };
                },
                footer: function footer(pageNumber, pageCount) {
                    return {
                        margin: [0, 0, 0, 50],
                        columns: [{ text: '', style: 'documentFooterLeft' }, { text: 'Page ' + pageNumber + " of " + pageCount, style: 'documentFooterCenter' }, { text: '', style: 'documentFooterRight' }]
                    };
                },
                content: [ddHeader, '\n\n', {
                    layout: 'lightHorizontalLines',
                    table: {

                        headerRows: 1,
                        widths: [25, 68, '*', 45, 38, 55],
                        body: poItems

                    } }, {
                    table: {
                        headerRows: 0,
                        widths: ['*', 80],
                        body: [[{
                            text: 'TOTAL ($)',
                            style: 'itemsFooterTotalTitle',
                            alignment: 'right'

                        }, {
                            text: poTotalAmount,
                            style: 'itemsFooterTotalValue',
                            alignment: 'right'
                        }]]
                    },
                    layout: 'lightHorizontalLines'
                }, {
                    table: {
                        headerRows: 0,
                        widths: ['*', 80],
                        body: [[{
                            text: 'Tax (%)',
                            style: 'itemsFooterTotalTitle',
                            alignment: 'right'

                        }, {
                            text: this.poData.tax_percent,
                            style: 'itemsFooterTotalValue',
                            alignment: 'right'
                        }]]
                    },
                    layout: 'lightHorizontalLines'
                }, {
                    table: {
                        headerRows: 0,
                        widths: ['*', 80],
                        body: [[{
                            text: 'Tax Amount ($)',
                            style: 'itemsFooterTotalTitle',
                            alignment: 'right'

                        }, {
                            text: this.poData.amount_tax,
                            style: 'itemsFooterTotalValue',
                            alignment: 'right'
                        }]]
                    },
                    layout: 'lightHorizontalLines'
                }, {
                    table: {
                        headerRows: 0,
                        widths: ['*', 80],
                        body: [[{
                            text: 'Rounding Amount($)',
                            style: 'itemsFooterTotalTitle',
                            alignment: 'right'

                        }, {
                            text: this.poData.amount_total_rounding,
                            style: 'itemsFooterTotalValue',
                            alignment: 'right'
                        }]]
                    },
                    layout: 'lightHorizontalLines'
                }, {
                    table: {
                        headerRows: 0,
                        widths: ['*', 80],
                        body: [[{
                            text: 'Total Amount ($)',
                            style: 'itemsFooterTotalTitle',
                            alignment: 'right'
                        }, {
                            text: this.poData.amount_total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                            style: 'itemsFooterTotalValue',
                            alignment: 'right'
                        }]]
                    },
                    layout: 'lightHorizontalLines'
                }, {
                    text: 'Remarks',
                    style: 'notesTitle'
                }, {
                    text: this.poData.remarks,
                    style: 'notesText'
                }, {
                    columns: [{
                        stack: [{
                            text: 'Issued By',
                            style: 'signaturePlaceholder'
                        }, {
                            text: '____________________________',
                            style: 'signaturePlaceholder'
                        }, {
                            text: 'Name  :' + this.poData.author_user_shortname,
                            style: 'signatureName'

                        }, {
                            text: 'Date  :' + poDate,
                            style: 'signatureJobTitle'

                        }],
                        width: 160
                    }, {
                        stack: [{
                            text: '         ',
                            style: 'signaturePlaceholder'
                        }, {
                            text: '                           ',
                            style: 'signaturePlaceholder'
                        }, {
                            text: '          ',
                            style: 'signatureName'

                        }, {
                            text: ' ',
                            style: 'signatureJobTitle'

                        }],
                        width: 160
                    }, {
                        stack: [{
                            text: 'Received By',
                            style: 'signaturePlaceholder'
                        }, {
                            text: '______________________________',
                            style: 'signaturePlaceholder'
                        }, {
                            text: 'Name  :',
                            style: 'signatureName'

                        }, {
                            text: 'Date  :',
                            style: 'signatureJobTitle'

                        }],
                        width: 160
                    }]
                }],
                styles: {
                    documentHeaderLeft: {
                        fontSize: 9,
                        margin: [5, 5, 5, 5],
                        alignment: 'left'
                    },
                    documentHeaderCenter: {
                        fontSize: 9,
                        margin: [5, 5, 5, 5],
                        alignment: 'center'
                    },
                    documentHeaderRight: {
                        fontSize: 9,
                        margin: [5, 5, 5, 5],
                        alignment: 'right'
                    },

                    documentFooterLeft: {
                        fontSize: 9,
                        margin: [5, 5, 5, 5],
                        alignment: 'left'
                    },
                    documentFooterCenter: {
                        fontSize: 9,
                        margin: [5, 5, 5, 5],
                        alignment: 'center'
                    },
                    documentFooterRight: {
                        fontSize: 9,
                        margin: [5, 5, 5, 5],
                        alignment: 'right'
                    },

                    invoiceTitle: {
                        fontSize: 20,
                        bold: true,
                        alignment: 'left',
                        margin: [0, 0, 0, 15]
                    },

                    invoiceSubTitle: {
                        fontSize: 9,
                        alignment: 'left'
                    },
                    invoiceSubValue: {
                        fontSize: 9,
                        alignment: 'left'
                    },

                    invoiceBillingTitle: {
                        fontSize: 12,
                        bold: true,
                        alignment: 'left',
                        margin: [0, 20, 0, 5]
                    },

                    invoiceBillingDetails: {
                        alignment: 'left'

                    },
                    invoiceBillingAddressTitle: {
                        margin: [0, 7, 0, 3],
                        bold: true
                    },
                    invoiceBillingAddress: {},

                    itemsHeader: {

                        fontSize: 9,
                        margin: [0, 5, 0, 5],
                        bold: true
                    },

                    itemTitle: {
                        bold: true
                    },
                    itemSubTitle: {
                        fontSize: 9
                    },
                    itemText: {
                        fontSize: 9,
                        margin: [0, 5, 0, 5],
                        alignment: 'left'
                    },
                    itemNumber: {
                        fontSize: 9,
                        margin: [0, 5, 0, 5],
                        alignment: 'right'
                    },
                    itemTotal: {
                        fontSize: 9,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right'
                    },

                    itemsFooterSubTitle: {
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right'
                    },
                    itemsFooterSubValue: {
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'center'
                    },
                    itemsFooterTotalTitle: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right'
                    },
                    itemsFooterTotalValue: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'center'
                    },
                    signaturePlaceholder: {
                        fontSize: 9,
                        margin: [0, 70, 0, 0]
                    },
                    signatureName: {
                        fontSize: 9,
                        margin: [0, 10, 0, 0],
                        bold: true,
                        alignment: 'left'
                    },
                    signatureJobTitle: {
                        fontSize: 9,
                        margin: [0, 20, 0, 0],
                        bold: true,
                        alignment: 'left'
                    },
                    notesTitle: {
                        fontSize: 9,
                        bold: true,
                        margin: [0, 50, 0, 3]
                    },
                    notesText: {
                        fontSize: 9
                    },
                    center: {
                        alignment: 'center'
                    }
                },
                defaultStyle: {
                    columnGap: 20,
                    font: this.font
                }
            };
            __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake___default.a.createPdf(dd).open();
        },
        manualClosePO: function manualClosePO() {
            var _this3 = this;

            this.$refs.manualCloseModal.hide();
            if (this.poData.po_fulfilment_remarks != '' && this.poData.po_fulfilment_remarks != null) {
                __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__functions_common_vue__["w" /* apiPOManualClose */], { po_num: this.poData.po_num, remarks: this.poData.po_fulfilment_remarks }, Object(__WEBPACK_IMPORTED_MODULE_1__functions_common_vue__["_7" /* authHeader */])()).then(function (res) {
                    _this3.po_status = "MANUAL-CLOSED";
                    _this3.hideBtns = false;
                    _this3.mbTitle = "Manual Close";
                    _this3.mbMsg = "PO " + _this3.poData.po_num + " has been Manual Closed.";
                    _this3.$refs.msgBox.show();
                }).catch(function (error) {
                    return alert(error);
                });
            } else {
                this.mbTitle = "Manual Close cancelled";
                this.mbMsg = "Reason has to be provided";
                this.$refs.msgBox.show();
            }
        },
        confirmManualClose: function confirmManualClose() {
            this.$refs.manualCloseModal.show();
        },
        fetchPO: function fetchPO(poNum) {
            var _this4 = this;

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__functions_common_vue__["z" /* apiPoGet */], { po_num: poNum }, Object(__WEBPACK_IMPORTED_MODULE_1__functions_common_vue__["_7" /* authHeader */])()).then(function (res) {
                var data;
                data = res.data.data;

                _this4.poData = data;
                _this4.poData.title = "Purchase Order " + _this4.poData.po_num;

                _this4.countryId = _this4.poData.country_id;
                console.log(_this4.countryId);
                if (_this4.countryId != null) {

                    if (_this4.countryId == 'TH') {
                        _this4.font = 'Garuda';
                    } else if (_this4.countryId == 'KH') {
                        _this4.font = 'Hanumanb';
                    }
                    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__functions_common_vue__["c" /* apiCountryLookup */], { params: { q: _this4.countryId } }).then(function (response) {

                        if (response.data != null) {
                            _this4.list = response.data.data.list;
                            _this4.item = _this4.list[0];
                            _this4.country_name = _this4.item.country_name;
                            _this4.country_name = _this4.country_name.toUpperCase();
                        }
                    });
                }

                _this4.po_status = data.po_status;
                _this4.po_fulfilment_status = data.po_fulfilment_status;
            }).catch(function (error) {
                return alert(error);
            });
        },
        validateValue: function validateValue(obj, index) {
            var ctrl = obj.target.name;
            var row = this.poData.po_items[index];
            var qty = row.qty;
            var unit_price = row.unit_price;
            var amount_total = row.amount_total;
            if (ctrl == 'qty') {

                if (isNaN(qty)) {
                    this.poData.po_items[index].qty = 0;
                }
            } else if (ctrl == 'unit_price') {
                if (isNaN(unit_price)) {
                    this.poData.po_items[index].unit_price = 0;
                }
            } else if (ctrl == 'amount_total') {
                if (isNaN(amount_total)) {
                    this.poData.po_items[index].amount_total = 0;
                }
            }
        },
        computeRow: function computeRow(obj, index) {
            var ctrl = obj.target.name;
            var row = this.poData.po_items[index];

            var qty = row.qty;
            var unit_price = row.unit_price;
            var amount_total = row.amount_total;

            if (ctrl == 'qty') {
                if (!isNaN(unit_price) && !isNaN(amount_total)) {
                    unit_price = unit_price * 1;
                    qty = qty * 1;

                    amount_total = qty * unit_price;

                    if (!isNaN(qty)) this.poData.po_items[index].qty = qty;

                    if (!isNaN(amount_total)) this.poData.po_items[index].amount_total = amount_total.toFixed(2);
                }
            } else if (ctrl == 'unit_price') {
                if (!isNaN(qty) && !isNaN(unit_price)) {
                    unit_price = unit_price * 1;
                    qty = qty * 1;

                    amount_total = qty * unit_price;

                    if (!isNaN(unit_price)) this.poData.po_items[index].unit_price = unit_price.toFixed(2);

                    if (!isNaN(amount_total)) this.poData.po_items[index].amount_total = amount_total.toFixed(2);
                }
            } else if (ctrl == 'amount_total') {
                if (!isNaN(qty) && !isNaN(amount_total)) {
                    amount_total = amount_total * 1;
                    qty = qty * 1;
                    unit_price = amount_total / qty;

                    if (!isNaN(unit_price)) this.poData.po_items[index].unit_price = unit_price.toFixed(2);

                    if (!isNaN(qty)) this.poData.po_items[index].qty = qty;

                    if (!isNaN(amount_total)) this.poData.po_items[index].amount_total = amount_total.toFixed(2);
                }
            }
        },
        setSupplier: function setSupplier(obj) {
            if (!this.lockEntry) {
                if (obj !== null) {
                    this.poData.supplier_id = obj.id;
                    this.poData.po_type = obj.supplier_type;
                    this.poData.po_category = obj.supplier_category;
                    this.poData.currency_id = obj.currency_id;
                    this.poData.tax_percent = obj.gst_percent;
                } else {
                    this.poData.supplier_id = null;
                    this.poData.po_type = null;
                    this.poData.po_category = null;
                    this.poData.currency_id = null;
                    this.poData.tax_percent = 0;
                }
            }
        },
        setWarehouse: function setWarehouse(obj) {
            var _this5 = this;

            if (!this.lockEntry) {
                var id;
                var country_id;

                if (obj !== null) {
                    if (obj.id != this.poData.location_id) {
                        id = obj.id;
                        country_id = obj.country_id;
                        this.poData.po_items = [];
                        this.poData.location_id = id;
                        this.countryId = country_id;
                        if (this.poData.location_id != '') {
                            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.apiProductUrl, { params: { q: '', q2: this.poData.location_id } }).then(function (res) {
                                var list;
                                list = res.data.data.list;
                                _this5.noItemsFound = list.length == 0;
                            }).catch(function (error) {
                                return alert(error);
                            });
                        }
                    }
                } else {
                    id = "";
                    this.noItemsFound = true;
                }
            }
        },
        addRow: function addRow() {
            this.visible = true;
            this.poData.po_items.push({ product_name: '', product_id: '', uom: '', qty: '', unit_price: '', amount_total: '' });
            this.poItemsCount = this.poItemsCount + 1;
        },
        removeRow: function removeRow(index) {
            this.poData.po_items.splice(index, 1);
        },
        setProduct: function setProduct(obj, index) {
            if (!this.lockEntry) {
                var name, sku, uom;
                this.prevWhId = this.poData.location_id;
                if (obj !== null) {
                    name = obj.name;
                    sku = obj.id;
                    uom = obj.uom;
                } else {
                    name = "";
                    sku = "";
                    uom = "";
                }

                this.poData.po_items[index].product_name = name;
                this.poData.po_items[index].product_id = sku;
                this.poData.po_items[index].uom = uom;
            }
        },
        confirmProcessPO: function confirmProcessPO() {
            if (!this.lockEntry) {
                this.confirmMessage = "Saved";
            } else {
                this.confirmMessage = "Approved";
            }
            this.modalShow = true;
        },
        confirmCancel: function confirmCancel() {

            this.confirmMessage = "Cancel";
            this.cancelModalShow = true;
        },
        back: function back() {
            this.$router.push({ name: 'Purchase Orders (POS)' });
        },
        hideModal: function hideModal() {
            this.$refs.myModalRef.hide();
            if (this.$route.params.poNum == '_new') {
                this.$router.push({ name: 'Purchase Orders (POS)' });
            }
        },
        hideErrorModal: function hideErrorModal() {
            this.$refs.myErrorModalRef.hide();
        },
        hideCancelModal: function hideCancelModal() {
            this.$refs.myCancelModalRef.hide();
            this.po_status = "CANCELLED";
        },
        hideApproveModal: function hideApproveModal() {
            this.$refs.myApproveModalRef.hide();
            this.po_status = "APPROVED";
        },
        validateItems: function validateItems() {
            var isValid;
            var item;

            isValid = true;

            if (this.poData.po_items.length > 0) {
                for (var n = 0; n < this.poData.po_items.length; n++) {
                    item = this.poData.po_items[n];
                    if (item.product_id == '' || isNaN(item.qty) || item.qty == '' || isNaN(item.unit_price) || item.unit_price == '' || isNaN(item.amount_total) || item.amount_total == '') {
                        isValid = false;
                        break;
                    } else if (parseInt(item.qty) == 0) {
                        isValid = false;
                        break;
                    }
                }
            } else isValid = false;

            return isValid;
        },
        processPO: function processPO() {
            var _this6 = this;

            if (!this.lockEntry) {
                if (1) {
                    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__functions_common_vue__["x" /* apiPOSave */], this.poData, Object(__WEBPACK_IMPORTED_MODULE_1__functions_common_vue__["_7" /* authHeader */])()).then(function (res) {
                        var r = res.data;

                        if (r.code == 1) {
                            var docName = r.data.po_num;
                            _this6.poDocumentNo = docName;
                            _this6.$refs.myModalRef.show();
                        } else {
                            _this6.errorMessage = r.msg;
                            _this6.$refs.myErrorModalRef.show();
                        }
                    }).catch(function (error) {
                        return alert(error);
                    });
                }
            } else {
                if (this.po_status == "PENDING") {
                    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__functions_common_vue__["u" /* apiPOApprove */], { po_num: this.poData.po_num, approve: 1 }, Object(__WEBPACK_IMPORTED_MODULE_1__functions_common_vue__["_7" /* authHeader */])()).then(function (res) {
                        _this6.hideBtns = false;
                        _this6.$refs.myApproveModalRef.show();
                        _this6.fetchPO(_this6.poRef);
                    }).catch(function (error) {
                        return alert(error);
                    });
                }
            }
        },
        cancel: function cancel() {
            var _this7 = this;

            if (!this.lockEntry) {
                this.$router.push({ name: 'Purchase Orders (POS)' });
                location.reload();
            } else {
                __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__functions_common_vue__["u" /* apiPOApprove */], { po_num: this.poData.po_num, approve: 0 }, Object(__WEBPACK_IMPORTED_MODULE_1__functions_common_vue__["_7" /* authHeader */])()).then(function (res) {
                    _this7.$refs.myCancelModalRef.show();
                }).catch(function (error) {
                    return alert(error);
                });
            }
        }
    }
});

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Spinner_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__functions_common_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_json_excel__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pdfmake_build_pdfmake__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pdfmake_build_pdfmake___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_pdfmake_build_pdfmake__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pdfmake_build_vfs_fonts__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pdfmake_build_vfs_fonts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pdfmake_build_vfs_fonts__);









__WEBPACK_IMPORTED_MODULE_4_pdfmake_build_pdfmake___default.a.vfs = __WEBPACK_IMPORTED_MODULE_5_pdfmake_build_vfs_fonts___default.a.pdfMake.vfs;
__WEBPACK_IMPORTED_MODULE_4_pdfmake_build_pdfmake___default.a.fonts = {
  "ukai": {
    normal: 'ukai.ttf',
    bold: 'ukai.ttf',
    italics: 'ukai.ttf',
    bolditalics: 'ukai.ttf'
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  components: { spinner: __WEBPACK_IMPORTED_MODULE_0__components_Spinner_vue__["a" /* default */], exportExcel: __WEBPACK_IMPORTED_MODULE_3_vue_json_excel__["a" /* default */] },
  props: {
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      apiPoSearch: __WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["B" /* apiPoSearch */],
      loading: false,
      filter: {
        grn_num: '',
        po_num: '',
        date_start: '',
        date_end: '',
        fulfilment_status: ''
      },
      seen: false,
      fulfilment_status: '',
      searchResults: [],
      searchResultsFields: [{ key: 'country_id', label: 'Country', sortable: true }, { key: 'location_name', label: 'Location' }, { key: 'last_grn_num', label: 'Last GRN', sortable: true }, { key: 'last_grn_date', label: 'GRN Date' }, { key: 'po_date', label: 'PO Date' }, { key: 'po_num', label: 'PO No' }, { key: 'supplier_name', label: 'Supplier' }, { key: 'po_type', label: 'Type' }, { key: 'po_fulfilment_status', label: 'Fulfilment Status' }],
      currentPage: 1,
      perPage: 20,
      totalRows: 0,
      noResults: false,
      exportHeaders: {
        'Country': 'country_id',
        'Location': 'location_name',
        'Last GRN': 'last_grn_num',
        'Last GRN Date': 'last_grn_date',
        'PO Date': 'po_date',
        'PO No': 'po_num',
        'Supplier': 'supplier_name',
        'Type': 'po_type',
        'Fulfilment Status': 'po_fulfilment_status'
      }
    };
  },

  methods: {
    print: function print() {
      var rows = [];
      var row = [];
      var date = new Date();
      rows.push(['Country', 'Location', 'Last GRN', 'Last GRN Date', 'PO Date', 'PO No', 'Supplier', 'Type', 'Fulfilment Status']);

      for (var key in this.searchResults) {
        var data = this.searchResults[key];
        row = [data.country_id, data.location_name, data.last_grn_num, data.last_grn_date, data.po_date, data.po_num, data.supplier_name, data.po_type, data.po_fulfilment_status];
        rows.push(row);
      }
      var dd = {
        header: { text: 'Good Receive Note List generated on' + " " + date, margin: [5, 10, 10, 20], alignment: 'center', fontSize: 7 },
        pageSize: 'A4',
        pageOrientation: 'landscape',

        pageMargins: [30, 30, 30, 20],
        defaultStyle: {
          font: 'ukai'
        },
        content: [{
          fontSize: 8,
          layout: 'lightHorizontalLines',

          table: {
            headerRows: 1,
            widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],

            body: rows

          }
        }]
      };

      __WEBPACK_IMPORTED_MODULE_4_pdfmake_build_pdfmake___default.a.createPdf(dd).open();
    },
    createNew: function createNew() {
      localStorage.setItem("grn_new.po_num", "");
      this.$router.push({ name: 'Goods Received Note (GRN)', params: { grnNum: '_new' } });
    },
    rowClick: function rowClick(item, index) {
      localStorage.setItem("grn_new.po_num", item.po_num);
      this.$router.push({ name: 'Goods Received Note (GRN)', params: { grnNum: '_new' } });
    },
    getRowCount: function getRowCount(list) {
      return list.length;
    },
    search: function search() {
      var _this = this;

      this.loading = true;
      this.seen = true;
      var sf = ["grns_list LIKE " + this.filter.grn_num, "po_num LIKE " + this.filter.po_num, "po_date >= " + this.filter.date_start, "po_date <= " + this.filter.date_end, "po_fulfilment_status = " + this.filter.fulfilment_status];

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["B" /* apiPoSearch */], sf).then(function (res) {
        return res;
      }).then(function (data) {
        var resultArray = [];
        var myData = data.data.data.list;
        for (var key in myData) {
          var date = myData[key].po_date;
          var lastGrnDate = myData[key].last_grn_date;
          var lastGrn = myData[key].last_grn_num;
          if (lastGrn == null) {
            lastGrn = '-';
          }
          date = new Date(date);
          var lastGrnDateResult;
          var result = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + (date.getMonth() + 1 > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear();
          if (lastGrnDate != null) {
            lastGrnDate = new Date(lastGrnDate);
            var lastGrnDateResult = "" + (lastGrnDate.getDate() > 9 ? '' : '0') + lastGrnDate.getDate() + '/' + (lastGrnDate.getMonth() + 1 > 9 ? '' : '0') + (lastGrnDate.getMonth() + 1) + '/' + lastGrnDate.getFullYear();
          } else {
            lastGrnDateResult = '-';
          }
          myData[key].po_date = result;
          myData[key].last_grn_date = lastGrnDateResult;
          myData[key].last_grn_num = lastGrn;
          resultArray.push(myData[key]);
          _this.loading = false;
        }
        _this.searchResults = resultArray;

        if (_this.searchResults.length == 0) {
          _this.loading = false;
          _this.noResults = true;
        }
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }
});

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Autocomplete_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__functions_common_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pdfmake_build_vfs_fonts__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pdfmake_build_vfs_fonts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_pdfmake_build_vfs_fonts__);








__WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake___default.a.vfs = __WEBPACK_IMPORTED_MODULE_4_pdfmake_build_vfs_fonts___default.a.pdfMake.vfs;
__WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake___default.a.fonts = {
    "ukai": {
        normal: 'ukai.ttf',
        bold: 'ukai.ttf',
        italics: 'ukai.ttf',
        bolditalics: 'ukai.ttf'
    },
    "Garuda": {
        normal: 'Garuda.ttf',
        bold: 'Garuda.ttf',
        italics: 'Garuda.ttf',
        bolditalics: 'Garuda.ttf'
    },
    "Hanumanb": {
        normal: 'Hanumanb.ttf',
        bold: 'Hanumanb.ttf',
        italics: 'Hanumanb.ttf',
        bolditalics: 'Hanumanb.ttf'
    }
};
/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'grn',
    components: { poLookup: __WEBPACK_IMPORTED_MODULE_1__components_Autocomplete_vue__["a" /* default */] },
    created: function created() {
        var _this = this;

        if (localStorage.getItem("grn_new.po_num") != "") {
            this.isPORetrieved = true;
            var poNum = localStorage.getItem("grn_new.po_num");
            var url = this.poLookupUrl;
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url, { params: { q: poNum, get: 1 } }).then(function (response) {
                _this.list = response.data.data.list;

                if (_this.list.length > 0) {
                    _this.item = _this.list[0];
                    console.log(_this.item);
                    if (_this.item !== null) {
                        var po = _this.item;

                        if (po.country_id != null) {
                            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["c" /* apiCountryLookup */], { params: { q: po.country_id } }).then(function (response) {

                                if (response.data != null) {
                                    _this.list = response.data.data.list;
                                    _this.item = _this.list[0];
                                    _this.country_name = _this.item.country_name;
                                    _this.country_name = _this.country_name.toUpperCase();
                                }
                            });
                        }
                        var curDate = new Date();
                        curDate = curDate.toISOString().substr(0, 10);
                        _this.grn.grn_date = curDate;
                        _this.grn.po = po;
                        _this.grn.po_num = po.po_num;
                        _this.isPORetrieved = true;
                    }
                }
            });
        } else {
            this.isPORetrieved = false;
            this.poNum = '';
        }
    },
    data: function data() {
        return {
            btnDisplay: 'Cancel',
            poNum: '',
            modalMsg: '',
            isPORetrieved: false,
            title: 'New GRN',
            errorMessage: '',
            country_name: '',
            poLookupUrl: __WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["v" /* apiPOLookup */],
            modalShow: false,
            modalCancelShow: false,
            grnDocNo: 'test',
            isValid: true,
            font: 'ukai',
            received_qty: 0,
            existingGrns: [],
            grn: {
                grn_num: '',
                grn_date: '',
                po_num: '',
                remarks: '',
                grn_items: {},
                po: {
                    grns: {}
                }
            }
        };
    },
    methods: {
        printGRN: function printGRN(row) {
            var grn_num = row.grn_num;
            var r = [];
            var grnsItems = [];
            var groTotalAmount = 0;
            r = [{
                text: 'S/No',
                style: 'itemsHeader'
            }, {
                text: 'Product Code',
                style: ['itemsHeader'],
                alignment: 'left'
            }, {
                text: 'Description',
                style: ['itemsHeader'],
                alignment: 'left'
            }, {
                text: 'Qty',
                style: ['itemsHeader'],
                alignment: 'right'
            }];
            grnsItems.push(r);

            var items = row.grn_items;
            for (var key in items) {
                var data = items[key];
                var qty = (data.qty * 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                if (data.product_name == null) {
                    data.product_name = "";
                }
                r = [{
                    text: key * 1 + 1,
                    style: 'itemText'
                }, {
                    text: data.product_id,
                    style: 'itemText'
                }, {
                    text: data.product_name,
                    style: 'itemText'
                }, {
                    text: qty,
                    style: 'itemNumber'
                }];
                grnsItems.push(r);
            }

            var ddHeader = {
                columns: [[{
                    text: 'ELKEN ' + this.country_name + ' GOODS RECEIVED NOTE',
                    style: 'invoiceTitle',
                    width: '*'
                }, {
                    stack: [{
                        columns: [{
                            text: 'GRN #',
                            style: 'invoiceSubTitle',
                            width: 95

                        }, {
                            text: grn_num,
                            style: 'invoiceSubValue',
                            width: 100
                        }]
                    }, {
                        text: ' '
                    }, {
                        columns: [{
                            text: 'GRN Date',
                            style: 'invoiceSubTitle',
                            width: 95

                        }, {
                            text: row.grn_date_friendly,
                            style: 'invoiceSubValue',
                            width: 100
                        }]

                    }, {
                        text: ' '
                    }, {
                        columns: [{
                            text: 'Reference PO #',
                            style: 'invoiceSubTitle',
                            width: 95

                        }, {
                            text: row.po_num,
                            style: 'invoiceSubValue'
                        }]

                    }]
                }]]
            };

            var dd = {
                header: function header(pageNumber, pageCount) {
                    return {
                        margin: [0, 10, 0, 0],
                        columns: [{
                            text: '',
                            style: 'documentHeaderLeft'
                        }, {
                            text: grn_num,
                            style: 'documentHeaderCenter'
                        }, {
                            text: '',
                            style: 'documentHeaderRight'
                        }]
                    };
                },
                footer: function footer(pageNumber, pageCount) {
                    return {
                        margin: [0, 0, 0, 50],
                        columns: [{
                            text: '',
                            style: 'documentFooterLeft'
                        }, {
                            text: 'Page ' + pageNumber + " of " + pageCount,
                            style: 'documentFooterCenter'
                        }, {
                            text: '',
                            style: 'documentFooterRight'
                        }]
                    };
                },
                content: [ddHeader, '\n\n', {
                    layout: 'lightHorizontalLines',
                    table: {

                        headerRows: 1,
                        widths: [25, 68, '*', 45, 45],
                        body: grnsItems

                    } }, {
                    text: 'Remarks',
                    style: 'notesTitle'
                }, {
                    text: row.remarks,
                    style: 'notesText'
                }, {
                    columns: [{
                        stack: [{
                            text: 'Received By',
                            style: 'signaturePlaceholder'
                        }, {
                            text: '______________________________',
                            style: 'signaturePlaceholder'
                        }, {
                            text: 'Name  :',
                            style: 'signatureName'

                        }, {
                            text: 'Date  :',
                            style: 'signatureJobTitle'

                        }],
                        width: 160
                    }]
                }],
                styles: {
                    documentHeaderLeft: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'left'
                    },
                    documentHeaderCenter: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'center'
                    },
                    documentHeaderRight: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'right'
                    },

                    documentFooterLeft: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'left'
                    },
                    documentFooterCenter: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'center'
                    },
                    documentFooterRight: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'right'
                    },

                    invoiceTitle: {
                        fontSize: 22,
                        bold: true,
                        alignment: 'left',
                        margin: [0, 0, 0, 15]
                    },

                    invoiceSubTitle: {
                        fontSize: 10,
                        alignment: 'left'
                    },
                    invoiceSubValue: {
                        fontSize: 10,
                        alignment: 'left'
                    },

                    invoiceBillingTitle: {
                        fontSize: 14,
                        bold: true,
                        alignment: 'left',
                        margin: [0, 20, 0, 5]
                    },

                    invoiceBillingDetails: {
                        alignment: 'left'

                    },
                    invoiceBillingAddressTitle: {
                        margin: [0, 7, 0, 3],
                        bold: true
                    },
                    invoiceBillingAddress: {},

                    itemsHeader: {

                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        bold: true
                    },

                    itemTitle: {
                        bold: true
                    },
                    itemSubTitle: {
                        fontSize: 10
                    },
                    itemText: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        alignment: 'left'
                    },
                    itemNumber: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        alignment: 'right'
                    },
                    itemTotal: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right'
                    },

                    itemsFooterSubTitle: {
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right'
                    },
                    itemsFooterSubValue: {
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'center'
                    },
                    itemsFooterTotalTitle: {
                        fontSize: 11,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right'
                    },
                    itemsFooterTotalValue: {
                        fontSize: 11,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'center'
                    },
                    signaturePlaceholder: {
                        fontSize: 10,
                        margin: [0, 70, 0, 0]
                    },
                    signatureName: {
                        fontSize: 10,
                        margin: [0, 10, 0, 0],
                        bold: true,
                        alignment: 'left'
                    },
                    signatureJobTitle: {
                        fontSize: 10,
                        margin: [0, 20, 0, 0],
                        bold: true,
                        alignment: 'left'
                    },
                    notesTitle: {
                        fontSize: 10,
                        bold: true,
                        margin: [0, 30, 0, 3]
                    },
                    notesText: {
                        fontSize: 10
                    },
                    center: {
                        alignment: 'center'
                    }
                },
                defaultStyle: {
                    columnGap: 20,
                    font: this.font
                }
            };
            __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake___default.a.createPdf(dd).open();
        },
        print: function print() {
            var poNum = this.grn.po_num;
            var row = [];
            var date = new Date(this.grn.po.po_date);
            var poDate = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + (date.getMonth() + 1 > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear();
            var poItems = [];
            var deliveryDate = '-';
            if (this.grn.po.po_date_eta != null) {
                var d = new Date(this.grn.po.po_date_eta);
                deliveryDate = "" + (d.getDate() > 9 ? '' : '0') + d.getDate() + '/' + (d.getMonth() + 1 > 9 ? '' : '0') + (d.getMonth() + 1) + '/' + d.getFullYear();
            }
            row = [{
                text: 'S/No',
                style: 'itemsHeader'
            }, {
                text: 'Product Code',
                style: ['itemsHeader'],
                alignment: 'left'
            }, {
                text: 'Description',
                style: ['itemsHeader'],
                alignment: 'left'
            }, {
                text: 'PO Qty',
                style: ['itemsHeader'],
                alignment: 'right'
            }, {
                text: 'Received Qty',
                style: ['itemsHeader'],
                alignment: 'right'
            }];
            poItems.push(row);
            var items = this.grn.po.po_items;
            for (var key in items) {
                var data = items[key];
                var qty = (data.qty * 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                var qty_received = (data.qty_received * 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                if (data.product_name == null) {
                    data.product_name = "";
                }
                row = [{
                    text: key * 1 + 1,
                    style: 'itemText'
                }, {
                    text: data.product_id,
                    style: 'itemText'
                }, {
                    text: data.product_name,
                    style: 'itemText'
                }, {
                    text: qty,
                    style: 'itemNumber'
                }, {
                    text: qty_received,
                    style: 'itemNumber'
                }];
                poItems.push(row);
            }
            var grnItems = [];
            var grnRow = [];
            grnRow = [{
                text: 'S/No',
                style: 'itemsHeader'
            }, {
                text: 'GRN #',
                style: ['itemsHeader'],
                alignment: 'left'
            }, {
                text: 'GRN Date',
                style: ['itemsHeader'],
                alignment: 'left'
            }, {
                text: 'Generated By',
                style: ['itemsHeader'],
                alignment: 'left'
            }];
            grnItems.push(grnRow);
            var grns = this.grn.po.grns;
            for (var _key in grns) {
                var gd = grns[_key];
                grnRow = [{
                    text: _key * 1 + 1,
                    style: 'itemText'
                }, {
                    text: gd.grn_num,
                    style: 'itemText'
                }, {
                    text: gd.grn_date_friendly,
                    style: 'itemText'
                }, {
                    text: gd.author_user_shortname,
                    style: 'itemText'
                }];
                grnItems.push(grnRow);
            }

            var ddHeader = {
                columns: [[{
                    text: 'ELKEN ' + this.country_name + ' GOODS RECEIVED NOTE',
                    style: 'invoiceTitle',
                    width: '*'
                }, {
                    stack: [{
                        columns: [{
                            text: 'PO #',
                            style: 'invoiceSubTitle',
                            width: 90

                        }, {
                            text: poNum,
                            style: 'invoiceSubValue',
                            width: 130
                        }, { text: '', style: 'invoiceSubValue', width: 80 }, {
                            text: 'PO Date',
                            style: 'invoiceSubTitle',
                            width: 90

                        }, {
                            text: poDate,
                            style: 'invoiceSubValue',
                            width: 130

                        }]
                    }, {
                        columns: [{
                            text: 'Supplier',
                            style: 'invoiceSubTitle',
                            width: 90

                        }, {
                            text: this.grn.po.supplier_full,
                            style: 'invoiceSubValue',
                            width: 130
                        }, { text: '', style: 'invoiceSubValue', width: 80 }, {
                            text: 'PO Type',
                            style: 'invoiceSubTitle',
                            width: 90

                        }, {
                            text: this.grn.po.po_type,
                            style: 'invoiceSubValue',
                            width: 130
                        }]

                    }, {
                        columns: [{
                            text: 'Stock Location',
                            style: 'invoiceSubTitle',
                            width: 90

                        }, {
                            text: this.grn.po.location_full,
                            style: 'invoiceSubValue',
                            width: 130
                        }, { text: '', style: 'invoiceSubValue', width: 80 }, {
                            text: 'Delivery Date',
                            style: 'invoiceSubTitle',
                            width: 90
                        }, {
                            text: '-',
                            style: 'invoiceSubValue',
                            width: 130
                        }]

                    }, {
                        columns: [{
                            text: 'PO Status',
                            style: 'invoiceSubTitle',
                            width: 90

                        }, {
                            text: this.grn.po.po_status,
                            style: 'invoiceSubValue',
                            width: 130
                        }, { text: '', style: 'invoiceSubValue', width: 80 }, {
                            text: 'Fulfilment Status',
                            style: 'invoiceSubTitle',
                            width: 90

                        }, {
                            text: this.grn.po.po_fulfilment_status,
                            style: 'invoiceSubValue',
                            width: 130

                        }]

                    }]
                }]]
            };

            var dd = {
                header: function header(pageNumber, pageCount) {
                    return {
                        margin: [0, 10, 0, 0],
                        columns: [{
                            text: '',
                            style: 'documentHeaderLeft'
                        }, {
                            text: poNum,
                            style: 'documentHeaderCenter'
                        }, {
                            text: '',
                            style: 'documentHeaderRight'
                        }]
                    };
                },
                footer: function footer(pageNumber, pageCount) {
                    return {
                        margin: [0, 0, 0, 50],
                        columns: [{
                            text: '',
                            style: 'documentFooterLeft'
                        }, {
                            text: 'Page ' + pageNumber + " of " + pageCount,
                            style: 'documentFooterCenter'
                        }, {
                            text: '',
                            style: 'documentFooterRight'
                        }]
                    };
                },
                content: [ddHeader, {
                    text: 'GRN Lists',
                    style: 'notesTitle'
                }, {
                    table: {
                        headerRows: 0,
                        widths: [25, 'auto', 80, 'auto'],
                        body: grnItems
                    },
                    layout: 'lightHorizontalLines'
                }, '\n\n', {
                    layout: 'lightHorizontalLines',
                    table: {

                        headerRows: 1,
                        widths: [25, 68, '*', 65, 65],
                        body: poItems

                    } }, {
                    text: 'PO Remarks',
                    style: 'notesTitle'
                }, {
                    text: this.grn.po.remarks,
                    style: 'notesText'
                }],
                styles: {
                    documentHeaderLeft: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'left'
                    },
                    documentHeaderCenter: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'center'
                    },
                    documentHeaderRight: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'right'
                    },

                    documentFooterLeft: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'left'
                    },
                    documentFooterCenter: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'center'
                    },
                    documentFooterRight: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'right'
                    },

                    invoiceTitle: {
                        fontSize: 22,
                        bold: true,
                        alignment: 'left',
                        margin: [0, 0, 0, 15]
                    },

                    invoiceSubTitle: {
                        fontSize: 10,
                        alignment: 'left'
                    },
                    invoiceSubValue: {
                        fontSize: 10,
                        alignment: 'left'
                    },

                    invoiceBillingTitle: {
                        fontSize: 14,
                        bold: true,
                        alignment: 'left',
                        margin: [0, 20, 0, 5]
                    },

                    invoiceBillingDetails: {
                        alignment: 'left'

                    },
                    invoiceBillingAddressTitle: {
                        margin: [0, 7, 0, 3],
                        bold: true
                    },
                    invoiceBillingAddress: {},

                    itemsHeader: {

                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        bold: true
                    },

                    itemTitle: {
                        bold: true
                    },
                    itemSubTitle: {
                        fontSize: 10
                    },
                    itemText: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        alignment: 'left'
                    },
                    itemNumber: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        alignment: 'right'
                    },
                    itemTotal: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right'
                    },

                    itemsFooterSubTitle: {
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right'
                    },
                    itemsFooterSubValue: {
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'center'
                    },
                    itemsFooterTotalTitle: {
                        fontSize: 11,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right'
                    },
                    itemsFooterTotalValue: {
                        fontSize: 11,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'center'
                    },
                    signaturePlaceholder: {
                        fontSize: 10,
                        margin: [0, 70, 0, 0]
                    },
                    signatureName: {
                        fontSize: 10,
                        margin: [0, 10, 0, 0],
                        bold: true,
                        alignment: 'left'
                    },
                    signatureJobTitle: {
                        fontSize: 10,
                        margin: [0, 20, 0, 0],
                        bold: true,
                        alignment: 'left'
                    },
                    notesTitle: {
                        fontSize: 10,
                        bold: true,
                        margin: [0, 30, 0, 3]
                    },
                    notesText: {
                        fontSize: 10
                    },
                    center: {
                        alignment: 'center'
                    }
                },
                defaultStyle: {
                    columnGap: 20,
                    font: this.font
                }
            };
            __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake___default.a.createPdf(dd).open();
        },
        retrievePO: function retrievePO() {
            if (this.grn.po_num != '') {
                this.isPORetrieved = true;
            }
        },
        cancelGrn: function cancelGrn() {
            this.grn.po_num = "";
            this.isPORetrieved = false;
        },
        setPoId: function setPoId(obj) {
            var _this2 = this;

            if (obj !== null) {
                var curDate = new Date();
                curDate = curDate.toISOString().substr(0, 10);
                this.grn.grn_date = curDate;
                this.grn.po = obj;
                if (obj.country_id != null) {
                    if (obj.country_id == 'TH') {
                        this.font = 'Garuda';
                    } else if (obj.country_id == 'KH') {
                        this.font = 'Hanumanb';
                    }

                    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["c" /* apiCountryLookup */], { params: { q: obj.country_id } }).then(function (response) {

                        if (response.data != null) {
                            _this2.list = response.data.data.list;
                            _this2.item = _this2.list[0];

                            _this2.country_name = _this2.item.country_name;
                            _this2.country_name = _this2.country_name.toUpperCase();
                        }
                    });
                }
                this.grn.po_num = obj.po_num;
            } else {
                this.grn.po_num = null;
            }
        },
        confirmSave: function confirmSave() {
            this.modalShow = true;
        },
        confirmCancel: function confirmCancel() {
            this.modalCancelShow = true;
        },
        hideModal: function hideModal() {
            this.$refs.myModalRef.hide();
            this.$router.push({ name: 'Goods Receive Note (GRN) With PO' });
        },
        hideErrorModal: function hideErrorModal() {
            this.$refs.myErrorModalRef.hide();
        },
        save: function save() {
            var _this3 = this;

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["g" /* apiGRNSave */], this.grn, Object(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["_7" /* authHeader */])()).then(function (res) {
                var r = res.data;

                if (r.code == 1) {
                    _this3.grnDocNo = r.data.grn_num;
                    _this3.$refs.myModalRef.show();
                } else {
                    _this3.errorMessage = r.msg;
                    _this3.$refs.myErrorModalRef.show();
                }
            }).catch(function (error) {
                return alert(error);
            });
        },
        cancel: function cancel() {
            this.$router.push({ name: 'Goods Receive Note (GRN) With PO' });
        },
        back: function back() {
            this.$router.push({ name: 'Goods Receive Note (GRN) With PO' });
        }
    }
});

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__functions_common_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Autocomplete_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_json_excel__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pdfmake_build_vfs_fonts__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pdfmake_build_vfs_fonts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_pdfmake_build_vfs_fonts__);












__WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake___default.a.vfs = __WEBPACK_IMPORTED_MODULE_7_pdfmake_build_vfs_fonts___default.a.pdfMake.vfs;
__WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake___default.a.fonts = {
  "ukai": {
    normal: 'ukai.ttf',
    bold: 'ukai.ttf',
    italics: 'ukai.ttf',
    bolditalics: 'ukai.ttf'
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  components: { spinner: __WEBPACK_IMPORTED_MODULE_1__components_Spinner_vue__["a" /* default */], countryLookup: __WEBPACK_IMPORTED_MODULE_3__components_Autocomplete_vue__["a" /* default */], exportExcel: __WEBPACK_IMPORTED_MODULE_5_vue_json_excel__["a" /* default */] },
  props: {
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
      loading: false,
      seen: false,
      searchResults: [],
      apiCountryLookup: __WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["c" /* apiCountryLookup */],
      noResults: false,
      filter: {
        gri_num: '',
        country_id: '',
        date_start: '',
        date_end: ''
      },
      exportHeaders: {
        'Country': 'country_id',
        'Location': 'location_id',
        'Date': 'gri_date',
        'GRI No': 'gri_num',
        'Supplier': 'supplier_name',
        'Remarks': 'remarks',
        'Created By': 'user_shortname'
      },
      searchResultsFields: [{ key: 'country_id', label: 'Country' }, { key: 'location_id', label: 'Location' }, { key: 'gri_date', label: 'Date' }, { key: 'gri_num', label: 'GRI No' }, { key: 'supplier_name', label: 'Supplier' }, { key: 'remarks', label: 'Remarks' }, { key: 'user_shortname', label: 'Created By' }],
      currentPage: 1,
      perPage: 20,
      totalRows: 0
    }, 'noResults', false);
  },

  methods: {
    print: function print() {
      var rows = [];
      var row = [];
      var date = new Date();
      rows.push(['Country', 'Location', 'Date', 'GRI No', 'Supplier', 'Remarks', 'Created By']);

      for (var key in this.searchResults) {
        var data = this.searchResults[key];
        row = [data.country_id, data.location_id, data.gri_date, data.gri_num, data.supplier_name, data.remarks, data.user_shortname];
        rows.push(row);
      }
      var dd = {
        header: { text: 'Goods Return Inwards List generated on' + " " + date, margin: [5, 10, 10, 20], alignment: 'center', fontSize: 8 },
        pageSize: 'A4',
        pageOrientation: 'portrait',

        pageMargins: [30, 30, 30, 20],
        defaultStyle: {
          font: 'ukai'
        },
        content: [{
          fontSize: 8,
          layout: 'lightHorizontalLines',
          table: {
            headerRows: 1,
            widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],

            body: rows

          }
        }]
      };

      __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake___default.a.createPdf(dd).open();
    },
    getRowCount: function getRowCount(list) {
      return list.length;
    },
    rowClick: function rowClick(item, index) {
      this.$router.push({ name: 'Goods Return Inwards Entry (GRI)', params: { griNum: item.gri_num } });
    },
    newGri: function newGri() {
      this.$router.push({ name: 'Goods Return Inwards Entry (GRI)', params: { griNum: '_new' } });
    },
    search: function search() {
      var _this = this;

      this.loading = true;
      this.seen = true;
      var sf = ["gri_num LIKE " + this.filter.gri_num, "country_id = " + this.filter.country_id, "gri_date >= " + this.filter.date_start, "gri_date <= " + this.filter.date_end];
      if (1) {
        __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["n" /* apiGriSearch */], sf, Object(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["_7" /* authHeader */])()).then(function (res) {
          return res;
        }).then(function (data) {
          var resultArray = [];
          var myData = data.data.data.list;
          for (var key in myData) {
            var date = myData[key].gri_date;
            var date = new Date(date);
            var result = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + (date.getMonth() + 1 > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear();
            myData[key].gri_date = result;
            resultArray.push(myData[key]);
            _this.loading = false;
          }
          _this.searchResults = resultArray;

          if (_this.searchResults.length == 0) {
            _this.loading = false;
            _this.noResults = true;
          }
        }).catch(function (error) {
          return console.log(error);
        });
      }
    },
    setCountry: function setCountry(obj) {
      var id;
      if (obj !== null) {
        id = obj.id;
      } else {
        id = null;
      }
      this.filter.country_id = id;
    }
  }
});

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Autocomplete_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__functions_common_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pdfmake_build_vfs_fonts__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pdfmake_build_vfs_fonts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_pdfmake_build_vfs_fonts__);









__WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake___default.a.vfs = __WEBPACK_IMPORTED_MODULE_4_pdfmake_build_vfs_fonts___default.a.pdfMake.vfs;
__WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake___default.a.fonts = {
    "ukai": {
        normal: 'ukai.ttf',
        bold: 'ukai.ttf',
        italics: 'ukai.ttf',
        bolditalics: 'ukai.ttf'
    },
    "Garuda": {
        normal: 'Garuda.ttf',
        bold: 'Garuda.ttf',
        italics: 'Garuda.ttf',
        bolditalics: 'Garuda.ttf'
    },
    "Hanumanb": {
        normal: 'Hanumanb.ttf',
        bold: 'Hanumanb.ttf',
        italics: 'Hanumanb.ttf',
        bolditalics: 'Hanumanb.ttf'
    }
};
/* harmony default export */ __webpack_exports__["a"] = ({
    components: { supplierLookup: __WEBPACK_IMPORTED_MODULE_1__components_Autocomplete_vue__["a" /* default */], warehouseLookup: __WEBPACK_IMPORTED_MODULE_1__components_Autocomplete_vue__["a" /* default */], productLookup: __WEBPACK_IMPORTED_MODULE_1__components_Autocomplete_vue__["a" /* default */] },
    created: function created() {
        this.gri_ref = this.$route.params.griNum;
        if (this.gri_ref == '_new') {
            var curDate = new Date();
            curDate = curDate.toISOString().substr(0, 10);
            this.gri.gri_date = curDate;
            this.noItemsFound = true;
        } else {
            this.lockEntry = true;
            this.fetch(this.gri_ref);
            this.noItemsFound = false;
        }
    },

    data: function data() {
        return {
            title: 'New GRI',
            apiSupplierUrl: __WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["U" /* apiSupplierLookup */],
            apiWarehouseUrl: __WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["V" /* apiWarehouseLookup */],
            apiLocationProductUrl: __WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["q" /* apiLocationProductUrl */],
            gri_ref: '',
            modalShow: false,
            country_name: '',
            modalCancelShow: false,
            hideBtn: true,
            prevWhId: '',
            noItemsFound: true,
            font: 'ukai',
            lockEntry: false,
            griDocNo: 'test',
            errorMessage: '',
            gri: {
                gri_date: '',
                reference_num: '',
                supplier_id: '',
                location_id: '',
                remarks: '',
                currency_id: '',
                gri_items: [{ product_name: '', product_id: '', qty_soh: '', qty: '', unit_gmp: '', amount_total: '' }]
            }
        };
    },
    methods: {
        print: function print() {
            console.log(this.gri);
            var gri_num = this.gri.gri_num;
            var row = [];
            var date = new Date(this.gri.gri_date);
            var griDate = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + (date.getMonth() + 1 > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear();
            var griItems = [];
            var griTotalAmount = 0;
            var supplier = '-';
            var currency = '-';
            if (this.gri.currency_id != null) {
                currency = this.gri.currency_id;
            }
            if (this.gri.supplier_name != null && this.gri.supplier_id != null) {
                supplier = this.gri.supplier_name + ' (' + this.gri.supplier_id + ')';
            }

            row = [{
                text: 'S/No',
                style: 'itemsHeader'
            }, {
                text: 'Product Code',
                style: ['itemsHeader'],
                alignment: 'left'
            }, {
                text: 'Description',
                style: ['itemsHeader'],
                alignment: 'left'
            }, {
                text: 'SOH',
                style: ['itemsHeader'],
                alignment: 'left'
            }, {
                text: 'Unit GMP',
                style: ['itemsHeader'],
                alignment: 'left'
            }, {
                text: 'Receive Qty',
                style: ['itemsHeader'],
                alignment: 'right'
            }, {
                text: 'Amount',
                style: ['itemsHeader'],
                alignment: 'right'
            }];
            griItems.push(row);
            var items = this.gri.gri_items;
            for (var key in items) {
                var data = items[key];
                griTotalAmount = griTotalAmount + data.amount_total * 1;
                var soh = (data.qty_soh * 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                var unit_gmp = '';
                if (data.unit_gmp != null) {
                    unit_gmp = (data.unit_gmp * 1).toFixed(2);
                    unit_gmp = data.unit_gmp.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                }

                var amount_total = (data.amount_total * 1).toFixed(2);
                amount_total = data.amount_total;
                var totalAmount = data.amount_total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                console.log(data.product_name);
                var qty = (data.qty * 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                if (data.product_name == null) {
                    data.product_name = "";
                }
                row = [{
                    text: key * 1 + 1,
                    style: 'itemText'
                }, {
                    text: data.product_id,
                    style: 'itemText'
                }, {
                    text: data.product_name,
                    style: 'itemText'
                }, {
                    text: soh,
                    style: 'itemText'
                }, {
                    text: unit_gmp,
                    style: 'itemText'
                }, {
                    text: qty,
                    style: 'itemNumber'
                }, {
                    text: totalAmount,
                    style: 'itemTotal'
                }];
                griItems.push(row);
            }
            griTotalAmount = griTotalAmount.toFixed(2);
            griTotalAmount = griTotalAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

            var ddHeader = {
                columns: [[{
                    text: 'ELKEN ' + this.country_name + ' GOODS RETURN INWARDS',
                    style: 'invoiceTitle',
                    width: '*'
                }, {
                    stack: [{
                        columns: [{
                            text: 'GRI #',
                            style: 'invoiceSubTitle',
                            width: 90

                        }, {
                            text: gri_num,
                            style: 'invoiceSubValue',
                            width: 100

                        }]
                    }, {
                        text: ' '
                    }, {
                        columns: [{
                            text: 'GRI Date',
                            style: 'invoiceSubTitle',
                            width: 90

                        }, {
                            text: griDate,
                            style: 'invoiceSubValue',
                            width: 100

                        }]

                    }, {
                        text: ' '
                    }, {
                        columns: [{
                            text: 'Supplier',
                            style: 'invoiceSubTitle',
                            width: 90

                        }, {
                            text: supplier,
                            style: 'invoiceSubValue'
                        }]

                    }, {
                        text: ' '
                    }, {
                        columns: [{
                            text: 'Stock Location',
                            style: 'invoiceSubTitle',
                            width: 90

                        }, {
                            text: this.gri.location_id,
                            style: 'invoiceSubValue'
                        }]
                    }, {
                        text: ' '
                    }, {
                        columns: [{
                            text: 'Reference #',
                            style: 'invoiceSubTitle',
                            width: 90

                        }, {
                            text: this.gri.reference_num,
                            style: 'invoiceSubValue',
                            width: 100

                        }]
                    }, {
                        text: ' '
                    }, {
                        columns: [{
                            text: 'Currency',
                            style: 'invoiceSubTitle',
                            width: 90

                        }, {
                            text: currency,
                            style: 'invoiceSubValue',
                            width: 100

                        }]
                    }]
                }]]
            };

            var dd = {
                header: function header(pageNumber, pageCount) {
                    return {
                        margin: [0, 10, 0, 0],
                        columns: [{
                            text: '',
                            style: 'documentHeaderLeft'
                        }, {
                            text: gri_num,
                            style: 'documentHeaderCenter'
                        }, {
                            text: '',
                            style: 'documentHeaderRight'
                        }]
                    };
                },
                footer: function footer(pageNumber, pageCount) {
                    return {
                        margin: [0, 0, 0, 50],
                        columns: [{
                            text: '',
                            style: 'documentFooterLeft'
                        }, {
                            text: 'Page ' + pageNumber + " of " + pageCount,
                            style: 'documentFooterCenter'
                        }, {
                            text: '',
                            style: 'documentFooterRight'
                        }]
                    };
                },
                content: [ddHeader, '\n\n', {
                    layout: 'lightHorizontalLines',
                    table: {

                        headerRows: 1,
                        widths: [25, 68, '*', 45, 45, 38, 55],
                        body: griItems

                    } }, {
                    table: {
                        headerRows: 0,
                        widths: ['*', 80],
                        body: [[{
                            text: 'TOTAL ($)',
                            style: 'itemsFooterTotalTitle',
                            alignment: 'right'

                        }, {
                            text: griTotalAmount,
                            style: 'itemsFooterTotalValue',
                            alignment: 'right'
                        }]]
                    },
                    layout: 'lightHorizontalLines'
                }, {
                    text: 'Remarks',
                    style: 'notesTitle'
                }, {
                    text: this.gri.remarks,
                    style: 'notesText'
                }, {
                    columns: [{
                        stack: [{
                            text: 'Issued By',
                            style: 'signaturePlaceholder'
                        }, {
                            text: '______________________________',
                            style: 'signaturePlaceholder'
                        }, {
                            text: 'Name  : ' + this.gri.user_shortname,
                            style: 'signatureName'

                        }, {
                            text: 'Date  : ' + griDate,
                            style: 'signatureJobTitle'

                        }],
                        width: 160
                    }, {
                        stack: [{
                            text: '  ',
                            style: 'signaturePlaceholder'
                        }, {
                            text: '                      ',
                            style: 'signaturePlaceholder'
                        }, {
                            text: '  ',
                            style: 'signatureName'

                        }, {
                            text: '      ',
                            style: 'signatureJobTitle'

                        }],
                        width: 180
                    }, {
                        stack: [{
                            text: 'Received By',
                            style: 'signaturePlaceholder'
                        }, {
                            text: '______________________________',
                            style: 'signaturePlaceholder'
                        }, {
                            text: 'Name  :',
                            style: 'signatureName'

                        }, {
                            text: 'Date  :',
                            style: 'signatureJobTitle'

                        }],
                        width: 160
                    }]
                }],
                styles: {
                    documentHeaderLeft: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'left'
                    },
                    documentHeaderCenter: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'center'
                    },
                    documentHeaderRight: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'right'
                    },

                    documentFooterLeft: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'left'
                    },
                    documentFooterCenter: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'center'
                    },
                    documentFooterRight: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'right'
                    },

                    invoiceTitle: {
                        fontSize: 22,
                        bold: true,
                        alignment: 'left',
                        margin: [0, 0, 0, 15]
                    },

                    invoiceSubTitle: {
                        fontSize: 10,
                        alignment: 'left'
                    },
                    invoiceSubValue: {
                        fontSize: 10,
                        alignment: 'left'
                    },

                    invoiceBillingTitle: {
                        fontSize: 14,
                        bold: true,
                        alignment: 'left',
                        margin: [0, 20, 0, 5]
                    },

                    invoiceBillingDetails: {
                        alignment: 'left'

                    },
                    invoiceBillingAddressTitle: {
                        margin: [0, 7, 0, 3],
                        bold: true
                    },
                    invoiceBillingAddress: {},

                    itemsHeader: {

                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        bold: true
                    },

                    itemTitle: {
                        bold: true
                    },
                    itemSubTitle: {
                        fontSize: 10
                    },
                    itemText: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        alignment: 'left'
                    },
                    itemNumber: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        alignment: 'right'
                    },
                    itemTotal: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right'
                    },

                    itemsFooterSubTitle: {
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right'
                    },
                    itemsFooterSubValue: {
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'center'
                    },
                    itemsFooterTotalTitle: {
                        fontSize: 11,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right'
                    },
                    itemsFooterTotalValue: {
                        fontSize: 11,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'center'
                    },
                    signaturePlaceholder: {
                        fontSize: 10,
                        margin: [0, 70, 0, 0]
                    },
                    signatureName: {
                        fontSize: 10,
                        margin: [0, 10, 0, 0],
                        bold: true,
                        alignment: 'left'
                    },
                    signatureJobTitle: {
                        fontSize: 10,
                        margin: [0, 20, 0, 0],
                        bold: true,
                        alignment: 'left'
                    },
                    notesTitle: {
                        fontSize: 10,
                        bold: true,
                        margin: [0, 30, 0, 3]
                    },
                    notesText: {
                        fontSize: 10
                    },
                    center: {
                        alignment: 'center'
                    }
                },
                defaultStyle: {
                    columnGap: 20,
                    font: this.font
                }
            };
            __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake___default.a.createPdf(dd).open();
        },
        addRow: function addRow() {
            this.gri.gri_items.push({ product_id: '', product_name: '', qty_soh: '', qty: '', unit_gmp: '', amount_total: '' });
        },
        removeRow: function removeRow(index) {
            this.gri.gri_items.splice(index, 1);
        },
        setSupplier: function setSupplier(obj) {
            if (!this.lockEntry) {
                if (obj !== null) {
                    this.gri.supplier_id = obj.id;
                    this.gri.currency_id = obj.currency_id;
                } else {
                    this.gri.supplier_id = null;
                    this.gri.currency_id = null;
                }
            }
        },
        setWarehouse: function setWarehouse(obj) {
            var _this = this;

            if (!this.lockEntry) {
                var id;
                var country_id;

                if (obj !== null) {
                    if (obj.id != this.gri.location_id) {
                        id = obj.id;
                        country_id = obj.country_id;
                        this.gri.gri_items = [];
                        this.gri.location_id = id;
                        this.countryId = country_id;
                        if (this.gri.location_id != '') {
                            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.apiLocationProductUrl, { params: { q: '', q2: id } }).then(function (res) {
                                var list;
                                list = res.data.data.list;
                                _this.noItemsFound = list.length == 0;
                            }).catch(function (error) {
                                return alert(error);
                            });
                        }
                    }
                } else {
                    id = "";
                    this.noItemsFound = true;
                }
            }
        },
        validateQty: function validateQty(index) {
            if (!this.lockEntry) {
                var item = this.gri.gri_items[index];
                if (!isNaN(item.qty)) {
                    if (item.qty < 0) {
                        item.qty = 0;
                    } else if (item.qty * 1 > item.qty_soh * 1) {
                        item.qty = 0;
                    }
                } else {
                    item.qty = 0;
                }
            }
        },
        setProduct: function setProduct(obj, index) {
            console.log(obj.id);
            if (!this.lockEntry) {
                this.prevWhId = this.gri.location_id;

                if (obj != []) {
                    var name, id, qty_soh, unit_gmp;

                    var isDuplicatedEntry = false;
                    var items = this.gri.gri_items;

                    for (var n = 0; n < items.length; n++) {
                        if (n != index) {
                            if (items[n].product_id == items[index].product_id && items[index].product_id != "") {
                                isDuplicatedEntry = true;
                            }

                            if (isDuplicatedEntry) break;
                        }
                    }
                    if (!isDuplicatedEntry) {
                        if (obj !== null) {
                            if (obj.id == "") {
                                qty_soh = "";
                                unit_gmp = "";
                            } else {
                                name = obj.name;
                                id = obj.id;
                                qty_soh = obj.qty_soh;
                                unit_gmp = obj.unit_gmp;
                            }
                        } else {
                            name = "";
                            id = "";
                            qty_soh = "";
                            unit_gmp = "";
                        }

                        if (isNaN(qty_soh)) qty_soh = "";
                    } else {
                        name = "";
                        id = "";
                        qty_soh = "";
                        unit_gmp = "";
                    }

                    this.gri.gri_items[index].product_id = id;
                    this.gri.gri_items[index].product_name = name;
                    this.gri.gri_items[index].qty_soh = qty_soh;

                    this.gri.gri_items[index].unit_gmp = unit_gmp;
                    this.gri.gri_items[index].qty = 0;
                }
            }
        },
        hideModal: function hideModal() {
            this.$refs.myModalRef.hide();
            this.$router.push({ name: 'Goods Return Inwards (GRIS)' });
        },
        closeGri: function closeGri() {
            this.modalCancelShow = true;
        },
        hideErrorModal: function hideErrorModal() {
            this.$refs.myErrorModalRef.hide();
        },
        fetch: function fetch(griNum) {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["l" /* apiGriGet */], { gri_num: griNum }, Object(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["_7" /* authHeader */])()).then(function (res) {
                var data;
                data = res.data.data;
                _this2.gri = data;
                if (_this2.gri.country_id != null) {
                    if (_this2.gri.country_id == 'TH') {
                        _this2.font = 'Garuda';
                    } else if (_this2.gri.country_id == 'KH') {
                        _this2.font = 'Hanumanb';
                    }
                    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["c" /* apiCountryLookup */], { params: { q: _this2.gri.country_id } }).then(function (response) {

                        if (response.data != null) {
                            _this2.list = response.data.data.list;
                            _this2.item = _this2.list[0];
                            _this2.country_name = _this2.item.country_name;
                            _this2.country_name = _this2.country_name.toUpperCase();
                        }
                    });
                }
                _this2.title = "Goods Return Inwards " + griNum;
            }).catch(function (error) {
                return console.log(error);
            });
        },
        save: function save() {
            this.modalShow = true;
        },
        back: function back() {
            this.$router.push({ name: 'Goods Return Inwards (GRIS)' });
        },
        handleOk: function handleOk() {
            var _this3 = this;

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["m" /* apiGriSave */], this.gri, Object(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["_7" /* authHeader */])()).then(function (res) {
                var r = res.data;

                if (r.code == 1) {
                    _this3.griDocNo = r.data.gri_num;
                    _this3.$refs.myModalRef.show();
                } else {
                    _this3.errorMessage = r.msg;
                    _this3.$refs.myErrorModalRef.show();
                }
            }).catch(function (error) {
                return console.log(error);
            });
        },
        handleCancelOk: function handleCancelOk() {
            this.$router.push({ name: 'Goods Return Inwards (GRIS)' });
        }
    }
});

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__functions_common_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Autocomplete_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_json_excel__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pdfmake_build_vfs_fonts__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pdfmake_build_vfs_fonts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_pdfmake_build_vfs_fonts__);












__WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake___default.a.vfs = __WEBPACK_IMPORTED_MODULE_7_pdfmake_build_vfs_fonts___default.a.pdfMake.vfs;
__WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake___default.a.fonts = {
  "ukai": {
    normal: 'ukai.ttf',
    bold: 'ukai.ttf',
    italics: 'ukai.ttf',
    bolditalics: 'ukai.ttf'
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  components: { spinner: __WEBPACK_IMPORTED_MODULE_1__components_Spinner_vue__["a" /* default */], countryLookup: __WEBPACK_IMPORTED_MODULE_3__components_Autocomplete_vue__["a" /* default */], exportExcel: __WEBPACK_IMPORTED_MODULE_5_vue_json_excel__["a" /* default */] },
  props: {
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
      loading: false,
      seen: false,
      searchResults: [],
      apiCountryLookup: __WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["c" /* apiCountryLookup */],
      noResults: false,
      filter: {
        gro_num: '',
        country_id: '',
        date_start: '',
        date_end: ''
      },
      exportHeaders: {
        'Country': 'country_id',
        'Location': 'location_id',
        'Date': 'gro_date',
        'GRO No': 'gro_num',
        'Supplier': 'supplier_name',
        'Remarks': 'remarks',
        'Created By': 'user_shortname'
      },
      searchResultsFields: [{ key: 'country_id', label: 'Country' }, { key: 'location_id', label: 'Location' }, { key: 'gro_date', label: 'Date' }, { key: 'gro_num', label: 'GRO No' }, { key: 'supplier_name', label: 'Supplier' }, { key: 'remarks', label: 'Remarks' }, { key: 'user_shortname', label: 'Created By' }],
      currentPage: 1,
      perPage: 10,
      totalRows: 0
    }, 'noResults', false);
  },

  methods: {
    print: function print() {
      var rows = [];
      var row = [];
      var date = new Date();
      rows.push(['Country', 'Location', 'Date', 'GRO Num', 'Supplier', 'Remarks', 'Created By']);

      for (var key in this.searchResults) {
        var data = this.searchResults[key];
        row = [data.country_id, data.location_id, data.gro_date, data.gro_num, data.supplier_name, data.remarks, data.user_shortname];
        rows.push(row);
      }
      var dd = {
        header: { text: 'Goods Return Outwards List generated on' + " " + date, margin: [5, 10, 10, 20], alignment: 'center', fontSize: 8 },
        pageSize: 'A4',
        pageOrientation: 'portrait',

        pageMargins: [30, 30, 30, 20],
        defaultStyle: {
          font: 'ukai'
        },
        content: [{
          fontSize: 8,
          layout: 'lightHorizontalLines',
          table: {
            headerRows: 1,
            widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],

            body: rows

          }
        }]
      };

      __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake___default.a.createPdf(dd).open();
    },
    getRowCount: function getRowCount(list) {
      return list.length;
    },
    rowClick: function rowClick(item, index) {
      this.$router.push({ name: 'Goods Return Outwards Entry (GRO)', params: { groNum: item.gro_num } });
    },
    newGro: function newGro() {
      this.$router.push({ name: 'Goods Return Outwards Entry (GRO)', params: { groNum: '_new' } });
    },
    search: function search() {
      var _this = this;

      this.loading = true;
      this.seen = true;
      var sf = ["gro_num LIKE " + this.filter.gro_num, "country_id = " + this.filter.country_id, "gro_date >= " + this.filter.date_start, "gro_date <= " + this.filter.date_end];

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["p" /* apiGroSearch */], sf).then(function (res) {
        return res;
      }).then(function (data) {
        var resultArray = [];
        var myData = data.data.data.list;
        for (var key in myData) {
          var date = myData[key].gro_date;
          var date = new Date(date);
          var result = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + (date.getMonth() + 1 > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear();
          myData[key].gro_date = result;
          resultArray.push(myData[key]);
          _this.loading = false;
        }
        _this.searchResults = resultArray;

        if (_this.searchResults.length == 0) {
          _this.loading = false;
          _this.noResults = true;
        }
      }).catch(function (error) {
        return console.log(error);
      });
    },
    setCountry: function setCountry(obj) {
      var id;
      if (obj !== null) {
        id = obj.id;
      } else {
        id = null;
      }
      this.filter.country_id = id;
    }
  }
});

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Autocomplete_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__functions_common_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pdfmake_build_vfs_fonts__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pdfmake_build_vfs_fonts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_pdfmake_build_vfs_fonts__);











__WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake___default.a.vfs = __WEBPACK_IMPORTED_MODULE_4_pdfmake_build_vfs_fonts___default.a.pdfMake.vfs;
__WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake___default.a.fonts = {
    "ukai": {
        normal: 'ukai.ttf',
        bold: 'ukai.ttf',
        italics: 'ukai.ttf',
        bolditalics: 'ukai.ttf'
    },
    "Garuda": {
        normal: 'Garuda.ttf',
        bold: 'Garuda.ttf',
        italics: 'Garuda.ttf',
        bolditalics: 'Garuda.ttf'
    },
    "Hanumanb": {
        normal: 'Hanumanb.ttf',
        bold: 'Hanumanb.ttf',
        italics: 'Hanumanb.ttf',
        bolditalics: 'Hanumanb.ttf'
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    components: { supplierLookup: __WEBPACK_IMPORTED_MODULE_1__components_Autocomplete_vue__["a" /* default */], warehouseLookup: __WEBPACK_IMPORTED_MODULE_1__components_Autocomplete_vue__["a" /* default */], productLookup: __WEBPACK_IMPORTED_MODULE_1__components_Autocomplete_vue__["a" /* default */] },
    created: function created() {
        this.gro_ref = this.$route.params.groNum;
        if (this.gro_ref == '_new') {
            var curDate = new Date();
            curDate = curDate.toISOString().substr(0, 10);
            this.gro.gro_date = curDate;
            this.noItemsFound = true;
        } else {
            this.lockEntry = true;
            this.fetch(this.gro_ref);
            this.noItemsFound = false;
        }
    },

    data: function data() {
        return {
            title: 'New GRO',
            apiSupplierUrl: __WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["U" /* apiSupplierLookup */],
            apiWarehouseUrl: __WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["V" /* apiWarehouseLookup */],
            apiLocationProductUrl: __WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["q" /* apiLocationProductUrl */],
            gro_ref: '',
            modalShow: false,
            modalCancelShow: false,
            hideBtn: true,
            country_name: '',
            prevWhId: '',
            noItemsFound: true,
            lockEntry: false,
            font: 'ukai',
            groDocNo: 'test',
            errorMessage: '',
            gro: {
                gro_date: '',
                reference_num: '',
                supplier_id: '',
                location_id: '',
                remarks: '',
                currency_id: '',
                gro_items: [{ product_name: '', product_id: '', qty_soh: '', qty: '', unit_gmp: '', amount_total: '' }]
            }
        };
    },
    methods: {
        print: function print() {
            var gro_num = this.gro.gro_num;
            var row = [];
            var date = new Date(this.gro.gro_date);
            var groDate = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + (date.getMonth() + 1 > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear();
            var groItems = [];
            var groTotalAmount = 0;
            var supplier = '-';
            var currency = "-";
            if (this.gro.currency_id != null) {
                currency = this.gro.currency_id;
            }
            if (this.gro.supplier_name != null && this.gro.supplier_id != null) {
                supplier = this.gro.supplier_name + ' (' + this.gro.supplier_id + ')';
            }
            row = [{
                text: 'S/No',
                style: 'itemsHeader'
            }, {
                text: 'Product Code',
                style: ['itemsHeader'],
                alignment: 'left'
            }, {
                text: 'Description',
                style: ['itemsHeader'],
                alignment: 'left'
            }, {
                text: 'SOH',
                style: ['itemsHeader'],
                alignment: 'left'
            }, {
                text: 'Unit GMP',
                style: ['itemsHeader'],
                alignment: 'left'
            }, {
                text: 'Return Qty',
                style: ['itemsHeader'],
                alignment: 'right'
            }, {
                text: 'Amount',
                style: ['itemsHeader'],
                alignment: 'right'
            }];
            groItems.push(row);
            var items = this.gro.gro_items;
            for (var key in items) {
                var data = items[key];
                groTotalAmount = groTotalAmount + data.amount_total * 1;
                var soh = (data.qty_soh * 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                var unit_gmp = '';
                if (data.unit_gmp != null) {
                    var unit_gmp = (data.unit_gmp * 1).toFixed(2);
                    unit_gmp = data.unit_gmp.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                }
                var amount_total = (data.amount_total * 1).toFixed(2);
                amount_total = data.amount_total;
                var totalAmount = data.amount_total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                console.log(data.product_name);
                var qty = (data.qty * 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                if (data.product_name == null) {
                    data.product_name = "";
                }
                row = [{
                    text: key * 1 + 1,
                    style: 'itemText'
                }, {
                    text: data.product_id,
                    style: 'itemText'
                }, {
                    text: data.product_name,
                    style: 'itemText'
                }, {
                    text: soh,
                    style: 'itemText'
                }, {
                    text: unit_gmp,
                    style: 'itemText'
                }, {
                    text: qty,
                    style: 'itemNumber'
                }, {
                    text: totalAmount,
                    style: 'itemTotal'
                }];
                groItems.push(row);
            }
            groTotalAmount = groTotalAmount.toFixed(2);
            groTotalAmount = groTotalAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

            var ddHeader = {
                columns: [[{
                    text: 'ELKEN ' + this.country_name + ' GOODS RETURN OUTWARDS',
                    style: 'invoiceTitle',
                    width: '*'
                }, {
                    stack: [{
                        columns: [{
                            text: 'GRO #',
                            style: 'invoiceSubTitle',
                            width: 90

                        }, {
                            text: gro_num,
                            style: 'invoiceSubValue',
                            width: 100

                        }]
                    }, {
                        text: ' '
                    }, {
                        columns: [{
                            text: 'GRO Date',
                            style: 'invoiceSubTitle',
                            width: 90

                        }, {
                            text: groDate,
                            style: 'invoiceSubValue',
                            width: 100

                        }]

                    }, {
                        text: ' '
                    }, {
                        columns: [{
                            text: 'Supplier',
                            style: 'invoiceSubTitle',
                            width: 90

                        }, {
                            text: supplier,
                            style: 'invoiceSubValue'
                        }]

                    }, {
                        text: ' '
                    }, {
                        columns: [{
                            text: 'Stock Location',
                            style: 'invoiceSubTitle',
                            width: 90

                        }, {
                            text: this.gro.location_id,
                            style: 'invoiceSubValue'
                        }]
                    }, {
                        text: ' '
                    }, {
                        columns: [{
                            text: 'Reference #',
                            style: 'invoiceSubTitle',
                            width: 90

                        }, {
                            text: this.gro.reference_num,
                            style: 'invoiceSubValue',
                            width: 100

                        }]
                    }, {
                        text: ' '
                    }, {
                        columns: [{
                            text: 'Currency',
                            style: 'invoiceSubTitle',
                            width: 90

                        }, {
                            text: currency,
                            style: 'invoiceSubValue',
                            width: 100

                        }]
                    }]
                }]]
            };

            var dd = {
                header: function header(pageNumber, pageCount) {
                    return {
                        margin: [0, 10, 0, 0],
                        columns: [{
                            text: '',
                            style: 'documentHeaderLeft'
                        }, {
                            text: gro_num,
                            style: 'documentHeaderCenter'
                        }, {
                            text: '',
                            style: 'documentHeaderRight'
                        }]
                    };
                },
                footer: function footer(pageNumber, pageCount) {
                    return {
                        margin: [0, 0, 0, 50],
                        columns: [{
                            text: '',
                            style: 'documentFooterLeft'
                        }, {
                            text: 'Page ' + pageNumber + " of " + pageCount,
                            style: 'documentFooterCenter'
                        }, {
                            text: '',
                            style: 'documentFooterRight'
                        }]
                    };
                },
                content: [ddHeader, '\n\n', {
                    layout: 'lightHorizontalLines',
                    table: {

                        headerRows: 1,
                        widths: [25, 68, '*', 45, 45, 38, 55],
                        body: groItems

                    } }, {
                    table: {
                        headerRows: 0,
                        widths: ['*', 80],
                        body: [[{
                            text: 'TOTAL ($)',
                            style: 'itemsFooterTotalTitle',
                            alignment: 'right'

                        }, {
                            text: groTotalAmount,
                            style: 'itemsFooterTotalValue',
                            alignment: 'right'
                        }]]
                    },
                    layout: 'lightHorizontalLines'
                }, {
                    text: 'Remarks',
                    style: 'notesTitle'
                }, {
                    text: this.gro.remarks,
                    style: 'notesText'
                }, {
                    columns: [{
                        stack: [{
                            text: 'Issued By',
                            style: 'signaturePlaceholder'
                        }, {
                            text: '______________________________',
                            style: 'signaturePlaceholder'
                        }, {
                            text: 'Name  : ' + this.gro.user_shortname,
                            style: 'signatureName'

                        }, {
                            text: 'Date  : ' + groDate,
                            style: 'signatureJobTitle'

                        }],
                        width: 160
                    }, {
                        stack: [{
                            text: '  ',
                            style: 'signaturePlaceholder'
                        }, {
                            text: '                      ',
                            style: 'signaturePlaceholder'
                        }, {
                            text: '  ',
                            style: 'signatureName'

                        }, {
                            text: '      ',
                            style: 'signatureJobTitle'

                        }],
                        width: 180
                    }, {
                        stack: [{
                            text: 'Received By',
                            style: 'signaturePlaceholder'
                        }, {
                            text: '______________________________',
                            style: 'signaturePlaceholder'
                        }, {
                            text: 'Name  :',
                            style: 'signatureName'

                        }, {
                            text: 'Date  :',
                            style: 'signatureJobTitle'

                        }],
                        width: 160
                    }]
                }],
                styles: {
                    documentHeaderLeft: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'left'
                    },
                    documentHeaderCenter: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'center'
                    },
                    documentHeaderRight: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'right'
                    },

                    documentFooterLeft: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'left'
                    },
                    documentFooterCenter: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'center'
                    },
                    documentFooterRight: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'right'
                    },

                    invoiceTitle: {
                        fontSize: 22,
                        bold: true,
                        alignment: 'left',
                        margin: [0, 0, 0, 15]
                    },

                    invoiceSubTitle: {
                        fontSize: 10,
                        alignment: 'left'
                    },
                    invoiceSubValue: {
                        fontSize: 10,
                        alignment: 'left'
                    },

                    invoiceBillingTitle: {
                        fontSize: 14,
                        bold: true,
                        alignment: 'left',
                        margin: [0, 20, 0, 5]
                    },

                    invoiceBillingDetails: {
                        alignment: 'left'

                    },
                    invoiceBillingAddressTitle: {
                        margin: [0, 7, 0, 3],
                        bold: true
                    },
                    invoiceBillingAddress: {},

                    itemsHeader: {

                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        bold: true
                    },

                    itemTitle: {
                        bold: true
                    },
                    itemSubTitle: {
                        fontSize: 10
                    },
                    itemText: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        alignment: 'left'
                    },
                    itemNumber: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        alignment: 'right'
                    },
                    itemTotal: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right'
                    },

                    itemsFooterSubTitle: {
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right'
                    },
                    itemsFooterSubValue: {
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'center'
                    },
                    itemsFooterTotalTitle: {
                        fontSize: 11,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right'
                    },
                    itemsFooterTotalValue: {
                        fontSize: 11,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'center'
                    },
                    signaturePlaceholder: {
                        fontSize: 10,
                        margin: [0, 70, 0, 0]
                    },
                    signatureName: {
                        fontSize: 10,
                        margin: [0, 10, 0, 0],
                        bold: true,
                        alignment: 'left'
                    },
                    signatureJobTitle: {
                        fontSize: 10,
                        margin: [0, 20, 0, 0],
                        bold: true,
                        alignment: 'left'
                    },
                    notesTitle: {
                        fontSize: 10,
                        bold: true,
                        margin: [0, 30, 0, 3]
                    },
                    notesText: {
                        fontSize: 10
                    },
                    center: {
                        alignment: 'center'
                    }
                },
                defaultStyle: {
                    columnGap: 20,
                    font: this.font
                }
            };
            __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake___default.a.createPdf(dd).open();
        },
        addRow: function addRow() {
            this.gro.gro_items.push({ product_id: '', product_name: '', qty_soh: '', qty: '', unit_gmp: '', amount_total: '' });
        },
        removeRow: function removeRow(index) {
            this.gro.gro_items.splice(index, 1);
        },
        setSupplier: function setSupplier(obj) {
            if (obj !== null) {
                this.gro.supplier_id = obj.id;
            } else {
                this.gro.supplier_id = null;
            }
        },
        setWarehouse: function setWarehouse(obj) {
            var _this = this;

            if (!this.lockEntry) {
                var id;
                var country_id;

                if (obj !== null) {
                    if (obj.id != this.gro.location_id) {
                        id = obj.id;
                        country_id = obj.country_id;
                        this.gro.gro_items = [];
                        this.gro.location_id = id;
                        this.countryId = country_id;
                        this.gro.currency_id = obj.currency_id;
                        if (this.gro.location_id != '') {
                            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.apiLocationProductUrl, { params: { q: '', q2: id } }).then(function (res) {
                                var list;
                                list = res.data.data.list;
                                _this.noItemsFound = list.length == 0;
                            }).catch(function (error) {
                                return alert(error);
                            });
                        }
                    }
                } else {
                    id = "";
                    this.noItemsFound = true;
                    this.gro.currency_id = null;
                }
            }
        },
        validateQty: function validateQty(index) {
            if (!this.lockEntry) {
                var item = this.gro.gro_items[index];
                if (!isNaN(item.qty)) {
                    if (item.qty < 0) {
                        item.qty = 0;
                    } else if (item.qty * 1 > item.qty_soh * 1) {
                        item.qty = 0;
                    }
                } else {
                    item.qty = 0;
                }
            }
        },
        setProduct: function setProduct(obj, index) {
            if (!this.lockEntry) {
                this.prevWhId = this.gro.location_id;

                if (obj != []) {
                    var name, id, qty_soh, unit_gmp;

                    var isDuplicatedEntry = false;
                    var items = this.gro.gro_items;

                    for (var n = 0; n < items.length; n++) {
                        if (n != index) {
                            if (items[n].product_id == items[index].product_id && items[index].product_id != "") {
                                isDuplicatedEntry = true;
                            }

                            if (isDuplicatedEntry) break;
                        }
                    }
                    if (!isDuplicatedEntry) {
                        if (obj !== null) {
                            if (obj.id == "") {
                                qty_soh = "";
                                unit_gmp = "";
                            } else {
                                name = obj.name;
                                id = obj.id;
                                qty_soh = obj.qty_soh;
                                unit_gmp = obj.unit_gmp;
                            }
                        } else {
                            name = "";
                            id = "";
                            qty_soh = "";
                            unit_gmp = "";
                        }

                        if (isNaN(qty_soh)) qty_soh = "";
                    } else {
                        name = "";
                        id = "";
                        qty_soh = "";
                        unit_gmp = "";
                    }

                    this.gro.gro_items[index].product_id = id;
                    this.gro.gro_items[index].product_name = name;
                    this.gro.gro_items[index].qty_soh = qty_soh;

                    this.gro.gro_items[index].unit_gmp = unit_gmp;
                    this.gro.gro_items[index].qty = 0;
                }
            }
        },
        hideModal: function hideModal() {
            this.$refs.myModalRef.hide();
            this.$router.push({ name: 'Goods Return Outwards (GROS)' });
        },
        closeGro: function closeGro() {
            this.modalCancelShow = true;
        },
        hideErrorModal: function hideErrorModal() {
            this.$refs.myErrorModalRef.hide();
        },
        fetch: function fetch(groNum) {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["o" /* apiGroGet */], { gro_num: groNum }, Object(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["_7" /* authHeader */])()).then(function (res) {
                var data;
                data = res.data.data;
                _this2.gro = data;
                if (_this2.gro.country_id != null) {
                    if (_this2.gro.country_id == 'TH') {
                        _this2.font = 'Garuda';
                    } else if (_this2.gro.country_id == 'KH') {
                        _this2.font = 'Hanumanb';
                    }
                    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["c" /* apiCountryLookup */], { params: { q: _this2.gro.country_id } }).then(function (response) {

                        if (response.data != null) {
                            _this2.list = response.data.data.list;
                            _this2.item = _this2.list[0];
                            _this2.country_name = _this2.item.country_name;
                            _this2.country_name = _this2.country_name.toUpperCase();
                        }
                    });
                }
                _this2.title = "Goods Return Outwards " + groNum;
            }).catch(function (error) {
                return console.log(error);
            });
        },
        save: function save() {
            this.modalShow = true;
        },
        back: function back() {

            this.$router.push({ name: 'Goods Return Outwards (GROS)' });
        },
        handleOk: function handleOk() {
            var _this3 = this;

            var gro_date = this.gro.gro_date;
            var today = new Date();
            var dd = today.getDate();
            var mm = today.getMonth() + 1;
            var yyyy = today.getFullYear();

            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            var today = yyyy + '-' + mm + '-' + dd;
            if (gro_date >= today) {
                __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["h" /* apiGROSave */], this.gro, Object(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["_7" /* authHeader */])()).then(function (res) {
                    var r = res.data;

                    if (r.code == 1) {
                        _this3.groDocNo = r.data.gro_num;
                        _this3.$refs.myModalRef.show();
                    } else {
                        _this3.errorMessage = r.msg;
                        _this3.$refs.myErrorModalRef.show();
                    }
                }).catch(function (error) {
                    return console.log(error);
                });
            } else {
                this.errorMessage = "Post Dated date entry not allowed for GRO date";
                this.$refs.myErrorModalRef.show();
            }
        },
        handleCancelOk: function handleCancelOk() {
            this.$router.push({ name: 'Goods Return Outwards (GROS)' });
        }
    }
});

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Autocomplete_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_json_excel__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__functions_common_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pdfmake_build_vfs_fonts__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pdfmake_build_vfs_fonts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_pdfmake_build_vfs_fonts__);













__WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake___default.a.vfs = __WEBPACK_IMPORTED_MODULE_7_pdfmake_build_vfs_fonts___default.a.pdfMake.vfs;
__WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake___default.a.fonts = {
    "ukai": {
        normal: 'ukai.ttf',
        bold: 'ukai.ttf',
        italics: 'ukai.ttf',
        bolditalics: 'ukai.ttf'
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    components: { countryLookup: __WEBPACK_IMPORTED_MODULE_3__components_Autocomplete_vue__["a" /* default */], warehouseLookup: __WEBPACK_IMPORTED_MODULE_3__components_Autocomplete_vue__["a" /* default */], productLookup: __WEBPACK_IMPORTED_MODULE_3__components_Autocomplete_vue__["a" /* default */], spinner: __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue__["a" /* default */], exportExcel: __WEBPACK_IMPORTED_MODULE_4_vue_json_excel__["a" /* default */] },
    props: {
        hover: {
            type: Boolean,
            default: false
        },
        striped: {
            type: Boolean,
            default: false
        },
        bordered: {
            type: Boolean,
            default: false
        },
        small: {
            type: Boolean,
            default: false
        },
        fixed: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        var _ref;

        return _ref = {
            loading: false,
            lockEntry: false,
            apiCountryLookup: __WEBPACK_IMPORTED_MODULE_5__functions_common_vue__["c" /* apiCountryLookup */],
            apiWarehouseLookup: __WEBPACK_IMPORTED_MODULE_5__functions_common_vue__["V" /* apiWarehouseLookup */],
            apiLocationProductUrl: __WEBPACK_IMPORTED_MODULE_5__functions_common_vue__["q" /* apiLocationProductUrl */]
        }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'lockEntry', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'product_name', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'prev_location_id', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'location_name', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'errorMessage', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'opening_balance', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'closing_balance', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'searchResults', []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'searchSummary', []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'exportHeaders', {
            'Doc No': 'doc_num',
            'Location Code': 'location_id',
            'Product Code': 'product_id',
            'Document Reference Parent': 'doc_reference',
            'DO/Trans Date': 'movement_date',
            'Trans. Type': 'trans_type',
            'Qty In': 'qty_in',
            'Qty Out': 'qty_out',
            'Cumulative Balance': 'culmulative_balance'
        }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'filter', {
            country_id: '',
            location_id: '',
            product_id: '',
            date_start: '',
            date_end: ''
        }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'excelResults', []), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'searchResultsFields', [{ key: 'doc_num', label: 'Doc No' }, { key: 'doc_reference', label: 'Document Reference Parent' }, { key: 'movement_date', label: 'DO/Trans Date' }, { key: 'trans_type', label: 'Trans. Type' }, { key: 'qty_in', label: 'Qty In' }, { key: 'qty_out', label: 'Qty Out' }, { key: 'culmulative_balance', label: 'Cumulative Balance' }]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'currentPage', 1), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'perPage', 20), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'totalRows', 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'noResults', false), _ref;
    },
    methods: {
        print: function print() {
            var product_name = ' - ';
            if (this.product_name != null) {
                product_name = this.product_name;
            }
            var rows = [];
            var row = [];
            var date = new Date();
            var summary = [];
            var summaryList = [];
            var start_date;
            var end_date;

            if (this.filter.date_start == '') {
                start_date = ' - ';
            } else {
                start_date = this.filter.date_start;
            }

            if (this.filter.date_end == '') {
                end_date = ' - ';
            } else {
                end_date = this.filter.date_end;
            }

            summaryList.push([' ', 'DO', 'GRN', 'GRO', 'GRI', 'WTO', 'WTR', 'SAN', 'SRF', 'SRR', 'WSC', 'TOTAL QTY']);
            summaryList.push(['Qty Out', this.searchSummary[0]["DO"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), this.searchSummary[0]["GRN"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), this.searchSummary[0]["GRO"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), this.searchSummary[0]["GRI"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), this.searchSummary[0]["WTO"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), this.searchSummary[0]["WTR"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), this.searchSummary[0]["SAN"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), this.searchSummary[0]["SRF"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), this.searchSummary[0]["SRR"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), this.searchSummary[0]["WSC"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), this.searchSummary[0]["TOTAL"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")]);
            summaryList.push(['Qty In', this.searchSummary[1]["DO"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), this.searchSummary[1]["GRN"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), this.searchSummary[1]["GRO"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), this.searchSummary[1]["GRI"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), this.searchSummary[1]["WTO"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), this.searchSummary[1]["WTR"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), this.searchSummary[1]["SAN"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), this.searchSummary[1]["SRF"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), this.searchSummary[1]["SRR"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), this.searchSummary[1]["WSC"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), this.searchSummary[1]["TOTAL"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")]);
            summaryList.push(['Total Trans', this.searchSummary[2]["DO"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), this.searchSummary[2]["GRN"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), this.searchSummary[2]["GRO"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), this.searchSummary[2]["GRI"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), this.searchSummary[2]["WTO"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), this.searchSummary[2]["WTR"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), this.searchSummary[2]["SAN"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), this.searchSummary[2]["SRF"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), this.searchSummary[2]["SRR"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), this.searchSummary[2]["WSC"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","), this.searchSummary[2]["TOTAL"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")]);

            rows.push(['Doc No', 'Document Reference', 'DO/Trans Date', 'Trans. Type', 'Qty In', 'Qty Out', 'Cumulative Balance']);

            for (var key in this.searchResults) {
                var data = this.searchResults[key];
                row = [data.doc_num, data.doc_reference, data.movement_date, data.trans_type, data.qty_in, data.qty_out, data.culmulative_balance];
                rows.push(row);
            }
            var dd = {
                header: { text: 'Stock Card Movement generated on' + " " + date, margin: [5, 10, 10, 0], alignment: 'center', fontSize: 8 },
                pageSize: 'A4',
                pageOrientation: 'portrait',

                pageMargins: [30, 20, 30, 20],
                defaultStyle: {
                    font: 'ukai'
                },
                content: [{ text: 'ELKEN STOCK CARD MOVEMENT', fontSize: 10, margin: [0, 10, 0, 0], bold: true }, { text: 'WH Code                   :  ' + this.filter.location_id, fontSize: 8, margin: [0, 10, 0, 0] }, { text: 'Stock Location            :  ' + this.location_name, fontSize: 8, margin: [0, 10, 0, 0] }, { text: 'Product Code              :  ' + this.filter.product_id, fontSize: 8, margin: [0, 10, 0, 0] }, { text: 'Product Name              :  ' + product_name, fontSize: 8, margin: [0, 10, 0, 0] }, { text: 'Date Start                :    ' + start_date, fontSize: 8, margin: [0, 10, 0, 0] }, { text: 'Date End                  :    ' + end_date, fontSize: 8, margin: [0, 10, 0, 0] }, { text: 'Opening Balance           :    ' + this.opening_balance, fontSize: 8, margin: [0, 10, 0, 0] }, { text: 'Closing Balance           :    ' + this.closing_balance, fontSize: 8, margin: [0, 10, 0, 0] }, { text: 'Summary', fontSize: 10, margin: [0, 20, 0, 0], bold: true }, {
                    fontSize: 8,
                    layout: 'lightHorizontalLines',
                    margin: [0, 10, 0, 0],

                    table: {
                        headerRows: 1,
                        widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
                        body: summaryList
                    }
                }, { text: 'Stock Movement Transactions', fontSize: 10, margin: [0, 20, 0, 0], bold: true }, {
                    fontSize: 8,
                    layout: 'lightHorizontalLines',
                    margin: [0, 10, 0, 0],

                    table: {
                        headerRows: 1,
                        widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],

                        body: rows
                    }

                }]
            };

            __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake___default.a.createPdf(dd).open();
        },
        setCountry: function setCountry(obj) {
            var id;
            if (obj !== null) {
                id = obj.id;
            } else {
                id = null;
            }
            this.filter.country_id = id;
        },
        setProduct: function setProduct(obj) {
            var id;
            if (obj !== null) {
                id = obj.id;
                this.product_name = obj.name;
            } else {
                id = null;
            }
            this.filter.product_id = id;
        },
        setWarehouse: function setWarehouse(obj) {
            var id;

            if (obj !== null) {
                id = obj.id;
                this.location_name = obj.name;
            } else {
                id = null;
            }
            this.filter.location_id = id;
        },
        search: function search() {
            var _this = this;

            this.loading = true;
            var sf = {
                "location_id": this.filter.location_id,
                "product_id": this.filter.product_id,
                "date_from": this.filter.date_start,
                "date_to": this.filter.date_end
            };
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_5__functions_common_vue__["T" /* apiStockcard */], sf, Object(__WEBPACK_IMPORTED_MODULE_5__functions_common_vue__["_7" /* authHeader */])()).then(function (res) {
                return res;
            }).then(function (data) {
                _this.searchSummary = data.data.data.summary;
                _this.searchResults = data.data.data.details;
                if (_this.searchSummary.length > 0 || _this.searchResults.length > 0) {
                    _this.lockEntry = true;
                }

                if (_this.searchResults.length > 0) {
                    for (var n = 0; n < _this.searchResults.length; n++) {
                        var date = _this.searchResults[n].movement_date;
                        var date = new Date(date);
                        var result = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + (date.getMonth() + 1 > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear();
                        _this.searchResults[n].movement_date = result;
                        var qty_in = _this.searchResults[n].qty_in * 1;
                        var qty_out = _this.searchResults[n].qty_out * 1;
                        var culmulative_balance = _this.searchResults[n].culmulative_balance * 1;
                        qty_in = qty_in.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                        qty_out = qty_out.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        culmulative_balance = culmulative_balance.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                        _this.excelResults.push({
                            doc_num: _this.searchResults[n].doc_num,
                            product_id: _this.filter.product_id,
                            doc_reference: _this.searchResults[n].doc_reference,
                            movement_date: _this.searchResults[n].movement_date,
                            trans_type: _this.searchResults[n].trans_type,
                            qty_out: qty_out,
                            qty_in: qty_in,
                            culmulative_balance: culmulative_balance
                        });
                        _this.searchResults[n].qty_in = qty_in;
                        _this.searchResults[n].qty_out = qty_out;
                        _this.searchResults[n].culmulative_balance = culmulative_balance;
                    }
                    var length = _this.searchResults.length;
                    _this.closing_balance = _this.searchResults[length - 1].culmulative_balance;
                }

                _this.opening_balance = data.data.data.opening_balance * 1;
                _this.opening_balance = _this.opening_balance.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                _this.loading = false;
                _this.noResults = true;
            }).catch(function (error) {
                return alert(error);
            });
        },
        getRowCount: function getRowCount(list) {
            return list.length;
        },
        back: function back() {
            this.lockEntry = false;
            this.searchResults = [];
            var obj = {};
            this.filter.product_id = '';
            this.filter.location_id = '';
            this.noResults = false;
        }
    }
});

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Autocomplete_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_json_excel__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__functions_common_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pdfmake_build_vfs_fonts__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pdfmake_build_vfs_fonts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_pdfmake_build_vfs_fonts__);












__WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake___default.a.vfs = __WEBPACK_IMPORTED_MODULE_7_pdfmake_build_vfs_fonts___default.a.pdfMake.vfs;
__WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake___default.a.fonts = {
    "ukai": {
        normal: 'ukai.ttf',
        bold: 'ukai.ttf',
        italics: 'ukai.ttf',
        bolditalics: 'ukai.ttf'
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    components: { countryLookup: __WEBPACK_IMPORTED_MODULE_2__components_Autocomplete_vue__["a" /* default */], warehouseLookup: __WEBPACK_IMPORTED_MODULE_2__components_Autocomplete_vue__["a" /* default */], productLookup: __WEBPACK_IMPORTED_MODULE_2__components_Autocomplete_vue__["a" /* default */], spinner: __WEBPACK_IMPORTED_MODULE_1__components_Spinner_vue__["a" /* default */], exportExcel: __WEBPACK_IMPORTED_MODULE_3_vue_json_excel__["a" /* default */], Multiselect: __WEBPACK_IMPORTED_MODULE_5_vue_multiselect___default.a },
    props: {
        hover: {
            type: Boolean,
            default: false
        },
        striped: {
            type: Boolean,
            default: false
        },
        bordered: {
            type: Boolean,
            default: false
        },
        small: {
            type: Boolean,
            default: false
        },
        fixed: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            allSelected: false,
            indeterminate: false,
            loading: false,
            apiCountryLookup: __WEBPACK_IMPORTED_MODULE_4__functions_common_vue__["c" /* apiCountryLookup */],
            apiWarehouseLookup: __WEBPACK_IMPORTED_MODULE_4__functions_common_vue__["V" /* apiWarehouseLookup */],
            apiProductLookup: __WEBPACK_IMPORTED_MODULE_4__functions_common_vue__["E" /* apiProductLookup */],
            lockEntry: false,
            errorMessage: '',
            searchResults: [],
            warehouses: [],
            selectedLocations: [],
            location_id: '',
            country_id: '',
            exportHeaders: {
                'Stock Location': 'location_id',
                'Product Code': 'product_id',
                'Product Name': 'product_name',
                'SOH': 'qty_soh',
                'Unit GMP': 'unit_gmp',
                'Total GMP': 'total_gmp'
            },
            filter: {
                country_id: '',
                selectedWarehouses: [],
                asof_date: ''
            },
            searchResultsFields: [{ key: 'location_id', label: 'Stock Location' }, { key: 'product_id', label: 'Product Code' }, { key: 'product_name', label: 'Product Name' }, { key: 'qty_soh', label: 'SOH', 'class': 'text-right' }, { key: 'unit_gmp', label: 'Unit GMP', 'class': 'text-right' }, { key: 'total_gmp', label: 'Total GMP', 'class': 'text-right' }],
            currentPage: 1,
            perPage: 20,
            totalRows: 0,
            noResults: false
        };
    },
    watch: {
        selectedLocations: function selectedLocations(newVal, oldVal) {
            if (newVal.length === 0) {
                this.allSelected = false;
            } else if (newVal.length === this.warehouses.length) {
                this.allSelected = true;
            } else {
                this.allSelected = false;
            }
        }
    },
    methods: {
        selectAll: function selectAll() {
            this.selectedLocations = [];

            if (!this.allSelected) {
                for (var w in this.warehouses) {
                    this.selectedLocations.push(this.warehouses[w]);
                }
            }
        },
        select: function select() {
            this.allSelected = false;
        },
        print: function print() {
            var rows = [];
            var row = [];
            var date = new Date();
            var total_soh_print = 0;
            var total_gmp_amount_print = 0;
            var header = [{
                text: 'Stock Location'
            }, {
                text: 'Product Code',
                alignment: 'left'
            }, {
                text: 'Description',
                alignment: 'left'
            }, {
                text: 'SOH',
                alignment: 'right'
            }, {
                text: 'Unit GMP',
                alignment: 'right'
            }, {
                text: 'Total GMP',
                alignment: 'right'
            }];
            rows.push(header);

            for (var key in this.searchResults) {
                var data = this.searchResults[key];

                row = [{
                    text: data.location_id
                }, {
                    text: data.product_id
                }, {
                    text: data.product_name
                }, {
                    text: data.qty_soh,
                    alignment: 'right'
                }, {
                    text: data.unit_gmp,
                    alignment: 'right'
                }, {
                    text: data.total_gmp,
                    alignment: 'right'
                }];

                rows.push(row);
            }
            var data = [{ text: " " }, { text: " " }, { text: "TOTAL", bold: true, fontSize: 10 }, { text: total_soh_print, bold: true, fontSize: 10, alignment: 'right' }, { text: " " }, { text: total_gmp_amount_print, bold: true, fontSize: 10, alignment: 'right' }];

            var dd = {
                pageSize: 'A4',
                pageOrientation: 'portrait',
                header: { text: 'Stock Balance Record generated on' + " " + date, margin: [5, 10, 10, 30], alignment: 'center', fontSize: 8 },

                pageMargins: [30, 20, 30, 20],
                defaultStyle: {
                    font: 'ukai'
                },
                content: [{ text: 'Stock Balance Record', fontSize: 8, margin: [0, 10, 0, 0], bold: true }, {
                    margin: [0, 10, 0, 0],
                    fontSize: 8,
                    layout: 'lightHorizontalLines',
                    table: {
                        headerRows: 1,
                        widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto'],

                        body: rows

                    }
                }]
            };

            __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake___default.a.createPdf(dd).open();
        },
        setCountry: function setCountry(obj) {
            var _this = this;

            var id;
            if (obj !== null) {
                id = obj.id;

                if (id != '') {
                    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_4__functions_common_vue__["V" /* apiWarehouseLookup */], { params: { q: this.lookupValue, q2: id, limit: 9999 } }).then(function (res) {
                        var list;
                        list = res.data.data.list;
                        var data;
                        var isDuplicate = false;
                        _this.warehouses = [];
                        _this.selectedLocations = [];
                        if (list.length > 0) {

                            for (var _data in list) {

                                _data = list[_data].location_id + ' - ' + list[_data].location_name;
                                for (var i = 0; i < _this.warehouses.length; i++) {
                                    if (_this.warehouses[i] == _data) {
                                        isDuplicate = true;
                                    }
                                }
                                if (isDuplicate == false) {
                                    _this.warehouses.push(_data);
                                }
                            }
                        }
                    }).catch(function (error) {
                        return alert(error);
                    });
                } else {
                    this.selectedLocations = [];
                }
            } else {
                id = null;
            }
            this.filter.country_id = id;
        },
        search: function search() {
            var _this2 = this;

            var selectedWH = this.selectedLocations;
            this.filter.selectedWarehouses = [];
            if (selectedWH.length > 0) {
                for (var n = 0; n < selectedWH.length; n++) {
                    var str = selectedWH[n];
                    var res;
                    for (var i = 0; i < str.length; i++) {
                        if (str[i] == '-') {
                            res = str.substring(0, i);
                            this.filter.selectedWarehouses.push(res);
                            break;
                        }
                    }
                }
            } else {
                console.log("No warehouse is being selected");
            }
            var total_soh = 0;
            var total_gmp_amount = 0;
            var sf = {
                "warehouses_list": this.filter.selectedWarehouses,
                "asof_date": this.filter.asof_date
            };
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_4__functions_common_vue__["K" /* apiSbrSearch */], sf, Object(__WEBPACK_IMPORTED_MODULE_4__functions_common_vue__["_7" /* authHeader */])()).then(function (res) {
                return res;
            }).then(function (data) {

                var results = data.data.data.list;

                var qty_soh;
                var unit_gmp;
                var total_gmp;
                var total_soh = 0;
                var total_gmp_amount = 0;
                if (results.length > 0) {
                    for (var n = 0; n < results.length; n++) {

                        qty_soh = results[n].qty_soh * 1;
                        unit_gmp = results[n].unit_gmp * 1;
                        total_gmp = results[n].total_gmp * 1;

                        total_soh = total_soh + qty_soh;
                        total_gmp_amount = total_gmp_amount + total_gmp;

                        qty_soh = qty_soh.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                        unit_gmp = unit_gmp.toFixed(2);
                        unit_gmp = unit_gmp.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                        total_gmp = total_gmp.toFixed(2);
                        total_gmp = total_gmp.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                        results[n].qty_soh = qty_soh;
                        results[n].unit_gmp = unit_gmp;
                        results[n].total_gmp = total_gmp;
                    }
                }
                _this2.searchResults = results;

                total_soh = total_soh * 1;
                total_soh = total_soh.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                total_gmp_amount = (total_gmp_amount * 1).toFixed(2);
                total_gmp_amount = total_gmp_amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

                _this2.loading = false;
                _this2.noResults = true;
            }).catch(function (error) {
                return alert(error);
            });
        },
        setProduct: function setProduct(obj) {
            var id;
            if (obj !== null) {
                id = obj.id;
            } else {
                id = null;
            }
            this.filter.product_id = id;
        },
        getRowCount: function getRowCount(list) {
            return list.length;
        },
        back: function back() {
            this.filter.country_id = '';
            this.filter.selectedWarehouses = [];
            this.filter.asof_date = '';
            this.noResults = false;
            this.searchResults = [];
            this.selectedLocations = [];
        }
    }

});

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Autocomplete_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__functions_common_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_json_excel__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pdfmake_build_vfs_fonts__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pdfmake_build_vfs_fonts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_pdfmake_build_vfs_fonts__);











__WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake___default.a.vfs = __WEBPACK_IMPORTED_MODULE_7_pdfmake_build_vfs_fonts___default.a.pdfMake.vfs;
__WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake___default.a.fonts = {
  "ukai": {
    normal: 'ukai.ttf',
    bold: 'ukai.ttf',
    italics: 'ukai.ttf',
    bolditalics: 'ukai.ttf'
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  components: { spinner: __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue__["a" /* default */], countryLookup: __WEBPACK_IMPORTED_MODULE_3__components_Autocomplete_vue__["a" /* default */], exportExcel: __WEBPACK_IMPORTED_MODULE_5_vue_json_excel__["a" /* default */] },
  props: {
    caption: {
      type: String,
      default: 'Table'
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var _ref;

    return _ref = {
      apiCountryLookup: __WEBPACK_IMPORTED_MODULE_4__functions_common_vue__["c" /* apiCountryLookup */],
      loading: false,
      noResults: false,
      filter: {
        wto_num: '',
        country_id: '',
        date_start: '',
        date_end: '',
        status: ''
      },
      searchResults: [],
      searchResultsFields: [{ key: 'country_id', label: 'Country Code' }, { key: 'from_location_id', label: 'Location From' }, { key: 'to_location_id', label: 'Location To' }, { key: 'wto_date', label: 'Date' }, { key: 'wto_num', label: 'WTO No', sortable: true }, { key: 'remarks', label: 'Remarks' }, { key: 'reason', label: 'Reason' }, { key: 'author_user_shortname', label: 'Created By' }],
      currentPage: 1,
      perPage: 20,
      totalRows: 0
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'noResults', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'exportHeaders', {
      'WTO No': 'wto_num',
      'Date': 'wto_date',
      'Country': 'country_id',
      'Location From': 'from_location_id',
      'Location To': 'to_location_id',
      'Status': 'status',
      'Remarks': 'remarks',
      'Reason': 'reason',
      'Created By': 'author_user_shortname'
    }), _ref;
  },
  methods: {
    print: function print() {
      var rows = [];
      var row = [];
      var date = new Date();
      rows.push(['WTO No', 'Date', 'Country Code', 'Location From', 'Location To', 'Status', 'Remarks', 'Reason', 'Created By']);

      for (var key in this.searchResults) {
        var data = this.searchResults[key];
        var ref = '-';
        var reason = '-';
        if (data.reason != '') {
          reason = data.reason;
        }
        if (data.remarks != '') {
          ref = data.remarks;
        }
        row = [data.wto_num, data.wto_date, data.country_id, data.from_location_id, data.to_location_id, data.status, ref, reason, data.author_user_shortname];
        rows.push(row);
      }
      var dd = {
        header: { text: 'Warehouse Transfer Order List generated on' + " " + date, margin: [5, 10, 10, 30], alignment: 'center', fontSize: 8 },
        pageSize: 'A4',
        pageOrientation: 'landscape',

        pageMargins: [30, 30, 30, 20],
        defaultStyle: {
          font: 'ukai'
        },
        content: [{
          fontSize: 9,
          layout: 'lightHorizontalLines',
          table: {
            headerRows: 1,
            widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 280, 'auto', 'auto'],
            body: rows
          }
        }]
      };

      __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake___default.a.createPdf(dd).open();
    },
    getRowCount: function getRowCount(items) {
      return items.length;
    },
    search: function search() {
      var _this = this;

      this.noResults = true;
      if (1) {
        this.loading = true;
        var sf = ["wto_num LIKE " + this.filter.wto_num, "country_id = " + this.filter.country_id, "wto_date >= " + this.filter.date_start, "wto_date <= " + this.filter.date_end, "status = " + this.filter.status];

        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_4__functions_common_vue__["_4" /* apiWtoSearch */], sf).then(function (res) {
          return res;
        }).then(function (data) {
          var resultArray = [];
          var myData = data.data.data.list;
          for (var key in myData) {
            var date = myData[key].wto_date;
            var date = new Date(date);
            var result = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + (date.getMonth() + 1 > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear();
            myData[key].wto_date = result;
            if (myData[key].remarks == '') {
              myData[key].remarks = '-';
            }
            if (myData[key].reason == '') {
              myData[key].reason = '-';
            }
            resultArray.push(myData[key]);
            _this.loading = false;
          }
          _this.searchResults = resultArray;

          if (_this.searchResults.length == 0) {
            _this.loading = false;
            _this.noResults = true;
          }
        }).catch(function (error) {
          return alert(error);
        });
      }
    },
    newWTO: function newWTO() {
      this.$router.push({ name: 'Warehouse Transfer Order Entry (WTO)', params: { wtoNum: '_new' } });
    },
    setCountry: function setCountry(obj) {
      var id;
      if (obj !== null) {
        id = obj.id;
      } else {
        id = null;
      }
      this.filter.country_id = id;
    },
    rowClick: function rowClick(item) {
      this.$router.push({ name: 'Warehouse Transfer Order Entry (WTO)', params: { wtoNum: item.wto_num } });
    }
  }
});

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Autocomplete_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__functions_common_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pdfmake_build_vfs_fonts__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pdfmake_build_vfs_fonts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_pdfmake_build_vfs_fonts__);










__WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake___default.a.vfs = __WEBPACK_IMPORTED_MODULE_4_pdfmake_build_vfs_fonts___default.a.pdfMake.vfs;
__WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake___default.a.fonts = {
    "ukai": {
        normal: 'ukai.ttf',
        bold: 'ukai.ttf',
        italics: 'ukai.ttf',
        bolditalics: 'ukai.ttf'
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    components: { warehouseLookup: __WEBPACK_IMPORTED_MODULE_1__components_Autocomplete_vue__["a" /* default */], productLookup: __WEBPACK_IMPORTED_MODULE_1__components_Autocomplete_vue__["a" /* default */], countryLookup: __WEBPACK_IMPORTED_MODULE_1__components_Autocomplete_vue__["a" /* default */] },
    data: function data() {
        return {
            parentName: 'Warehouse Transfer Orders',
            defaultTitle: 'Warehouse Transfer Order',
            title: 'New WTO',
            country_name: '',
            apiWarehouseUrl: __WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["V" /* apiWarehouseLookup */],
            apiCountryLookup: __WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["c" /* apiCountryLookup */],
            apiLocationProductUrl: __WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["q" /* apiLocationProductUrl */],
            docRef: '',
            hideBtns: false,
            modalManualCloseShow: false,
            displayTxt: '',
            prevWhId: '',
            preCountryId: '',
            lockEntry: false,
            wto_status: '',
            modalShow: false,
            modalCancelShow: false,
            wtoDocNo: '',
            errorMessage: '',
            wto: {
                wto_date: '',
                country_id: '',
                from_location_id: '',
                to_location_id: '',
                reference_num: '',
                reason: '',
                remarks: '',
                wto_items: [{ product_name: '', product_id: '', qty_soh: '', qty: '' }]
            }
        };
    },
    created: function created() {
        this.docRef = this.$route.params.wtoNum;
        if (this.docRef == '_new') {
            var curDate = new Date();
            curDate = curDate.toISOString().substr(0, 10);
            this.wto.wto_date = curDate;
        } else {
            this.fetch(this.docRef);
            this.lockEntry = true;
        }
    },

    methods: {
        validateQty: function validateQty(index) {
            var items = this.wto.wto_items;
            if (items[index].qty < 0) {
                items[index].qty = 0;
            }
        },
        print: function print() {
            var wto_num = this.wto.wto_num;
            var row = [];
            var date = new Date(this.wto.wto_date);
            var wtoDate = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + (date.getMonth() + 1 > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear();
            var wtoItems = [];
            var groTotalAmount = 0;
            row = [{
                text: 'S/No',
                style: 'itemsHeader'
            }, {
                text: 'Product Code',
                style: ['itemsHeader'],
                alignment: 'left'
            }, {
                text: 'Description',
                style: ['itemsHeader'],
                alignment: 'left'
            }, {
                text: 'SOH',
                style: ['itemsHeader'],
                alignment: 'right'
            }, {
                text: 'Transfer Qty',
                style: ['itemsHeader'],
                alignment: 'right'
            }];
            wtoItems.push(row);
            var items = this.wto.wto_items;
            for (var key in items) {
                var data = items[key];
                var soh = (data.qty_soh * 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                var qty = (data.qty * 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                if (data.product_name == null) {
                    data.product_name = "";
                }
                row = [{
                    text: key * 1 + 1,
                    style: 'itemText'
                }, {
                    text: data.product_id,
                    style: 'itemText'
                }, {
                    text: data.product_name,
                    style: 'itemText'
                }, {
                    text: soh,
                    style: 'itemNumber'
                }, {
                    text: qty,
                    style: 'itemNumber'
                }];
                wtoItems.push(row);
            }

            var ddHeader = {
                columns: [[{
                    text: 'ELKEN ' + this.country_name + ' WAREHOUSE TRANSFER ORDER',
                    style: 'invoiceTitle',
                    width: '*'
                }, {
                    stack: [{
                        columns: [{
                            text: 'WTO #',
                            style: 'invoiceSubTitle',
                            width: 150

                        }, {
                            text: wto_num,
                            style: 'invoiceSubValue',
                            width: 150
                        }]
                    }, {
                        text: ' '
                    }, {
                        columns: [{
                            text: 'WTO Date',
                            style: 'invoiceSubTitle',
                            width: 150

                        }, {
                            text: wtoDate,
                            style: 'invoiceSubValue',
                            width: 150

                        }]

                    }, {
                        text: ' '
                    }, {
                        columns: [{
                            text: 'Status',
                            style: 'invoiceSubTitle',
                            width: 150

                        }, {
                            text: this.wto.status,
                            style: 'invoiceSubValue'
                        }]

                    }, {
                        text: ' '
                    }, {
                        columns: [{
                            text: 'Country',
                            style: 'invoiceSubTitle',
                            width: 150

                        }, {
                            text: this.wto.country_id,
                            style: 'invoiceSubValue'
                        }]
                    }, {
                        text: ' '
                    }, {
                        columns: [{
                            text: 'Stock Location From',
                            style: 'invoiceSubTitle',
                            width: 150

                        }, {
                            text: this.wto.from_location_full,
                            style: 'invoiceSubValue'
                        }]
                    }, {
                        text: ' '
                    }, {
                        columns: [{
                            text: 'Stock Location To',
                            style: 'invoiceSubTitle',
                            width: 150

                        }, {
                            text: this.wto.to_location_full,
                            style: 'invoiceSubValue'

                        }]
                    }, {
                        text: ' '
                    }, {
                        columns: [{
                            text: 'Reason',
                            style: 'invoiceSubTitle',
                            width: 150

                        }, {
                            text: this.wto.reason,
                            style: 'invoiceSubValue'

                        }]
                    }, {
                        text: ' '
                    }, {
                        columns: [{
                            text: 'Reference #',
                            style: 'invoiceSubTitle',
                            width: 150

                        }, {
                            text: this.wto.reference_num,
                            style: 'invoiceSubValue'
                        }]
                    }]
                }]]
            };

            var dd = {
                header: function header(pageNumber, pageCount) {
                    return {
                        margin: [0, 10, 0, 0],
                        columns: [{
                            text: '',
                            style: 'documentHeaderLeft'
                        }, {
                            text: wto_num,
                            style: 'documentHeaderCenter'
                        }, {
                            text: '',
                            style: 'documentHeaderRight'
                        }]
                    };
                },
                footer: function footer(pageNumber, pageCount) {
                    return {
                        margin: [0, 0, 0, 50],
                        columns: [{
                            text: '',
                            style: 'documentFooterLeft'
                        }, {
                            text: 'Page ' + pageNumber + " of " + pageCount,
                            style: 'documentFooterCenter'
                        }, {
                            text: '',
                            style: 'documentFooterRight'
                        }]
                    };
                },
                content: [ddHeader, '\n\n', {
                    layout: 'lightHorizontalLines',
                    table: {

                        headerRows: 1,
                        widths: [25, 68, '*', 45, 45],
                        body: wtoItems

                    } }, {
                    text: 'Remarks',
                    style: 'notesTitle'
                }, {
                    text: this.wto.remarks,
                    style: 'notesText'
                }, {
                    columns: [{
                        stack: [{
                            text: 'Issued By',
                            style: 'signaturePlaceholder'
                        }, {
                            text: '______________________________',
                            style: 'signaturePlaceholder'
                        }, {
                            text: 'Name  : ' + this.wto.author_user_shortname,
                            style: 'signatureName'

                        }, {
                            text: 'Date  : ' + wtoDate,
                            style: 'signatureJobTitle'

                        }],
                        width: 160
                    }, {
                        stack: [{
                            text: '  ',
                            style: 'signaturePlaceholder'
                        }, {
                            text: '                      ',
                            style: 'signaturePlaceholder'
                        }, {
                            text: '  ',
                            style: 'signatureName'

                        }, {
                            text: '      ',
                            style: 'signatureJobTitle'

                        }],
                        width: 180
                    }, {
                        stack: [{
                            text: 'Received By',
                            style: 'signaturePlaceholder'
                        }, {
                            text: '______________________________',
                            style: 'signaturePlaceholder'
                        }, {
                            text: 'Name  :',
                            style: 'signatureName'

                        }, {
                            text: 'Date  :',
                            style: 'signatureJobTitle'

                        }],
                        width: 160
                    }]
                }],
                styles: {
                    documentHeaderLeft: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'left'
                    },
                    documentHeaderCenter: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'center'
                    },
                    documentHeaderRight: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'right'
                    },

                    documentFooterLeft: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'left'
                    },
                    documentFooterCenter: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'center'
                    },
                    documentFooterRight: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'right'
                    },

                    invoiceTitle: {
                        fontSize: 22,
                        bold: true,
                        alignment: 'left',
                        margin: [0, 0, 0, 15]
                    },

                    invoiceSubTitle: {
                        fontSize: 10,
                        alignment: 'left'
                    },
                    invoiceSubValue: {
                        fontSize: 10,
                        alignment: 'left'
                    },

                    invoiceBillingTitle: {
                        fontSize: 14,
                        bold: true,
                        alignment: 'left',
                        margin: [0, 20, 0, 5]
                    },

                    invoiceBillingDetails: {
                        alignment: 'left'

                    },
                    invoiceBillingAddressTitle: {
                        margin: [0, 7, 0, 3],
                        bold: true
                    },
                    invoiceBillingAddress: {},

                    itemsHeader: {

                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        bold: true
                    },

                    itemTitle: {
                        bold: true
                    },
                    itemSubTitle: {
                        fontSize: 10
                    },
                    itemText: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        alignment: 'left'
                    },
                    itemNumber: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        alignment: 'right'
                    },
                    itemTotal: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right'
                    },

                    itemsFooterSubTitle: {
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right'
                    },
                    itemsFooterSubValue: {
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'center'
                    },
                    itemsFooterTotalTitle: {
                        fontSize: 11,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right'
                    },
                    itemsFooterTotalValue: {
                        fontSize: 11,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'center'
                    },
                    signaturePlaceholder: {
                        fontSize: 10,
                        margin: [0, 70, 0, 0]
                    },
                    signatureName: {
                        fontSize: 10,
                        margin: [0, 10, 0, 0],
                        bold: true,
                        alignment: 'left'
                    },
                    signatureJobTitle: {
                        fontSize: 10,
                        margin: [0, 20, 0, 0],
                        bold: true,
                        alignment: 'left'
                    },
                    notesTitle: {
                        fontSize: 10,
                        bold: true,
                        margin: [0, 30, 0, 3]
                    },
                    notesText: {
                        fontSize: 10
                    },
                    center: {
                        alignment: 'center'
                    }
                },
                defaultStyle: {
                    columnGap: 20,
                    font: 'ukai'
                }
            };
            __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake___default.a.createPdf(dd).open();
        },
        save: function save() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["_3" /* apiWtoSave */], this.wto, Object(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["_7" /* authHeader */])()).then(function (res) {
                var r = res.data;
                if (r.code == 1) {
                    _this.wtoDocNo = r.data.wto_num;
                    _this.displayTxt = " saved";
                    _this.$refs.myModalRef.show();
                } else {
                    _this.errorMessage = r.msg;
                    _this.$refs.myErrorModalRef.show();
                }
            }).catch(function (error) {
                return console.log(error);
            });
        },
        fetch: function fetch(docNum) {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["_0" /* apiWtoGet */], { wto_num: docNum }, Object(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["_7" /* authHeader */])()).then(function (res) {
                var data;
                data = res.data.data;
                _this2.wto_status = data.status;
                if (_this2.wto_status == 'MANUAL-CLOSED' || _this2.wto_status == 'CLOSE') {
                    _this2.hideBtns = true;
                }
                _this2.wto = data;

                if (_this2.wto.country_id != null) {
                    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["c" /* apiCountryLookup */], { params: { q: _this2.wto.country_id } }).then(function (response) {

                        if (response.data != null) {
                            _this2.list = response.data.data.list;
                            _this2.item = _this2.list[0];
                            _this2.country_name = _this2.item.country_name;
                            _this2.country_name = _this2.country_name.toUpperCase();
                        }
                    });
                }
                _this2.title = _this2.defaultTitle + ' ' + docNum;
            }).catch(function (error) {
                return alert(error);
            });
        },
        setWarehouseFrom: function setWarehouseFrom(obj) {
            if (!this.lockEntry) {
                var id = obj.id;
                var id2 = this.wto.to_location_id;

                this.prevCountryId = this.wto.country_id;
                if (id2 != null) {
                    if (id == id2) {
                        id = null;
                        this.$refs.warehouseFrom.clear();
                    }
                }

                this.wto.from_location_id = id;
                this.wto.wto_items = [];
            }
        },
        setWarehouseTo: function setWarehouseTo(obj) {
            if (!this.lockEntry) {
                var id = obj.id;
                var id2 = this.wto.from_location_id;
                this.prevCountryId = this.wto.country_id;

                if (id2 != null) {
                    if (id == id2) {
                        id = null;
                        this.$refs.warehouseTo.clear();
                    }
                }

                this.wto.to_location_id = id;
                this.wto.wto_items = [];
            }
        },
        checkValue: function checkValue() {
            var show = false;
            if (this.wto.from_location_id != '' && this.wto.to_location_id != '') {
                if (this.wto.from_location_id != null && this.wto.to_location_id != null) {
                    show = true;
                } else {
                    show = false;
                }
            } else {
                show = false;
            }
            return show;
        },
        setProduct: function setProduct(obj, index) {
            if (!this.lockEntry) {
                this.prevWhId = this.wto.from_location_id;

                if (obj != []) {
                    var name, id, qty_soh, unit_gmp;

                    var isDuplicatedEntry = false;
                    var items = this.wto.wto_items;

                    for (var n = 0; n < items.length; n++) {
                        if (n != index) {
                            if (items[n].product_id == items[index].product_id && items[index].product_id != "") {
                                isDuplicatedEntry = true;
                            }

                            if (isDuplicatedEntry) break;
                        }
                    }
                    if (!isDuplicatedEntry) {
                        if (obj !== null) {
                            if (obj.id == "") {
                                qty_soh = "";
                                unit_gmp = "";
                            } else {
                                name = obj.name;
                                id = obj.id;
                                qty_soh = obj.qty_soh;
                                unit_gmp = obj.unit_gmp;
                            }
                        } else {
                            name = "";
                            id = "";
                            qty_soh = "";
                            unit_gmp = "";
                        }

                        if (isNaN(qty_soh)) qty_soh = "";
                    } else {
                        name = "";
                        id = "";
                        qty_soh = "";
                        unit_gmp = "";
                    }

                    this.wto.wto_items[index].product_id = id;
                    this.wto.wto_items[index].product_name = name;
                    this.wto.wto_items[index].qty_soh = qty_soh;
                    this.wto.wto_items[index].qty = 0;
                }
            }
        },
        addRow: function addRow() {
            this.wto.wto_items.push({ product_id: '', product_name: '', qty_soh: '', qty: '' });
        },
        removeRow: function removeRow(index) {
            this.wto.wto_items.splice(index, 1);
        },
        setCountry: function setCountry(obj) {
            if (!this.lockEntry) {
                var id;
                if (obj !== null) {
                    id = obj.id;
                } else {
                    id = null;
                }
                this.wto.country_id = id;

                if (this.wto.country_id == '' || this.wto.country != this.prevCountryId) {
                    this.wto.wto_items = [];
                    this.wto.from_location_id = null;
                    this.wto.to_location_id = null;
                }
            }
        },
        confirmManualClose: function confirmManualClose() {
            this.modalManualCloseShow = true;
        },
        confirmSave: function confirmSave() {
            this.modalShow = true;
        },
        confirmCancel: function confirmCancel() {
            this.modalCancelShow = true;
        },
        cancel: function cancel() {
            this.$router.push({ name: 'Warehouse Transfer Orders (WTOS)' });
        },
        hideModal: function hideModal() {
            this.$refs.myModalRef.hide();
            this.$router.push({ name: 'Warehouse Transfer Orders (WTOS)' });
        },
        hideErrorModal: function hideErrorModal() {
            this.$refs.myErrorModalRef.hide();
        },
        back: function back() {
            this.$router.push({ name: 'Warehouse Transfer Orders (WTOS)' });
        },
        manualClose: function manualClose() {
            var _this3 = this;

            this.hideBtns = true;
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["_2" /* apiWtoManualClose */], { wto_num: this.wto.wto_num, approve: 1 }, Object(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["_7" /* authHeader */])()).then(function (res) {
                var r = res.data;
                if (r.code == 1) {
                    _this3.wtoDocNo = r.data.wto_num;
                    _this3.displayTxt = "manual-closed";
                    _this3.hideBtns = true;
                    _this3.$refs.myModalRef.show();
                } else {
                    _this3.errorMessage = r.msg;
                    _this3.$refs.myErrorModalRef.show();
                }
            }).catch(function (error) {
                return alert(error);
            });
        }
    }
});

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Autocomplete_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__functions_common_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_json_excel__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pdfmake_build_vfs_fonts__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pdfmake_build_vfs_fonts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_pdfmake_build_vfs_fonts__);












__WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake___default.a.vfs = __WEBPACK_IMPORTED_MODULE_7_pdfmake_build_vfs_fonts___default.a.pdfMake.vfs;
__WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake___default.a.fonts = {
  "ukai": {
    normal: 'ukai.ttf',
    bold: 'ukai.ttf',
    italics: 'ukai.ttf',
    bolditalics: 'ukai.ttf'
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  components: { spinner: __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue__["a" /* default */], countryLookup: __WEBPACK_IMPORTED_MODULE_3__components_Autocomplete_vue__["a" /* default */], exportExcel: __WEBPACK_IMPORTED_MODULE_5_vue_json_excel__["a" /* default */] },
  props: {
    caption: {
      type: String,
      default: 'Table'
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var _ref;

    return _ref = {
      isWtrAdmin: false,
      apiCountryLookup: __WEBPACK_IMPORTED_MODULE_4__functions_common_vue__["c" /* apiCountryLookup */],
      loading: false,
      noResults: false,
      filter: {
        wto_num: '',
        wtr_num: '',
        country_id: '',
        date_start: '',
        date_end: '',
        status: ''
      },
      searchResults: [],
      searchResultsFields: [{ key: 'country_id', label: 'Country Code' }, { key: 'from_location_id', label: 'Location From' }, { key: 'to_location_id', label: 'Location To' }, { key: 'wto_date', label: 'Date' }, { key: 'wto_num', label: 'WTO No' }, { key: 'status', label: 'Status' }, { key: 'last_wtr_num', label: 'Last WTR', sortable: true }, { key: 'last_wtr_date', label: 'WTR Date' }, { key: 'author_user_shortname', label: 'Created By' }],
      currentPage: 1,
      perPage: 20,
      totalRows: 0
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'noResults', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'exportHeaders', {
      'WTO No': 'wto_num',
      'WTO Date': 'wto_date',
      'Country': 'country_id',
      'Location From': 'from_location_id',
      'Location To': 'to_location_id',
      'Status': 'status',
      'Last WTR': 'last_wtr_num',
      'Last WTR Date': 'last_wtr_date',
      'Created By': 'author_user_shortname'
    }), _ref;
  },
  created: function created() {
    var app_role;

    app_role = JSON.parse(localStorage.getItem('app_role'));
    this.isWtrAdmin = app_role.includes('WTR_ADMIN');
  },
  methods: {
    print: function print() {
      var rows = [];
      var row = [];
      var date = new Date();
      rows.push(['WTO No', 'WTO Date', 'Country Code', 'Location From', 'Location To', 'Status', 'Last WTR', 'Last WTR Date', 'Created By']);

      for (var key in this.searchResults) {
        var data = this.searchResults[key];
        row = [data.wto_num, data.wto_date, data.country_id, data.from_location_id, data.to_location_id, data.status, data.last_wtr_num, data.last_wtr_date, data.author_user_shortname];
        rows.push(row);
      }
      var dd = {
        header: { text: 'Warehouse Transfer Receiving List generated on' + " " + date, margin: [5, 10, 10, 30], alignment: 'center', fontSize: 8 },
        pageSize: 'A4',
        pageOrientation: 'landscape',

        pageMargins: [30, 30, 30, 20],
        defaultStyle: {
          font: 'ukai'
        },
        content: [{
          fontSize: 10,
          layout: 'lightHorizontalLines',
          table: {
            headerRows: 1,
            widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
            body: rows
          }
        }]
      };

      __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake___default.a.createPdf(dd).open();
    },
    getRowCount: function getRowCount(items) {
      return items.length;
    },
    search: function search() {
      var _this = this;

      this.loading = true;
      var sf = ["wto_num LIKE " + this.filter.wto_num, "wtrs_list LIKE " + this.filter.wtr_num, "country_id = " + this.filter.country_id, "wto_date >= " + this.filter.date_start, "wto_date <= " + this.filter.date_end, "status = " + this.filter.status];
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_4__functions_common_vue__["_6" /* apiWtrSearch */], sf, Object(__WEBPACK_IMPORTED_MODULE_4__functions_common_vue__["_7" /* authHeader */])()).then(function (res) {
        return res;
      }).then(function (data) {
        var resultArray = [];
        var myData = data.data.data.list;
        for (var key in myData) {
          var date = myData[key].wto_date;
          date = new Date(date);
          var result = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + (date.getMonth() + 1 > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear();
          var wtrDateResult = '-';
          if (myData[key].last_wtr_date != null) {
            var wtrDate = myData[key].last_wtr_date;
            wtrDate = new Date(wtrDate);
            wtrDateResult = "" + (wtrDate.getDate() > 9 ? '' : '0') + wtrDate.getDate() + '/' + (wtrDate.getMonth() + 1 > 9 ? '' : '0') + (wtrDate.getMonth() + 1) + '/' + wtrDate.getFullYear();
          }
          var wtr_num = '-';
          if (myData[key].last_wtr_num != null) {
            wtr_num = myData[key].last_wtr_num;
          }
          myData[key].last_wtr_num = wtr_num;
          myData[key].wto_date = result;
          myData[key].last_wtr_date = wtrDateResult;
          resultArray.push(myData[key]);
          _this.loading = false;
        }
        _this.searchResults = resultArray;

        if (_this.searchResults.length == 0) {
          _this.loading = false;
          _this.noResults = true;
        }
      }).catch(function (error) {
        return alert(error);
      });
    },
    newWTR: function newWTR() {
      localStorage.setItem("wtr_new.wto_num", "");
      this.$router.push({ name: 'Warehouse Transfer Receiving Entry (WTR)', params: { wtrNum: '_new' } });
    },
    setCountry: function setCountry(obj) {
      var id;
      if (obj !== null) {
        id = obj.id;
      } else {
        id = null;
      }
      this.filter.country_id = id;
    },
    rowClick: function rowClick(item, index) {
      localStorage.setItem("wtr_new.wto_num", item.wto_num);
      this.$router.push({ name: 'Warehouse Transfer Receiving Entry (WTR)', params: { wtrNum: '_new' } });
    }
  }
});

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Autocomplete_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__functions_common_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pdfmake_build_vfs_fonts__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pdfmake_build_vfs_fonts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_pdfmake_build_vfs_fonts__);








__WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake___default.a.vfs = __WEBPACK_IMPORTED_MODULE_4_pdfmake_build_vfs_fonts___default.a.pdfMake.vfs;
__WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake___default.a.fonts = {
    "ukai": {
        normal: 'ukai.ttf',
        bold: 'ukai.ttf',
        italics: 'ukai.ttf',
        bolditalics: 'ukai.ttf'
    }
};
/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'wtr',
    components: { wtoLookup: __WEBPACK_IMPORTED_MODULE_1__components_Autocomplete_vue__["a" /* default */] },
    data: function data() {
        return {
            wtoNum: '',
            modalMsg: '',
            isWTORetrieved: false,
            isWtrAdmin: false,
            modalShow: false,
            modalCancelShow: false,
            title: 'New WTR',
            errorMessage: '',
            apiWtoLookup: __WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["_1" /* apiWtoLookup */],
            wtrDocNo: 'test',
            isValid: true,
            received_qty: 0,
            country_name: '',
            wtr: {
                wtr_num: '',
                wtr_date: '',
                wto_num: '',
                remarks: '',
                reference_num: '',
                wtr_items: {},
                wto: {
                    wtrs: {}
                }
            }
        };
    },
    created: function created() {
        var _this = this;

        var app_role;

        app_role = JSON.parse(localStorage.getItem('app_role'));
        this.isWtrAdmin = app_role.includes('WTR_ADMIN');

        if (localStorage.getItem("wtr_new.wto_num") != "") {
            this.isWTORetrieved = true;
            var wtoNum = localStorage.getItem("wtr_new.wto_num");
            var url = this.apiWtoLookup;

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url, { params: { q: wtoNum, get: 1 } }, Object(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["_7" /* authHeader */])()).then(function (response) {
                _this.list = response.data.data.list;
                if (_this.list.length > 0) {
                    _this.item = _this.list[0];
                    if (_this.item !== null) {
                        _this.isWTORetrieved = true;

                        var wto = _this.item;
                        console.log(wto);
                        if (wto.country_id != null) {
                            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["c" /* apiCountryLookup */], { params: { q: wto.country_id } }).then(function (response) {

                                if (response.data != null) {
                                    _this.list = response.data.data.list;
                                    _this.item = _this.list[0];
                                    _this.country_name = _this.item.country_name;
                                    _this.country_name = _this.country_name.toUpperCase();
                                }
                            });
                        }
                        var curDate = new Date();
                        curDate = curDate.toISOString().substr(0, 10);
                        _this.wtr.wtr_date = curDate;
                        _this.wtr.wto = wto;
                        _this.wtr.wto_num = wto.wto_num;
                    }
                }
            }).catch(function (error) {
                return alert(error);
            });
        } else {
            this.isWToRetrieved = false;
            this.wtrNum = '';
        }
    },
    methods: {
        printWTR: function printWTR(row) {
            var wtr_num = row.wtr_num;
            var r = [];
            var wtrItems = [];
            r = [{
                text: 'S/No',
                style: 'itemsHeader'
            }, {
                text: 'Product Code',
                style: ['itemsHeader'],
                alignment: 'left'
            }, {
                text: 'Description',
                style: ['itemsHeader'],
                alignment: 'left'
            }, {
                text: 'Qty',
                style: ['itemsHeader'],
                alignment: 'right'
            }];
            wtrItems.push(r);

            var items = row.wtr_items;
            for (var key in items) {
                var data = items[key];
                var qty = (data.qty * 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                if (data.product_name == null) {
                    data.product_name = "";
                }
                r = [{
                    text: key * 1 + 1,
                    style: 'itemText'
                }, {
                    text: data.product_id,
                    style: 'itemText'
                }, {
                    text: data.product_name,
                    style: 'itemText'
                }, {
                    text: qty,
                    style: 'itemNumber'
                }];
                wtrItems.push(r);
            }

            var ddHeader = {
                columns: [[{
                    text: 'ELKEN ' + this.country_name + ' WAREHOUSE TRANSFER RECEIVING',
                    style: 'invoiceTitle',
                    width: '*'
                }, {
                    stack: [{
                        columns: [{
                            text: 'WTR #',
                            style: 'invoiceSubTitle',
                            width: 150

                        }, {
                            text: wtr_num,
                            style: 'invoiceSubValue',
                            width: 100
                        }]
                    }, {
                        text: ' '
                    }, {
                        columns: [{
                            text: 'WTR Date',
                            style: 'invoiceSubTitle',
                            width: 150

                        }, {
                            text: row.wtr_date_friendly,
                            style: 'invoiceSubValue',
                            width: 100
                        }]

                    }, {
                        text: ' '
                    }, {
                        columns: [{
                            text: 'Reference WTO #',
                            style: 'invoiceSubTitle',
                            width: 150

                        }, {
                            text: row.wto_num,
                            style: 'invoiceSubValue'
                        }]

                    }, {
                        text: ' '
                    }, {
                        columns: [{
                            text: 'Location From (Warehouse)',
                            style: 'invoiceSubTitle',
                            width: 150

                        }, {
                            text: this.wtr.wto.from_location_full,
                            style: 'invoiceSubValue'
                        }]

                    }, {
                        text: ' '
                    }, {
                        columns: [{
                            text: 'Receiving Warehouse',
                            style: 'invoiceSubTitle',
                            width: 150

                        }, {
                            text: this.wtr.wto.to_location_full,
                            style: 'invoiceSubValue'
                        }]

                    }]
                }]]
            };

            var dd = {
                header: function header(pageNumber, pageCount) {
                    return {
                        margin: [0, 10, 0, 0],
                        columns: [{
                            text: '',
                            style: 'documentHeaderLeft'
                        }, {
                            text: wtr_num,
                            style: 'documentHeaderCenter'
                        }, {
                            text: '',
                            style: 'documentHeaderRight'
                        }]
                    };
                },
                footer: function footer(pageNumber, pageCount) {
                    return {
                        margin: [0, 0, 0, 50],
                        columns: [{
                            text: '',
                            style: 'documentFooterLeft'
                        }, {
                            text: 'Page ' + pageNumber + " of " + pageCount,
                            style: 'documentFooterCenter'
                        }, {
                            text: '',
                            style: 'documentFooterRight'
                        }]
                    };
                },
                content: [ddHeader, '\n\n', {
                    layout: 'lightHorizontalLines',
                    table: {

                        headerRows: 1,
                        widths: [25, 68, '*', 45, 45],
                        body: wtrItems

                    } }, {
                    text: 'Remarks',
                    style: 'notesTitle'
                }, {
                    text: row.remarks,
                    style: 'notesText'
                }, {
                    columns: [{
                        stack: [{
                            text: 'Received By',
                            style: 'signaturePlaceholder'
                        }, {
                            text: '______________________________',
                            style: 'signaturePlaceholder'
                        }, {
                            text: 'Name  :',
                            style: 'signatureName'

                        }, {
                            text: 'Date  :',
                            style: 'signatureJobTitle'

                        }],
                        width: 160
                    }]
                }],
                styles: {
                    documentHeaderLeft: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'left'
                    },
                    documentHeaderCenter: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'center'
                    },
                    documentHeaderRight: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'right'
                    },

                    documentFooterLeft: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'left'
                    },
                    documentFooterCenter: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'center'
                    },
                    documentFooterRight: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'right'
                    },

                    invoiceTitle: {
                        fontSize: 20,
                        bold: true,
                        alignment: 'left',
                        margin: [0, 0, 0, 15]
                    },

                    invoiceSubTitle: {
                        fontSize: 10,
                        alignment: 'left'
                    },
                    invoiceSubValue: {
                        fontSize: 10,
                        alignment: 'left'
                    },

                    invoiceBillingTitle: {
                        fontSize: 14,
                        bold: true,
                        alignment: 'left',
                        margin: [0, 20, 0, 5]
                    },

                    invoiceBillingDetails: {
                        alignment: 'left'

                    },
                    invoiceBillingAddressTitle: {
                        margin: [0, 7, 0, 3],
                        bold: true
                    },
                    invoiceBillingAddress: {},

                    itemsHeader: {

                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        bold: true
                    },

                    itemTitle: {
                        bold: true
                    },
                    itemSubTitle: {
                        fontSize: 10
                    },
                    itemText: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        alignment: 'left'
                    },
                    itemNumber: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        alignment: 'right'
                    },
                    itemTotal: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right'
                    },

                    itemsFooterSubTitle: {
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right'
                    },
                    itemsFooterSubValue: {
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'center'
                    },
                    itemsFooterTotalTitle: {
                        fontSize: 11,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right'
                    },
                    itemsFooterTotalValue: {
                        fontSize: 11,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'center'
                    },
                    signaturePlaceholder: {
                        fontSize: 10,
                        margin: [0, 70, 0, 0]
                    },
                    signatureName: {
                        fontSize: 10,
                        margin: [0, 10, 0, 0],
                        bold: true,
                        alignment: 'left'
                    },
                    signatureJobTitle: {
                        fontSize: 10,
                        margin: [0, 20, 0, 0],
                        bold: true,
                        alignment: 'left'
                    },
                    notesTitle: {
                        fontSize: 10,
                        bold: true,
                        margin: [0, 30, 0, 3]
                    },
                    notesText: {
                        fontSize: 10
                    },
                    center: {
                        alignment: 'center'
                    }
                },
                defaultStyle: {
                    columnGap: 20,
                    font: 'ukai'
                }
            };
            __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake___default.a.createPdf(dd).open();
        },
        print: function print() {
            console.log(this.wtr.wto);
            var wtoNum = this.wtr.wto_num;
            var row = [];
            var date = new Date(this.wtr.wto.wto_date);
            var wtoDate = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + (date.getMonth() + 1 > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear();
            var wtoItems = [];
            row = [{
                text: 'S/No',
                style: 'itemsHeader'
            }, {
                text: 'Product Code',
                style: ['itemsHeader'],
                alignment: 'left'
            }, {
                text: 'Description',
                style: ['itemsHeader'],
                alignment: 'left'
            }, {
                text: 'WTO Qty',
                style: ['itemsHeader'],
                alignment: 'right'
            }, {
                text: 'Received Qty',
                style: ['itemsHeader'],
                alignment: 'right'
            }];
            wtoItems.push(row);
            var items = this.wtr.wto.wto_items;
            for (var key in items) {
                var data = items[key];
                var qty = (data.qty * 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                var qty_received = (data.qty_received * 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                if (data.product_name == null) {
                    data.product_name = "";
                }
                row = [{
                    text: key * 1 + 1,
                    style: 'itemText'
                }, {
                    text: data.product_id,
                    style: 'itemText'
                }, {
                    text: data.product_name,
                    style: 'itemText'
                }, {
                    text: qty,
                    style: 'itemNumber'
                }, {
                    text: qty_received,
                    style: 'itemNumber'
                }];
                wtoItems.push(row);
            }
            var wtrItems = [];
            var wtrsRow = [];
            wtrsRow = [{
                text: 'S/No',
                style: 'itemsHeader'
            }, {
                text: 'GRN #',
                style: ['itemsHeader'],
                alignment: 'left'
            }, {
                text: 'GRN Date',
                style: ['itemsHeader'],
                alignment: 'left'
            }, {
                text: 'Generated By',
                style: ['itemsHeader'],
                alignment: 'left'
            }];
            wtrItems.push(wtrsRow);
            var wtrs = this.wtr.wto.wtrs;
            for (var _key in wtrs) {
                var gd = wtrs[_key];
                wtrsRow = [{
                    text: _key * 1 + 1,
                    style: 'itemText'
                }, {
                    text: gd.wtr_num,
                    style: 'itemText'
                }, {
                    text: gd.wtr_date_friendly,
                    style: 'itemText'
                }, {
                    text: gd.author_user_shortname,
                    style: 'itemText'
                }];
                wtrItems.push(wtrsRow);
            }

            var ddHeader = {
                columns: [[{
                    text: 'ELKEN ' + this.country_name + ' WAREHOUSE TRANSFER RECEIVING',
                    style: 'invoiceTitle',
                    width: '*'
                }, {
                    stack: [{
                        columns: [{
                            text: 'WTO #',
                            style: 'invoiceSubTitle',
                            width: 90

                        }, {
                            text: wtoNum,
                            style: 'invoiceSubValue',
                            width: 130
                        }, { text: '', style: 'invoiceSubValue', width: 40 }, {
                            text: 'WTO Date',
                            style: 'invoiceSubTitle',
                            width: 80

                        }, {
                            text: wtoDate,
                            style: 'invoiceSubValue',
                            width: 130

                        }]
                    }, {
                        columns: [{
                            text: 'Location From',
                            style: 'invoiceSubTitle',
                            width: 90

                        }, {
                            text: this.wtr.wto.from_location_full,
                            style: 'invoiceSubValue',
                            width: 130
                        }, { text: '', style: 'invoiceSubValue', width: 40 }, {
                            text: 'Location To',
                            style: 'invoiceSubTitle',
                            width: 80

                        }, {
                            text: this.wtr.wto.to_location_full,
                            style: 'invoiceSubValue',
                            width: 'auto'
                        }]

                    }, {
                        columns: [{
                            text: 'Status',
                            style: 'invoiceSubTitle',
                            width: 90

                        }, {
                            text: this.wtr.wto.status,
                            style: 'invoiceSubValue',
                            width: 130
                        }, { text: '', style: 'invoiceSubValue', width: 40 }, {
                            text: 'Reason',
                            style: 'invoiceSubTitle',
                            width: 80

                        }, {
                            text: this.wtr.wto.reason,
                            style: 'invoiceSubValue',
                            width: 130
                        }]

                    }]
                }]]
            };

            var dd = {
                header: function header(pageNumber, pageCount) {
                    return {
                        margin: [0, 10, 0, 0],
                        columns: [{
                            text: '',
                            style: 'documentHeaderLeft'
                        }, {
                            text: wtoNum,
                            style: 'documentHeaderCenter'
                        }, {
                            text: '',
                            style: 'documentHeaderRight'
                        }]
                    };
                },
                footer: function footer(pageNumber, pageCount) {
                    return {
                        margin: [0, 0, 0, 50],
                        columns: [{
                            text: '',
                            style: 'documentFooterLeft'
                        }, {
                            text: 'Page ' + pageNumber + " of " + pageCount,
                            style: 'documentFooterCenter'
                        }, {
                            text: '',
                            style: 'documentFooterRight'
                        }]
                    };
                },
                content: [ddHeader, {
                    text: 'WTR Lists',
                    style: 'notesTitle'
                }, {
                    table: {
                        headerRows: 0,
                        widths: [25, 'auto', 80, 'auto'],
                        body: wtrItems
                    },
                    layout: 'lightHorizontalLines'
                }, '\n\n', {
                    layout: 'lightHorizontalLines',
                    table: {

                        headerRows: 1,
                        widths: [25, 68, '*', 65, 65],
                        body: wtoItems

                    } }, {
                    text: 'WTO Remarks',
                    style: 'notesTitle'
                }, {
                    text: this.wtr.wto.remarks,
                    style: 'notesText'
                }],
                styles: {
                    documentHeaderLeft: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'left'
                    },
                    documentHeaderCenter: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'center'
                    },
                    documentHeaderRight: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'right'
                    },

                    documentFooterLeft: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'left'
                    },
                    documentFooterCenter: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'center'
                    },
                    documentFooterRight: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'right'
                    },

                    invoiceTitle: {
                        fontSize: 20,
                        bold: true,
                        alignment: 'left',
                        margin: [0, 0, 0, 15]
                    },

                    invoiceSubTitle: {
                        fontSize: 10,
                        alignment: 'left'
                    },
                    invoiceSubValue: {
                        fontSize: 10,
                        alignment: 'left'
                    },

                    invoiceBillingTitle: {
                        fontSize: 14,
                        bold: true,
                        alignment: 'left',
                        margin: [0, 20, 0, 5]
                    },

                    invoiceBillingDetails: {
                        alignment: 'left'

                    },
                    invoiceBillingAddressTitle: {
                        margin: [0, 7, 0, 3],
                        bold: true
                    },
                    invoiceBillingAddress: {},

                    itemsHeader: {

                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        bold: true
                    },

                    itemTitle: {
                        bold: true
                    },
                    itemSubTitle: {
                        fontSize: 10
                    },
                    itemText: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        alignment: 'left'
                    },
                    itemNumber: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        alignment: 'right'
                    },
                    itemTotal: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right'
                    },

                    itemsFooterSubTitle: {
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right'
                    },
                    itemsFooterSubValue: {
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'center'
                    },
                    itemsFooterTotalTitle: {
                        fontSize: 11,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right'
                    },
                    itemsFooterTotalValue: {
                        fontSize: 11,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'center'
                    },
                    signaturePlaceholder: {
                        fontSize: 10,
                        margin: [0, 70, 0, 0]
                    },
                    signatureName: {
                        fontSize: 10,
                        margin: [0, 10, 0, 0],
                        bold: true,
                        alignment: 'left'
                    },
                    signatureJobTitle: {
                        fontSize: 10,
                        margin: [0, 20, 0, 0],
                        bold: true,
                        alignment: 'left'
                    },
                    notesTitle: {
                        fontSize: 10,
                        bold: true,
                        margin: [0, 30, 0, 3]
                    },
                    notesText: {
                        fontSize: 10
                    },
                    center: {
                        alignment: 'center'
                    }
                },
                defaultStyle: {
                    columnGap: 20,
                    font: 'ukai'
                }
            };
            __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake___default.a.createPdf(dd).open();
        },
        retrieveWTO: function retrieveWTO() {
            if (this.wtr.wto_num != '') {
                this.isWTORetrieved = true;
            }
        },
        rowClick: function rowClick(item, index) {
            localStorage.setItem("wtr_new.wto_num", item.wto_num);
            this.$router.push({ name: 'Warehouse Transfer Receiving (WTR)', params: { wtrNum: '_new' } });
        },
        cancelWtr: function cancelWtr() {
            this.wtr.wto_num = "";
            this.isWTORetrieved = false;
        },
        setWtoId: function setWtoId(obj) {
            if (obj !== null) {
                var curDate = new Date();
                curDate = curDate.toISOString().substr(0, 10);
                this.wtr.wtr_date = curDate;
                this.wtr.wto = obj;
                this.wtr.wto_num = obj.wto_num;
            } else {
                this.wtr.wto_num = null;
            }
        },
        validateUpdateQtyEntries: function validateUpdateQtyEntries(index) {
            var updateQty;
            updateQty = this.wtr.wto.wto_items[index].qty_received_current * 1;
            var requestedQty;
            requestedQty = this.wtr.wto.wto_items[index].qty * 1;
            var receivedQty = this.wtr.wto.wto_items[index].qty_received * 1;
            var maxAcceptedQty = requestedQty - receivedQty;
            if (updateQty < 0) {
                this.errorMessage = "Update WTR Quantity Value must not be a negative number";
                this.$refs.myErrorModalRef.show();
            } else if (updateQty > maxAcceptedQty) {
                this.errorMessage = "Update WTR Quantity Value must not exceed the requested of the WTO Qty";
                this.$refs.myErrorModalRef.show();
            }
        },
        confirmSave: function confirmSave() {
            this.modalShow = true;
        },
        save: function save() {
            var _this2 = this;

            if (1) {
                __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["_5" /* apiWtrSave */], this.wtr, Object(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["_7" /* authHeader */])()).then(function (res) {
                    var r = res.data;

                    if (r.code == 1) {
                        _this2.wtrDocNo = r.data.wtr_num;
                        _this2.$refs.myModalRef.show();
                    } else {
                        _this2.errorMessage = r.msg;
                        _this2.$refs.myErrorModalRef.show();
                    }
                }).catch(function (error) {
                    return alert(error);
                });
            }
        },
        confirmCancel: function confirmCancel() {
            this.modalCancelShow = true;
        },
        cancel: function cancel() {
            this.$router.push({ name: 'Warehouse Transfer Receivings (WTRS)' });
        },
        back: function back() {
            this.$router.push({ name: 'Warehouse Transfer Receivings (WTRS)' });
        },
        hideModal: function hideModal() {
            this.$refs.myModalRef.hide();
            this.$router.push({ name: 'Warehouse Transfer Receivings (WTRS)' });
        },
        hideErrorModal: function hideErrorModal() {
            this.$refs.myErrorModalRef.hide();
        }
    }
});

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Autocomplete_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__functions_common_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_json_excel__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pdfmake_build_vfs_fonts__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pdfmake_build_vfs_fonts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_pdfmake_build_vfs_fonts__);












__WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake___default.a.vfs = __WEBPACK_IMPORTED_MODULE_7_pdfmake_build_vfs_fonts___default.a.pdfMake.vfs;
__WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake___default.a.fonts = {
  "ukai": {
    normal: 'ukai.ttf',
    bold: 'ukai.ttf',
    italics: 'ukai.ttf',
    bolditalics: 'ukai.ttf'
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  components: { spinner: __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue__["a" /* default */], countryLookup: __WEBPACK_IMPORTED_MODULE_3__components_Autocomplete_vue__["a" /* default */], wscLookup: __WEBPACK_IMPORTED_MODULE_3__components_Autocomplete_vue__["a" /* default */], exportExcel: __WEBPACK_IMPORTED_MODULE_5_vue_json_excel__["a" /* default */] },
  props: {
    caption: {
      type: String,
      default: 'Table'
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var _ref;

    return _ref = {
      apiCountryLookup: __WEBPACK_IMPORTED_MODULE_4__functions_common_vue__["c" /* apiCountryLookup */],
      apiWscLookUp: __WEBPACK_IMPORTED_MODULE_4__functions_common_vue__["W" /* apiWscLookUp */],
      loading: false,
      noResults: false,
      filter: {
        credit_note_number: '',
        country_id: '',
        from_date: '',
        to_date: '',
        cancellation_status_name: ''
      },
      searchResults: [],
      searchResultsFields: [{ key: 'country_code', label: 'Country Code' }, { key: 'stock_location_name', label: 'Location Name' }, { key: 'transaction_date', label: 'Date' }, { key: 'credit_note_number', label: 'Cancellation Doc. No' }, { key: 'old_member_id', label: 'IBO/Stockist ID' }, { key: 'member_name', label: 'IBO/Stockist Name' }, { key: 'cancellation_status_name', label: 'Approval Status' }, { key: 'receiving_status', label: 'Receiving Status' }, { key: 'elken_author_user_shortname', label: 'Created By' }],
      currentPage: 1,
      perPage: 20,
      totalRows: 0
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'noResults', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'exportHeaders', {
      'Cancellation Doc No': 'credit_note_number',
      'Date': 'transaction_date',
      'Country': 'country_code',
      'Location': 'stock_location_name',
      'IBO/Stockist ID': 'old_member_id',
      'IBO/Stockist Name': 'member_name',
      'Status': 'cancellation_status_name',
      'Created By': 'elken_author_user_shortname'
    }), _ref;
  },
  methods: {
    print: function print() {
      var rows = [];
      var row = [];
      var date = new Date();
      rows.push(['Cancellation Doc #', 'Date', 'Country', 'Location', 'IBO/Stockist ID', 'IBO/Stockist Name', 'Status', 'Created By']);

      for (var key in this.searchResults) {
        var data = this.searchResults[key];
        row = [data.credit_note_number, data.transaction_date, data.country_code, data.stock_location_name, data.old_member_id, data.member_name, data.cancellation_status_name, data.elken_author_user_shortname];
        rows.push(row);
      }
      var dd = {
        header: { text: 'Sales Cancellation Posting List generated on' + " " + date, margin: [5, 10, 10, 30], alignment: 'center', fontSize: 9 },
        pageSize: 'A4',
        pageOrientation: 'portrait',
        defaultStyle: {
          font: 'ukai'
        },

        pageMargins: [30, 30, 30, 20],

        content: [{
          fontSize: 8,
          layout: 'lightHorizontalLines',
          table: {
            headerRows: 1,
            widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
            body: rows
          }
        }]
      };

      __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake___default.a.createPdf(dd).open();
    },
    rowClick: function rowClick(item) {
      localStorage.setItem("wsc_new.credit_note_number", item.credit_note_number);
      this.$router.push({ name: 'Sales Cancellation Entry (SC)', params: { wscNum: '_new' } });
    },
    getRowCount: function getRowCount(items) {
      return items.length;
    },
    search: function search() {
      var _this = this;

      this.noResults = true;
      this.loading = true;
      var sf = {
        "credit_note_number": this.filter.credit_note_number,
        "country_id": this.filter.country_id,
        "from_date": this.filter.from_date,
        "to_date": this.filter.to_date,
        "cancellation_status_name": this.filter.cancellation_status_name
      };
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_4__functions_common_vue__["Y" /* apiWscSearch */], sf, Object(__WEBPACK_IMPORTED_MODULE_4__functions_common_vue__["_7" /* authHeader */])()).then(function (res) {
        return res;
      }).then(function (data) {

        var resultArray = [];
        var myData = data.data.data;
        for (var key in myData) {
          var date = myData[key].transaction_date;
          var date = new Date(date);
          var result = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + (date.getMonth() + 1 > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear();
          myData[key].transaction_date = result;
          resultArray.push(myData[key]);
          _this.loading = false;
        }
        _this.searchResults = resultArray;

        if (_this.searchResults.length == 0) {
          _this.loading = false;
          _this.noResults = true;
        }
      }).catch(function (error) {
        return alert(error);
      });
    },
    newWSC: function newWSC() {
      localStorage.setItem("wsc_new.credit_note_number", "");
      this.$router.push({ name: 'Sales Cancellation Entry (SC)', params: { wscNum: '_new' } });
    },
    setWsc: function setWsc(obj) {
      var id;
      if (obj !== null) {
        id = obj.id;
      } else {
        id = null;
      }
      this.filter.credit_note_number = id;
    },
    setCountry: function setCountry(obj) {
      var id;
      if (obj !== null) {
        id = obj.id;
      } else {
        id = null;
      }
      this.filter.country_id = id;
    }
  }
});

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Autocomplete_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__functions_common_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pdfmake_build_vfs_fonts__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pdfmake_build_vfs_fonts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_pdfmake_build_vfs_fonts__);









__WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake___default.a.vfs = __WEBPACK_IMPORTED_MODULE_4_pdfmake_build_vfs_fonts___default.a.pdfMake.vfs;
__WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake___default.a.fonts = {
    "ukai": {
        normal: 'ukai.ttf',
        bold: 'ukai.ttf',
        italics: 'ukai.ttf',
        bolditalics: 'ukai.ttf'
    },
    "Garuda": {
        normal: 'Garuda.ttf',
        bold: 'Garuda.ttf',
        italics: 'Garuda.ttf',
        bolditalics: 'Garuda.ttf'
    },
    "Hanumanb": {
        normal: 'Hanumanb.ttf',
        bold: 'Hanumanb.ttf',
        italics: 'Hanumanb.ttf',
        bolditalics: 'Hanumanb.ttf'
    }
};
/* harmony default export */ __webpack_exports__["a"] = ({
    components: { warehouseLookup: __WEBPACK_IMPORTED_MODULE_1__components_Autocomplete_vue__["a" /* default */], wscLookup: __WEBPACK_IMPORTED_MODULE_1__components_Autocomplete_vue__["a" /* default */] },
    data: function data() {
        return {
            title: 'New Sales Cancellation',
            apiWarehouseUrl: __WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["V" /* apiWarehouseLookup */],
            apiWscUrl: __WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["W" /* apiWscLookUp */],
            isVisible: false,
            wsc_ref: '',
            list: [],
            font: 'ukai',
            item: {},
            lockEntry: false,
            isWscRetrieved: false,
            wscDocNo: '12345',
            errorMessage: '',
            wsc: {},
            country_name: ''
        };
    },
    created: function created() {
        var _this = this;

        if (localStorage.getItem("wsc_new.credit_note_number") != '') {
            this.isWscRetrieved = true;
            var wscNum = localStorage.getItem("wsc_new.credit_note_number");
            var url = this.apiWscUrl;

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url, { params: { q: wscNum, get: 1 } }, Object(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["_7" /* authHeader */])()).then(function (response) {
                _this.list = response.data.data.list;
                if (_this.list.length > 0) {
                    _this.item = _this.list[0];

                    if (_this.item !== null) {
                        _this.isWscRetrieved = true;

                        _this.wsc = _this.item.wsc[0];
                        if (_this.wsc.old_member_id == null) {
                            _this.wsc.old_member_id = _this.item.old_member_id;
                        }
                        _this.wsc.receiving_status = _this.item.wsc.receiving_status;
                        if (_this.wsc.country_code != null) {
                            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["c" /* apiCountryLookup */], { params: { q: _this.wsc.country_code } }).then(function (response) {

                                if (_this.wsc.country_code == 'TH') {
                                    _this.font = 'Garuda';
                                } else if (_this.wsc.country_code == 'KH') {
                                    _this.font = 'Hanumanb';
                                }

                                if (response.data != null) {
                                    _this.list = response.data.data.list;
                                    _this.item = _this.list[0];
                                    _this.country_name = _this.item.country_name;
                                    _this.country_name = _this.country_name.toUpperCase();
                                }
                            });
                        }
                        var curDate = new Date();
                        curDate = curDate.toISOString().substr(0, 10);
                        _this.wsc.wsc_date = curDate;
                    }
                    var totalQty = 0;
                    var totalQtyReturned = 0;
                    for (var key in _this.wsc.items) {
                        var wsc_item = _this.wsc.items[key];
                        wsc_item.quantity = wsc_item.quantity * 1;
                        wsc_item.qty_returned = wsc_item.qty_returned * 1;
                        _this.wsc.items[key].cancellation_amount_friendly = (wsc_item.cancellation_amount * 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                        totalQty = totalQty + wsc_item.quantity;
                        totalQtyReturned = totalQtyReturned + wsc_item.qty_returned;
                    }
                    if (totalQty == totalQtyReturned) {
                        _this.isVisible = true;
                    }
                }
            }).catch(function (error) {
                return alert(error);
            });
        } else {
            this.isWscRetrieved = false;
            this.wsc.credit_note_number = '';
        }
    },

    computed: {
        confirm_return_amount: function confirm_return_amount() {
            var total = 0;
            for (var k in this.wsc.items) {
                var item = this.wsc.items[k];
                item.qty_allocated = item.qty_allocated * 1;
                item.quantity = item.quantity * 1;
                item.cancellation_amount = item.cancellation_amount * 1;
                var receiving_amount = item.cancellation_amount * item.qty_allocated / item.quantity;
                total = total + receiving_amount;
            }
            total = total.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            return total;
        }
    },
    methods: {
        print: function print() {
            var wsc_num = this.wsc.credit_note_number;
            var row = [];
            var date = new Date(this.wsc.transaction_date);
            var cancellationDate = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + (date.getMonth() + 1 > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear();
            var wscItems = [];
            var groTotalAmount = 0;
            row = [{
                text: 'S/No',
                style: 'itemsHeader'
            }, {
                text: 'Product Code',
                style: ['itemsHeader'],
                alignment: 'left'
            }, {
                text: 'Description',
                style: ['itemsHeader'],
                alignment: 'left'
            }, {
                text: 'Cancellation Amount',
                style: ['itemsHeader'],
                alignment: 'left'
            }, {
                text: 'Cancellation Qty',
                style: ['itemsHeader'],
                alignment: 'right'
            }, {
                text: 'Returned Qty',
                style: ['itemsHeader'],
                alignment: 'right'
            }];
            wscItems.push(row);
            var items = this.wsc.items;
            for (var key in items) {
                var data = items[key];
                var cancellation_amount = (data.cancellation_amount * 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                var qty = (data.quantity * 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                var qty_returned = (data.qty_returned * 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                if (data.product_name == null) {
                    data.product_name = "";
                }
                row = [{
                    text: key * 1 + 1,
                    style: 'itemText'
                }, {
                    text: data.product_id,
                    style: 'itemText'
                }, {
                    text: data.product_name,
                    style: 'itemText'
                }, {
                    text: cancellation_amount,
                    style: 'itemText'
                }, {
                    text: qty,
                    style: 'itemNumber'
                }, {
                    text: qty_returned,
                    style: 'itemNumber'
                }];
                wscItems.push(row);
            }
            var ddHeader = {
                columns: [[{
                    text: 'ELKEN ' + this.country_name + ' SALES CANCELLATION',
                    style: 'invoiceTitle',
                    width: '*'
                }, {
                    stack: [{
                        columns: [{
                            text: 'Cancellation Doc #',
                            style: 'invoiceSubTitle',
                            width: 150

                        }, {
                            text: wsc_num,
                            style: 'invoiceSubValue',
                            width: 100
                        }]
                    }, {
                        text: ' '
                    }, {
                        columns: [{
                            text: 'Sales Doc #',
                            style: 'invoiceSubTitle',
                            width: 150

                        }, {
                            text: this.wsc.invoice_number,
                            style: 'invoiceSubValue',
                            width: 100
                        }]
                    }, {
                        text: ' '
                    }, {
                        columns: [{
                            text: 'Tax Invoice #',
                            style: 'invoiceSubTitle',
                            width: 150

                        }, {
                            text: this.wsc.tax_invoice_number,
                            style: 'invoiceSubValue',
                            width: 100
                        }]
                    }, {
                        text: ' '
                    }, {
                        columns: [{
                            text: 'Transaction Date',
                            style: 'invoiceSubTitle',
                            width: 150

                        }, {
                            text: cancellationDate,
                            style: 'invoiceSubValue',
                            width: 100

                        }]

                    }, {
                        text: ' '
                    }, {
                        columns: [{
                            text: 'Transaction Location',
                            style: 'invoiceSubTitle',
                            width: 150

                        }, {
                            text: this.wsc.stock_location_name,
                            style: 'invoiceSubValue'
                        }]

                    }, { text: ' ' }, {
                        columns: [{
                            text: 'Approval Status',
                            style: 'invoiceSubTitle',
                            width: 150

                        }, {
                            text: this.wsc.cancellation_status_name,
                            style: 'invoiceSubValue'
                        }]

                    }, { text: ' ' }, {
                        columns: [{
                            text: 'Receiving Status',
                            style: 'invoiceSubTitle',
                            width: 150

                        }, {
                            text: this.wsc.receiving_status,
                            style: 'invoiceSubValue',
                            width: 100
                        }]
                    }, {
                        text: ' '
                    }, {
                        columns: [{
                            text: 'Transaction Type',
                            style: 'invoiceSubTitle',
                            width: 150

                        }, {
                            text: this.wsc.cancellation_reason_name,
                            style: 'invoiceSubValue'
                        }]

                    }, {
                        text: ' '
                    }, {
                        columns: [{
                            text: 'Member',
                            style: 'invoiceSubTitle',
                            width: 150

                        }, {
                            text: this.wsc.old_member_id + ' - ' + this.wsc.member_name,
                            style: 'invoiceSubValue'
                        }]

                    }, {
                        text: ' '
                    }, {
                        columns: [{
                            text: 'Buy Back Amount',
                            style: 'invoiceSubTitle',
                            width: 150

                        }, {
                            text: (this.wsc.amount_buy_back * 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                            style: 'invoiceSubValue'
                        }]
                    }, {
                        text: ' '
                    }, {
                        columns: [{
                            text: 'Cancellation Amount',
                            style: 'invoiceSubTitle',
                            width: 150

                        }, {
                            text: (this.wsc.amount_cancellation * 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                            style: 'invoiceSubValue'
                        }]
                    }]
                }]]
            };

            var dd = {
                header: function header(pageNumber, pageCount) {
                    return {
                        margin: [0, 10, 0, 0],
                        columns: [{
                            text: '',
                            style: 'documentHeaderLeft'
                        }, {
                            text: wsc_num,
                            style: 'documentHeaderCenter'
                        }, {
                            text: '',
                            style: 'documentHeaderRight'
                        }]
                    };
                },
                footer: function footer(pageNumber, pageCount) {
                    return {
                        margin: [0, 0, 0, 50],
                        columns: [{
                            text: '',
                            style: 'documentFooterLeft'
                        }, {
                            text: 'Page ' + pageNumber + " of " + pageCount,
                            style: 'documentFooterCenter'
                        }, {
                            text: '',
                            style: 'documentFooterRight'
                        }]
                    };
                },
                content: [ddHeader, '\n\n', {
                    layout: 'lightHorizontalLines',
                    table: {

                        headerRows: 1,
                        widths: [25, 'auto', 'auto', 'auto', 'auto', 'auto'],
                        body: wscItems

                    } }, {
                    columns: [{
                        stack: [{
                            text: 'Received By',
                            style: 'signaturePlaceholder'
                        }, {
                            text: '______________________________',
                            style: 'signaturePlaceholder'
                        }, {
                            text: 'Name  :',
                            style: 'signatureName'

                        }, {
                            text: 'Date  :',
                            style: 'signatureJobTitle'

                        }],
                        width: 160
                    }]
                }],
                styles: {
                    documentHeaderLeft: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'left'
                    },
                    documentHeaderCenter: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'center'
                    },
                    documentHeaderRight: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'right'
                    },

                    documentFooterLeft: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'left'
                    },
                    documentFooterCenter: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'center'
                    },
                    documentFooterRight: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'right'
                    },

                    invoiceTitle: {
                        fontSize: 22,
                        bold: true,
                        alignment: 'left',
                        margin: [0, 0, 0, 15]
                    },

                    invoiceSubTitle: {
                        fontSize: 10,
                        alignment: 'left'
                    },
                    invoiceSubValue: {
                        fontSize: 10,
                        alignment: 'left'
                    },

                    invoiceBillingTitle: {
                        fontSize: 14,
                        bold: true,
                        alignment: 'left',
                        margin: [0, 20, 0, 5]
                    },

                    invoiceBillingDetails: {
                        alignment: 'left'

                    },
                    invoiceBillingAddressTitle: {
                        margin: [0, 7, 0, 3],
                        bold: true
                    },
                    invoiceBillingAddress: {},

                    itemsHeader: {

                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        bold: true
                    },

                    itemTitle: {
                        bold: true
                    },
                    itemSubTitle: {
                        fontSize: 10
                    },
                    itemText: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        alignment: 'left'
                    },
                    itemNumber: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        alignment: 'right'
                    },
                    itemTotal: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right'
                    },

                    itemsFooterSubTitle: {
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right'
                    },
                    itemsFooterSubValue: {
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'center'
                    },
                    itemsFooterTotalTitle: {
                        fontSize: 11,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right'
                    },
                    itemsFooterTotalValue: {
                        fontSize: 11,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'center'
                    },
                    signaturePlaceholder: {
                        fontSize: 10,
                        margin: [0, 70, 0, 0]
                    },
                    signatureName: {
                        fontSize: 10,
                        margin: [0, 10, 0, 0],
                        bold: true,
                        alignment: 'left'
                    },
                    signatureJobTitle: {
                        fontSize: 10,
                        margin: [0, 20, 0, 0],
                        bold: true,
                        alignment: 'left'
                    },
                    notesTitle: {
                        fontSize: 10,
                        bold: true,
                        margin: [0, 30, 0, 3]
                    },
                    notesText: {
                        fontSize: 10
                    },
                    center: {
                        alignment: 'center'
                    }
                },
                defaultStyle: {
                    columnGap: 20,
                    font: this.font
                }
            };
            __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake___default.a.createPdf(dd).open();
        },
        validateQtyAllocated: function validateQtyAllocated(row) {
            row.qty_allocated = row.qty_allocated * 1;
            row.quantity = row.quantity * 1;
            row.qty_returned = row.qty_returned * 1;
            var allowQty = row.quantity - row.qty_returned;
            if (row.qty_allocated < 0) {
                row.qty_allocated = 0;
            }
            if (row.qty_allocated > allowQty) {
                row.qty_allocated = 0;
            }
        },
        setWsc: function setWsc(obj) {

            if (obj !== null) {
                if (obj.id != '') {
                    this.wsc = obj.wsc[0];
                    if (this.wsc.old_member_id == null) {
                        this.wsc.old_member_id = obj.old_member_id;
                    }

                    console.log(obj.wsc.receiving_status);
                    this.wsc.receiving_status = obj.wsc.receiving_status;
                    var curDate = new Date();
                    curDate = curDate.toISOString().substr(0, 10);
                    this.wsc.wsc_date = curDate;
                    var totalQty = 0;
                    var totalQtyReturned = 0;
                    for (var key in this.wsc.items) {
                        var wsc_item = this.wsc.items[key];
                        wsc_item.quantity = wsc_item.quantity * 1;
                        wsc_item.qty_returned = wsc_item.qty_returned * 1;
                        totalQty = totalQty + wsc_item.quantity;
                        totalQtyReturned = totalQtyReturned + wsc_item.qty_returned;
                    }
                    if (totalQty == totalQtyReturned) {
                        this.isVisible = true;
                    }
                }
            } else {
                this.isWscRetrieved = false;
                this.wsc.credit_note_number = null;
            }
        },
        retrieveSalesDoc: function retrieveSalesDoc() {
            this.isWscRetrieved = true;
        },
        setWarehouse: function setWarehouse(obj) {
            var id;

            if (obj !== null) {
                id = obj.id;
            } else {
                id = null;
            }
            this.wsc.location_id = id;
        },
        save: function save() {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["X" /* apiWscSave */], this.wsc, Object(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["_7" /* authHeader */])()).then(function (res) {
                var r = res.data;
                if (r.code == 1) {
                    _this2.wscDocNo = r.data;
                    _this2.$refs.myModalRef.show();
                } else {
                    _this2.errorMessage = r.data;
                    _this2.$refs.myErrorModalRef.show();
                }
            }).catch(function (error) {
                return alert(error);
            });
        },
        closeWSC: function closeWSC() {
            this.$router.push({ name: 'Sales Cancellations (SCS)' });
        },
        close: function close() {
            this.$router.push({ name: 'Sales Cancellations (SCS)' });
        },
        hideModal: function hideModal() {
            this.$refs.myModalRef.hide();
            this.$router.push({ name: 'Sales Cancellations (SCS)' });
        },
        hideErrorModal: function hideErrorModal() {
            this.$refs.myErrorModalRef.hide();
        }
    }
});

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Autocomplete_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__functions_common_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_json_excel__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pdfmake_build_vfs_fonts__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pdfmake_build_vfs_fonts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_pdfmake_build_vfs_fonts__);











__WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake___default.a.vfs = __WEBPACK_IMPORTED_MODULE_7_pdfmake_build_vfs_fonts___default.a.pdfMake.vfs;
__WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake___default.a.fonts = {
  "ukai": {
    normal: 'ukai.ttf',
    bold: 'ukai.ttf',
    italics: 'ukai.ttf',
    bolditalics: 'ukai.ttf'
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  components: { spinner: __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue__["a" /* default */], countryLookup: __WEBPACK_IMPORTED_MODULE_3__components_Autocomplete_vue__["a" /* default */], exportExcel: __WEBPACK_IMPORTED_MODULE_5_vue_json_excel__["a" /* default */] },
  props: {
    caption: {
      type: String,
      default: 'Table'
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var _ref;

    return _ref = {
      apiCountryLookup: __WEBPACK_IMPORTED_MODULE_4__functions_common_vue__["c" /* apiCountryLookup */],
      loading: false,
      noResults: false,
      filter: {
        srf_num: '',
        country_id: '',
        date_start: '',
        date_end: '',
        status: ''
      },
      searchResults: [],
      searchResultsFields: [{ key: 'country_id', label: 'Country' }, { key: 'location_id', label: 'Location' }, { key: 'srf_date', label: 'Date' }, { key: 'srf_num', label: 'SRF No' }, { key: 'requestor_user_id', label: 'Requestor Email' }, { key: 'requestor_user_shortname', label: 'Requestor Name' }, { key: 'reference_num', label: 'Reference No' }, { key: 'reason', label: 'Reason' }, { key: 'returning_type', label: 'Type' }, { key: 'status', label: 'Returnable Status' }, { key: 'approval_status', label: 'Approval Status' }, { key: 'author_user_shortname', label: 'Created By' }],
      currentPage: 1,
      perPage: 20,
      totalRows: 0
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'noResults', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'exportHeaders', {
      'SRF Num': 'srf_num',
      'Date': 'srf_date',
      'Country': 'country_id',
      'Location': 'location_id',
      'Requestor Email': 'requestor_user_id',
      'Requestor': 'requestor_user_shortname',
      'Reference #': 'reference_num',
      'Reason': 'reason',
      'Type': 'returning_type',
      'Returnable Status': 'status',
      'Approval Status': 'approval_status',
      'Created By': 'author_user_shortname'
    }), _ref;
  },
  methods: {
    print: function print() {
      var rows = [];
      var row = [];
      var date = new Date();
      rows.push(['SRF No', 'Date', 'Country', 'Location', 'Requestor Email', 'Requestor', 'Reference #', 'Reason', 'Type', 'Returnable Status', 'Approval Status', 'Created By']);

      for (var key in this.searchResults) {
        var data = this.searchResults[key];
        var ref = '-';
        if (data.reference_num != '') {
          ref = data.reference_num;
        }
        var reason = '-';
        if (data.reason != '') {
          reason = data.reason;
        }
        row = [data.srf_num, data.srf_date, data.country_id, data.location_id, data.requestor_user_id, data.requestor_user_shortname, ref, reason, data.returning_type, data.status, data.approval_status, data.author_user_shortname];
        rows.push(row);
      }
      var dd = {
        header: { text: 'Stock Requisition Form List generated on' + " " + date, margin: [5, 10, 10, 30], alignment: 'center', fontSize: 8 },
        pageSize: 'A4',
        pageOrientation: 'landscape',

        pageMargins: [30, 30, 30, 20],
        defaultStyle: {
          font: 'ukai'
        },
        content: [{
          fontSize: 7.5,
          layout: 'lightHorizontalLines',
          table: {
            headerRows: 1,
            widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', '*', 'auto', 'auto', 'auto'],
            body: rows
          }
        }]
      };

      __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake___default.a.createPdf(dd).open();
    },
    rowClick: function rowClick(item, index) {
      this.$router.push({ name: 'Stock Requisition Form Entry (SRF)', params: { srfNum: item.srf_num } });
    },
    getRowCount: function getRowCount(items) {
      return items.length;
    },
    search: function search() {
      var _this = this;

      this.loading = true;
      var sf = ["srf_num LIKE " + this.filter.srf_num, "country_id = " + this.filter.country_id, "srf_date >= " + this.filter.date_start, "srf_date <= " + this.filter.date_end, "status = " + this.filter.status];
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_4__functions_common_vue__["R" /* apiSrfSearch */], sf).then(function (res) {
        return res;
      }).then(function (data) {
        console.log(data);
        var resultArray = [];
        var myData = data.data.data.list;
        for (var key in myData) {
          var date = myData[key].srf_date;
          var date = new Date(date);
          var result = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + (date.getMonth() + 1 > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear();
          myData[key].srf_date = result;
          if (myData[key].reason == '') {
            myData[key].reason = '-';
          }
          resultArray.push(myData[key]);
          _this.loading = false;
        }
        _this.searchResults = resultArray;

        if (_this.searchResults.length == 0) {
          _this.loading = false;
          _this.noResults = true;
        }
      }).catch(function (error) {
        return alert(error);
      });
    },
    newSRF: function newSRF() {
      this.$router.push({ name: 'Stock Requisition Form Entry (SRF)', params: { srfNum: '_new' } });
    },
    setCountry: function setCountry(obj) {
      var id;
      if (obj !== null) {
        id = obj.id;
      } else {
        id = null;
      }
      this.filter.country_id = id;
    }
  },
  rowClick: function rowClick(item) {
    this.$router.push({ name: 'Stock Requisition Form Entry (SRF)', params: { sfNum: item.srf_num } });
  }
});

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Autocomplete_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__functions_common_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pdfmake_build_vfs_fonts__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pdfmake_build_vfs_fonts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_pdfmake_build_vfs_fonts__);









__WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake___default.a.vfs = __WEBPACK_IMPORTED_MODULE_4_pdfmake_build_vfs_fonts___default.a.pdfMake.vfs;
__WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake___default.a.fonts = {
    "ukai": {
        normal: 'ukai.ttf',
        bold: 'ukai.ttf',
        italics: 'ukai.ttf',
        bolditalics: 'ukai.ttf'
    }
};
/* harmony default export */ __webpack_exports__["a"] = ({
    components: { employeeLookup: __WEBPACK_IMPORTED_MODULE_1__components_Autocomplete_vue__["a" /* default */], warehouseLookup: __WEBPACK_IMPORTED_MODULE_1__components_Autocomplete_vue__["a" /* default */], productLookup: __WEBPACK_IMPORTED_MODULE_1__components_Autocomplete_vue__["a" /* default */] },
    data: function data() {
        return {
            isWh: false,
            isWhHoo: false,
            isAcc: false,
            isAccFn: false,
            btnVisible: false,
            closeModalShow: false,
            approveModalShow: false,
            title: 'New SRF',
            apiWarehouseUrl: __WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["V" /* apiWarehouseLookup */],
            apiLocationProductUrl: __WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["q" /* apiLocationProductUrl */],
            apiEmployeeLookup: __WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["f" /* apiEmployeeLookup */],
            apiReasonLookup: __WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["F" /* apiReasonLookup */],
            countryId: '',
            country_name: '',
            srf_ref: '',
            lockEntry: false,
            modalShow: false,
            modalCancelShow: false,
            showItemsTable: false,
            srfDocNo: '',
            modalErrorShow: false,
            prevWhID: '',
            errorMessage: '',
            noItemsFound: true,
            srf_reason_list_items: [],
            srf: {
                requested_date: '',
                location_id: '',
                requestor_user_id: '',
                reference_num: '',
                event_start_date: '',
                event_end_date: '',
                return_date: '',
                returning_type: 'NON RETURNABLE',
                reason: '',
                remarks: '',
                amount_total: '',
                currency_id: '',
                status: '',
                approval_status: '',
                rejected_reason: '',
                rejecter_user_id: '',
                rejected_at: '',
                approver_user_id: '',
                approved_at: '',
                closed_by_user_id: '',
                closed_at: '',
                srf_items: [{ product_name: '', product_id: '', qty_soh: '', qty: '', unit_gmp: '', amount_total: '' }]
            }
        };
    },
    computed: {
        returnDate: function returnDate() {
            var date = '';
            if (this.srf.returning_type != 'NON RETURNABLE') {
                if (this.srf.event_end_date != '') {
                    var event_end_date = this.srf.event_end_date;
                    var date = new Date(Date.parse(event_end_date) + 12096e5);
                    date = date.toISOString().substr(0, 10);
                }
            }
            this.srf.return_date = date;
            return date;
        }
    },
    created: function created() {
        var _this = this;

        var app_role;

        app_role = JSON.parse(localStorage.getItem("app_role"));
        this.isWh = app_role.includes("WH");
        this.isWhHoo = app_role.includes("WH_HOO");
        this.isAcc = app_role.includes("AC");
        this.isAccFn = app_role.includes("AC_FN");

        this.srf_ref = this.$route.params.srfNum;
        if (this.srf_ref == '_new') {
            var curDate = new Date();
            curDate = curDate.toISOString().substr(0, 10);
            this.srf.srf_date = curDate;
            this.lockEntry = false;
            this.noItemsFound = true;
        } else {
            this.lockEntry = true;
            this.noItemsFound = false;
            this.fetch(this.srf_ref);
        }

        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["F" /* apiReasonLookup */], { params: { module: 'srf' } }, Object(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["_7" /* authHeader */])()).then(function (res) {
            if (res.data.code == 1) {
                res.data.data.forEach(function (item, index) {
                    _this.srf_reason_list_items.push(item.description);
                });
            }
        }).catch(function (error) {
            return alert(error);
        });
    },

    methods: {
        print: function print() {
            console.log(this.srf.return_date);
            var srf_num = this.srf.srf_num;
            var row = [];
            var date = new Date(this.srf.srf_date);
            var srfDate = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + (date.getMonth() + 1 > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear();
            var srfItems = [];
            var returnDate = '-';
            var rd = this.returnDate;
            if (rd != '') {
                var d = new Date(this.srf.return_date);
                returnDate = "" + (d.getDate() > 9 ? '' : '0') + d.getDate() + '/' + (d.getMonth() + 1 > 9 ? '' : '0') + (d.getMonth() + 1) + '/' + d.getFullYear();
            }
            row = [{
                text: 'S/No',
                style: 'itemsHeader'
            }, {
                text: 'Product Code',
                style: ['itemsHeader'],
                alignment: 'left'
            }, {
                text: 'Description',
                style: ['itemsHeader'],
                alignment: 'left'
            }, {
                text: 'SOH',
                style: ['itemsHeader'],
                alignment: 'left'
            }, {
                text: 'Unit GMP',
                style: ['itemsHeader'],
                alignment: 'left'
            }, {
                text: 'Qty',
                style: ['itemsHeader'],
                alignment: 'right'
            }, {
                text: 'Total GMP',
                style: ['itemsHeader'],
                alignment: 'left'
            }];
            srfItems.push(row);
            var items = this.srf.srf_items;
            for (var key in items) {
                var data = items[key];
                var soh = (data.qty_soh * 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                var qty = (data.qty * 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                var unit_gmp = (data.unit_gmp * 1).toFixed(2);
                unit_gmp = unit_gmp.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                var amount_total = (data.amount_total * 1).toFixed(2);
                amount_total = amount_total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                if (data.product_name == null) {
                    data.product_name = "";
                }
                row = [{
                    text: key * 1 + 1,
                    style: 'itemText'
                }, {
                    text: data.product_id,
                    style: 'itemText'
                }, {
                    text: data.product_name,
                    style: 'itemText'
                }, {
                    text: soh,
                    style: 'itemText'
                }, {
                    text: unit_gmp,
                    style: 'itemText'
                }, {
                    text: qty,
                    style: 'itemNumber'
                }, {
                    text: amount_total,
                    style: 'itemText'
                }];
                srfItems.push(row);
            }

            var ddHeader = {
                columns: [[{
                    text: 'ELKEN ' + this.country_name + ' STOCK REQUISITION FORM',
                    style: 'invoiceTitle',
                    width: '*'
                }, {
                    stack: [{
                        columns: [{
                            text: 'SRF #',
                            style: 'invoiceSubTitle',
                            width: 95

                        }, {
                            text: srf_num,
                            style: 'invoiceSubValue',
                            width: 100
                        }, { text: '', style: 'invoiceSubValue', width: 80 }, {
                            text: 'SRF Date',
                            style: 'invoiceSubTitle',
                            width: 95

                        }, {
                            text: srfDate,
                            style: 'invoiceSubValue',
                            width: 100

                        }]
                    }, {
                        columns: [{
                            text: 'Requestor',
                            style: 'invoiceSubTitle',
                            width: 95

                        }, {
                            text: this.srf.requestor_user_shortname,
                            style: 'invoiceSubValue',
                            width: 100
                        }, { text: '', style: 'invoiceSubValue', width: 80 }, {
                            text: 'Stock Location',
                            style: 'invoiceSubTitle',
                            width: 95

                        }, {
                            text: this.srf.location_full,
                            style: 'invoiceSubValue',
                            width: 100
                        }]

                    }, {
                        columns: [{
                            text: 'Event Start Date',
                            style: 'invoiceSubTitle',
                            width: 95

                        }, {
                            text: this.srf.event_start_date,
                            style: 'invoiceSubValue'
                        }, { text: '', style: 'invoiceSubValue', width: 80 }, {
                            text: 'Event End Date',
                            style: 'invoiceSubTitle',
                            width: 95

                        }, {
                            text: this.srf.event_end_date,
                            style: 'invoiceSubValue',
                            width: 100
                        }]

                    }, {
                        columns: [{
                            text: 'Reference #',
                            style: 'invoiceSubTitle',
                            width: 95

                        }, {
                            text: this.srf.reference_num,
                            style: 'invoiceSubValue'
                        }, { text: '', style: 'invoiceSubValue', width: 80 }, {
                            text: 'Reason',
                            style: 'invoiceSubTitle',
                            width: 95

                        }, {
                            text: this.srf.reason,
                            style: 'invoiceSubValue'
                        }]
                    }, {
                        columns: [{
                            text: 'Returning Type',
                            style: 'invoiceSubTitle',
                            width: 95

                        }, {
                            text: this.srf.returning_type,
                            style: 'invoiceSubValue'
                        }, { text: '', style: 'invoiceSubValue', width: 80 }, {
                            text: 'Return Date',
                            style: 'invoiceSubTitle',
                            width: 95

                        }, {
                            text: returnDate,
                            style: 'invoiceSubValue'
                        }]
                    }, {
                        columns: [{
                            text: 'Currency Code',
                            style: 'invoiceSubTitle',
                            width: 95

                        }, {
                            text: this.srf.currency_id,
                            style: 'invoiceSubValue'
                        }]
                    }]
                }]]
            };

            var dd = {
                header: function header(pageNumber, pageCount) {
                    return {
                        margin: [0, 10, 0, 0],
                        columns: [{
                            text: '',
                            style: 'documentHeaderLeft'
                        }, {
                            text: srf_num,
                            style: 'documentHeaderCenter'
                        }, {
                            text: '',
                            style: 'documentHeaderRight'
                        }]
                    };
                },
                footer: function footer(pageNumber, pageCount) {
                    return {
                        margin: [0, 0, 0, 50],
                        columns: [{
                            text: '',
                            style: 'documentFooterLeft'
                        }, {
                            text: 'Page ' + pageNumber + " of " + pageCount,
                            style: 'documentFooterCenter'
                        }, {
                            text: '',
                            style: 'documentFooterRight'
                        }]
                    };
                },
                content: [ddHeader, '\n\n', {
                    layout: 'lightHorizontalLines',
                    table: {

                        headerRows: 1,
                        widths: [25, 'auto', '*', 'auto', 'auto', 'auto', 'auto'],
                        body: srfItems

                    } }, {
                    text: 'Remarks',
                    style: 'notesTitle'
                }, {
                    text: this.srf.remarks,
                    style: 'notesText'
                }, {
                    columns: [{
                        stack: [{
                            text: 'Issued By',
                            style: 'signaturePlaceholder'
                        }, {
                            text: '______________________________',
                            style: 'signaturePlaceholder'
                        }, {
                            text: 'Name  : ' + this.srf.author_user_shortname,
                            style: 'signatureName'

                        }, {
                            text: 'Date  : ' + srfDate,
                            style: 'signatureJobTitle'

                        }],
                        width: 160
                    }, {
                        stack: [{
                            text: '  ',
                            style: 'signaturePlaceholder'
                        }, {
                            text: '                      ',
                            style: 'signaturePlaceholder'
                        }, {
                            text: '  ',
                            style: 'signatureName'

                        }, {
                            text: '      ',
                            style: 'signatureJobTitle'

                        }],
                        width: 180
                    }, {
                        stack: [{
                            text: 'Received By',
                            style: 'signaturePlaceholder'
                        }, {
                            text: '______________________________',
                            style: 'signaturePlaceholder'
                        }, {
                            text: 'Name  :',
                            style: 'signatureName'

                        }, {
                            text: 'Date  :',
                            style: 'signatureJobTitle'

                        }],
                        width: 160
                    }]
                }],
                styles: {
                    documentHeaderLeft: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'left'
                    },
                    documentHeaderCenter: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'center'
                    },
                    documentHeaderRight: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'right'
                    },

                    documentFooterLeft: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'left'
                    },
                    documentFooterCenter: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'center'
                    },
                    documentFooterRight: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'right'
                    },

                    invoiceTitle: {
                        fontSize: 22,
                        bold: true,
                        alignment: 'left',
                        margin: [0, 0, 0, 15]
                    },

                    invoiceSubTitle: {
                        fontSize: 10,
                        alignment: 'left'
                    },
                    invoiceSubValue: {
                        fontSize: 10,
                        alignment: 'left'
                    },

                    invoiceBillingTitle: {
                        fontSize: 14,
                        bold: true,
                        alignment: 'left',
                        margin: [0, 20, 0, 5]
                    },

                    invoiceBillingDetails: {
                        alignment: 'left'

                    },
                    invoiceBillingAddressTitle: {
                        margin: [0, 7, 0, 3],
                        bold: true
                    },
                    invoiceBillingAddress: {},

                    itemsHeader: {

                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        bold: true
                    },

                    itemTitle: {
                        bold: true
                    },
                    itemSubTitle: {
                        fontSize: 10
                    },
                    itemText: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        alignment: 'left'
                    },
                    itemNumber: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        alignment: 'right'
                    },
                    itemTotal: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right'
                    },

                    itemsFooterSubTitle: {
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right'
                    },
                    itemsFooterSubValue: {
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'center'
                    },
                    itemsFooterTotalTitle: {
                        fontSize: 11,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right'
                    },
                    itemsFooterTotalValue: {
                        fontSize: 11,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'center'
                    },
                    signaturePlaceholder: {
                        fontSize: 10,
                        margin: [0, 70, 0, 0]
                    },
                    signatureName: {
                        fontSize: 10,
                        margin: [0, 10, 0, 0],
                        bold: true,
                        alignment: 'left'
                    },
                    signatureJobTitle: {
                        fontSize: 10,
                        margin: [0, 20, 0, 0],
                        bold: true,
                        alignment: 'left'
                    },
                    notesTitle: {
                        fontSize: 10,
                        bold: true,
                        margin: [0, 30, 0, 3]
                    },
                    notesText: {
                        fontSize: 10
                    },
                    center: {
                        alignment: 'center'
                    }
                },
                defaultStyle: {
                    columnGap: 20,
                    font: 'ukai'
                }
            };
            __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake___default.a.createPdf(dd).open();
        },
        back: function back() {
            this.$router.push({ name: 'Stock Requisition Forms (SRFS)' });
        },
        fetch: function fetch(docNum) {
            var _this2 = this;

            this.lockEntry = true;
            var sf = ["srf_num = " + docNum];
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["R" /* apiSrfSearch */], sf, Object(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["_7" /* authHeader */])()).then(function (res) {
                var data;
                data = res.data.data.list[0];
                _this2.srf = data;
                _this2.title = "Stock Requisition Form (" + data.srf_num + ")";
                if (_this2.srf.country_id != null) {
                    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["c" /* apiCountryLookup */], { params: { q: _this2.srf.country_id } }).then(function (response) {
                        if (response.data != null) {
                            _this2.list = response.data.data.list;
                            _this2.item = _this2.list[0];
                            _this2.country_name = _this2.item.country_name;
                            _this2.country_name = _this2.country_name.toUpperCase();
                        }
                    });
                }
                _this2.countryId = data.country_id;
                _this2.status = data.status;

                if (_this2.isAccFn) {
                    _this2.btnVisible = true;
                } else if (_this2.isWhHoo) {
                    if (_this2.lockEntry) {
                        _this2.btnVisible = true;
                    }
                }
            }).catch(function (error) {
                return alert(error);
            });
        },
        setEmployee: function setEmployee(obj) {
            if (!this.lockEntry) {
                var id;

                if (obj !== null) {
                    id = obj.id;
                } else {
                    id = null;
                }
                this.srf.requestor_user_id = id;
            }
        },
        setWarehouse: function setWarehouse(obj) {
            var _this3 = this;

            if (!this.lockEntry) {
                var id;
                var curr_id;

                if (obj !== null) {
                    if (obj.id != this.srf.location_id) {
                        id = obj.id;
                        curr_id = obj.currency_id;
                        this.srf.srf_items = [];
                        this.srf.location_id = id;
                        this.srf.currency_id = curr_id;
                        if (this.srf.location_id != '') {
                            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["q" /* apiLocationProductUrl */], { params: { q: '', q2: id } }, Object(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["_7" /* authHeader */])()).then(function (res) {
                                var list;
                                list = res.data.data.list;
                                _this3.noItemsFound = list.length == 0;
                            }).catch(function (error) {
                                return alert(error);
                            });
                        }
                    }
                } else {
                    id = "";
                    this.noItemsFound = true;
                }
            }
        },
        setProduct: function setProduct(obj, index) {
            if (!this.lockEntry) {
                this.prevWhId = this.srf.location_id;
                var name, id, qty_soh, unit_gmp;
                var isDuplicatedEntry = false;
                var items = this.srf.srf_items;

                for (var n = 0; n < items.length; n++) {
                    if (n != index) {
                        if (items[n].product_id == items[index].product_id && items[index].product_id != "") {
                            isDuplicatedEntry = true;
                        }

                        if (isDuplicatedEntry) break;
                    }
                }

                if (!isDuplicatedEntry) {
                    if (obj !== null) {
                        if (obj.id == "") {
                            qty_soh = "";
                            unit_gmp = "";
                        } else {
                            name = obj.name;
                            id = obj.id;
                            qty_soh = obj.qty_soh;
                            unit_gmp = obj.unit_gmp;
                        }
                    } else {
                        name = "";
                        id = "";
                        qty_soh = "";
                        unit_gmp = "";
                    }

                    if (isNaN(qty_soh)) qty_soh = "";
                } else {
                    name = "";
                    id = "";
                    qty_soh = "";
                    unit_gmp = "";
                }

                this.srf.srf_items[index].product_id = id;
                this.srf.srf_items[index].product_name = name;
                this.srf.srf_items[index].qty_soh = qty_soh;
                this.srf.srf_items[index].unit_gmp = unit_gmp;
            }
        },
        addRow: function addRow() {
            this.srf.srf_items.push({ product_id: '', product_name: '', qty_soh: '', qty: '', unit_gmp: '', total_gmp: '' });
        },
        removeRow: function removeRow(index) {
            this.srf.srf_items.splice(index, 1);
        },
        confirmSave: function confirmSave() {
            this.modalShow = true;
        },
        save: function save() {
            var _this4 = this;

            var srf_date = this.srf.srf_date;
            var tday = new Date();
            var dd = tday.getDate();
            var mm = tday.getMonth() + 1;
            var yyyy = tday.getFullYear();

            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            var tday = yyyy + '-' + mm + '-' + dd;

            if (this.srf.srf_date >= tday) {
                if (this.srf.event_start_date != '' && this.srf.event_end_date != '') {
                    var check = 1;
                    var start_date = this.srf.event_start_date;
                    var end_date = this.srf.event_end_date;
                    var today = new Date();
                    var dd = today.getDate();
                    var mm = today.getMonth() + 1;
                    var yyyy = today.getFullYear();
                    if (dd < 10) {
                        dd = '0' + dd;
                    }
                    if (mm < 10) {
                        mm = '0' + mm;
                    }
                    var today = yyyy + '-' + mm + '-' + dd;

                    if (start_date >= today && end_date >= today) {
                        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["Q" /* apiSrfSave */], this.srf, Object(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["_7" /* authHeader */])()).then(function (res) {
                            var r = res.data;
                            if (r.code == 1) {
                                _this4.srfDocNo = r.data.srf_num;
                                _this4.$refs.myModalRef.show();
                            } else {
                                _this4.errorMessage = r.msg;
                                _this4.$refs.myErrorModalRef.show();
                            }
                        }).catch(function (error) {
                            alert("System Error");
                        });
                    } else {
                        this.errorMessage = "Post Dated date entry not allowed for event start date / event end date";
                        this.$refs.myErrorModalRef.show();
                    }
                } else {
                    this.errorMessage = "Invalid entry in event start date / event end date";
                    this.$refs.myErrorModalRef.show();
                }
            } else {
                this.errorMessage = "Post Dated date entry not allowed for SRF date";
                this.$refs.myErrorModalRef.show();
            }
        },
        confirmCancel: function confirmCancel() {
            this.modalCancelShow = true;
        },
        cancel: function cancel() {
            this.$router.push({ name: 'Stock Requisition Forms (SRFS)' });
        },
        hideModal: function hideModal() {
            this.$refs.myModalRef.hide();
            this.$router.push({ name: 'Stock Requisition Forms (SRFS)' });
        },
        hideErrorModal: function hideErrorModal() {
            this.$refs.myErrorModalRef.hide();
        },
        showErrorModal: function showErrorModal(errorMessage) {
            this.errorMessage = errorMessage;
            this.$refs.myErrorModalRef.show();
        },
        validateQty: function validateQty(index) {
            if (!this.lockEntry && 0) {
                var item = this.srf.srf_items[index];
                if (!isNaN(item.qty)) {
                    if (item.qty < 0) {
                        item.qty = 0;
                    } else if (item.qty * 1 > item.qty_soh * 1) {
                        item.qty = 0;
                    }
                } else {
                    item.qty = 0;
                }
            }
        },
        close: function close() {
            var _this5 = this;

            if (this.isWhHoo || this.isAccFn) {
                __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["N" /* apiSrfClose */], { srf_num: this.srf.srf_num }, Object(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["_7" /* authHeader */])()).then(function (res) {
                    _this5.srf.status = "CLOSED";
                    _this5.mbTitle = "Close";
                    _this5.mbMsg = "SRF " + _this5.srf.srf_num + " has been closed.";
                    _this5.$refs.msgBox.show();
                    _this5.fetch(_this5.srf_ref);
                }).catch(function (error) {
                    return alert(error);
                });
            }
        },
        confirmClose: function confirmClose() {
            this.closeModalShow = true;
        },
        approve: function approve() {
            var _this6 = this;

            if (this.isWhHoo) {
                __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["M" /* apiSrfApprove */], { srf_num: this.srf.srf_num, approve: 1, reason: '' }, Object(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["_7" /* authHeader */])()).then(function (res) {
                    _this6.srf.approval_status = "APPROVED";
                    _this6.mbTitle = "Approve";
                    _this6.mbMsg = "SRF " + _this6.srf.srf_num + " has been approved.";
                    _this6.$refs.msgBox.show();
                    _this6.fetch(_this6.srf_ref);
                }).catch(function (error) {
                    return alert(error);
                });
            } else if (this.isAccFn) {
                __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["M" /* apiSrfApprove */], { srf_num: this.srf.srf_num, approve: 1 }, Object(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["_7" /* authHeader */])()).then(function (res) {
                    _this6.srf.approval_status = "APPROVED";
                    _this6.mbTitle = "Approve";
                    _this6.mbMsg = "SRF " + _this6.srf.srf_num + " has been approved.";
                    _this6.$refs.msgBox.show();
                    _this6.fetch(_this6.srf_ref);
                }).catch(function (error) {
                    return alert(error);
                });
            }
        },
        confirmApprove: function confirmApprove() {
            this.approveModalShow = true;
        },
        reject: function reject() {
            var _this7 = this;

            this.$refs.rejectModal.hide();
            if (this.srf.rejected_reason != '' && this.srf.rejected_reason != null) {
                __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["M" /* apiSrfApprove */], { srf_num: this.srf.srf_num, approve: 0, reason: this.srf.rejected_reason }, Object(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["_7" /* authHeader */])()).then(function (res) {
                    if (res.data.code == 1) {
                        _this7.srf.approval_status = "REJECTED";
                        _this7.mbTitle = "Reject";
                        _this7.mbMsg = "SRF " + _this7.srf.srf_num + " has been rejected.";
                        _this7.$refs.msgBox.show();
                        _this7.fetch(_this7.srf_ref);
                    }
                }).catch(function (error) {
                    return alert(error);
                });
            } else {
                this.mbTitle = "Manual Close cancelled";
                this.mbMsg = "Reason has to be provided";
                this.$refs.msgBox.show();
            }
        },
        confirmReject: function confirmReject() {
            this.$refs.rejectModal.show();
        }
    }
});

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Autocomplete_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__functions_common_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_json_excel__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pdfmake_build_vfs_fonts__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pdfmake_build_vfs_fonts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_pdfmake_build_vfs_fonts__);











__WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake___default.a.vfs = __WEBPACK_IMPORTED_MODULE_7_pdfmake_build_vfs_fonts___default.a.pdfMake.vfs;
__WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake___default.a.fonts = {
  "ukai": {
    normal: 'ukai.ttf',
    bold: 'ukai.ttf',
    italics: 'ukai.ttf',
    bolditalics: 'ukai.ttf'
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  components: { spinner: __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue__["a" /* default */], countryLookup: __WEBPACK_IMPORTED_MODULE_3__components_Autocomplete_vue__["a" /* default */], exportExcel: __WEBPACK_IMPORTED_MODULE_5_vue_json_excel__["a" /* default */] },
  props: {
    caption: {
      type: String,
      default: 'Table'
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var _ref;

    return _ref = {
      apiCountryLookup: __WEBPACK_IMPORTED_MODULE_4__functions_common_vue__["c" /* apiCountryLookup */],
      loading: false,
      noResults: false,
      filter: {
        srf_num: '',
        srr_num: '',
        country_id: '',
        date_start: '',
        date_end: '',
        returning_type: 'RETURNABLE'
      },
      searchResults: [],
      searchResultsFields: [{ key: 'country_id', label: 'Country' }, { key: 'location_id', label: 'Location' }, { key: 'srf_date', label: 'SRF Date' }, { key: 'srf_num', label: 'Last SRR' }, { key: 'status', label: 'Status' }, { key: 'last_srr_date', label: 'SRR Date' }, { key: 'last_srr_num', label: 'SRR No' }, { key: 'requestor_user_shortname', label: 'Requestor Name' }],
      currentPage: 1,
      perPage: 20,
      totalRows: 0
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'noResults', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'exportHeaders', {
      'SRF No': 'srf_num',
      'Date': 'srf_date',
      'Country': 'country_id',
      'Location': 'location_id',
      'Last SRR No': 'last_srr_num',
      'Last SRR Date': 'last_srr_date',
      'Status': 'status',
      'Requestor Name': 'requestor_user_shortname'
    }), _ref;
  },
  methods: {
    print: function print() {
      var rows = [];
      var row = [];
      var date = new Date();
      rows.push(['SRF No', 'Date', 'Country', 'Location', 'Last SRR No', 'Last SRR Date', 'Status', 'Requestor Name']);

      for (var key in this.searchResults) {
        var data = this.searchResults[key];
        row = [data.srf_num, data.srf_date, data.country_id, data.location_id, data.last_srr_num, data.last_srr_date, data.status, data.requestor_user_shortname];
        rows.push(row);
      }
      var dd = {
        header: { text: 'Stock Requisition Return List generated on' + " " + date, margin: [5, 10, 10, 30], alignment: 'center', fontSize: 9 },
        pageSize: 'A4',
        pageOrientation: 'portrait',
        defaultStyle: {
          font: 'ukai'
        },

        pageMargins: [30, 30, 30, 20],

        content: [{
          fontSize: 9.5,
          layout: 'lightHorizontalLines',
          table: {
            headerRows: 1,
            widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
            body: rows
          }
        }]
      };
      __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake___default.a.createPdf(dd).open();
    },
    getRowCount: function getRowCount(items) {
      return items.length;
    },
    search: function search() {
      var _this = this;

      this.loading = true;
      this.noResults = true;
      var sf = ["srf_num LIKE " + this.filter.srf_num, "srrs_list LIKE " + this.filter.srr_num, "country_id = " + this.filter.country_id, "srr_date >= " + this.filter.date_start, "srr_date <= " + this.filter.date_end, "returning_type = " + this.filter.returning_type];
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_4__functions_common_vue__["R" /* apiSrfSearch */], sf).then(function (res) {
        return res;
      }).then(function (data) {
        var resultArray = [];
        var myData = data.data.data.list;

        for (var key in myData) {
          var date = myData[key].last_srr_date;
          var srfDate = myData[key].srf_date;
          srfDate = new Date(srfDate);
          var srfDateResult = "" + (srfDate.getDate() > 9 ? '' : '0') + srfDate.getDate() + '/' + (srfDate.getMonth() + 1 > 9 ? '' : '0') + (srfDate.getMonth() + 1) + '/' + srfDate.getFullYear();
          if (date !== null) {
            date = new Date(date);
            var result = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + (date.getMonth() + 1 > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear();
          } else {
            result = "-";
          }
          var last_srr = '-';

          if (myData[key].last_srr_num != null) {
            last_srr = myData[key].last_srr_num;
          }
          myData[key].last_srr_num = last_srr;
          myData[key].last_srr_date = result;
          myData[key].srf_date = srfDateResult;
          resultArray.push(myData[key]);
          _this.loading = false;
        }
        _this.searchResults = resultArray;

        if (_this.searchResults.length == 0) {
          _this.loading = false;
          _this.noResults = true;
        }
      }).catch(function (error) {
        return alert(error);
      });
    },
    newSRR: function newSRR() {
      localStorage.setItem("srr_new.srf_num", "");
      this.$router.push({ name: 'Stock Requisition Return Entry (SRR)', params: { srrNum: '_new' } });
    },
    setCountry: function setCountry(obj) {
      var id;
      if (obj !== null) {
        id = obj.id;
      } else {
        id = null;
      }
      this.filter.country_id = id;
    },
    rowClick: function rowClick(item) {
      localStorage.setItem("srr_new.srf_num", item.srf_num);
      this.$router.push({ name: 'Stock Requisition Return Entry (SRR)', params: { srrNum: '_new' } });
    }
  }
});

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Autocomplete_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__functions_common_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pdfmake_build_vfs_fonts__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pdfmake_build_vfs_fonts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_pdfmake_build_vfs_fonts__);








__WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake___default.a.vfs = __WEBPACK_IMPORTED_MODULE_4_pdfmake_build_vfs_fonts___default.a.pdfMake.vfs;
__WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake___default.a.fonts = {
    "ukai": {
        normal: 'ukai.ttf',
        bold: 'ukai.ttf',
        italics: 'ukai.ttf',
        bolditalics: 'ukai.ttf'
    },
    "Garuda": {
        normal: 'Garuda.ttf',
        bold: 'Garuda.ttf',
        italics: 'Garuda.ttf',
        bolditalics: 'Garuda.ttf'
    },
    "Hanumanb": {
        normal: 'Hanumanb.ttf',
        bold: 'Hanumanb.ttf',
        italics: 'Hanumanb.ttf',
        bolditalics: 'Hanumanb.ttf'
    }
};
/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'srr',
    components: { srfLookup: __WEBPACK_IMPORTED_MODULE_1__components_Autocomplete_vue__["a" /* default */] },
    data: function data() {
        return {
            modalShow: false,
            modalCancelShow: false,
            country_name: '',
            srfNum: '',
            modalMsg: '',
            font: 'ukai',
            isSrfRetrieved: false,
            title: 'New SRR',
            errorMessage: '',
            apiSrfLookup: __WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["P" /* apiSrfLookup */],
            srrDocNo: 'test',
            isValid: true,
            received_qty: 0,
            srr: {
                srr_num: '',
                srr_date: '',
                srf_num: '',
                remarks: '',
                reference_num: '',
                srr_items: {},
                srf: {
                    srrs: []
                }
            }
        };
    },
    created: function created() {
        var _this = this;

        if (localStorage.getItem("srr_new.srf_num") != "") {
            this.isSrfRetrieved = true;
            var srfNum = localStorage.getItem("srr_new.srf_num");
            var url = this.apiSrfLookup;

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url, { params: { q: srfNum, get: 1 } }, Object(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["_7" /* authHeader */])()).then(function (response) {
                _this.list = response.data.data.list;

                if (_this.list.length > 0) {
                    _this.item = _this.list[0];
                    if (_this.item !== null) {
                        _this.isSrfRetrieved = true;
                        var srf = _this.item;
                        if (srf.country_id != null) {
                            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["c" /* apiCountryLookup */], { params: { q: srf.country_id } }).then(function (response) {

                                if (response.data != null) {
                                    _this.list = response.data.data.list;
                                    _this.item = _this.list[0];
                                    _this.country_name = _this.item.country_name;
                                    _this.country_name = _this.country_name.toUpperCase();
                                }
                            });
                        }
                        _this.srr.srf = srf;
                        _this.srr.srf_num = srf.srf_num;

                        _this.srr.srf.srrs = _this.item.srrs;
                        for (var n = 0; n < _this.srr.srf.srrs.length; n++) {
                            var date = _this.srr.srf.srrs[n].srr_date;
                            date = new Date(date);
                            var result = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + (date.getMonth() + 1 > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear();
                            _this.srr.srf.srrs[n].srr_date = result;
                        }
                        var curDate = new Date();
                        curDate = curDate.toISOString().substr(0, 10);
                        _this.srr.srr_date = curDate;
                    }
                }
            }).catch(function (error) {
                return alert(error);
            });
        } else {
            this.isSrfRetrieved = false;
            this.srfNum = '';
        }
    },

    methods: {
        printSRR: function printSRR(row) {
            console.log(row);
            var srr_num = row.srr_num;
            var r = [];
            var srrItems = [];
            r = [{
                text: 'S/No',
                style: 'itemsHeader'
            }, {
                text: 'Product Code',
                style: ['itemsHeader'],
                alignment: 'left'
            }, {
                text: 'Description',
                style: ['itemsHeader'],
                alignment: 'left'
            }, {
                text: 'Qty',
                style: ['itemsHeader'],
                alignment: 'right'
            }];
            srrItems.push(r);

            var items = row.srr_items;
            for (var key in items) {
                var data = items[key];
                var qty = (data.qty * 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                if (data.product_name == null) {
                    data.product_name = "";
                }
                r = [{
                    text: key * 1 + 1,
                    style: 'itemText'
                }, {
                    text: data.product_id,
                    style: 'itemText'
                }, {
                    text: data.product_name,
                    style: 'itemText'
                }, {
                    text: qty,
                    style: 'itemNumber'
                }];
                srrItems.push(r);
            }

            var ddHeader = {
                columns: [[{
                    text: 'ELKEN ' + this.country_name + ' STOCK REQUSITION RETURN',
                    style: 'invoiceTitle',
                    width: '*'
                }, {
                    stack: [{
                        columns: [{
                            text: 'SRR #',
                            style: 'invoiceSubTitle',
                            width: 95

                        }, {
                            text: srr_num,
                            style: 'invoiceSubValue',
                            width: 100
                        }]
                    }, {
                        text: ' '
                    }, {
                        columns: [{
                            text: 'SRR Date',
                            style: 'invoiceSubTitle',
                            width: 95

                        }, {
                            text: row.srr_date,
                            style: 'invoiceSubValue',
                            width: 100
                        }]

                    }, {
                        text: ' '
                    }, {
                        columns: [{
                            text: 'Reference SRF#',
                            style: 'invoiceSubTitle',
                            width: 95

                        }, {
                            text: row.srf_num,
                            style: 'invoiceSubValue'
                        }]

                    }, {
                        text: ' '
                    }, {
                        columns: [{
                            text: 'Reason',
                            style: 'invoiceSubTitle',
                            width: 95

                        }, {
                            text: '',
                            style: 'invoiceSubValue',
                            width: 100
                        }]
                    }]
                }]]
            };

            var dd = {
                header: function header(pageNumber, pageCount) {
                    return {
                        margin: [0, 10, 0, 0],
                        columns: [{
                            text: '',
                            style: 'documentHeaderLeft'
                        }, {
                            text: srr_num,
                            style: 'documentHeaderCenter'
                        }, {
                            text: '',
                            style: 'documentHeaderRight'
                        }]
                    };
                },
                footer: function footer(pageNumber, pageCount) {
                    return {
                        margin: [0, 0, 0, 50],
                        columns: [{
                            text: '',
                            style: 'documentFooterLeft'
                        }, {
                            text: 'Page ' + pageNumber + " of " + pageCount,
                            style: 'documentFooterCenter'
                        }, {
                            text: '',
                            style: 'documentFooterRight'
                        }]
                    };
                },
                content: [ddHeader, '\n\n', {
                    layout: 'lightHorizontalLines',
                    table: {

                        headerRows: 1,
                        widths: [25, 68, '*', 45, 45],
                        body: srrItems

                    } }, {
                    text: 'Remarks',
                    style: 'notesTitle'
                }, {
                    text: row.remarks,
                    style: 'notesText'
                }, {
                    columns: [{
                        stack: [{
                            text: 'Issued By',
                            style: 'signaturePlaceholder'
                        }, {
                            text: '______________________________',
                            style: 'signaturePlaceholder'
                        }, {
                            text: 'Name  : ' + row.author_user_shortname,
                            style: 'signatureName'

                        }, {
                            text: 'Date  : ' + row.srr_date,
                            style: 'signatureJobTitle'

                        }],
                        width: 160
                    }, {
                        stack: [{
                            text: '  ',
                            style: 'signaturePlaceholder'
                        }, {
                            text: '                      ',
                            style: 'signaturePlaceholder'
                        }, {
                            text: '  ',
                            style: 'signatureName'

                        }, {
                            text: '      ',
                            style: 'signatureJobTitle'

                        }],
                        width: 180
                    }, {
                        stack: [{
                            text: 'Received By',
                            style: 'signaturePlaceholder'
                        }, {
                            text: '______________________________',
                            style: 'signaturePlaceholder'
                        }, {
                            text: 'Name  :',
                            style: 'signatureName'

                        }, {
                            text: 'Date  :',
                            style: 'signatureJobTitle'

                        }],
                        width: 160
                    }]
                }],
                styles: {
                    documentHeaderLeft: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'left'
                    },
                    documentHeaderCenter: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'center'
                    },
                    documentHeaderRight: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'right'
                    },

                    documentFooterLeft: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'left'
                    },
                    documentFooterCenter: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'center'
                    },
                    documentFooterRight: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'right'
                    },

                    invoiceTitle: {
                        fontSize: 22,
                        bold: true,
                        alignment: 'left',
                        margin: [0, 0, 0, 15]
                    },

                    invoiceSubTitle: {
                        fontSize: 10,
                        alignment: 'left'
                    },
                    invoiceSubValue: {
                        fontSize: 10,
                        alignment: 'left'
                    },

                    invoiceBillingTitle: {
                        fontSize: 14,
                        bold: true,
                        alignment: 'left',
                        margin: [0, 20, 0, 5]
                    },

                    invoiceBillingDetails: {
                        alignment: 'left'

                    },
                    invoiceBillingAddressTitle: {
                        margin: [0, 7, 0, 3],
                        bold: true
                    },
                    invoiceBillingAddress: {},

                    itemsHeader: {

                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        bold: true
                    },

                    itemTitle: {
                        bold: true
                    },
                    itemSubTitle: {
                        fontSize: 10
                    },
                    itemText: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        alignment: 'left'
                    },
                    itemNumber: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        alignment: 'right'
                    },
                    itemTotal: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right'
                    },

                    itemsFooterSubTitle: {
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right'
                    },
                    itemsFooterSubValue: {
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'center'
                    },
                    itemsFooterTotalTitle: {
                        fontSize: 11,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right'
                    },
                    itemsFooterTotalValue: {
                        fontSize: 11,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'center'
                    },
                    signaturePlaceholder: {
                        fontSize: 10,
                        margin: [0, 70, 0, 0]
                    },
                    signatureName: {
                        fontSize: 10,
                        margin: [0, 10, 0, 0],
                        bold: true,
                        alignment: 'left'
                    },
                    signatureJobTitle: {
                        fontSize: 10,
                        margin: [0, 20, 0, 0],
                        bold: true,
                        alignment: 'left'
                    },
                    notesTitle: {
                        fontSize: 10,
                        bold: true,
                        margin: [0, 30, 0, 3]
                    },
                    notesText: {
                        fontSize: 10
                    },
                    center: {
                        alignment: 'center'
                    }
                },
                defaultStyle: {
                    columnGap: 20,
                    font: this.font
                }
            };
            __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake___default.a.createPdf(dd).open();
        },
        print: function print() {
            var srfNum = this.srr.srf_num;
            var row = [];
            var date = new Date(this.srr.srf.srf_date);
            var srfDate = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + (date.getMonth() + 1 > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear();
            var srrItems = [];
            var returnDate = '-';
            var eventStart = '-';
            var eventEnd = '-';
            if (this.srr.srf.event_start_date != null) {
                var s = new Date(this.srr.srf.event_start_date);
                eventStart = "" + (s.getDate() > 9 ? '' : '0') + s.getDate() + '/' + (s.getMonth() + 1 > 9 ? '' : '0') + (s.getMonth() + 1) + '/' + s.getFullYear();
            }
            if (this.srr.srf.event_start_date != null) {
                var e = new Date(this.srr.srf.event_end_date);
                eventEnd = "" + (e.getDate() > 9 ? '' : '0') + e.getDate() + '/' + (e.getMonth() + 1 > 9 ? '' : '0') + (e.getMonth() + 1) + '/' + e.getFullYear();
            }
            if (this.srr.srf.return_date != null) {
                var d = new Date(this.srr.srf.return_date);
                returnDate = "" + (d.getDate() > 9 ? '' : '0') + d.getDate() + '/' + (d.getMonth() + 1 > 9 ? '' : '0') + (d.getMonth() + 1) + '/' + d.getFullYear();
            }
            row = [{
                text: 'S/No',
                style: 'itemsHeader'
            }, {
                text: 'SKU',
                style: ['itemsHeader'],
                alignment: 'left'
            }, {
                text: 'Description',
                style: ['itemsHeader'],
                alignment: 'left'
            }, {
                text: 'SRF Qty',
                style: ['itemsHeader'],
                alignment: 'left'
            }, {
                text: 'Unit GMP',
                style: ['itemsHeader'],
                alignment: 'left'
            }, {
                text: 'Total GMP',
                style: ['itemsHeader'],
                alignment: 'left'
            }, {
                text: 'SRR Qty',
                style: ['itemsHeader'],
                alignment: 'right'
            }, {
                text: 'Returned GMP',
                style: ['itemsHeader'],
                alignment: 'left'
            }, {
                text: 'Utilized Qty',
                style: ['itemsHeader'],
                alignment: 'right'
            }, {
                text: 'Utilized GMP',
                style: ['itemsHeader'],
                alignment: 'left'
            }];
            srrItems.push(row);
            var items = this.srr.srf.srf_items;
            for (var key in items) {
                var data = items[key];
                var qty = (data.qty * 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                var qty_returned = (data.qty_returned * 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                var total_gmp = (data.amount_total * 1).toFixed(2);
                total_gmp = total_gmp.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                var unit_gmp = (data.unit_gmp * 1).toFixed(2);
                unit_gmp = unit_gmp.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                var returned_gmp = (data.unit_gmp * 1 * data.qty_received_current * 1).toFixed(2);
                returned_gmp = returned_gmp.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                var utilized_qty = data.qty * 1 - (data.qty_returned * 1 + data.qty_received_current * 1);
                utilized_qty = utilized_qty.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                var utilized_gmp = (data.unit_gmp * 1 * (data.qty * 1 - (data.qty_returned * 1 + data.qty_received_current * 1))).toFixed(2);
                utilized_gmp = utilized_gmp.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                if (data.product_name == null) {
                    data.product_name = "";
                }
                row = [{
                    text: key * 1 + 1,
                    style: 'itemText'
                }, {
                    text: data.product_id,
                    style: 'itemText'
                }, {
                    text: data.product_name,
                    style: 'itemText'
                }, {
                    text: qty,
                    style: 'itemNumber'
                }, {
                    text: unit_gmp,
                    style: 'itemText'
                }, {
                    text: total_gmp,
                    style: 'itemText'
                }, {
                    text: qty_returned,
                    style: 'itemNumber'
                }, {
                    text: returned_gmp,
                    style: 'itemText'
                }, {
                    text: utilized_qty,
                    style: 'itemText'
                }, {
                    text: utilized_gmp,
                    style: 'itemText'
                }];
                srrItems.push(row);
            }
            var srrsItems = [];
            var srrRow = [];
            srrRow = [{
                text: 'S/No',
                style: 'itemsHeader'
            }, {
                text: 'SRR #',
                style: ['itemsHeader'],
                alignment: 'left'
            }, {
                text: 'SRR Date',
                style: ['itemsHeader'],
                alignment: 'left'
            }, {
                text: 'Generated By',
                style: ['itemsHeader'],
                alignment: 'left'
            }];
            srrsItems.push(srrRow);
            var srrs = this.srr.srf.srrs;
            for (var _key in srrs) {
                var gd = srrs[_key];
                srrRow = [{
                    text: _key * 1 + 1,
                    style: 'itemText'
                }, {
                    text: gd.srr_num,
                    style: 'itemText'
                }, {
                    text: gd.srr_date,
                    style: 'itemText'
                }, {
                    text: gd.author_user_shortname,
                    style: 'itemText'
                }];
                srrsItems.push(srrRow);
            }

            var ddHeader = {
                columns: [[{
                    text: 'ELKEN ' + this.country_name + ' STOCK REQUSITION RETURN',
                    style: 'invoiceTitle',
                    width: '*'
                }, {
                    stack: [{
                        columns: [{
                            text: 'SRF #',
                            style: 'invoiceSubTitle',
                            width: 90

                        }, {
                            text: srfNum,
                            style: 'invoiceSubValue',
                            width: 130
                        }, { text: '', style: 'invoiceSubValue', width: 80 }, {
                            text: 'SRF Date',
                            style: 'invoiceSubTitle',
                            width: 90

                        }, {
                            text: srfDate,
                            style: 'invoiceSubValue',
                            width: 130

                        }]
                    }, {
                        columns: [{
                            text: 'Stock Location',
                            style: 'invoiceSubTitle',
                            width: 90

                        }, {
                            text: this.srr.srf.location_full,
                            style: 'invoiceSubValue',
                            width: 130
                        }, { text: '', style: 'invoiceSubValue', width: 80 }, {
                            text: 'Status',
                            style: 'invoiceSubTitle',
                            width: 90

                        }, {
                            text: this.srr.srf.status,
                            style: 'invoiceSubValue',
                            width: 130
                        }]

                    }, {
                        columns: [{
                            text: 'Requestor',
                            style: 'invoiceSubTitle',
                            width: 90

                        }, {
                            text: this.srr.srf.requestor_user_shortname,
                            style: 'invoiceSubValue',
                            width: 130
                        }, { text: '', style: 'invoiceSubValue', width: 80 }, {
                            text: 'Reason',
                            style: 'invoiceSubTitle',
                            width: 90
                        }, {
                            text: this.srr.srf.reason,
                            style: 'invoiceSubValue',
                            width: 130
                        }]

                    }, {
                        columns: [{
                            text: 'Event Start Date',
                            style: 'invoiceSubTitle',
                            width: 90

                        }, {
                            text: eventStart,
                            style: 'invoiceSubValue',
                            width: 130
                        }, { text: '', style: 'invoiceSubValue', width: 80 }, {
                            text: 'Event End Date',
                            style: 'invoiceSubTitle',
                            width: 90

                        }, {
                            text: eventEnd,
                            style: 'invoiceSubValue',
                            width: 130

                        }]

                    }, {
                        columns: [{
                            text: 'Returnning Type',
                            style: 'invoiceSubTitle',
                            width: 90

                        }, {
                            text: this.srr.srf.returning_type,
                            style: 'invoiceSubValue',
                            width: 130
                        }, { text: '', style: 'invoiceSubValue', width: 80 }, {
                            text: 'Est Return Date',
                            style: 'invoiceSubTitle',
                            width: 90

                        }, {
                            text: returnDate,
                            style: 'invoiceSubValue',
                            width: 130
                        }]

                    }, {
                        columns: [{
                            text: 'Currency Code',
                            style: 'invoiceSubTitle',
                            width: 90

                        }, {
                            text: this.srr.srf.currency_id,
                            style: 'invoiceSubValue',
                            width: 130

                        }]

                    }]
                }]]
            };

            var dd = {
                header: function header(pageNumber, pageCount) {
                    return {
                        margin: [0, 10, 0, 0],
                        columns: [{
                            text: '',
                            style: 'documentHeaderLeft'
                        }, {
                            text: srfNum,
                            style: 'documentHeaderCenter'
                        }, {
                            text: '',
                            style: 'documentHeaderRight'
                        }]
                    };
                },
                footer: function footer(pageNumber, pageCount) {
                    return {
                        margin: [0, 0, 0, 50],
                        columns: [{
                            text: '',
                            style: 'documentFooterLeft'
                        }, {
                            text: 'Page ' + pageNumber + " of " + pageCount,
                            style: 'documentFooterCenter'
                        }, {
                            text: '',
                            style: 'documentFooterRight'
                        }]
                    };
                },
                content: [ddHeader, {
                    text: 'SRR Lists',
                    style: 'notesTitle'
                }, {
                    table: {
                        headerRows: 0,
                        widths: [25, 'auto', 80, 'auto'],
                        body: srrsItems
                    },
                    layout: 'lightHorizontalLines'
                }, '\n\n', {
                    layout: 'lightHorizontalLines',
                    table: {

                        headerRows: 1,
                        widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
                        body: srrItems

                    } }, {
                    text: 'SRF Remarks',
                    style: 'notesTitle'
                }, {
                    text: this.srr.srf.remarks,
                    style: 'notesText'
                }],
                styles: {
                    documentHeaderLeft: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'left'
                    },
                    documentHeaderCenter: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'center'
                    },
                    documentHeaderRight: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'right'
                    },

                    documentFooterLeft: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'left'
                    },
                    documentFooterCenter: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'center'
                    },
                    documentFooterRight: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'right'
                    },

                    invoiceTitle: {
                        fontSize: 22,
                        bold: true,
                        alignment: 'left',
                        margin: [0, 0, 0, 15]
                    },

                    invoiceSubTitle: {
                        fontSize: 10,
                        alignment: 'left'
                    },
                    invoiceSubValue: {
                        fontSize: 10,
                        alignment: 'left'
                    },

                    invoiceBillingTitle: {
                        fontSize: 14,
                        bold: true,
                        alignment: 'left',
                        margin: [0, 20, 0, 5]
                    },

                    invoiceBillingDetails: {
                        alignment: 'left'

                    },
                    invoiceBillingAddressTitle: {
                        margin: [0, 7, 0, 3],
                        bold: true
                    },
                    invoiceBillingAddress: {},

                    itemsHeader: {

                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        bold: true
                    },

                    itemTitle: {
                        bold: true
                    },
                    itemSubTitle: {
                        fontSize: 10
                    },
                    itemText: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        alignment: 'left'
                    },
                    itemNumber: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        alignment: 'right'
                    },
                    itemTotal: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right'
                    },

                    itemsFooterSubTitle: {
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right'
                    },
                    itemsFooterSubValue: {
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'center'
                    },
                    itemsFooterTotalTitle: {
                        fontSize: 11,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right'
                    },
                    itemsFooterTotalValue: {
                        fontSize: 11,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'center'
                    },
                    signaturePlaceholder: {
                        fontSize: 10,
                        margin: [0, 70, 0, 0]
                    },
                    signatureName: {
                        fontSize: 10,
                        margin: [0, 10, 0, 0],
                        bold: true,
                        alignment: 'left'
                    },
                    signatureJobTitle: {
                        fontSize: 10,
                        margin: [0, 20, 0, 0],
                        bold: true,
                        alignment: 'left'
                    },
                    notesTitle: {
                        fontSize: 10,
                        bold: true,
                        margin: [0, 30, 0, 3]
                    },
                    notesText: {
                        fontSize: 10
                    },
                    center: {
                        alignment: 'center'
                    }
                },
                defaultStyle: {
                    columnGap: 20,
                    font: this.font
                }
            };
            __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake___default.a.createPdf(dd).open();
        },
        retrieveSRF: function retrieveSRF() {
            if (this.srr.srf_num != '') {
                this.isSrfRetrieved = true;
            }
        },
        setSrfId: function setSrfId(obj) {
            var _this2 = this;

            if (obj !== null) {
                this.srr.srr_date = curDate;
                this.srr.srf = obj;
                this.srr.srf_num = obj.srf_num;
                if (this.obj.country_id != null) {
                    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["c" /* apiCountryLookup */], { params: { q: this.obj.country_id } }).then(function (response) {

                        if (response.data != null) {
                            _this2.list = response.data.data.list;
                            _this2.item = _this2.list[0];
                            _this2.country_name = _this2.item.country_name;
                            _this2.country_name = _this2.country_name.toUpperCase();
                        }
                    });
                }

                var curDate = new Date();
                curDate = curDate.toISOString().substr(0, 10);
                this.srr.srr_date = curDate;
            } else {
                this.srr.srf_num = null;
            }
        },
        confirmSave: function confirmSave() {
            this.modalShow = true;
        },
        save: function save() {
            var _this3 = this;

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["S" /* apiSrrSave */], this.srr, Object(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["_7" /* authHeader */])()).then(function (res) {
                var r = res.data;
                if (r.code == 1) {
                    _this3.srrDocNo = r.data.srr_num;
                    _this3.$refs.myModalRef.show();
                } else {
                    _this3.errorMessage = r.msg;
                    _this3.$refs.myErrorModalRef.show();
                }
            }).catch(function (error) {
                return alert(error);
            });
        },
        confirmCancel: function confirmCancel() {
            this.modalCancelShow = true;
        },
        cancel: function cancel() {
            this.$router.push({ name: 'Stock Requisition Returns (SRRS)' });
        },
        hideModal: function hideModal() {
            this.$refs.myModalRef.hide();
            this.$router.push({ name: 'Stock Requisition Returns (SRRS)' });
        },
        hideErrorModal: function hideErrorModal() {
            this.$refs.myErrorModalRef.hide();
        },
        validateQty: function validateQty(index) {
            if (!this.lockEntry && 0) {
                var updateQty;
                updateQty = this.srr.srf.srf_items[index].qty_received_current * 1;
                var requestedQty;
                requestedQty = this.srr.srf.srf_items[index].qty * 1;
                var returnedQty = this.srr.srf.srf_items[index].qty_returned * 1;

                var maxQty = requestedQty * 1 - returnedQty * 1;
                if (updateQty < 0) {
                    this.errorMessage = "SRR Quantity Value must not be a negative number";
                    this.$refs.myErrorModalRef.show();
                    this.srr.srf.srf_items[index].qty_received_current = 0;
                } else if (updateQty > maxQty) {
                    this.errorMessage = "SRR Quantity Value must not exceed the requested of the SRF Qty";
                    this.$refs.myErrorModalRef.show();
                    this.srr.srf.srf_items[index].qty_received_current = 0;
                }
            }
        },
        back: function back() {
            this.$router.push({ name: 'Stock Requisition Returns (SRRS)' });
        }
    }
});

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Autocomplete_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__functions_common_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_json_excel__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pdfmake_build_vfs_fonts__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pdfmake_build_vfs_fonts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_pdfmake_build_vfs_fonts__);











__WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake___default.a.vfs = __WEBPACK_IMPORTED_MODULE_7_pdfmake_build_vfs_fonts___default.a.pdfMake.vfs;
__WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake___default.a.fonts = {
  "ukai": {
    normal: 'ukai.ttf',
    bold: 'ukai.ttf',
    italics: 'ukai.ttf',
    bolditalics: 'ukai.ttf'
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  components: { spinner: __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue__["a" /* default */], countryLookup: __WEBPACK_IMPORTED_MODULE_3__components_Autocomplete_vue__["a" /* default */], exportExcel: __WEBPACK_IMPORTED_MODULE_5_vue_json_excel__["a" /* default */] },
  props: {
    caption: {
      type: String,
      default: 'Table'
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var _ref;

    return _ref = {
      apiCountryLookup: __WEBPACK_IMPORTED_MODULE_4__functions_common_vue__["c" /* apiCountryLookup */],
      loading: false,
      noResults: false,
      filter: {
        san_num: '',
        country_id: '',
        date_start: '',
        date_end: '',
        reason: '',
        status: ''
      },
      searchResults: [],
      searchResultsFields: [{ key: 'country_id', label: 'Country Code' }, { key: 'location_id', label: 'Location' }, { key: 'san_date', label: 'SAN Date' }, { key: 'san_num', label: 'SAN No' }, { key: 'reason', label: 'Reason' }, { key: 'reference_num', label: 'Reference No' }, { key: 'status', label: 'Status' }, { key: 'rejection_reason', label: 'Rejection Reason' }, { key: 'author_user_shortname', label: 'Created By' }, { key: 'approver_user_shortname', label: 'Approver' }, { key: 'approved_date', label: 'Aproved Date' }],
      currentPage: 1,
      perPage: 20,
      totalRows: 0
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'noResults', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'exportHeaders', {
      'SAN No': 'san_num',
      'Date': 'san_date',
      'Country': 'country_id',
      'Location': 'location_id',
      'Reason': 'reason',
      'Reference #': 'reference_num',
      'Status': 'status',
      'Rejection Reason': 'rejection_reason',
      'Created By': 'author_user_shortname',
      'Approver': 'approver_user_shortname',
      'Approved Date': 'approved_date'
    }), _ref;
  },
  computed: {
    reasonsList: function reasonsList() {
      var list = [];

      list.push('');
      list.push('CONVERSION');
      list.push('STOCK COUNT VARIANCE');
      list.push('SHIPMENT DISCREPANCY');
      list.push('GRB / WRITE-OFF ITEM');
      list.push('RECEIVING ERROR BY STAFF');
      list.push('OTHERS');

      return list;
    }

  },
  methods: {
    print: function print() {
      var rows = [];
      var row = [];
      var date = new Date();
      rows.push(['SAN No', 'Date', 'Country', 'Location', 'Reason', 'Status', 'Rejection Reason', 'Reference #', 'Created By', 'Approver', 'Approved Date']);

      for (var key in this.searchResults) {
        var data = this.searchResults[key];
        var ref = '-';
        if (data.reference_num != '') {
          ref = data.reference_num;
        }
        row = [data.san_num, data.san_date, data.country_id, data.location_id, data.reason, data.status, data.rejection_reason, ref, data.author_user_shortname, data.approver_user_shortname, data.approved_date];
        rows.push(row);
      }
      var dd = {
        header: { text: 'Stock Adjustment Listing generated on' + " " + date, margin: [5, 10, 10, 30], alignment: 'center', fontSize: 9 },
        pageSize: 'A4',
        pageOrientation: 'landscape',

        pageMargins: [30, 30, 30, 20],
        defaultStyle: {
          font: 'ukai'
        },

        content: [{
          fontSize: 10,
          layout: 'lightHorizontalLines',
          table: {
            headerRows: 1,
            widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
            body: rows
          }
        }]
      };

      __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake___default.a.createPdf(dd).open();
    },
    rowClick: function rowClick(item, index) {
      this.$router.push({ name: 'Stock Adjustment Note Entry (SAN)', params: { sanNum: item.san_num } });
    },
    getRowCount: function getRowCount(items) {
      return items.length;
    },
    search: function search() {
      var _this = this;

      this.loading = true;
      var sf = ["san_num LIKE " + this.filter.san_num, "country_id = " + this.filter.country_id, "san_date >= " + this.filter.date_start, "san_date <= " + this.filter.date_end, "status = " + this.filter.status, "reason = " + this.filter.reason];
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_4__functions_common_vue__["J" /* apiSanSearch */], sf, Object(__WEBPACK_IMPORTED_MODULE_4__functions_common_vue__["_7" /* authHeader */])()).then(function (res) {
        return res;
      }).then(function (data) {
        var resultArray = [];
        var myData = data.data.data.list;
        for (var key in myData) {
          var date = myData[key].san_date;
          var date = new Date(date);
          var result = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + (date.getMonth() + 1 > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear();
          myData[key].san_date = result;
          var rejection_reason = myData[key].rejection_reason;
          if (rejection_reason == null) {
            myData[key].rejection_reason = '-';
          }
          var r = '-';
          if (myData[key].approved_date != null) {
            var d = myData[key].approved_date;
            d = new Date(d);
            r = "" + (d.getDate() > 9 ? '' : '0') + d.getDate() + '/' + (d.getMonth() + 1 > 9 ? '' : '0') + (d.getMonth() + 1) + '/' + d.getFullYear();
          }
          if (myData[key].approver_user_shortname == null) {
            myData[key].approver_user_shortname = '-';
          }
          myData[key].approved_date = r;
          resultArray.push(myData[key]);
          _this.loading = false;
        }
        _this.searchResults = resultArray;

        if (_this.searchResults.length == 0) {
          _this.loading = false;
          _this.noResults = true;
        }
      }).catch(function (error) {
        _this.loading = false;
        alert(error);
      });
    },
    newSAN: function newSAN() {
      this.$router.push({ name: 'Stock Adjustment Note Entry (SAN)', params: { sanNum: '_new' } });
    },
    setCountry: function setCountry(obj) {
      var id;
      if (obj !== null) {
        id = obj.id;
      } else {
        id = null;
      }
      this.filter.country_id = id;
    }
  }
});

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Autocomplete_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__functions_common_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pdfmake_build_vfs_fonts__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pdfmake_build_vfs_fonts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_pdfmake_build_vfs_fonts__);










__WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake___default.a.vfs = __WEBPACK_IMPORTED_MODULE_4_pdfmake_build_vfs_fonts___default.a.pdfMake.vfs;
__WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake___default.a.fonts = {
    "ukai": {
        normal: 'ukai.ttf',
        bold: 'ukai.ttf',
        italics: 'ukai.ttf',
        bolditalics: 'ukai.ttf'
    },
    "Garuda": {
        normal: 'Garuda.ttf',
        bold: 'Garuda.ttf',
        italics: 'Garuda.ttf',
        bolditalics: 'Garuda.ttf'
    },
    "Hanumanb": {
        normal: 'Hanumanb.ttf',
        bold: 'Hanumanb.ttf',
        italics: 'Hanumanb.ttf',
        bolditalics: 'Hanumanb.ttf'
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    components: { warehouseLookup: __WEBPACK_IMPORTED_MODULE_1__components_Autocomplete_vue__["a" /* default */], productLookup: __WEBPACK_IMPORTED_MODULE_1__components_Autocomplete_vue__["a" /* default */], countryLookup: __WEBPACK_IMPORTED_MODULE_1__components_Autocomplete_vue__["a" /* default */] },
    computed: {
        reasonsList: function reasonsList() {
            var list = [];

            list.push('');
            list.push('CONVERSION');
            list.push('STOCK COUNT VARIANCE');
            list.push('SHIPMENT DISCREPANCY');
            list.push('GRB / WRITE-OFF ITEM');
            list.push('RECEIVING ERROR BY STAFF');
            list.push('OTHERS');

            return list;
        }
    },
    data: function data() {
        return {
            isWh: false,
            isWhHoo: false,
            isAcc: false,
            isAccFn: false,
            mbTitle: "",
            mbMsg: "",
            country_name: '',
            backBtnVisible: false,
            title: 'New SAN',
            apiWarehouseUrl: __WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["V" /* apiWarehouseLookup */],
            apiLocationProductUrl: __WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["q" /* apiLocationProductUrl */],
            modalShow: false,
            approveModalShow: false,
            modalCancelShow: false,
            noItemsFound: true,
            btnVisible: false,
            confirmTxt: '',
            lockEntry: false,
            sanDocNo: '12345',
            errorMessage: '',
            font: 'ukai',
            san: {
                san_date: '',
                location_id: '',
                status: '',
                reference_num: '',
                reason: '',
                san_reject_remarks: '',
                remarks: '',
                san_items: [{ product_name: '', product_id: '', qty_soh: '', qty: '', unit_gmp: '', total_gmp: '' }]
            }
        };
    },
    created: function created() {
        var app_role;

        app_role = JSON.parse(localStorage.getItem("app_role"));
        this.isWh = app_role.includes("WH");
        this.isWhHoo = app_role.includes("WH_HOO");
        this.isAcc = app_role.includes("AC");
        this.isAccFn = app_role.includes("AC_FN");


        this.san_ref = this.$route.params.sanNum;
        if (this.san_ref == '_new') {
            var curDate = new Date();
            curDate = curDate.toISOString().substr(0, 10);
            this.san.san_date = curDate;
            this.noItemsFound = true;
        } else {
            this.lockEntry = true;
            console.log(this.btnVisible);
            this.fetch(this.san_ref);
            this.title = "Stock Adjustment Note" + this.$route.params.sanNum;
            this.noItemsFound = false;
        }
    },

    methods: {
        print: function print() {
            var san_num = this.san.san_num;
            var row = [];
            var date = new Date(this.san.san_date);
            var sanDate = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + (date.getMonth() + 1 > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear();
            var sanItems = [];
            var approver = '-';
            var approvedDate = '-';
            var rejection_remarks = '-';
            if (this.san.rejection_reason != null) {
                rejection_remarks = this.san.rejection_reason;
            }
            console.log(this.san);
            if (this.san.approver_user_shortname != null) {
                approver = this.san.approver_user_shortname;
            }
            if (this.san.approved_date != null) {
                var d = new Date(this.san.approved_date);
                approvedDate = "" + (d.getDate() > 9 ? '' : '0') + d.getDate() + '/' + (d.getMonth() + 1 > 9 ? '' : '0') + (d.getMonth() + 1) + '/' + d.getFullYear();
            }
            var approvedText = "Approved By";
            if (this.san.status == 'REJECTED') {
                approvedText = 'Rejected By';
            }
            row = [{
                text: 'S/No',
                style: 'itemsHeader'
            }, {
                text: 'Product Code',
                style: ['itemsHeader'],
                alignment: 'left'
            }, {
                text: 'Description',
                style: ['itemsHeader'],
                alignment: 'left'
            }, {
                text: 'SOH',
                style: ['itemsHeader'],
                alignment: 'left'
            }, {
                text: 'Unit GMP',
                style: ['itemsHeader'],
                alignment: 'left'
            }, {
                text: 'Total GMP',
                style: ['itemsHeader'],
                alignment: 'left'
            }, {
                text: 'Qty',
                style: ['itemsHeader'],
                alignment: 'right'
            }];
            sanItems.push(row);
            var items = this.san.san_items;
            for (var key in items) {
                var data = items[key];
                var soh = (data.qty_soh * 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                var qty = (data.qty * 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                var unit_gmp = (data.unit_gmp * 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                var total_gmp = (data.total_gmp * 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                if (data.product_name == null) {
                    data.product_name = "";
                }
                row = [{
                    text: key * 1 + 1,
                    style: 'itemText'
                }, {
                    text: data.product_id,
                    style: 'itemText'
                }, {
                    text: data.product_name,
                    style: 'itemText'
                }, {
                    text: soh,
                    style: 'itemText'
                }, {
                    text: unit_gmp,
                    style: 'itemText'
                }, {
                    text: total_gmp,
                    style: 'itemText'
                }, {
                    text: qty,
                    style: 'itemNumber'
                }];
                sanItems.push(row);
            }

            var ddHeader = {
                columns: [[{
                    text: 'ELKEN ' + this.country_name + ' STOCK ADJUSTMENT NOTE',
                    style: 'invoiceTitle',
                    width: '*'
                }, {
                    stack: [{
                        columns: [{
                            text: 'SAN #',
                            style: 'invoiceSubTitle',
                            width: 95

                        }, {
                            text: san_num,
                            style: 'invoiceSubValue',
                            width: 100
                        }]
                    }, {
                        text: ' '
                    }, {
                        columns: [{
                            text: 'SAN Date',
                            style: 'invoiceSubTitle',
                            width: 95

                        }, {
                            text: sanDate,
                            style: 'invoiceSubValue',
                            width: 100

                        }]

                    }, {
                        text: ' '
                    }, {
                        columns: [{
                            text: 'Status',
                            style: 'invoiceSubTitle',
                            width: 95

                        }, {
                            text: this.san.status,
                            style: 'invoiceSubValue'
                        }]
                    }, {
                        text: ' '
                    }, {
                        columns: [{
                            text: 'Stock Location',
                            style: 'invoiceSubTitle',
                            width: 95

                        }, {
                            text: this.san.location_id,
                            style: 'invoiceSubValue'
                        }]
                    }, {
                        text: ' '
                    }, {
                        columns: [{
                            text: 'Reason',
                            style: 'invoiceSubTitle',
                            width: 95

                        }, {
                            text: this.san.reason,
                            style: 'invoiceSubValue'
                        }]
                    }, {
                        text: ' '
                    }, {
                        columns: [{
                            text: 'Reference #',
                            style: 'invoiceSubTitle',
                            width: 95

                        }, {
                            text: this.san.reference_num,
                            style: 'invoiceSubValue'
                        }]
                    }]
                }]]
            };

            var dd = {
                header: function header(pageNumber, pageCount) {
                    return {
                        margin: [0, 10, 0, 0],
                        columns: [{
                            text: '',
                            style: 'documentHeaderLeft'
                        }, {
                            text: san_num,
                            style: 'documentHeaderCenter'
                        }, {
                            text: '',
                            style: 'documentHeaderRight'
                        }]
                    };
                },
                footer: function footer(pageNumber, pageCount) {
                    return {
                        margin: [0, 0, 0, 50],
                        columns: [{
                            text: '',
                            style: 'documentFooterLeft'
                        }, {
                            text: 'Page ' + pageNumber + " of " + pageCount,
                            style: 'documentFooterCenter'
                        }, {
                            text: '',
                            style: 'documentFooterRight'
                        }]
                    };
                },
                content: [ddHeader, '\n\n', {
                    layout: 'lightHorizontalLines',
                    table: {

                        headerRows: 1,
                        widths: [25, 68, '*', 55, 55, 55, 45],
                        body: sanItems

                    } }, {
                    text: 'Remarks',
                    style: 'notesTitle'
                }, {
                    text: this.san.remarks,
                    style: 'notesText'
                }, {
                    text: 'Rejection Remarks',
                    style: 'notesTitle'
                }, {
                    text: rejection_remarks,
                    style: 'notesText'
                }, {
                    columns: [{
                        stack: [{
                            text: 'Issued By',
                            style: 'signaturePlaceholder'
                        }, {
                            text: '____________________________',
                            style: 'signaturePlaceholder'
                        }, {
                            text: 'Name  :' + this.san.author_user_shortname,
                            style: 'signatureName'

                        }, {
                            text: 'Date  :' + sanDate,
                            style: 'signatureJobTitle'

                        }],
                        width: 160
                    }, {
                        stack: [{
                            text: ' ',
                            style: 'signaturePlaceholder'
                        }, {
                            text: ' ',
                            style: 'signaturePlaceholder'
                        }, {
                            text: '                 ',
                            style: 'signatureName'

                        }, {
                            text: ' ',
                            style: 'signatureJobTitle'

                        }],
                        width: 160
                    }, {
                        stack: [{
                            text: approvedText,
                            style: 'signaturePlaceholder'
                        }, {
                            text: '______________________________',
                            style: 'signaturePlaceholder'
                        }, {
                            text: 'Name : ' + approver,
                            style: 'signatureName'

                        }, {
                            text: 'Date  : ' + approvedDate,
                            style: 'signatureJobTitle'

                        }],
                        width: 160
                    }]
                }],
                styles: {
                    documentHeaderLeft: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'left'
                    },
                    documentHeaderCenter: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'center'
                    },
                    documentHeaderRight: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'right'
                    },

                    documentFooterLeft: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'left'
                    },
                    documentFooterCenter: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'center'
                    },
                    documentFooterRight: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'right'
                    },

                    invoiceTitle: {
                        fontSize: 22,
                        bold: true,
                        alignment: 'left',
                        margin: [0, 0, 0, 15]
                    },

                    invoiceSubTitle: {
                        fontSize: 10,
                        alignment: 'left'
                    },
                    invoiceSubValue: {
                        fontSize: 10,
                        alignment: 'left'
                    },

                    invoiceBillingTitle: {
                        fontSize: 14,
                        bold: true,
                        alignment: 'left',
                        margin: [0, 20, 0, 5]
                    },

                    invoiceBillingDetails: {
                        alignment: 'left'

                    },
                    invoiceBillingAddressTitle: {
                        margin: [0, 7, 0, 3],
                        bold: true
                    },
                    invoiceBillingAddress: {},

                    itemsHeader: {

                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        bold: true
                    },

                    itemTitle: {
                        bold: true
                    },
                    itemSubTitle: {
                        fontSize: 10
                    },
                    itemText: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        alignment: 'left'
                    },
                    itemNumber: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        alignment: 'right'
                    },
                    itemTotal: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right'
                    },

                    itemsFooterSubTitle: {
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right'
                    },
                    itemsFooterSubValue: {
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'center'
                    },
                    itemsFooterTotalTitle: {
                        fontSize: 11,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right'
                    },
                    itemsFooterTotalValue: {
                        fontSize: 11,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'center'
                    },
                    signaturePlaceholder: {
                        fontSize: 10,
                        margin: [0, 70, 0, 0]
                    },
                    signatureName: {
                        fontSize: 10,
                        margin: [0, 10, 0, 0],
                        bold: true,
                        alignment: 'left'
                    },
                    signatureJobTitle: {
                        fontSize: 10,
                        margin: [0, 20, 0, 0],
                        bold: true,
                        alignment: 'left'
                    },
                    notesTitle: {
                        fontSize: 10,
                        bold: true,
                        margin: [0, 30, 0, 3]
                    },
                    notesText: {
                        fontSize: 10
                    },
                    center: {
                        alignment: 'center'
                    }
                },
                defaultStyle: {
                    columnGap: 20,
                    font: this.font
                }
            };
            __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake___default.a.createPdf(dd).open();
        },
        approve: function approve() {
            var _this = this;

            if (this.isWhHoo) {
                __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["G" /* apiSanApprove */], { san_num: this.san.san_num, approve: 1, reason: '' }, Object(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["_7" /* authHeader */])()).then(function (res) {
                    _this.san.status = "APPROVED";
                    _this.mbTitle = "Approve";
                    _this.mbMsg = "SAN " + _this.san.san_num + " has been Aproved.";
                    _this.$refs.msgBox.show();
                    _this.fetch(_this.san_ref);
                }).catch(function (error) {
                    return alert(error);
                });
            } else if (this.isAccFn) {
                __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["G" /* apiSanApprove */], { san_num: this.san.san_num, approve: 1 }, Object(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["_7" /* authHeader */])()).then(function (res) {
                    _this.san.status = "APPROVED";
                    _this.mbTitle = "Approve";
                    _this.mbMsg = "SAN " + _this.san.san_num + " has been Aproved.";
                    _this.$refs.msgBox.show();
                    _this.fetch(_this.san_ref);
                }).catch(function (error) {
                    return alert(error);
                });
            }
        },
        confirmApprove: function confirmApprove() {
            this.approveModalShow = true;
        },
        confirmReject: function confirmReject() {
            this.$refs.rejectModal.show();
        },
        reject: function reject() {
            var _this2 = this;

            this.$refs.rejectModal.hide();
            if (this.san.san_reject_remarks != '' && this.san.san_reject_remarks != null) {
                __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["G" /* apiSanApprove */], { san_num: this.san.san_num, approve: 0, reason: this.san.san_reject_remarks }, Object(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["_7" /* authHeader */])()).then(function (res) {
                    if (res.data.code == 1) {
                        _this2.san.status = "REJECTED";
                        _this2.mbTitle = "Reject";
                        _this2.mbMsg = "SAN " + _this2.san.san_num + " has been Rejected.";
                        _this2.$refs.msgBox.show();
                        _this2.fetch(_this2.san_ref);
                    }
                }).catch(function (error) {
                    return alert(error);
                });
            } else {
                this.mbTitle = "Manual Close cancelled";
                this.mbMsg = "Reason has to be provided";
                this.$refs.msgBox.show();
            }
        },
        fetch: function fetch(sanNum) {
            var _this3 = this;

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["H" /* apiSanGet */], { san_num: sanNum }, Object(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["_7" /* authHeader */])()).then(function (res) {
                var data;
                data = res.data.data;

                _this3.san = data;
                if (_this3.san.country_id != null) {
                    if (_this3.san.country_id == 'TH') {
                        _this3.font = 'Garuda';
                    } else if (_this3.san.country_id == 'KH') {
                        _this3.font = 'Hanumanb';
                    }
                    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["c" /* apiCountryLookup */], { params: { q: _this3.san.country_id } }).then(function (response) {

                        if (response.data != null) {
                            _this3.list = response.data.data.list;
                            _this3.item = _this3.list[0];
                            _this3.country_name = _this3.item.country_name;
                            _this3.country_name = _this3.country_name.toUpperCase();
                        }
                    });
                }
                _this3.title = "Stock Adjustment Note " + sanNum;
                if (_this3.isAccFn) {
                    _this3.btnVisible = true;
                } else if (_this3.isWhHoo) {
                    if (_this3.lockEntry && _this3.san.reason == "CONVERSION") {
                        _this3.btnVisible = true;
                    } else {
                        _this3.backBtnVisible = true;
                    }
                } else if (_this3.isWh) {
                    _this3.backBtnVisible = true;
                } else if (_this3.isAcc) {
                    _this3.backBtnVisible = true;
                }
            }).catch(function (error) {
                return alert(error);
            });
        },
        setWarehouse: function setWarehouse(obj) {
            var _this4 = this;

            if (!this.lockEntry) {
                var id;

                if (obj !== null) {
                    if (obj.id != this.san.location_id) {
                        id = obj.id;
                        this.san.san_items = [];
                        this.san.location_id = id;
                        if (this.san.location_id != '') {
                            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(this.apiLocationProductUrl, { params: { q: '', q2: id } }).then(function (res) {
                                var list;
                                list = res.data.data.list;
                                console.log(list.length);
                                _this4.noItemsFound = list.length == 0;
                            }).catch(function (error) {
                                return alert(error);
                            });
                        }
                    }
                } else {
                    id = "";
                    this.noItemsFound = true;
                }
            }
        },
        addRow: function addRow() {
            this.san.san_items.push({ product_id: '', product_name: '', qty_soh: '', qty: '', unit_gmp: '', total_gmp: '' });
        },
        removeRow: function removeRow(index) {
            this.san.san_items.splice(index, 1);
        },
        setProduct: function setProduct(obj, index) {
            if (!this.lockEntry) {
                var name, id, qty_soh, qty, unit_gmp;

                if (obj !== null) {
                    name = obj.name;
                    id = obj.id;
                    qty_soh = obj.qty_soh;
                    unit_gmp = obj.unit_gmp;
                } else {
                    name = "";
                    id = "";
                    qty_soh = "";
                    unit_gmp = "";
                }

                this.san.san_items[index].product_id = id;
                this.san.san_items[index].product_name = name;
                this.san.san_items[index].qty_soh = qty_soh;
                this.san.san_items[index].unit_gmp = unit_gmp;
                this.san.san_items[index].total_gmp = 1 * qty_soh * (1 * unit_gmp);
            }
        },
        confirmSave: function confirmSave() {
            this.confirmTxt = " created";
            this.modalShow = true;
        },
        save: function save() {
            var _this5 = this;

            var san_date = this.san.san_date;
            var today = new Date();
            var dd = today.getDate();
            var mm = today.getMonth() + 1;
            var yyyy = today.getFullYear();

            if (dd < 10) {
                dd = '0' + dd;
            }
            if (mm < 10) {
                mm = '0' + mm;
            }
            var today = yyyy + '-' + mm + '-' + dd;
            if (san_date >= today) {
                __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["I" /* apiSanSave */], this.san, Object(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["_7" /* authHeader */])()).then(function (res) {
                    var r = res.data;
                    if (r.code == 1) {
                        _this5.sanDocNo = r.data.san_num;
                        _this5.$refs.myModalRef.show();
                    } else {
                        _this5.errorMessage = r.msg;
                        _this5.$refs.myErrorModalRef.show();
                    }
                }).catch(function (error) {
                    return alert(error);
                });
            } else {
                this.errorMessage = "Post Dated date entry not allowed for SAN date";
                this.$refs.myErrorModalRef.show();
            }
        },
        confirmCancel: function confirmCancel() {
            this.modalCancelShow = true;
        },
        cancel: function cancel() {
            this.$router.push({ name: 'Stock Adjustment Notes (SANS)' });
        },
        hideModal: function hideModal() {
            this.$refs.myModalRef.hide();
            this.$router.push({ name: 'Stock Adjustment Notes (SANS)' });
        },
        hideErrorModal: function hideErrorModal() {
            this.$refs.myErrorModalRef.hide();
        },
        back: function back() {
            this.$router.push({ name: 'Stock Adjustment Notes (SANS)' });
        }
    }
});

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Autocomplete_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__functions_common_vue__ = __webpack_require__(4);







/* harmony default export */ __webpack_exports__["a"] = ({
  components: { spinner: __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue__["a" /* default */], countryLookup: __WEBPACK_IMPORTED_MODULE_3__components_Autocomplete_vue__["a" /* default */] },
  props: {
    caption: {
      type: String,
      default: 'Table'
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    var _this = this;

    console.log(__WEBPACK_IMPORTED_MODULE_4__functions_common_vue__["d" /* apiCourierLists */]);
    __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_4__functions_common_vue__["d" /* apiCourierLists */], {}, Object(__WEBPACK_IMPORTED_MODULE_4__functions_common_vue__["_7" /* authHeader */])()).then(function (res) {
      if (res.data.code == 1) {
        _this.courierlist = res.data.data;
      }
      console.log(res.data.data);
    }).catch(function (error) {
      return alert(error);
    });
  },

  data: function data() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
      apiCountryLookup: __WEBPACK_IMPORTED_MODULE_4__functions_common_vue__["c" /* apiCountryLookup */],
      apiWarehouseLookup: __WEBPACK_IMPORTED_MODULE_4__functions_common_vue__["V" /* apiWarehouseLookup */],
      modalShow: false,
      errorMessage: '',
      successMessage: '',
      modalCancelShow: false,
      loading: false,
      courierlist: [],
      pstatusList: ['PENDING', 'IN-TRANSIT', 'DELIVERED', 'UNDELIVERED'],
      istatusList: ['IN-TRANSIT', 'DELIVERED', 'UNDELIVERED'],
      dstatusList: ['DELIVERED', 'UNDELIVERED'],
      ustatusList: ['DELIVERED', 'UNDELIVERED'],
      noResults: false,
      filter: {
        country_id: '',
        from_location_id: '',
        sales_doc_num: '',
        date_start: '',
        date_end: '',
        delivery_status_name: 'PENDING'
      },
      searchResults: [],
      searchResultsFields: [{ key: 'from_location_id', label: 'WH' }, { key: 'do_info', label: 'DO' }, { key: 'invoice_nums', label: 'Invoices' }, { key: 'member_full', label: 'IBO / Stockist' }, { key: 'courier_company', label: 'Courier' }, { key: 'delivery_number', label: 'Delivery #' }, { key: 'delivery_status_name', label: 'Status' }, { key: 'pod_date', label: 'POD Date' }],
      currentPage: 1,
      perPage: 30,
      totalRows: 0
    }, 'noResults', false);
  },
  methods: {
    setWarehouse: function setWarehouse(obj) {
      var id;

      if (obj !== null) {
        id = obj.id;
      } else {
        id = "";
      }

      this.filter.from_location_id = id;
    },
    setCountry: function setCountry(obj) {
      var id;

      if (obj !== null) {
        id = obj.id;
      } else {
        id = "";
      }

      this.filter.country_id = id;
    },
    update: function update() {
      var _this2 = this;

      this.loading = true;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_4__functions_common_vue__["D" /* apiPodUpdate */], this.searchResults, Object(__WEBPACK_IMPORTED_MODULE_4__functions_common_vue__["_7" /* authHeader */])()).then(function (res) {
        var r = res.data;
        _this2.loading = false;
        if (r.code == 1) {
          _this2.$refs.myModalRef.show();
          _this2.search();
        } else {
          _this2.errorMessage = "Changes not detected";
          _this2.$refs.myErrorModalRef.show();
        }
      }).catch(function (error) {
        return alert(error);
      });
    },
    cancel: function cancel() {
      this.search();
    },
    confirmUpate: function confirmUpate() {
      this.modalShow = true;
    },
    confirmCancel: function confirmCancel() {
      this.modalCancelShow = true;
    },
    getRowCount: function getRowCount(items) {
      return items.length;
    },
    hideModal: function hideModal() {
      this.$refs.myModalRef.hide();
    },
    hideErrorModal: function hideErrorModal() {
      this.$refs.myErrorModalRef.hide();
    },
    search: function search() {
      var _this3 = this;

      this.loading = true;
      var sf = {
        country_id: this.filter.country_id,
        from_location_id: this.filter.from_location_id,
        sales_doc_num: this.filter.sales_doc_num,
        from_date: this.filter.date_start,
        to_date: this.filter.date_end,
        delivery_status_name: this.filter.delivery_status_name
      };

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_4__functions_common_vue__["C" /* apiPodSearch */], sf, Object(__WEBPACK_IMPORTED_MODULE_4__functions_common_vue__["_7" /* authHeader */])()).then(function (res) {
        return res;
      }).then(function (data) {
        var resultArray = [];
        var myData = data.data.data;
        for (var key in myData) {
          var date = myData[key].do_date;
          var member_full = myData[key].old_member_id + '<br/>' + myData[key].member_name;
          myData[key].member_full = member_full;
          var date = new Date(date);
          var result = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + (date.getMonth() + 1 > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear();
          myData[key].do_date = result;
          myData[key].do_info = myData[key].do_num + '<br/>' + '(' + myData[key].do_date + ')';
          var invoice_nums = '';
          var invoice_num_list = myData[key].invoice_nums_list;
          var curDate = new Date();
          curDate = curDate.toISOString().substr(0, 10);
          var currentStatus = myData[key].delivery_status_name;
          myData[key].current_status = currentStatus;
          myData[key].pod_date = curDate;
          for (var d in invoice_num_list) {
            if (invoice_num_list[d] != invoice_num_list[invoice_num_list.length - 1]) {
              invoice_nums = invoice_nums + invoice_num_list[d] + '<br/>';
            } else {
              invoice_nums = invoice_nums + invoice_num_list[d];
            }
          }
          myData[key].invoice_nums = invoice_nums;
          resultArray.push(myData[key]);
          _this3.loading = false;
        }
        _this3.searchResults = resultArray;

        if (_this3.searchResults.length == 0) {
          _this3.loading = false;
          _this3.noResults = true;
        }
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }
});

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Autocomplete_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__functions_common_vue__ = __webpack_require__(4);









/* harmony default export */ __webpack_exports__["a"] = ({
    components: { spinner: __WEBPACK_IMPORTED_MODULE_2__components_Spinner_vue__["a" /* default */], memberLookup: __WEBPACK_IMPORTED_MODULE_3__components_Autocomplete_vue__["a" /* default */], warehouseLookup: __WEBPACK_IMPORTED_MODULE_3__components_Autocomplete_vue__["a" /* default */] },
    created: function created() {
        console.log(Object(__WEBPACK_IMPORTED_MODULE_4__functions_common_vue__["_7" /* authHeader */])());
    },

    props: {
        caption: {
            type: String,
            default: 'Table'
        },
        hover: {
            type: Boolean,
            default: false
        },
        striped: {
            type: Boolean,
            default: false
        },
        bordered: {
            type: Boolean,
            default: false
        },
        small: {
            type: Boolean,
            default: false
        },
        fixed: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
            apiMemberLookupUrl: __WEBPACK_IMPORTED_MODULE_4__functions_common_vue__["s" /* apiMemberLookup */],
            apiWarehouseUrl: __WEBPACK_IMPORTED_MODULE_4__functions_common_vue__["V" /* apiWarehouseLookup */],
            loading: false,
            selectAll: false,
            noResults: false,
            errorModal: false,
            modalShow: false,
            from_location_id: '',
            transactions_filter: {
                trans_date: '',
                status: ''
            },
            sales_transactions: [],
            filter: {
                customer_id: '',
                date_start: '',
                date_end: '',
                delivery_method: '',
                delivery_status: ''
            },
            pickListInfo: [],
            selectedSalesDoc: [],
            transactions: [],
            transactionsFields: [{ key: 'trans_date', label: 'Date' }, { key: 'status', label: 'Status' }],
            pickListInfoFields: [{ key: 'picking_list_date', label: 'Pick Date' }, { key: 'picking_list_num', label: 'Pick List No' }, { key: 'author_user_shortname', label: 'Created By' }],
            searchResults: [],
            searchResultsFields: [{ key: 'trans_date', label: 'Trans Date' }, { key: 'sales_doc_num', label: 'Sales Docs No' }, { key: 'inv_number', label: 'Invoice No' }, { key: 'customer_id', label: 'IBO/Stockist No' }, { key: 'customer_name', label: 'IBO/Stockist Name' }, { key: 'channel', label: 'Channel' }, { key: 'trans_loc', label: 'Trans. Loc' }, { key: 'delivery_method', label: 'Delivery Method' }, { key: 'delivery_town', label: 'Delivery Town' }, { key: 'status', label: 'Status' }, { key: 'check_box', label: ' ', 'class': 'text-center' }, { key: 'wsi_entry', label: ' ', 'class': 'text-center' }],
            currentPage: 1,
            currentPickPage: 1,
            perPage: 10,
            totalRows: 0
        }, 'noResults', false);
    },
    watch: {
        selectedSalesDoc: function selectedSalesDoc(newVal, oldVal) {
            if (newVal.length === 0) {
                this.selectAll = false;
            } else if (newVal.length === this.sales_transactions.length) {
                this.selectAll = true;
            } else {
                this.selectAll = false;
            }
        }
    },
    methods: {
        select: function select() {
            this.selectedSalesDoc = [];
            if (!this.selectAll) {
                for (var i in this.searchResults) {
                    if (this.searchResults[i].status == "PENDING") {
                        this.selectedSalesDoc.push(this.searchResults[i].sales_doc_num);
                    }
                }
            }
        },
        setWarehouse: function setWarehouse(obj) {
            if (!this.lockEntry) {
                var id;

                if (obj !== null) {
                    if (obj.id != this.location_id) {
                        this.selectedSalesDoc = [];
                    }
                    id = obj.id;
                } else {
                    id = "";
                }
                this.from_location_id = id;
            }
        },
        setMember: function setMember(obj) {
            var id;
            if (obj !== null) {
                id = obj.id;
            } else {
                id = null;
            }
            this.filter.customer_id = id;
        },
        pickListDetails: function pickListDetails(item, index) {
            this.$router.push({ name: 'Picking List Info', params: { picklistNum: item.picking_list_num } });
        },
        searchTransactions: function searchTransactions() {
            var sf = ["trans_date <= " + this.transactions_filter.trans_date, "status = " + this.transactions_filter.status];
        },
        getRowCount: function getRowCount(items) {
            return items.length;
        },
        search: function search() {
            var _this = this;

            this.loading = true;
            this.noResults = true;
            this.selectedSalesDoc = [];
            var sf = {
                user_id: this.filter.customer_id,
                from_date: this.filter.date_start,
                to_date: this.filter.date_end,
                from_location_id: this.from_location_id,
                delivery_method_name: this.filter.delivery_method,
                delivery_status_name: this.filter.delivery_status
            };
            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_4__functions_common_vue__["Z" /* apiWsiSearch */], sf, Object(__WEBPACK_IMPORTED_MODULE_4__functions_common_vue__["_7" /* authHeader */])()).then(function (res) {
                return res;
            }).then(function (data) {
                var resultArray = [];
                var myData = data.data.data.sales;

                var pickList = data.data.data.picking_list;
                for (var p in pickList) {
                    var picking_list_date = pickList[p].picklist_date;
                    if (picking_list_date == '') {
                        picking_list_date = '-';
                    } else {
                        var pickDate = new Date(picking_list_date);
                        picking_list_date = "" + (pickDate.getDate() > 9 ? '' : '0') + pickDate.getDate() + '/' + (pickDate.getMonth() + 1 > 9 ? '' : '0') + (pickDate.getMonth() + 1) + '/' + pickDate.getFullYear() + " " + (pickDate.getHours() > 9 ? '' : '0') + pickDate.getHours() + ":" + (pickDate.getMinutes() > 9 ? '' : '0') + pickDate.getMinutes() + ":" + (pickDate.getSeconds() > 9 ? '' : '0') + pickDate.getSeconds();
                    }

                    pickList[p].picking_list_date = picking_list_date;
                    pickList[p].picking_list_num = pickList[p].picklist_num;
                    pickList[p].author_user_shortname = pickList[p].author_user_shortname;
                    _this.pickListInfo.push(pickList[p]);
                }
                _this.pickListInfo = data.data.data.picking_list;

                for (var key in myData) {
                    var date = myData[key].transaction_date;
                    var date = new Date(date);
                    var result = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + (date.getMonth() + 1 > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear();
                    myData[key].trans_date = result;
                    myData[key].sales_doc_num = myData[key].document_number;
                    myData[key].customer_id = myData[key].old_member_id;
                    myData[key].customer_name = myData[key].member_name;
                    myData[key].channel = myData[key].channel_name;
                    myData[key].trans_loc = myData[key].transaction_location_name;
                    myData[key].delivery_method = myData[key].delivery_method_name;
                    myData[key].sale_id = myData[key].document_number;
                    myData[key].delivery_town = myData[key].delivery_town_name;
                    myData[key].status = myData[key].delivery_status_name;
                    resultArray.push(myData[key]);
                    _this.loading = false;
                }
                _this.searchResults = resultArray;
                for (var k in _this.searchResults) {
                    if (_this.searchResults[k].status == "PENDING") {
                        _this.sales_transactions.push(_this.searchResults[k]);
                    }
                }
                if (_this.searchResults.length == 0) {
                    _this.loading = false;
                    _this.noResults = true;
                }
            }).catch(function (error) {
                return console.log(error);
            });
        },
        confirmGeneratePickingList: function confirmGeneratePickingList() {
            this.modalShow = true;
        },
        generatePickingList: function generatePickingList() {
            var _this2 = this;

            var item = this.selectedSalesDoc;

            if (item.length <= 10) {
                this.loading = true;
                __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_4__functions_common_vue__["j" /* apiGeneratePickingList */], { sales_invoices_num: this.selectedSalesDoc, from_location_id: this.from_location_id }, Object(__WEBPACK_IMPORTED_MODULE_4__functions_common_vue__["_7" /* authHeader */])()).then(function (res) {
                    var data = res.data.data;
                    var picking_list_date = data.picking_list_date;
                    if (picking_list_date == null) {
                        picking_list_date = '-';
                    } else {
                        var pickDate = new Date(picking_list_date);
                        picking_list_date = "" + (pickDate.getDate() > 9 ? '' : '0') + pickDate.getDate() + '/' + (pickDate.getMonth() + 1 > 9 ? '' : '0') + (pickDate.getMonth() + 1) + '/' + pickDate.getFullYear() + " " + (pickDate.getHours() > 9 ? '' : '0') + pickDate.getHours() + ":" + (pickDate.getMinutes() > 9 ? '' : '0') + pickDate.getMinutes() + ":" + (pickDate.getSeconds() > 9 ? '' : '0') + pickDate.getSeconds();
                    }
                    data.picking_list_date = picking_list_date;

                    _this2.$router.push({ name: 'Picking List Info', params: { picklistNum: data.picking_list_num } });
                }).catch(function (error) {
                    console.log(error);
                    _this2.loading = false;
                });

                this.selectedSalesDoc = [];
            } else {
                this.errorModal = true;
            }
        },
        handleCancel: function handleCancel() {
            this.selectedSalesDoc = [];
        },
        rowClick: function rowClick(row) {
            this.selectedSalesDoc.push(row.document_number);
            this.modalShow = true;
        }
    }
});

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Autocomplete_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__functions_common_vue__ = __webpack_require__(4);







/* harmony default export */ __webpack_exports__["a"] = ({
    created: function created() {
        this.wsi_ref = this.$route.params.wsiNum;
        if (this.wsi_ref == '_new') {
            var curDate = new Date();
            curDate = curDate.toISOString().substr(0, 10);
            this.wsi.wsi_date = curDate;
            this.noItemsFound = true;
        } else {
            this.lockEntry = true;
            this.fetch(this.wsi_ref);
            this.noItemsFound = false;
        }
    },

    data: function data() {
        return {
            title: 'Stock Issuance',
            apiWarehouseUrl: __WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["V" /* apiWarehouseLookup */],
            apiCountryLookup: __WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["c" /* apiCountryLookup */],
            apiLocationProductUrl: __WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["q" /* apiLocationProductUrl */],
            wsi_ref: '',
            lockEntry: false,
            showIssuanceRecord: false,
            modalShow: false,
            errorMessage: '',
            wsi: {
                location_full: '',
                customer_full: '',
                invoice_num: '',
                trans_loc: '',
                self_pickup_id: '',
                picking_location: '',
                status: '',
                trans_date: '',
                channel: '',
                shipping_address: '',
                contact_num: '',
                remarks: '',
                pickListInfo: [{ picklist_date: '', picklist_num: '', pl_author_user_shortname: '', do_date: '', do_num: '', do_author_user_shortname: '', courier_company_id: '', courier_no: '' }],
                wsi_items: [{ product_name: '', product_id: '', qty_soh: '', order_qty: '', qty: '', os_qty: '', delivered_qty: '' }]
            }
        };
    },
    methods: {
        fetch: function fetch(salesDocNo) {},
        confirmGenerateDO: function confirmGenerateDO() {
            this.modalShow = true;
        },
        generateDO: function generateDO() {
            this.showIssuanceRecord = true;
        },
        handleCancel: function handleCancel() {},
        back: function back() {
            this.$router.push({ name: 'Stock Issuance' });
        },
        save: function save() {},
        confirmSave: function confirmSave() {}
    }
});

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Autocomplete_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__functions_common_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Switch__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_js_toggle_button__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_js_toggle_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_js_toggle_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pdfmake_build_pdfmake__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pdfmake_build_pdfmake___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_pdfmake_build_pdfmake__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pdfmake_build_vfs_fonts__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_pdfmake_build_vfs_fonts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_pdfmake_build_vfs_fonts__);













__WEBPACK_IMPORTED_MODULE_7_pdfmake_build_pdfmake___default.a.vfs = __WEBPACK_IMPORTED_MODULE_8_pdfmake_build_vfs_fonts___default.a.pdfMake.vfs;
__WEBPACK_IMPORTED_MODULE_7_pdfmake_build_pdfmake___default.a.fonts = {
    "ukai": {
        normal: 'ukai.ttf',
        bold: 'ukai.ttf',
        italics: 'ukai.ttf',
        bolditalics: 'ukai.ttf'
    },
    "Garuda": {
        normal: 'Garuda.ttf',
        bold: 'Garuda.ttf',
        italics: 'Garuda.ttf',
        bolditalics: 'Garuda.ttf'
    },
    "Hanumanb": {
        normal: 'Hanumanb.ttf',
        bold: 'Hanumanb.ttf',
        italics: 'Hanumanb.ttf',
        bolditalics: 'Hanumanb.ttf'
    }
};

__WEBPACK_IMPORTED_MODULE_6_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_js_toggle_button___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
    components: { spinner: __WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue__["a" /* default */], cSwitch: __WEBPACK_IMPORTED_MODULE_4__components_Switch__["a" /* default */] },
    props: {
        caption: {
            type: String,
            default: 'Table'
        },
        hover: {
            type: Boolean,
            default: false
        },
        striped: {
            type: Boolean,
            default: false
        },
        bordered: {
            type: Boolean,
            default: false
        },
        small: {
            type: Boolean,
            default: false
        },
        fixed: {
            type: Boolean,
            default: false
        }
    },
    created: function created() {
        var _this = this;

        this.picklist_ref = this.$route.params.picklistNum;
        this.getPickingList();
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["d" /* apiCourierLists */], {}, Object(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["_7" /* authHeader */])()).then(function (res) {
            if (res.data.code == 1) {
                _this.courier_list = res.data.data;
            }
        }).catch(function (error) {
            return alert(error);
        });
    },
    data: function data() {
        return {
            showPickListHeader: false,
            font: 'ukai',
            DoNum: '',
            activeColor: 'red',
            otherColor: 'grey',
            title: "Picking List Details",
            modalShow: false,
            old_value: 0,
            dosLength: '',
            errorMessage: '',
            qty_picked: 0,
            prev_allocated_qty: 0,
            loading: false,
            lockEntry: false,
            picklist_ref: '',
            showGenerateDo: true,
            pList: {},
            pickList_items: [],
            updateList: {},
            packItems: [],
            dos: [],
            picking_list_items_fields: [{ key: 'product_code', label: 'Product Code' }, { key: 'product_name', label: 'Product Name' }, { key: 'qty', label: 'Qty' }, { key: 'qty_picked', label: 'Qty Picked' }, { key: 'qty_balance', label: 'Qty Balance' }],
            picking_list: {},
            courier_list: []
        };
    },

    methods: {
        getPickingList: function getPickingList() {
            var _this2 = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["y" /* apiPicklistGet */], { picklist_num: this.picklist_ref }, Object(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["_7" /* authHeader */])()).then(function (res) {
                _this2.pList = res.data.data;
                var pDate = new Date(_this2.pList.picklist_date);
                _this2.pList.picklist_date = "" + (pDate.getDate() > 9 ? '' : '0') + pDate.getDate() + '/' + (pDate.getMonth() + 1 > 9 ? '' : '0') + (pDate.getMonth() + 1) + '/' + pDate.getFullYear() + " " + (pDate.getHours() > 9 ? '' : '0') + pDate.getHours() + ":" + (pDate.getMinutes() > 9 ? '' : '0') + pDate.getMinutes() + ":" + (pDate.getSeconds() > 9 ? '' : '0') + pDate.getSeconds();
                var data = _this2.pList.packlists;
                _this2.dosLength = res.data.data.dos.lengths;
                var totalQty = 0;
                var total = 0;
                var dos = res.data.data.dos;
                var sales_invoices = JSON.parse(_this2.pList.sales_invoices_num);

                var consignments = [];
                var sales_docs = [];
                var consignment_nums = '';
                var sales_invoice_nums = '';

                for (var d in sales_invoices) {
                    var document_start_char = sales_invoices[d].substring(0, 2);

                    if (document_start_char == "CN") {
                        consignments.push(sales_invoices[d]);
                    } else {
                        sales_docs.push(sales_invoices[d]);
                    }
                }

                for (var c in consignments) {
                    if (consignments[c] != consignments[consignments.length - 1]) {
                        consignment_nums = consignment_nums + consignments[c] + ' / ';
                    } else {
                        consignment_nums = consignment_nums + consignments[c];
                    }
                }

                for (var s in sales_docs) {
                    if (sales_docs[s] != sales_docs[sales_docs.length - 1]) {
                        sales_invoice_nums = sales_invoice_nums + sales_docs[s] + ' / ';
                    } else {
                        sales_invoice_nums = sales_invoice_nums + sales_docs[s];
                    }
                }
                _this2.pList.consignment_nums = consignment_nums;
                _this2.pList.sales_invoice_nums = sales_invoice_nums;

                var tax_invoices_num = JSON.parse(_this2.pList.tax_invoices_num);
                var p_tax_invoices_num = '';

                for (var t in tax_invoices_num) {
                    if (tax_invoices_num[t] != tax_invoices_num[tax_invoices_num.length - 1]) {
                        p_tax_invoices_num = p_tax_invoices_num + tax_invoices_num[t] + ' / ';
                    } else {
                        p_tax_invoices_num = p_tax_invoices_num + tax_invoices_num[t];
                    }
                }
                _this2.pList.tax_invoices_nums = p_tax_invoices_num;

                var _loop = function _loop(i) {
                    item = dos[i];
                    doDate = dos[i].do_date;

                    if (doDate != null) {
                        doDate = new Date(doDate);
                        doDate = "" + (doDate.getDate() > 9 ? '' : '0') + doDate.getDate() + '/' + (doDate.getMonth() + 1 > 9 ? '' : '0') + (doDate.getMonth() + 1) + '/' + doDate.getFullYear();
                    } else {
                        doDate = '-';
                    }
                    dos[i].do_date = doDate;
                    if (item.country_id != null) {

                        if (item.country_id == 'TH') {
                            _this2.font = 'Garuda';
                        } else if (item.country_id == 'KH') {
                            _this2.font = 'Hanumanb';
                        }
                        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["c" /* apiCountryLookup */], { params: { q: item.country_id } }).then(function (response) {

                            if (response.data != null) {
                                var list = response.data.data.list;
                                var item = list[0];
                                var country_name = item.country_name;
                                country_name = country_name.toUpperCase();
                                dos[i].country_name = country_name;
                            }
                        });
                    }
                };

                for (var i in dos) {
                    var item;
                    var doDate;

                    _loop(i);
                }
                for (var key in data) {
                    var member_id = data[key].old_member_id;
                    var member_name = data[key].member_name;
                    var member_full = member_id + " - " + member_name;
                    var invoice_nums = "";
                    var invoice_num_list = data[key].invoice_nums_list;
                    var tax_invoice_nums_list = JSON.parse(data[key].tax_invoice_nums_list);
                    var tax_invoices_nums = "";

                    for (var _d in invoice_num_list) {
                        if (invoice_num_list[_d] != invoice_num_list[invoice_num_list.length - 1]) {
                            invoice_nums = invoice_nums + invoice_num_list[_d] + ' / ';
                        } else {
                            invoice_nums = invoice_nums + invoice_num_list[_d];
                        }
                    }

                    for (var _t in tax_invoice_nums_list) {
                        if (tax_invoice_nums_list[_t] != tax_invoice_nums_list[tax_invoice_nums_list.length - 1]) {
                            tax_invoices_nums = tax_invoices_nums + tax_invoice_nums_list[_t] + ' / ';
                        } else {
                            tax_invoices_nums = tax_invoices_nums + tax_invoice_nums_list[_t];
                        }
                    }

                    data[key].tax_invoices_nums = tax_invoices_nums;
                    data[key].invoice_num_list = invoice_nums;

                    data[key].member_full = member_full;
                    if (data[key].delivery_address == null) {
                        data[key].delivery_address = '';
                    }
                    var items = data[key].items;
                    for (var k in items) {
                        items[k].qty = items[k].qty * 1;
                        items[k].qty_delivered = items[k].qty_delivered * 1;
                        var qtyBalance = items[k].qty - items[k].qty_delivered;
                        totalQty = totalQty + qtyBalance;
                        total = totalQty + qtyBalance;
                    }
                    if (total > 0) {
                        data[key].isCompleted = false;
                    } else {
                        data[key].isCompleted = true;
                    }
                }
                if (totalQty > 0) {
                    _this2.showGenerateDo = false;
                }
                _this2.loading = false;
            }).catch(function (error) {
                return alert(error);
            });
        },
        hideErrorModal: function hideErrorModal() {
            this.$refs.myErrorModalRef.hide();
        },
        packAll: function packAll(items) {
            for (var k in items) {
                items[k].qty = items[k].qty * 1;
                items[k].qty_delivered = items[k].qty_delivered * 1;
                items[k].qty_allocated = items[k].qty_allocated * 1;

                if (items[k].qty != items[k].qty_delivered) {
                    items[k].qty_allocated = items[k].qty - items[k].qty_delivered;
                }

                this.computePickingListQty(items[k]);
            }
        },
        clearAll: function clearAll(items) {
            for (var k in items) {
                if (items[k].qty * 1 != items[k].qty_delivered * 1) {
                    items[k].qty_allocated = 0;
                }
                this.computePickingListQty(items[k]);
            }
        },
        getValue: function getValue(row) {
            this.old_value = row.qty_allocated;
        },
        back: function back() {
            this.$router.push({ name: 'Stock Issuance (SI)' });
        },
        computePickingListQty: function computePickingListQty(row) {
            var _this3 = this;

            row.qty = row.qty * 1;
            row.qty_delivered = row.qty_delivered * 1;
            row.qty_allocated = row.qty_allocated * 1;

            if (row.qty_allocated < 0) {
                row.qty_allocated = 0;
            }
            if (row.qty_allocated > row.qty - row.qty_delivered) {
                row.qty_allocated = 0;
            }

            for (var key in this.pList.picklist_items) {
                this.pList.picklist_items[key].qty_picked = 0;
            }
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["y" /* apiPicklistGet */], { picklist_num: this.picklist_ref }, Object(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["_7" /* authHeader */])()).then(function (res) {
                var data = res.data.data.picklist_items;
                for (var d in data) {

                    if (_this3.pList.picklist_items[d].product_code == data[d].product_code) {
                        _this3.pList.picklist_items[d].qty_picked = data[d].qty_picked;
                    }
                }
                for (var _key in _this3.pList.picklist_items) {
                    for (var x in _this3.pList.packlists) {
                        for (var n in _this3.pList.packlists[x].items) {
                            if (_this3.pList.picklist_items[_key].product_code == _this3.pList.packlists[x].items[n].product_code) {
                                var item = _this3.pList.picklist_items[_key];
                                item.qty_picked = item.qty_picked * 1;

                                item.qty_picked = item.qty_picked + _this3.pList.packlists[x].items[n].qty_allocated;
                                item.qty_balance = item.qty - item.qty_picked;
                            }
                        }
                    }
                }
            });
        },
        hideModal: function hideModal() {
            this.$refs.myModalRef.hide();
            location.reload();
        },
        confirmGenerateDO: function confirmGenerateDO() {
            this.modalShow = true;
        },
        generateDO: function generateDO() {
            var _this4 = this;

            this.showGenerateDo = false;
            this.loading = true;
            var sum = 0;
            for (var key in this.pList.packlists) {
                var eachDo = this.pList.packlists[key];
                for (var i in eachDo.items) {
                    sum = sum + eachDo.items[i].qty_allocated;
                }
            }
            if (sum > 0) {
                __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["i" /* apiGenerateDO */], { picking_list: this.pList }, Object(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["_7" /* authHeader */])()).then(function (response) {
                    if (response.data.code == 1) {
                        _this4.loading = false;
                        _this4.showGenerateDo = true;
                        _this4.$refs.myModalRef.show();
                    }
                });
            } else {
                this.loading = false;
                this.showGenerateDo = true;
                this.modalShow = false;
                this.errorMessage = "Invalid Entry in Do Items";
                this.$refs.myErrorModalRef.show();
            }
        },
        printDO: function printDO(item) {
            var do_num = item.do_num;
            var do_item_row = [];
            var doItems = [];
            do_item_row = [{ text: 'S/No', style: 'itemsHeader' }, { text: 'Product Code', style: ['itemsHeader'], alignment: 'left' }, { text: 'Product Name', style: ['itemsHeader'], alignment: 'left' }, { text: 'Qty', style: ['itemsHeader'], alignment: 'right' }];
            doItems.push(do_item_row);
            for (var key in item.items) {
                var data = item.items[key];
                do_item_row = [{ text: key * 1 + 1, style: 'itemText' }, { text: data.product_code, style: 'itemText' }, { text: data.product_name, style: 'itemText' }, { text: data.qty, style: 'itemNumber' }];
                doItems.push(do_item_row);
            }

            var consignments = [];
            var sales_docs = [];

            for (var d in item.invoice_nums_list) {
                var document_start_char = item.invoice_nums_list[d].substring(0, 2);

                if (document_start_char == "CN") {
                    consignments.push(item.invoice_nums_list[d]);
                } else {
                    sales_docs.push(item.invoice_nums_list[d]);
                }
            }

            var consignment_nums = '';
            if (consignments.length == 0) {
                consignment_nums = '-';
            } else {
                for (var a in consignments) {
                    if (consignments[a] == consignments[consignments.length - 1]) {
                        consignment_nums = consignment_nums + consignments[a];
                    } else {
                        consignment_nums = consignment_nums + consignments[a] + " / ";
                    }
                }
            }
            var invoice_nums = '';
            if (sales_docs.length > 0) {
                for (var _a in sales_docs) {
                    if (sales_docs[_a] == sales_docs[sales_docs.length - 1]) {
                        invoice_nums = invoice_nums + sales_docs[_a];
                    } else {
                        invoice_nums = invoice_nums + sales_docs[_a] + " / ";
                    }
                }
            } else {
                invoice_nums = "-";
            }

            var tax_invoices_nums = '';
            var tax_invoice_nums_list = [];

            if (item.tax_invoice_nums_list != null) {
                tax_invoice_nums_list = JSON.parse(item.tax_invoice_nums_list);
            }

            if (tax_invoice_nums_list.length > 0) {
                for (var t in tax_invoice_nums_list) {

                    if (tax_invoice_nums_list[t] == tax_invoice_nums_list[tax_invoice_nums_list.length - 1]) {
                        tax_invoices_nums = tax_invoices_nums + tax_invoice_nums_list[t];
                    } else {
                        tax_invoices_nums = tax_invoices_nums + tax_invoice_nums_list[t] + " / ";
                    }
                }
            } else {
                tax_invoices_nums = "-";
            }
            var addressTitle = '';
            var address = '';
            if (item.delivery_method_name == 'DELIVERY') {
                addressTitle = 'Delivery Address';
                address = item.delivery_address;
            } else item.delivery_method_name == 'DELIVERY';
            {
                addressTitle = 'Pickup Location';
                address = this.pList.from_location_name + ' (' + item.from_location_id + ')';
            }

            var courier_company = '-';
            if (item.courier_company != '') {
                courier_company = item.courier_company;
            }

            var delivery_number = '-';
            if (item.delivery_number != '') {
                delivery_number = item.delivery_number;
            }

            var ddHeader = {
                columns: [[{
                    text: 'ELKEN ' + item.country_name + ' DELIVERY ORDER',
                    style: 'invoiceTitle',
                    width: '*'
                }, {
                    stack: [{
                        columns: [{
                            text: 'DO #',
                            style: 'invoiceSubTitle',
                            width: 90

                        }, {
                            text: item.do_num,
                            style: 'invoiceSubValue',
                            width: 100

                        }, {
                            text: '',
                            style: 'invoiceSubValue',
                            width: 80
                        }, {
                            text: 'DO Date',
                            style: 'invoiceSubTitle',
                            width: 90

                        }, {
                            text: item.do_date,
                            style: 'invoiceSubValue',
                            width: 100
                        }]
                    }, {
                        columns: [{
                            text: 'Picking List #',
                            style: 'invoiceSubTitle',
                            width: 90

                        }, {
                            text: item.picklist_num,
                            style: 'invoiceSubValue',
                            width: 100
                        }, {
                            text: '',
                            style: 'invoiceSubValue',
                            width: 80
                        }, {
                            text: 'From Location',
                            style: 'invoiceSubTitle',
                            width: 90

                        }, {
                            text: item.from_location_id + ' - ' + this.pList.from_location_name,
                            style: 'invoiceSubValue',
                            width: 100
                        }]
                    }, {
                        columns: [{
                            text: 'Delivery Method',
                            style: 'invoiceSubTitle',
                            width: 90

                        }, {
                            text: item.delivery_method_name,
                            style: 'invoiceSubValue',
                            width: 100
                        }, {
                            text: '',
                            style: 'invoiceSubValue',
                            width: 80
                        }, {
                            text: 'Courier Company',
                            style: 'invoiceSubTitle',
                            width: 90

                        }, {
                            text: courier_company,
                            style: 'invoiceSubValue',
                            width: 100
                        }]
                    }, {
                        columns: [{
                            text: 'Delivery #',
                            style: 'invoiceSubTitle',
                            width: 90

                        }, {
                            text: delivery_number,
                            style: 'invoiceSubValue',
                            width: 100
                        }, {
                            text: '',
                            style: 'invoiceSubValue',
                            width: 80
                        }, {
                            text: 'IBO',
                            style: 'invoiceSubTitle',
                            width: 90

                        }, {
                            text: item.old_member_id + ' - ' + item.member_name,
                            style: 'invoiceSubValue'
                        }]
                    }, {
                        columns: [{
                            text: 'Sales Doc #',
                            style: 'invoiceSubTitle',
                            width: 90

                        }, {
                            text: invoice_nums,
                            style: 'invoiceSubValue'
                        }]
                    }, {
                        columns: [{
                            text: 'Consignments #',
                            style: 'invoiceSubTitle',
                            width: 90

                        }, {
                            text: consignment_nums,
                            style: 'invoiceSubValue'
                        }]
                    }, {
                        columns: [{
                            text: 'Tax Invoice #',
                            style: 'invoiceSubTitle',
                            width: 90

                        }, {
                            text: tax_invoices_nums,
                            style: 'invoiceSubValue'
                        }]
                    }, {
                        columns: [{
                            text: addressTitle,
                            style: 'invoiceSubTitle',
                            width: 90

                        }, {
                            text: address,
                            style: 'invoiceSubValue'
                        }]
                    }]
                }]]
            };

            var dd = {
                header: function header(pageNumber, pageCount) {
                    return {
                        margin: [0, 10, 0, 0],
                        columns: [{ text: '', style: 'documentHeaderLeft' }, { text: '', style: 'documentHeaderCenter' }, { text: '', style: 'documentHeaderRight' }]
                    };
                },
                footer: function footer(pageNumber, pageCount) {
                    return {
                        margin: [0, 0, 0, 50],
                        columns: [{ text: '', style: 'documentFooterLeft' }, { text: 'Page ' + pageNumber + " of " + pageCount, style: 'documentFooterCenter' }, { text: '', style: 'documentFooterRight' }]
                    };
                },
                content: [ddHeader, '\n\n', {
                    layout: 'lightHorizontalLines',
                    table: {

                        headerRows: 1,
                        widths: [25, 68, '*', 80],
                        body: doItems
                    } }, {
                    columns: [{
                        stack: [{
                            text: 'Issued By',
                            style: 'signaturePlaceholder'
                        }, {
                            text: '_________________________',
                            style: 'signaturePlaceholder'
                        }, {
                            text: 'Name  : ' + item.created_author_id,
                            style: 'signatureName'

                        }, {
                            text: 'Date  : ' + '',
                            style: 'signatureJobTitle'
                        }],
                        width: 160
                    }, {
                        stack: [{
                            text: '  ',
                            style: 'signaturePlaceholder'
                        }, {
                            text: '                      ',
                            style: 'signaturePlaceholder'
                        }, {
                            text: '  ',
                            style: 'signatureName'
                        }, {
                            text: '      ',
                            style: 'signatureJobTitle'
                        }],
                        width: 160
                    }, {
                        stack: [{
                            text: 'Received By',
                            style: 'signaturePlaceholder'
                        }, {
                            text: '__________________________',
                            style: 'signaturePlaceholder'
                        }, {
                            text: 'Name  :',
                            style: 'signatureName'

                        }, {
                            text: 'Date  :',
                            style: 'signatureJobTitle'

                        }],
                        width: 160
                    }]
                }],
                styles: {
                    documentHeaderLeft: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'left'
                    },
                    documentHeaderCenter: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'center'
                    },
                    documentHeaderRight: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'right'
                    },

                    documentFooterLeft: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'left'
                    },
                    documentFooterCenter: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'center'
                    },
                    documentFooterRight: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'right'
                    },

                    invoiceTitle: {
                        fontSize: 22,
                        bold: true,
                        alignment: 'left',
                        margin: [0, 0, 0, 15]
                    },

                    invoiceSubTitle: {
                        fontSize: 10,
                        alignment: 'left'
                    },
                    invoiceSubValue: {
                        fontSize: 10,
                        alignment: 'left'
                    },

                    invoiceBillingTitle: {
                        fontSize: 14,
                        bold: true,
                        alignment: 'left',
                        margin: [0, 20, 0, 5]
                    },

                    invoiceBillingDetails: {
                        alignment: 'left'

                    },
                    invoiceBillingAddressTitle: {
                        margin: [0, 7, 0, 3],
                        bold: true
                    },
                    invoiceBillingAddress: {},

                    itemsHeader: {

                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        bold: true
                    },

                    itemTitle: {
                        bold: true
                    },
                    itemSubTitle: {
                        fontSize: 10
                    },
                    itemText: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        alignment: 'left'
                    },
                    itemNumber: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        alignment: 'right'
                    },
                    itemTotal: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right'
                    },

                    itemsFooterSubTitle: {
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right'
                    },
                    itemsFooterSubValue: {
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'center'
                    },
                    itemsFooterTotalTitle: {
                        fontSize: 11,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right'
                    },
                    itemsFooterTotalValue: {
                        fontSize: 11,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'center'
                    },
                    signaturePlaceholder: {
                        fontSize: 10,
                        margin: [0, 70, 0, 0]
                    },
                    signatureName: {
                        fontSize: 10,
                        margin: [0, 10, 0, 0],
                        bold: true,
                        alignment: 'left'
                    },
                    signatureJobTitle: {
                        fontSize: 10,
                        margin: [0, 20, 0, 0],
                        bold: true,
                        alignment: 'left'
                    },
                    notesTitle: {
                        fontSize: 10,
                        bold: true,
                        margin: [0, 50, 0, 3]
                    },
                    notesText: {
                        fontSize: 10
                    },
                    center: {
                        alignment: 'center'
                    }
                },
                defaultStyle: {
                    columnGap: 20,
                    font: this.font
                }
            };
            __WEBPACK_IMPORTED_MODULE_7_pdfmake_build_pdfmake___default.a.createPdf(dd).open();
        },
        printWithoutConsolidatedPickList: function printWithoutConsolidatedPickList() {
            var picking_list_number = this.picklist_ref;
            var row = [];
            var pickList_items = [];
            var packList = [];
            var dos = this.pList.packlists;
            var packingList = [];
            for (var d in dos) {
                var delivery_address_text = '';
                var delivery_address = '';
                if (dos[d].delivery_method_name == 'DELIVERY') {
                    delivery_address_text = "Delivery Address";
                    delivery_address = dos[d].delivery_address;
                } else {
                    delivery_address_text = "Pick-up Location";
                    delivery_address = this.pList.from_location_name + ' (' + this.pList.from_location_id + ')';
                }
                var pHeader = {
                    columns: [[{
                        text: 'INDIVIDUAL PICKING LIST',
                        style: 'invoiceTitle',
                        width: '*'
                    }, {
                        stack: [{
                            columns: [{
                                text: 'Picking List #',
                                style: 'invoiceSubTitle',
                                width: 90

                            }, {
                                text: picking_list_number,
                                style: 'invoiceSubValue'
                            }]
                        }, {
                            text: ' '
                        }, {
                            columns: [{
                                text: 'Picking List Date',
                                style: 'invoiceSubTitle',
                                width: 90

                            }, {
                                text: this.pList.picklist_date,
                                style: 'invoiceSubValue'
                            }]
                        }, {
                            text: ' '
                        }, {
                            columns: [{
                                text: 'Location From',
                                style: 'invoiceSubTitle',
                                width: 90

                            }, {
                                text: this.pList.from_location_name + ' (' + this.pList.from_location_id + ')',
                                style: 'invoiceSubValue'
                            }]
                        }, {
                            text: ' '
                        }, {
                            columns: [{
                                text: 'IBO / Stockist',
                                style: 'invoiceSubTitle',
                                width: 90

                            }, {
                                text: dos[d].member_full,
                                style: 'invoiceSubValue'
                            }]
                        }, {
                            text: ' '
                        }, {
                            columns: [{
                                text: 'Delivery Method',
                                style: 'invoiceSubTitle',
                                width: 90

                            }, {
                                text: dos[d].delivery_method_name,
                                style: 'invoiceSubValue',
                                width: 100
                            }]
                        }, {
                            text: ' '
                        }, {
                            columns: [{
                                text: 'Sales Doc #',
                                style: 'invoiceSubTitle',
                                width: 90

                            }, {
                                text: dos[d].invoice_num_list,
                                style: 'invoiceSubValue'
                            }]
                        }, {
                            text: ' '
                        }, {
                            columns: [{
                                text: 'Tax Invoices #',
                                style: 'invoiceSubTitle',
                                width: 90

                            }, {
                                text: dos[d].tax_invoices_nums,
                                style: 'invoiceSubValue'
                            }]
                        }, {
                            text: ' '
                        }, {
                            columns: [{
                                text: delivery_address_text,
                                style: 'invoiceSubTitle',
                                width: 90

                            }, {
                                text: delivery_address,
                                style: 'invoiceSubValue',
                                with: 'auto'
                            }]

                        }]
                    }]]
                };
                var do_items = [];
                var data = [];
                data = [{
                    text: 'S/No',
                    style: 'itemsHeader'
                }, {
                    text: 'SKU',
                    style: ['itemsHeader'],
                    alignment: 'left'
                }, {
                    text: 'Product Name',
                    style: ['itemsHeader'],
                    alignment: 'left'
                }, {
                    text: 'Qty',
                    style: ['itemsHeader'],
                    alignment: 'right'
                }, {
                    text: 'Qty Delivered',
                    style: ['itemsHeader'],
                    alignment: 'right'
                }, {
                    text: 'Qty Balance',
                    style: ['itemsHeader'],
                    alignment: 'right'
                }];
                do_items.push(data);
                var do_items_format = [];
                var dois = dos[d].items;
                packingList.push(pHeader);
                packingList.push('\n\n');
                for (var k in dois) {
                    data = [{
                        text: k * 1 + 1,
                        style: 'itemText'
                    }, {
                        text: dois[k].product_code,
                        style: 'itemText'
                    }, {
                        text: dois[k].product_name,
                        style: 'itemText'
                    }, {
                        text: dois[k].qty,
                        style: 'itemNumber'
                    }, {
                        text: dois[k].qty_delivered,
                        style: 'itemText',
                        alignment: 'right'
                    }, {
                        text: dois[k].qty - dois[k].qty_delivered,
                        style: 'itemText',
                        alignment: 'right'
                    }];
                    do_items.push(data);

                    if (d == dos.length - 1) {
                        do_items_format = {
                            layout: 'lightHorizontalLines',
                            table: {
                                headerRows: 1,
                                widths: [25, 60, '*', 65, 70, 75],
                                body: do_items
                            }
                        };
                    } else {
                        do_items_format = {
                            layout: 'lightHorizontalLines',
                            table: {
                                headerRows: 1,
                                widths: [25, 60, '*', 65, 70, 75],
                                body: do_items
                            },
                            pageBreak: 'after'
                        };
                    }
                }
                packingList.push(do_items_format);
            }
            var dd = {
                header: function header(pageNumber, pageCount) {
                    return {
                        margin: [0, 20, 0, 0],
                        columns: [{
                            text: '',
                            style: 'documentHeaderLeft'
                        }, {
                            text: picking_list_number,
                            style: 'documentHeaderCenter'
                        }, {
                            text: '',
                            style: 'documentHeaderRight'
                        }]
                    };
                },
                footer: function footer(pageNumber, pageCount) {
                    return {
                        margin: [0, 0, 0, 30],
                        columns: [{
                            text: '',
                            style: 'documentFooterLeft'
                        }, {
                            text: 'Page ' + pageNumber + " of " + pageCount,
                            style: 'documentFooterCenter'
                        }, {
                            text: '',
                            style: 'documentFooterRight'
                        }]
                    };
                },

                content: [packingList, {
                    columns: [{
                        stack: [{
                            text: 'Issued By',
                            style: 'signaturePlaceholder'
                        }, {
                            text: '______________________________',
                            style: 'signaturePlaceholder'
                        }, {
                            text: 'Name  : ' + this.pList.author_user_shortname,
                            style: 'signatureName'

                        }, {
                            text: 'Date  : ' + this.pList.picklist_date,
                            style: 'signatureJobTitle'

                        }],
                        width: 160
                    }, {
                        stack: [{
                            text: '  ',
                            style: 'signaturePlaceholder'
                        }, {
                            text: '                      ',
                            style: 'signaturePlaceholder'
                        }, {
                            text: '  ',
                            style: 'signatureName'

                        }, {
                            text: '      ',
                            style: 'signatureJobTitle'

                        }],
                        width: 180
                    }, {
                        stack: [{
                            text: 'Picked By',
                            style: 'signaturePlaceholder'
                        }, {
                            text: '______________________________',
                            style: 'signaturePlaceholder'
                        }, {
                            text: 'Name  :',
                            style: 'signatureName'

                        }, {
                            text: 'Date  :',
                            style: 'signatureJobTitle'

                        }],
                        width: 160
                    }]
                }],
                styles: {
                    documentHeaderLeft: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'left'
                    },
                    documentHeaderCenter: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'center'
                    },
                    documentHeaderRight: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'right'
                    },

                    documentFooterLeft: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'left'
                    },
                    documentFooterCenter: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'center'
                    },
                    documentFooterRight: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'right'
                    },

                    invoiceTitle: {
                        fontSize: 22,
                        bold: true,
                        alignment: 'left',
                        margin: [0, 0, 0, 15]
                    },

                    invoiceSubTitle: {
                        fontSize: 10,
                        alignment: 'left'
                    },
                    invoiceSubValue: {
                        fontSize: 10,
                        alignment: 'left'
                    },

                    invoiceBillingTitle: {
                        fontSize: 14,
                        bold: true,
                        alignment: 'left',
                        margin: [0, 20, 0, 5]
                    },

                    invoiceBillingDetails: {
                        alignment: 'left'

                    },
                    invoiceBillingAddressTitle: {
                        margin: [0, 7, 0, 3],
                        bold: true
                    },
                    invoiceBillingAddress: {},

                    itemsHeader: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        bold: true
                    },

                    itemTitle: {
                        bold: true
                    },
                    itemSubTitle: {
                        fontSize: 10
                    },
                    itemText: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        alignment: 'left'
                    },
                    itemNumber: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        alignment: 'right'
                    },
                    itemTotal: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right'
                    },

                    itemsFooterSubTitle: {
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right'
                    },
                    itemsFooterSubValue: {
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'center'
                    },
                    itemsFooterTotalTitle: {
                        fontSize: 11,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right'
                    },
                    itemsFooterTotalValue: {
                        fontSize: 11,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'center'
                    },
                    signaturePlaceholder: {
                        fontSize: 10,
                        margin: [0, 70, 0, 0]
                    },
                    signatureName: {
                        fontSize: 10,
                        margin: [0, 10, 0, 0],
                        bold: true,
                        alignment: 'left'
                    },
                    signatureJobTitle: {
                        fontSize: 10,
                        margin: [0, 20, 0, 0],
                        bold: true,
                        alignment: 'left'
                    },
                    notesTitle: {
                        fontSize: 10,
                        bold: true,
                        margin: [0, 50, 0, 3]
                    },
                    notesText: {
                        fontSize: 10
                    },
                    center: {
                        alignment: 'center'
                    }
                },
                defaultStyle: {
                    columnGap: 20,
                    font: this.font
                }
            };
            __WEBPACK_IMPORTED_MODULE_7_pdfmake_build_pdfmake___default.a.createPdf(dd).open();
        },
        printWithConsolidatedPickList: function printWithConsolidatedPickList() {

            var picking_list_number = this.picklist_ref;
            var row = [];
            var pickList_items = [];
            row = [{
                text: 'S/No',
                style: 'itemsHeader'
            }, {
                text: 'Product Code',
                style: ['itemsHeader'],
                alignment: 'left'
            }, {
                text: 'Product Name',
                style: ['itemsHeader'],
                alignment: 'left'
            }, {
                text: 'Qty',
                style: ['itemsHeader'],
                alignment: 'right'
            }, {
                text: 'Qty Picked',
                style: ['itemsHeader'],
                alignment: 'right'
            }, {
                text: 'Balance Qty To Pick',
                style: ['itemsHeader'],
                alignment: 'right'
            }];
            pickList_items.push(row);

            for (var key in this.pList.picklist_items) {
                var data = this.pList.picklist_items[key];
                row = [{
                    text: key * 1 + 1,
                    style: 'itemText'
                }, {
                    text: data.product_code,
                    style: 'itemText'
                }, {
                    text: data.product_name,
                    style: 'itemText'
                }, {
                    text: data.qty,
                    style: 'itemNumber'
                }, {
                    text: data.qty_picked,
                    style: 'itemNumber'
                }, {
                    text: data.qty_balance,
                    style: 'itemNumber'
                }];
                pickList_items.push(row);
            }
            var pack_lists = this.pList.packlists;
            var member_and_delivery = '';


            for (var p in pack_lists) {
                if (p == pack_lists.length - 1) {
                    member_and_delivery = member_and_delivery + pack_lists[p].member_full + " (" + pack_lists[p].delivery_method_name + ")";
                } else {
                    member_and_delivery = member_and_delivery + pack_lists[p].member_full + " (" + pack_lists[p].delivery_method_name + ")" + ", ";
                }
            }

            var consignment_nums = "-";
            if (this.pList.consignment_nums != '') {
                consignment_nums = this.pList.consignment_nums;
            }

            var sales_invoice_nums = '-';
            if (this.pList.sales_invoice_nums != '') {
                sales_invoice_nums = this.pList.sales_invoice_nums;
            }

            var tax_invoices_nums = '-';
            if (this.pList.tax_invoices_nums != '') {
                tax_invoices_nums = this.pList.tax_invoices_nums;
            }
            var ddHeader = {
                columns: [[{
                    text: 'ELKEN CONSOLIDATED PICKING LIST',
                    style: 'invoiceTitle',
                    width: '*'
                }, {
                    stack: [{
                        columns: [{
                            text: 'Picking List #',
                            style: 'invoiceSubTitle',
                            width: 100
                        }, {
                            text: this.picklist_ref,
                            style: 'invoiceSubValue',
                            width: 84

                        }, {
                            text: '',
                            style: 'invoiceSubValue',
                            width: 80
                        }, {
                            text: 'Picking List Date',
                            style: 'invoiceSubTitle',
                            width: 90

                        }, {
                            text: this.pList.picklist_date,
                            style: 'invoiceSubValue',
                            width: 100

                        }]
                    }, {
                        columns: [{
                            text: 'Location From',
                            style: 'invoiceSubTitle',
                            width: 100

                        }, {
                            text: this.pList.from_location_name + ' (' + this.pList.from_location_id + ')',
                            style: 'invoiceSubValue',
                            width: 84

                        }, {
                            text: '',
                            style: 'invoiceSubValue',
                            width: 80
                        }, {
                            text: 'Status',
                            style: 'invoiceSubTitle',
                            width: 90

                        }, {
                            text: this.pList.picklist_status,
                            style: 'invoiceSubValue',
                            width: 100

                        }]
                    }, {
                        columns: [{
                            text: 'Sales Docs #',
                            style: 'invoiceSubTitle',
                            width: 100

                        }, {
                            text: sales_invoice_nums,
                            style: 'invoiceSubValue',
                            width: '*'
                        }]
                    }, {
                        text: '',
                        style: 'invoiceSubValue',
                        width: 80
                    }, {
                        columns: [{
                            text: 'Consignments #',
                            style: 'invoiceSubTitle',
                            width: 100

                        }, {
                            text: consignment_nums,
                            style: 'invoiceSubValue',
                            width: '*'

                        }]
                    }, {
                        text: '',
                        style: 'invoiceSubValue',
                        width: 80
                    }, {
                        columns: [{
                            text: 'Tax Invoices #',
                            style: 'invoiceSubTitle',
                            width: 100

                        }, {
                            text: tax_invoices_nums,
                            style: 'invoiceSubValue',
                            width: '*'

                        }]
                    }, {
                        text: '',
                        style: 'invoiceSubValue',
                        width: 80
                    }, {
                        columns: [{
                            text: 'IBO / Stockist',
                            style: 'invoiceSubTitle',
                            width: 100

                        }, {
                            text: member_and_delivery,
                            style: 'invoiceSubValue',
                            width: '*'

                        }]
                    }]
                }]]
            };
            var packList = [];
            var dos = this.pList.packlists;
            var packingList = [];
            for (var d in dos) {
                var delivery_address_text = '';
                var delivery_address = '';
                if (dos[d].delivery_method_name == 'DELIVERY') {
                    delivery_address_text = "Delivery Address";
                    delivery_address = dos[d].delivery_address;
                } else {
                    delivery_address_text = "Pick-up Location";
                    delivery_address = this.pList.from_location_name + ' (' + this.pList.from_location_id + ')';
                }
                var pHeader = {
                    columns: [[{
                        pageBreak: 'before',
                        text: 'INDIVIDUAL PICKING LIST',
                        style: 'invoiceTitle',
                        width: '*'
                    }, {
                        stack: [{
                            columns: [{
                                text: 'Picking List #',
                                style: 'invoiceSubTitle',
                                width: 90

                            }, {
                                text: picking_list_number,
                                style: 'invoiceSubValue'
                            }]
                        }, {
                            text: ' '
                        }, {
                            columns: [{
                                text: 'Picking List Date',
                                style: 'invoiceSubTitle',
                                width: 90

                            }, {
                                text: this.pList.picklist_date,
                                style: 'invoiceSubValue'
                            }]
                        }, {
                            text: ' '
                        }, {
                            columns: [{
                                text: 'Location From',
                                style: 'invoiceSubTitle',
                                width: 90

                            }, {
                                text: this.pList.from_location_name + ' (' + this.pList.from_location_id + ')',
                                style: 'invoiceSubValue'
                            }]
                        }, {
                            text: ' '
                        }, {
                            columns: [{
                                text: 'IBO / Stockist',
                                style: 'invoiceSubTitle',
                                width: 90

                            }, {
                                text: dos[d].member_full,
                                style: 'invoiceSubValue'
                            }]
                        }, {
                            text: ' '
                        }, {
                            columns: [{
                                text: 'Delivery Method',
                                style: 'invoiceSubTitle',
                                width: 90

                            }, {
                                text: dos[d].delivery_method_name,
                                style: 'invoiceSubValue',
                                width: 100
                            }]
                        }, {
                            text: ' '
                        }, {
                            columns: [{
                                text: 'Sales Doc #',
                                style: 'invoiceSubTitle',
                                width: 90

                            }, {
                                text: dos[d].invoice_num_list,
                                style: 'invoiceSubValue'
                            }]
                        }, {
                            text: ' '
                        }, {
                            columns: [{
                                text: 'Tax Invoices #',
                                style: 'invoiceSubTitle',
                                width: 90

                            }, {
                                text: dos[d].tax_invoices_nums,
                                style: 'invoiceSubValue'
                            }]
                        }, {
                            text: ' '
                        }, {
                            columns: [{
                                text: delivery_address_text,
                                style: 'invoiceSubTitle',
                                width: 90

                            }, {
                                text: delivery_address,
                                style: 'invoiceSubValue',
                                with: 'auto'
                            }]
                        }]
                    }]]
                };
                var do_items = [];
                var data = [];
                data = [{
                    text: 'S/No',
                    style: 'itemsHeader'
                }, {
                    text: 'Product Code',
                    style: ['itemsHeader'],
                    alignment: 'left'
                }, {
                    text: 'Product Name',
                    style: ['itemsHeader'],
                    alignment: 'left'
                }, {
                    text: 'Qty',
                    style: ['itemsHeader'],
                    alignment: 'right'
                }, {
                    text: 'Qty Delivered',
                    style: ['itemsHeader'],
                    alignment: 'right'
                }, {
                    text: 'Qty Balance',
                    style: ['itemsHeader'],
                    alignment: 'right'
                }];
                do_items.push(data);
                var do_items_format = [];
                var dois = dos[d].items;
                packingList.push(pHeader);
                packingList.push('\n\n');

                for (var k in dois) {
                    data = [{
                        text: k * 1 + 1,
                        style: 'itemText'
                    }, {
                        text: dois[k].product_code,
                        style: 'itemText'
                    }, {
                        text: dois[k].product_name,
                        style: 'itemText'
                    }, {
                        text: dois[k].qty,
                        style: 'itemNumber'
                    }, {
                        text: dois[k].qty_delivered,
                        style: 'itemNumber',
                        alignment: 'right'
                    }, {
                        text: dois[k].qty - dois[k].qty_delivered,
                        style: 'itemNumber',
                        alignment: 'right'
                    }];
                    do_items.push(data);
                    do_items_format = {
                        layout: 'lightHorizontalLines',
                        table: {
                            headerRows: 1,
                            widths: [25, 60, '*', 65, 70, 75],
                            body: do_items
                        }
                    };
                }
                packingList.push(do_items_format);
            }
            var dd = {
                header: function header(pageNumber, pageCount) {
                    return {
                        margin: [0, 20, 0, 0],
                        columns: [{
                            text: '',
                            style: 'documentHeaderLeft'
                        }, {
                            text: picking_list_number,
                            style: 'documentHeaderCenter'
                        }, {
                            text: '',
                            style: 'documentHeaderRight'
                        }]
                    };
                },
                footer: function footer(pageNumber, pageCount) {
                    return {
                        margin: [0, 0, 0, 30],
                        columns: [{
                            text: '',
                            style: 'documentFooterLeft'
                        }, {
                            text: 'Page ' + pageNumber + " of " + pageCount,
                            style: 'documentFooterCenter'
                        }, {
                            text: '',
                            style: 'documentFooterRight'
                        }]
                    };
                },

                content: [ddHeader, '\n\n', {
                    layout: 'lightHorizontalLines',
                    table: {

                        headerRows: 1,
                        widths: [25, 68, '*', 45, 80, 80],
                        body: pickList_items
                    } }, {
                    columns: [{
                        stack: [{
                            text: 'Issued By',
                            style: 'signaturePlaceholder'
                        }, {
                            text: '____________________________',
                            style: 'signaturePlaceholder'
                        }, {
                            text: 'Name  :' + this.pList.author_user_shortname,
                            style: 'signatureName'

                        }, {
                            text: 'Date  :' + this.pList.picklist_date,
                            style: 'signatureJobTitle'

                        }],
                        width: 160
                    }, {
                        stack: [{
                            text: '         ',
                            style: 'signaturePlaceholder'
                        }, {
                            text: '                           ',
                            style: 'signaturePlaceholder'
                        }, {
                            text: '          ',
                            style: 'signatureName'

                        }, {
                            text: ' ',
                            style: 'signatureJobTitle'

                        }],
                        width: 160
                    }, {
                        stack: [{
                            text: 'Picked By',
                            style: 'signaturePlaceholder'
                        }, {
                            text: '______________________________',
                            style: 'signaturePlaceholder'
                        }, {
                            text: 'Name  :',
                            style: 'signatureName'

                        }, {
                            text: 'Date  :',
                            style: 'signatureJobTitle'

                        }],
                        width: 160
                    }]
                }],
                styles: {
                    documentHeaderLeft: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'left'
                    },
                    documentHeaderCenter: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'center'
                    },
                    documentHeaderRight: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'right'
                    },

                    documentFooterLeft: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'left'
                    },
                    documentFooterCenter: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'center'
                    },
                    documentFooterRight: {
                        fontSize: 10,
                        margin: [5, 5, 5, 5],
                        alignment: 'right'
                    },

                    invoiceTitle: {
                        fontSize: 22,
                        bold: true,
                        alignment: 'left',
                        margin: [0, 0, 0, 15]
                    },

                    invoiceSubTitle: {
                        fontSize: 10,
                        alignment: 'left'
                    },
                    invoiceSubValue: {
                        fontSize: 10,
                        alignment: 'left'
                    },

                    invoiceBillingTitle: {
                        fontSize: 14,
                        bold: true,
                        alignment: 'left',
                        margin: [0, 20, 0, 5]
                    },

                    invoiceBillingDetails: {
                        alignment: 'left'

                    },
                    invoiceBillingAddressTitle: {
                        margin: [0, 7, 0, 3],
                        bold: true
                    },
                    invoiceBillingAddress: {},

                    itemsHeader: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        bold: true
                    },

                    itemTitle: {
                        bold: true
                    },
                    itemSubTitle: {
                        fontSize: 10
                    },
                    itemText: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        alignment: 'left'
                    },
                    itemNumber: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        alignment: 'right'
                    },
                    itemTotal: {
                        fontSize: 10,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right'
                    },

                    itemsFooterSubTitle: {
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right'
                    },
                    itemsFooterSubValue: {
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'center'
                    },
                    itemsFooterTotalTitle: {
                        fontSize: 11,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'right'
                    },
                    itemsFooterTotalValue: {
                        fontSize: 11,
                        margin: [0, 5, 0, 5],
                        bold: true,
                        alignment: 'center'
                    },
                    signaturePlaceholder: {
                        fontSize: 10,
                        margin: [0, 70, 0, 0]
                    },
                    signatureName: {
                        fontSize: 10,
                        margin: [0, 10, 0, 0],
                        bold: true,
                        alignment: 'left'
                    },
                    signatureJobTitle: {
                        fontSize: 10,
                        margin: [0, 20, 0, 0],
                        bold: true,
                        alignment: 'left'
                    },
                    notesTitle: {
                        fontSize: 10,
                        bold: true,
                        margin: [0, 50, 0, 3]
                    },
                    notesText: {
                        fontSize: 10
                    },
                    center: {
                        alignment: 'center'
                    }
                },
                defaultStyle: {
                    columnGap: 20,
                    font: this.font
                }
            };
            __WEBPACK_IMPORTED_MODULE_7_pdfmake_build_pdfmake___default.a.createPdf(dd).open();
        }
    }
});

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Autocomplete_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__functions_common_vue__ = __webpack_require__(4);







/* harmony default export */ __webpack_exports__["a"] = ({
    components: { spinner: __WEBPACK_IMPORTED_MODULE_1__components_Spinner_vue__["a" /* default */] },
    props: {
        caption: {
            type: String,
            default: 'Table'
        },
        hover: {
            type: Boolean,
            default: false
        },
        striped: {
            type: Boolean,
            default: false
        },
        bordered: {
            type: Boolean,
            default: false
        },
        small: {
            type: Boolean,
            default: false
        },
        fixed: {
            type: Boolean,
            default: false
        }
    },
    created: function created() {},
    data: function data() {
        return {
            loading: false,
            modalShow: false,
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            noResults: false,
            selectedSalesDoc: [],
            filter: {
                stockist_id: '',
                date_start: '',
                date_end: '',
                status: ''
            },
            searchResults: [],
            searchResultsFields: [{ key: 'trans_date', label: 'Transaction Date' }, { key: 'sales_doc_num', label: 'Sales Doc No.' }, { key: 'customer_id', label: 'IBO ID' }, { key: 'customer_name', label: 'IBO Name' }, { key: 'status', label: 'Status' }, { key: 'check_box', label: ' ', 'class': 'text-center' }],
            picklistInfo: [],
            picklistInfoFields: [{ key: 'picking_list_date', label: 'Pick Date' }, { key: 'picking_list_num', label: 'Pick List No' }, { key: 'author_user_shortname', label: 'Created By' }, { key: 'do_date', label: 'Do Date' }, { key: 'do_num', label: 'Do Num' }, { key: 'do_author_user_shortname', label: 'Created By' }, { key: 'courier_num', label: 'Courier No' }, { key: 'courier_company', label: 'Courier Company' }]
        };
    },

    methods: {
        search: function search() {
            var _this = this;

            this.loading = true;
            this.noResults = true;
            this.selectedSalesDoc = [];
            var sf = {
                member_search: "",
                from_date: this.filter.date_start,
                to_date: this.filter.date_end,
                search_text: "",
                delivery_method_id: "0",
                order_status_id: "0"
            };

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__functions_common_vue__["Z" /* apiWsiSearch */], sf, Object(__WEBPACK_IMPORTED_MODULE_3__functions_common_vue__["_7" /* authHeader */])()).then(function (res) {
                return res;
            }).then(function (data) {
                var resultArray = [];
                var myData = data.data.data.data;

                for (var key in myData) {
                    var date = myData[key].transaction_date;
                    var date = new Date(date);
                    var result = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + (date.getMonth() + 1 > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear();
                    myData[key].trans_date = result;
                    myData[key].sales_doc_num = myData[key].document_number;
                    myData[key].customer_id = myData[key].member.user.old_member_id;
                    myData[key].customer_name = myData[key].member.name;
                    myData[key].channel = myData[key].channel.name;
                    myData[key].trans_loc = myData[key].transaction_location.code;
                    myData[key].shipping_method = myData[key].delivery_method;

                    myData[key].sale_id = myData[key].document_number;
                    myData[key].shipping_town = "";
                    myData[key].status = myData[key].delivery_status;
                    resultArray.push(myData[key]);
                    _this.loading = false;
                }
                _this.searchResults = resultArray;

                if (_this.searchResults.length == 0) {
                    _this.loading = false;
                    _this.noResults = true;
                }
            }).catch(function (error) {
                return console.log(error);
            });
        },
        getRowCount: function getRowCount(items) {
            return items.length;
        },
        handleCancel: function handleCancel() {
            this.selectedSalesDoc = [];
        },
        previewPickingList: function previewPickingList() {
            alert("Preview");
        }
    }
});

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Autocomplete_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__functions_common_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_json_excel__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pdfmake_build_pdfmake__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pdfmake_build_pdfmake___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pdfmake_build_pdfmake__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_vfs_fonts__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_vfs_fonts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_pdfmake_build_vfs_fonts__);










__WEBPACK_IMPORTED_MODULE_5_pdfmake_build_pdfmake___default.a.vfs = __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_vfs_fonts___default.a.pdfMake.vfs;
__WEBPACK_IMPORTED_MODULE_5_pdfmake_build_pdfmake___default.a.fonts = {
    "ukai": {
        normal: 'ukai.ttf',
        bold: 'ukai.ttf',
        italics: 'ukai.ttf',
        bolditalics: 'ukai.ttf'
    }
};
/* harmony default export */ __webpack_exports__["a"] = ({
    components: { spinner: __WEBPACK_IMPORTED_MODULE_1__components_Spinner_vue__["a" /* default */], countryLookup: __WEBPACK_IMPORTED_MODULE_2__components_Autocomplete_vue__["a" /* default */], warehouseLookup: __WEBPACK_IMPORTED_MODULE_2__components_Autocomplete_vue__["a" /* default */], exportExcel: __WEBPACK_IMPORTED_MODULE_4_vue_json_excel__["a" /* default */] },
    props: {
        caption: {
            type: String,
            default: 'Table'
        },
        hover: {
            type: Boolean,
            default: false
        },
        striped: {
            type: Boolean,
            default: false
        },
        bordered: {
            type: Boolean,
            default: false
        },
        small: {
            type: Boolean,
            default: false
        },
        fixed: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            loading: false,
            apiCountryLookup: __WEBPACK_IMPORTED_MODULE_3__functions_common_vue__["c" /* apiCountryLookup */],
            apiWarehouseLookup: __WEBPACK_IMPORTED_MODULE_3__functions_common_vue__["V" /* apiWarehouseLookup */],
            filter: {
                country: '',
                warehouse: '',
                invoice_date: '',
                invoice_number: '',
                goods_issued_date: ''
            },
            exportHeaders: {
                'Country': 'country',
                'Location': 'warehouse',
                'Trans Type': 'transaction_type',
                'Invoice Date': 'invoice_date',
                'Sale Doc #': 'invoice_number',
                'Tax Invoice #': 'tax_invoice_number',
                'Goods Issues Date': 'goods_issued_date',
                'Picking List #': 'picking_list_number',
                'Delivery Method': 'delivery_method',
                'Courier': 'courier',
                'Delivery #': 'delivery_number',
                'Member': 'member',
                'SKU': 'sku',
                'Description': 'description',
                'Qty': 'qty',
                'Total DP': 'total_dp',
                'Delivery Status': 'delivery_status'
            },
            searchResults: [],
            searchResultsFields: [{ key: 'country', label: 'Country' }, { key: 'warehouse', label: 'Warehouse' }, { key: 'transaction_type', label: 'Trans Type' }, { key: 'invoice_date', label: 'Invoice Date' }, { key: 'invoice_number', label: 'Sales Doc #' }, { key: 'tax_invoice_number', label: 'Tax Invoice #' }, { key: 'goods_issued_date', label: 'Goods Issued Date' }, { key: 'picking_list_number', label: 'Picking List #' }, { key: 'delivery_method', label: 'Delivery Method' }, { key: 'courier', label: 'Courier' }, { key: 'delivery_number', label: 'Delivery #' }, { key: 'member', label: 'Member' }, { key: 'sku', label: 'SKU' }, { key: 'description', label: 'Description' }, { key: 'qty', label: 'Qty' }, { key: 'total_dp', label: 'Total DP' }, { key: 'delivery_status', label: 'Delivery Status' }],
            currentPage: 1,
            perPage: 30,
            totalRows: 0,
            noResults: false
        };
    },

    methods: {
        print: function print() {
            var rows = [];
            var row = [];
            var date = new Date();
            rows.push(['Country', 'Location', 'Trans Type', 'Invoice Date', 'Sales Doc #', 'Tax Invoice #', 'Goods Issued date', 'Picking List #', 'Delivery Method', 'Courier', 'Delivery #', 'Member', 'SKU', 'Description', 'Qty', 'Total DP', 'Delivery Status']);

            for (var key in this.searchResults) {
                var data = this.searchResults[key];
                row = [data.country, data.warehouse, data.transaction_type, data.invoice_date, data.invoice_number, data.tax_invoice_number, data.goods_issued_date, data.picking_list_number, data.delivery_method, data.courier, data.delivery_number, data.member, data.sku, data.description, data.qty, data.total_dp, data.delivery_status];
                rows.push(row);
            }
            var dd = {
                header: { text: 'Stock Delivered Report generated on' + " " + date, margin: [5, 7, 10, 30], alignment: 'center', fontSize: 7 },
                pageSize: 'A4',
                pageOrientation: 'landscape',

                pageMargins: [30, 20, 30, 20],
                defaultStyle: {
                    font: 'ukai'
                },
                content: [{
                    fontSize: 7.5,
                    layout: 'lightHorizontalLines',
                    table: {
                        headerRows: 1,
                        widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
                        body: rows
                    }
                }]
            };

            __WEBPACK_IMPORTED_MODULE_5_pdfmake_build_pdfmake___default.a.createPdf(dd).open();
        },
        search: function search() {
            var _this = this;

            var sf = ["country = " + this.filter.country, "warehouse = " + this.filter.warehouse, "invoice_date = " + this.filter.invoice_date, "tax_invoice_number LIKE " + this.filter.invoice_number, "goods_issued_date = " + this.filter.goods_issued_date, "trans_type = " + "do"];

            if (1) {
                this.loading = true;
                __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__functions_common_vue__["e" /* apiDeliveredOrdersSearch */], sf, Object(__WEBPACK_IMPORTED_MODULE_3__functions_common_vue__["_7" /* authHeader */])()).then(function (res) {
                    return res;
                }).then(function (data) {
                    _this.loading = false;
                    var myData = data.data.data;
                    for (var d in myData) {
                        var date = myData[d].invoice_date;
                        var date = new Date(date);
                        var result = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + (date.getMonth() + 1 > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear();
                        myData[d].invoice_date = result;

                        var gid = myData[d].goods_issued_date;
                        var gid = new Date(gid);
                        gid = "" + (gid.getDate() > 9 ? '' : '0') + gid.getDate() + '/' + (gid.getMonth() + 1 > 9 ? '' : '0') + (gid.getMonth() + 1) + '/' + gid.getFullYear() + " " + (gid.getHours() > 9 ? '' : '0') + gid.getHours() + ":" + (gid.getMinutes() > 9 ? '' : '0') + gid.getMinutes() + ":" + (gid.getSeconds() > 9 ? '' : '0') + gid.getSeconds();

                        myData[d].goods_issued_date = gid;

                        if (myData[d].total_dp == "") {
                            myData[d].total_dp = "-";
                        }

                        if (myData[d].transaction_type == "") {
                            myData[d].transaction_type = "-";
                        }

                        if (myData[d].tax_invoice_number == null) {
                            myData[d].tax_invoice_number = "-";
                        }
                    }
                    _this.searchResults = myData;

                    if (_this.searchResults.length == 0) {
                        _this.noResults = true;
                        _this.loading = false;
                    }
                }).catch(function (error) {
                    return alert(error);
                });
            }
        },
        setCountry: function setCountry(obj) {
            var id;

            if (obj !== null) {
                id = obj.id;
            } else {
                id = "";
            }
            this.filter.country = id;
        },
        setWarehouse: function setWarehouse(obj) {
            var id;

            if (obj !== null) {
                id = obj.id;
            } else {
                id = "";
            }
            this.filter.warehouse = id;
        },
        getRowCount: function getRowCount(items) {
            return items.length;
        }
    }
});

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Autocomplete_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__functions_common_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_json_excel__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pdfmake_build_pdfmake__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pdfmake_build_pdfmake___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pdfmake_build_pdfmake__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_vfs_fonts__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_vfs_fonts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_pdfmake_build_vfs_fonts__);











__WEBPACK_IMPORTED_MODULE_5_pdfmake_build_pdfmake___default.a.vfs = __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_vfs_fonts___default.a.pdfMake.vfs;
__WEBPACK_IMPORTED_MODULE_5_pdfmake_build_pdfmake___default.a.fonts = {
    "ukai": {
        normal: 'ukai.ttf',
        bold: 'ukai.ttf',
        italics: 'ukai.ttf',
        bolditalics: 'ukai.ttf'
    }
};
/* harmony default export */ __webpack_exports__["a"] = ({
    components: { spinner: __WEBPACK_IMPORTED_MODULE_1__components_Spinner_vue__["a" /* default */], countryLookup: __WEBPACK_IMPORTED_MODULE_2__components_Autocomplete_vue__["a" /* default */], warehouseLookup: __WEBPACK_IMPORTED_MODULE_2__components_Autocomplete_vue__["a" /* default */], exportExcel: __WEBPACK_IMPORTED_MODULE_4_vue_json_excel__["a" /* default */] },
    props: {
        caption: {
            type: String,
            default: 'Table'
        },
        hover: {
            type: Boolean,
            default: false
        },
        striped: {
            type: Boolean,
            default: false
        },
        bordered: {
            type: Boolean,
            default: false
        },
        small: {
            type: Boolean,
            default: false
        },
        fixed: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            loading: false,
            apiCountryLookup: __WEBPACK_IMPORTED_MODULE_3__functions_common_vue__["c" /* apiCountryLookup */],
            apiWarehouseLookup: __WEBPACK_IMPORTED_MODULE_3__functions_common_vue__["V" /* apiWarehouseLookup */],
            filter: {
                country: '',
                warehouse: '',
                invoice_date: '',
                invoice_number: ''
            },
            exportHeaders: {
                'Country': 'country',
                'Location': 'warehouse',
                'Trans Type': 'transaction_type',
                'Invoice Date': 'invoice_date',
                'Sales Doc #': 'invoice_number',
                'Tax Invoice #': 'tax_invoice_number',
                'Delivery Method': 'delivery_method',
                'Member': 'member',
                'SKU': 'sku',
                'Description': 'description',
                'Qty': 'qty',
                'Total DP': 'total_dp',
                'Delivery Status': 'delivery_status'
            },
            searchResults: [],
            searchResultsFields: [{ key: 'country', label: 'Country' }, { key: 'warehouse', label: 'Warehouse' }, { key: 'transaction_type', label: 'Trans Type' }, { key: 'invoice_date', label: 'Invoice Date' }, { key: 'invoice_number', label: 'Sales Doc #' }, { key: 'tax_invoice_number', label: 'Tax Invoice #' }, { key: 'delivery_method', label: 'Delivery Method' }, { key: 'member', label: 'Member' }, { key: 'sku', label: 'SKU' }, { key: 'description', label: 'Description' }, { key: 'qty', label: 'Qty' }, { key: 'total_dp', label: 'Total DP' }, { key: 'delivery_status', label: 'Delivery Status' }],
            currentPage: 1,
            perPage: 30,
            totalRows: 0,
            noResults: false
        };
    },

    methods: {
        print: function print() {
            var rows = [];
            var row = [];
            var date = new Date();
            rows.push(['Country', 'Location', 'Trans Type', 'Invoice Date', 'Invoice #', 'Delivery Method', 'Member', 'SKU', 'Description', 'Qty', 'Total DP', 'Delivery Status']);

            for (var key in this.searchResults) {
                var data = this.searchResults[key];
                row = [data.country, data.warehouse, data.transaction_type, data.invoice_date, data.invoice_number, data.delivery_method, data.member, data.sku, data.description, data.qty, data.total_dp, data.delivery_status];
                rows.push(row);
            }
            var dd = {
                header: { text: 'Stock Un-Delivered Report generated on' + " " + date, margin: [5, 7, 10, 30], alignment: 'center', fontSize: 7 },
                pageSize: 'A4',
                pageOrientation: 'landscape',

                pageMargins: [30, 20, 30, 20],
                defaultStyle: {
                    font: 'ukai'
                },
                content: [{
                    fontSize: 7.5,
                    layout: 'lightHorizontalLines',
                    table: {
                        headerRows: 1,
                        widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
                        body: rows

                    }
                }]
            };

            __WEBPACK_IMPORTED_MODULE_5_pdfmake_build_pdfmake___default.a.createPdf(dd).open();
        },
        search: function search() {
            var _this = this;

            var sf = ["country = " + this.filter.country, "warehouse = " + this.filter.warehouse, "invoice_date = " + this.filter.invoice_date, "invoice_number LIKE " + this.filter.invoice_number, "delivery_status = " + "PENDING"];

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__functions_common_vue__["t" /* apiOutstandingOrdersSearch */], sf, Object(__WEBPACK_IMPORTED_MODULE_3__functions_common_vue__["_7" /* authHeader */])()).then(function (res) {
                return res;
            }).then(function (data) {
                _this.loading = false;
                var myData = data.data.data;
                for (var d in myData) {
                    var date = myData[d].invoice_date;
                    var date = new Date(date);
                    var result = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + (date.getMonth() + 1 > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear();
                    myData[d].invoice_date = result;

                    if (myData[d].total_dp == "") {
                        myData[d].total_dp = "-";
                    }

                    if (myData[d].transaction_type == "") {
                        myData[d].transaction_type = "-";
                    }

                    if (myData[d].tax_invoice_number == null) {
                        myData[d].tax_invoice_number = "-";
                    }
                }
                _this.searchResults = myData;

                if (_this.searchResults.length == 0) {
                    _this.noResults = true;
                    _this.loading = false;
                }
            }).catch(function (error) {
                return alert(error);
            });
        },
        setCountry: function setCountry(obj) {
            var id;

            if (obj !== null) {
                id = obj.id;
            } else {
                id = "";
            }
            this.filter.country = id;
        },
        setWarehouse: function setWarehouse(obj) {
            var id;

            if (obj !== null) {
                id = obj.id;
            } else {
                id = "";
            }
            this.filter.warehouse = id;
        },
        getRowCount: function getRowCount(items) {
            return items.length;
        }
    }
});

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Autocomplete_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__functions_common_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pdfmake_build_pdfmake__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pdfmake_build_pdfmake___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_pdfmake_build_pdfmake__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pdfmake_build_vfs_fonts__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pdfmake_build_vfs_fonts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pdfmake_build_vfs_fonts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_json_excel__ = __webpack_require__(12);










__WEBPACK_IMPORTED_MODULE_4_pdfmake_build_pdfmake___default.a.vfs = __WEBPACK_IMPORTED_MODULE_5_pdfmake_build_vfs_fonts___default.a.pdfMake.vfs;
__WEBPACK_IMPORTED_MODULE_4_pdfmake_build_pdfmake___default.a.fonts = {
    "ukai": {
        normal: 'ukai.ttf',
        bold: 'ukai.ttf',
        italics: 'ukai.ttf',
        bolditalics: 'ukai.ttf'
    }
};



/* harmony default export */ __webpack_exports__["a"] = ({
    components: { spinner: __WEBPACK_IMPORTED_MODULE_1__components_Spinner_vue__["a" /* default */], countryLookup: __WEBPACK_IMPORTED_MODULE_2__components_Autocomplete_vue__["a" /* default */], warehouseLookup: __WEBPACK_IMPORTED_MODULE_2__components_Autocomplete_vue__["a" /* default */], exportExcel: __WEBPACK_IMPORTED_MODULE_6_vue_json_excel__["a" /* default */] },
    props: {
        caption: {
            type: String,
            default: 'Table'
        },
        hover: {
            type: Boolean,
            default: false
        },
        striped: {
            type: Boolean,
            default: false
        },
        bordered: {
            type: Boolean,
            default: false
        },
        small: {
            type: Boolean,
            default: false
        },
        fixed: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            loading: false,
            apiCountryLookup: __WEBPACK_IMPORTED_MODULE_3__functions_common_vue__["c" /* apiCountryLookup */],
            apiWarehouseLookup: __WEBPACK_IMPORTED_MODULE_3__functions_common_vue__["V" /* apiWarehouseLookup */],
            filter: {
                country_id: '',
                location_id: '',
                back_order_num: '',
                transaction_date: '',
                sales_doc_num: '',
                invoice_date: ''
            },
            exportHeaders: {
                'Country': 'country_id',
                'Location': 'location_id',
                'Trans Date': 'transaction_date',
                'Invoice Date': 'invoice_date',
                'Invoice #': 'invoice_number',
                'Member': 'member_name',
                'SKU': 'product_code',
                'Description': 'product_name',
                'BackOrder Qty': 'back_order_qty',
                'Delivery Method': 'delivery_method_name',
                'Remarks': 'remarks'
            },
            searchResults: [],
            searchResultsFields: [{ key: 'country_id', label: 'Country' }, { key: 'location_id', label: 'Warehouse' }, { key: 'transaction_date', label: 'Trans Date' }, { key: 'invoice_date', label: 'Invoice Date' }, { key: 'invoice_number', label: 'Invoice #' }, { key: 'member_name', label: 'Customer Name' }, { key: 'product_code', label: 'SKU' }, { key: 'product_name', label: 'Description' }, { key: 'back_order_qty', label: 'BackOrder Qty' }, { key: 'delivery_method_name', label: 'Delivery Method' }, { key: 'remarks', label: 'Remarks' }],
            currentPage: 1,
            perPage: 30,
            totalRows: 0,
            noResults: false
        };
    },

    methods: {
        print: function print() {
            var rows = [];
            var row = [];
            var date = new Date();
            rows.push(['Country', 'Location', 'Trans Date', 'Invoice #', 'Invoice Date', 'Member Name', 'SKU', 'Description', 'Back Order Qty', 'Delivery Method', 'Remarks']);

            for (var key in this.searchResults) {
                var data = this.searchResults[key];
                row = [data.country_id, data.location_id, data.transaction_date, data.invoice_number, data.invoice_date, data.member_name, data.product_code, data.product_name, data.back_order_qty, data.delivery_method_name, data.remarks];
                rows.push(row);
            }
            var dd = {
                header: { text: 'Back Order Report generated on' + " " + date, margin: [5, 7, 10, 30], alignment: 'center', fontSize: 7 },
                pageSize: 'A4',
                pageOrientation: 'landscape',

                pageMargins: [30, 20, 30, 20],
                defaultStyle: {
                    font: 'ukai'
                },
                content: [{
                    fontSize: 8,
                    layout: 'lightHorizontalLines',
                    table: {
                        headerRows: 1,
                        widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
                        body: rows

                    }
                }]
            };

            __WEBPACK_IMPORTED_MODULE_4_pdfmake_build_pdfmake___default.a.createPdf(dd).open();
        },
        search: function search() {
            var _this = this;

            var sf = ["country_id = " + this.filter.country_id, "location_id = " + this.filter.location_id, "back_order_num LIKE " + this.filter.back_order_num, "transaction_date = " + this.filter.transaction_date];

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__functions_common_vue__["b" /* apiBackOrdersSearch */], sf, Object(__WEBPACK_IMPORTED_MODULE_3__functions_common_vue__["_7" /* authHeader */])()).then(function (res) {
                return res;
            }).then(function (data) {
                _this.loading = false;

                var items = data.data.data;
                var result = '';

                for (var d in items) {
                    var date = items[d].invoice_date;

                    if (date != null && date != '-') {
                        var date = new Date(date);
                        result = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + (date.getMonth() + 1 > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear();
                    } else {
                        result = "-";
                    }

                    var transaction_date = items[d].transaction_date;
                    if (transaction_date != null) {
                        transaction_date = new Date(transaction_date);
                        transaction_date = "" + (transaction_date.getDate() > 9 ? '' : '0') + transaction_date.getDate() + '/' + (transaction_date.getMonth() + 1 > 9 ? '' : '0') + (transaction_date.getMonth() + 1) + '/' + transaction_date.getFullYear();
                    } else {
                        transaction_date = "-";
                    }

                    items[d].transaction_date = transaction_date;
                    items[d].invoice_date = result;
                }

                _this.searchResults = items;
                if (_this.searchResults.length == 0) {
                    _this.noResults = true;
                    _this.loading = false;
                }
            }).catch(function (error) {
                return alert(error);
            });
        },
        setCountry: function setCountry(obj) {
            var id;

            if (obj !== null) {
                id = obj.id;
            } else {
                id = "";
            }
            this.filter.country_id = id;
        },
        setWarehouse: function setWarehouse(obj) {
            var id;

            if (obj !== null) {
                id = obj.id;
            } else {
                id = "";
            }
            this.filter.location_id = id;
        },
        getRowCount: function getRowCount(items) {
            return items.length;
        }
    }
});

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__functions_common_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Autocomplete_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_json_excel__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pdfmake_build_pdfmake__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pdfmake_build_pdfmake___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pdfmake_build_pdfmake__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_vfs_fonts__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_vfs_fonts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_pdfmake_build_vfs_fonts__);










__WEBPACK_IMPORTED_MODULE_5_pdfmake_build_pdfmake___default.a.vfs = __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_vfs_fonts___default.a.pdfMake.vfs;
__WEBPACK_IMPORTED_MODULE_5_pdfmake_build_pdfmake___default.a.fonts = {
  "ukai": {
    normal: 'ukai.ttf',
    bold: 'ukai.ttf',
    italics: 'ukai.ttf',
    bolditalics: 'ukai.ttf'
  },
  "Roboto": {
    normal: 'Roboto-Regular.ttf',
    bold: 'Roboto-Medium.ttf',
    italics: 'Roboto-Italic.ttf',
    bolditalics: 'Roboto-Italic.ttf'
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  components: { supplierLookup: __WEBPACK_IMPORTED_MODULE_2__components_Autocomplete_vue__["a" /* default */], spinner: __WEBPACK_IMPORTED_MODULE_3__components_Spinner_vue__["a" /* default */], exportExcel: __WEBPACK_IMPORTED_MODULE_4_vue_json_excel__["a" /* default */] },
  props: {
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      loading: false,
      filter: {
        po_num: '',
        grn_num: '',
        supplier_id: '',
        po_date: '',
        last_grn_date: '',
        po_status: '',
        po_fulfilment_status: ''
      },
      apiUrl: __WEBPACK_IMPORTED_MODULE_1__functions_common_vue__["U" /* apiSupplierLookup */],
      supplier_fullId: '',
      seen: false,
      searchResults: [],
      searchResultsFields: [{ key: 'po_num', label: 'PO No' }, { key: 'po_date', label: 'PO Date' }, { key: 'supplier_full', label: 'Supplier' }, { key: 'po_type', label: 'Type' }, { key: 'po_category', label: 'Category' }, { key: 'po_status', label: 'PO Status' }, { key: 'po_fulfilment_status', label: 'Fulfilment Status' }, { key: 'grns_list', label: 'GRN List' }, { key: 'last_grn_date', label: 'Last GRN Date' }, { key: 'location_id', label: 'Location' }, { key: 'product_code', label: 'SKU' }, { key: 'qty', label: 'PO Qty' }, { key: 'qty_received', label: 'Received Qty' }, { key: 'qty_balance', label: 'Balance Qty' }, { key: 'remarks', label: 'PO Remarks' }, { key: 'last_grn_remarks', label: 'Last GRN Remarks' }],
      currentPage: 1,
      perPage: 20,
      totalRows: 0,
      noResults: false,
      exportHeaders: {
        'PO No': 'po_num',
        'Date': 'po_date',
        'Supplier Ful': 'supplier_full',
        'PO Status': 'po_status',
        'Fulfilment Status': 'po_fulfilment_status',
        'GRN List': 'grns_list',
        'Last GRN Date': 'last_grn_date',
        'Location': 'location_id',
        'SKU': 'product_code',
        'Description': 'product_name',
        'PO Qty': 'qty',
        'GRN Qty': 'qty_received',
        'Qty Balance': 'qty_balance',
        'PO Remarks': 'remarks',
        'Last GRN Remarks': 'last_grn_remarks'
      }
    };
  },
  created: function created() {
    var auth_header = localStorage.access_token;
    window.addEventListener('keyup', this.checkKey);
  },

  methods: {
    print: function print() {
      var rows = [];
      var row = [];
      var date = new Date();
      rows.push(['PO No', 'PO Date', 'supplier_full', 'PO Status', 'Fulfilment Status', 'GRN No', 'Last GRN Date', 'Location', 'SKU', 'PO Qty', 'GRN Qty', 'Qty Balance']);

      for (var key in this.searchResults) {
        var data = this.searchResults[key];
        row = [data.po_num, data.po_date, data.supplier_full, data.po_status, data.po_fulfilment_status, data.grns_list, data.last_grn_date, data.location_id, data.product_code, data.qty, data.qty_received, data.qty_balance];
        rows.push(row);
      }
      var dd = {
        header: { text: 'PO & GRN Tracking Report generated on' + " " + date, margin: [5, 10, 10, 20], alignment: 'center', fontSize: 7 },
        pageSize: 'A4',
        pageOrientation: 'landscape',
        defaultStyle: {
          font: 'ukai'
        },

        pageMargins: [30, 20, 30, 20],

        content: [{
          fontSize: 10,
          layout: 'lightHorizontalLines',
          table: {
            headerRows: 1,
            widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],

            body: rows

          }
        }]
      };

      __WEBPACK_IMPORTED_MODULE_5_pdfmake_build_pdfmake___default.a.createPdf(dd).open();
    },
    checkKey: function checkKey(e) {
      if (e.key == 'Enter') {}
    },
    search: function search() {
      var _this = this;

      this.loading = true;
      this.submitted = true;
      this.seen = true;
      var sf = ["po_num LIKE " + this.filter.po_num, "supplier_id = " + this.filter.supplier_id, "po_date = " + this.filter.po_date, "grns_list = " + this.filter.grn_num, "po_status = " + this.filter.po_status, "po_po_fulfilment_status = " + this.filter.po_fulfilment_status];
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__functions_common_vue__["A" /* apiPoGrnTrackingReport */], sf, Object(__WEBPACK_IMPORTED_MODULE_1__functions_common_vue__["_7" /* authHeader */])()).then(function (res) {
        return res;
      }).then(function (data) {
        var resultArray = [];
        var myData = data.data.data;

        for (var key in myData) {
          var date = myData[key].po_date;
          var date = new Date(date);
          var result = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + (date.getMonth() + 1 > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear();
          myData[key].po_date = result;

          var grn_date = myData[key].last_grn_date;
          var grn_date = new Date(grn_date);
          var grn_result = "" + (grn_date.getDate() > 9 ? '' : '0') + grn_date.getDate() + '/' + (grn_date.getMonth() + 1 > 9 ? '' : '0') + (grn_date.getMonth() + 1) + '/' + grn_date.getFullYear();
          myData[key].last_grn_date = grn_result;

          var qty = myData[key].qty;
          myData[key].qty = qty.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

          var qty_received = myData[key].qty_received;
          myData[key].qty_received = qty_received.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

          var qty_balance = myData[key].qty_balance;
          myData[key].qty_balance = qty_balance.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

          resultArray.push(myData[key]);
          _this.loading = false;
        }

        _this.searchResults = resultArray;
        if (_this.searchResults.length == 0) {
          _this.loading = false;
          _this.noResults = true;
        }
      }).catch(function (error) {
        return console.log(error);
      });
    },
    setSupplierId: function setSupplierId(obj) {
      var id;

      if (obj !== null) id = obj.id;else id = '';

      this.filter.supplier_id = id;
    },
    getRowCount: function getRowCount(list) {
      return list.length;
    }
  }
});

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Autocomplete_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__functions_common_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pdfmake_build_pdfmake__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pdfmake_build_pdfmake___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_pdfmake_build_pdfmake__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pdfmake_build_vfs_fonts__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pdfmake_build_vfs_fonts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pdfmake_build_vfs_fonts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_json_excel__ = __webpack_require__(12);










__WEBPACK_IMPORTED_MODULE_4_pdfmake_build_pdfmake___default.a.vfs = __WEBPACK_IMPORTED_MODULE_5_pdfmake_build_vfs_fonts___default.a.pdfMake.vfs;
__WEBPACK_IMPORTED_MODULE_4_pdfmake_build_pdfmake___default.a.fonts = {
  "ukai": {
    normal: 'ukai.ttf',
    bold: 'ukai.ttf',
    italics: 'ukai.ttf',
    bolditalics: 'ukai.ttf'
  }
};



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { spinner: __WEBPACK_IMPORTED_MODULE_1__components_Spinner_vue__["a" /* default */], countryLookup: __WEBPACK_IMPORTED_MODULE_2__components_Autocomplete_vue__["a" /* default */], warehouseLookup: __WEBPACK_IMPORTED_MODULE_2__components_Autocomplete_vue__["a" /* default */], exportExcel: __WEBPACK_IMPORTED_MODULE_6_vue_json_excel__["a" /* default */] },
  props: {
    caption: {
      type: String,
      default: 'Table'
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      loading: false,
      apiCountryLookup: __WEBPACK_IMPORTED_MODULE_3__functions_common_vue__["c" /* apiCountryLookup */],
      apiWarehouseLookup: __WEBPACK_IMPORTED_MODULE_3__functions_common_vue__["V" /* apiWarehouseLookup */],
      filter: {
        doc_num: '',
        doc_date: '',
        from_date: '',
        to_date: ''
      },
      exportHeaders: {
        'Trans Date': 'doc_date',
        'Doc #': 'doc_num',
        'From Date': 'from_date',
        'To Date': 'to_date',
        'Expired Date': 'expired_date',
        'SKU': 'product_code',
        'Qty': 'qty',
        'Unit Price': 'unit_price',
        'Total': 'total'
      },
      searchResults: [],
      searchResultsFields: [{ key: 'doc_date', label: 'Doc. Date' }, { key: 'doc_num', label: 'Doc. No' }, { key: 'from_date', label: 'From Date' }, { key: 'to_date', label: 'To Date' }, { key: 'expired_date', label: 'Expired Date' }, { key: 'product_code', label: 'SKU' }, { key: 'product_name', label: 'Product Name' }, { key: 'qty', label: 'Qty' }, { key: 'unit_price', label: 'Unit Price' }, { key: 'total', label: 'Total' }],
      currentPage: 1,
      perPage: 30,
      totalRows: 0,
      noResults: false
    };
  },

  methods: {
    print: function print() {
      var rows = [];
      var row = [];
      var date = new Date();

      rows.push(['Doc. Date', 'Doc. No', 'From Date', 'To Date', 'Expired Date', 'SKU', 'Product Name', 'Qty', 'Uni Price', 'Total']);

      for (var key in this.searchResults) {
        var data = this.searchResults[key];
        row = [data.doc_date, data.doc_num, data.from_date, data.to_date, data.expired_date, data.product_code, data.product_name, data.qty, data.unit_price, data.total];
        rows.push(row);
      }
      var dd = {
        header: { text: 'SRF DO Listing generated on' + " " + date, margin: [5, 7, 10, 30], alignment: 'center', fontSize: 7 },
        pageSize: 'A4',
        pageOrientation: 'portrait',

        pageMargins: [30, 20, 30, 20],
        defaultStyle: {
          font: 'ukai'
        },
        content: [{
          fontSize: 8.5,
          layout: 'lightHorizontalLines',
          table: {
            headerRows: 1,
            widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
            body: rows

          }
        }]
      };

      __WEBPACK_IMPORTED_MODULE_4_pdfmake_build_pdfmake___default.a.createPdf(dd).open();
    },
    search: function search() {
      var _this = this;

      this.loading = true;
      this.submitted = true;
      this.seen = true;
      var sf = ["doc_num LIKE " + this.filter.doc_num, "doc_date = " + this.filter.doc_date, "from_date = " + this.filter.from_date, "to_date = " + this.filter.to_date, "returning_type <> " + 'NON RETURNABLE'];
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__functions_common_vue__["O" /* apiSrfDoListingReport */], sf, Object(__WEBPACK_IMPORTED_MODULE_3__functions_common_vue__["_7" /* authHeader */])()).then(function (res) {
        return res;
      }).then(function (data) {
        var resultArray = [];
        var myData = data.data.data;

        for (var key in myData) {
          var date = myData[key].do_date;
          var date = new Date(date);
          var result = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + (date.getMonth() + 1 > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear();
          myData[key].po_date = result;

          var from_date = myData[key].from_date;
          var from_date = new Date(from_date);
          var from_result = "" + (from_date.getDate() > 9 ? '' : '0') + from_date.getDate() + '/' + (from_date.getMonth() + 1 > 9 ? '' : '0') + (from_date.getMonth() + 1) + '/' + from_date.getFullYear();
          myData[key].from_date = from_result;

          var to_date = myData[key].to_date;
          var to_date = new Date(to_date);
          var to_result = "" + (to_date.getDate() > 9 ? '' : '0') + to_date.getDate() + '/' + (to_date.getMonth() + 1 > 9 ? '' : '0') + (to_date.getMonth() + 1) + '/' + to_date.getFullYear();
          myData[key].to_date = to_result;

          var expired_date = myData[key].expired_date;
          var expired_date = new Date(expired_date);
          var expired_result = "" + (expired_date.getDate() > 9 ? '' : '0') + expired_date.getDate() + '/' + (expired_date.getMonth() + 1 > 9 ? '' : '0') + (expired_date.getMonth() + 1) + '/' + expired_date.getFullYear();
          myData[key].expired_date = expired_result;

          resultArray.push(myData[key]);
          _this.loading = false;
        }

        _this.searchResults = myData;
        if (_this.searchResults.length == 0) {
          _this.loading = false;
          _this.noResults = true;
        }
      }).catch(function (error) {
        return console.log(error);
      });
    },
    setCountry: function setCountry(obj) {
      var id;

      if (obj !== null) {
        id = obj.id;
      } else {
        id = "";
      }
      this.filter.country_id = id;
    },
    setWarehouse: function setWarehouse(obj) {
      var id;

      if (obj !== null) {
        id = obj.id;
      } else {
        id = "";
      }
      this.filter.location_id = id;
    },
    getRowCount: function getRowCount(items) {
      return items.length;
    }
  }
});

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Autocomplete_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__functions_common_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pdfmake_build_pdfmake__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_pdfmake_build_pdfmake___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_pdfmake_build_pdfmake__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pdfmake_build_vfs_fonts__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pdfmake_build_vfs_fonts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pdfmake_build_vfs_fonts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_json_excel__ = __webpack_require__(12);










__WEBPACK_IMPORTED_MODULE_4_pdfmake_build_pdfmake___default.a.vfs = __WEBPACK_IMPORTED_MODULE_5_pdfmake_build_vfs_fonts___default.a.pdfMake.vfs;
__WEBPACK_IMPORTED_MODULE_4_pdfmake_build_pdfmake___default.a.fonts = {
  "ukai": {
    normal: 'ukai.ttf',
    bold: 'ukai.ttf',
    italics: 'ukai.ttf',
    bolditalics: 'ukai.ttf'
  }
};



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { spinner: __WEBPACK_IMPORTED_MODULE_1__components_Spinner_vue__["a" /* default */], countryLookup: __WEBPACK_IMPORTED_MODULE_2__components_Autocomplete_vue__["a" /* default */], warehouseLookup: __WEBPACK_IMPORTED_MODULE_2__components_Autocomplete_vue__["a" /* default */], exportExcel: __WEBPACK_IMPORTED_MODULE_6_vue_json_excel__["a" /* default */] },
  props: {
    caption: {
      type: String,
      default: 'Table'
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      loading: false,
      apiCountryLookup: __WEBPACK_IMPORTED_MODULE_3__functions_common_vue__["c" /* apiCountryLookup */],
      apiWarehouseLookup: __WEBPACK_IMPORTED_MODULE_3__functions_common_vue__["V" /* apiWarehouseLookup */],
      filter: {
        srf_num: '',
        location_id: '',
        doc_num: '',
        from_doc_date: '',
        to_doc_date: ''
      },
      exportHeaders: {
        'Staff ID': 'staff_id',
        'Staff Name': 'staff_name',
        'Doc Date': 'doc_date',
        'Doc #': 'doc_num',
        'SRF #': 'srf_num',
        'Location ID': 'location_id',
        'Event Start Date': 'event_start_date',
        'Event End Date': 'event_end_date',
        'Returnable Type': 'returning_type',
        'Trans Type': 'reason',
        'Reference No': 'reference_num',
        'SKU': 'product_code',
        'Product Name': 'product_name',
        'Unit Price': 'unit_price',
        'SRF Qty': 'srf_qty',
        'SRR Qty': 'srr_qty',
        'Usage Qty': 'usage_qty',
        'Total': 'usage_total_amount',
        'Remarks': 'remarks'
      },
      searchResults: [],
      searchResultsFields: [{ key: 'staff_id', label: 'Staff ID' }, { key: 'staff_name', label: 'Staff Name' }, { key: 'doc_date', label: 'Doc. Date' }, { key: 'doc_num', label: 'Doc. No' }, { key: 'srf_num', label: 'SRF No' }, { key: 'location_id', label: 'Location ID' }, { key: 'event_start_date', label: 'Event Start Date' }, { key: 'event_end_date', label: 'Event End Date' }, { key: 'returning_type', label: 'Returnable Type' }, { key: 'reason', label: 'Trans Type' }, { key: 'reference_num', label: 'Reference No' }, { key: 'product_code', label: 'SKU' }, { key: 'product_name', label: 'Product Name' }, { key: 'unit_price', label: 'Unit Price' }, { key: 'srf_qty', label: 'SRF Qty' }, { key: 'srr_qty', label: 'SRR Qty' }, { key: 'usage_qty', label: 'Usage Qty' }, { key: 'usage_total_amount', label: 'Total' }, { key: 'remarks', label: 'Remarks' }],
      currentPage: 1,
      perPage: 30,
      totalRows: 0,
      noResults: false
    };
  },

  methods: {
    print: function print() {
      var rows = [];
      var row = [];
      var date = new Date();
      rows.push(['Staff ID', 'Staff Name', 'Doc Date', 'Doc No', 'SRF No', 'Location ID', 'Event Start Date', 'Event End Date', 'Returnable Type', 'Trans Type', 'Reference No', 'SKU', 'Product Name', 'Unit Price', 'SRF Qty', 'SRR Qty', 'Usage Qty', 'Total', 'Remarks']);

      for (var key in this.searchResults) {
        var data = this.searchResults[key];
        row = [data.staff_id, data.staff_name, data.doc_date, data.doc_num, data.srf_num, data.location_id, data.event_start_date, data.event_end_date, data.returning_type, data.reason, data.reference_num, data.product_code, data.product_name, data.unit_price, data.srf_qty, data.srr_qty, data.usage_qty, data.usage_total_amount, data.remarks];
        rows.push(row);
      }
      var dd = {
        header: { text: 'SR Usage Listings Report generated on' + " " + date, margin: [5, 7, 10, 30], alignment: 'center', fontSize: 7 },
        pageSize: 'A4',
        pageOrientation: 'landscape',

        pageMargins: [30, 20, 30, 20],
        defaultStyle: {
          font: 'ukai'
        },
        content: [{
          fontSize: 8,
          layout: 'lightHorizontalLines',
          table: {
            headerRows: 1,
            widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
            body: rows
          }
        }]
      };

      __WEBPACK_IMPORTED_MODULE_4_pdfmake_build_pdfmake___default.a.createPdf(dd).open();
    },
    search: function search() {
      var _this = this;

      this.loading = true;
      this.submitted = true;
      this.seen = true;
      var sf = ["doc_num LIKE " + this.filter.doc_num, "doc_date >= " + this.filter.from_doc_date, "doc_date <= " + this.filter.to_doc_date, "location_id = " + this.filter.location_id, "srf_num = " + this.filter.srf_num];
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__functions_common_vue__["L" /* apiSrUsageListingReport */], sf, Object(__WEBPACK_IMPORTED_MODULE_3__functions_common_vue__["_7" /* authHeader */])()).then(function (res) {
        return res;
      }).then(function (data) {
        var resultArray = [];
        var myData = data.data.data;

        for (var key in myData) {
          var docDate = myData[key].doc_date;
          if (docDate != null) {
            docDate = new Date(docDate);
            myData[key].doc_date = "" + (docDate.getDate() > 9 ? '' : '0') + docDate.getDate() + '/' + (docDate.getMonth() + 1 > 9 ? '' : '0') + (docDate.getMonth() + 1) + '/' + docDate.getFullYear();
          } else {
            myData[key].doc_date = "";
          }

          var eventStartDate = myData[key].event_start_date;
          if (eventStartDate != null) {
            eventStartDate = new Date(eventStartDate);
            myData[key].event_start_date = "" + (eventStartDate.getDate() > 9 ? '' : '0') + eventStartDate.getDate() + '/' + (eventStartDate.getMonth() + 1 > 9 ? '' : '0') + (eventStartDate.getMonth() + 1) + '/' + eventStartDate.getFullYear();
          } else {
            myData[key].event_start_date = "";
          }

          var eventEndDate = myData[key].event_end_date;
          if (eventEndDate != null) {
            eventEndDate = new Date(eventEndDate);
            myData[key].event_end_date = "" + (eventEndDate.getDate() > 9 ? '' : '0') + eventEndDate.getDate() + '/' + (eventEndDate.getMonth() + 1 > 9 ? '' : '0') + (eventEndDate.getMonth() + 1) + '/' + eventEndDate.getFullYear();
          } else {
            myData[key].event_end_date = "";
          }

          var srf_qty = myData[key].srf_qty;
          myData[key].srf_qty = srf_qty.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

          var srr_qty = myData[key].srr_qty;
          myData[key].srr_qty = srr_qty.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

          var usage_qty = myData[key].usage_qty;
          myData[key].usage_qty = usage_qty.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

          resultArray.push(myData[key]);
          _this.loading = false;
        }

        _this.searchResults = myData;
        if (_this.searchResults.length == 0) {
          _this.loading = false;
          _this.noResults = true;
        }
      }).catch(function (error) {
        return console.log(error);
      });
    },
    setWarehouse: function setWarehouse(obj) {
      var id;

      if (obj !== null) {
        id = obj.id;
      } else {
        id = "";
      }
      this.filter.location_id = id;
    },
    getRowCount: function getRowCount(items) {
      return items.length;
    }
  }
});

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Spinner_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__functions_common_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Autocomplete_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_json_excel__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pdfmake_build_vfs_fonts__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pdfmake_build_vfs_fonts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_pdfmake_build_vfs_fonts__);












__WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake___default.a.vfs = __WEBPACK_IMPORTED_MODULE_7_pdfmake_build_vfs_fonts___default.a.pdfMake.vfs;
__WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake___default.a.fonts = {
  "ukai": {
    normal: 'ukai.ttf',
    bold: 'ukai.ttf',
    italics: 'ukai.ttf',
    bolditalics: 'ukai.ttf'
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  components: { spinner: __WEBPACK_IMPORTED_MODULE_1__components_Spinner_vue__["a" /* default */], countryLookup: __WEBPACK_IMPORTED_MODULE_3__components_Autocomplete_vue__["a" /* default */], exportExcel: __WEBPACK_IMPORTED_MODULE_5_vue_json_excel__["a" /* default */] },
  props: {
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
      loading: false,
      seen: false,
      searchResults: [],
      apiCountryLookup: __WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["c" /* apiCountryLookup */],
      noResults: false,
      filter: {
        gri_num: '',
        country_id: '',
        date_start: '',
        date_end: ''
      },
      exportHeaders: {
        'Country': 'country_id',
        'Location': 'location_id',
        'Supplier': 'supplier_name',
        'Date': 'gri_date',
        'GRI No': 'gri_num',
        'SKU': 'product_code',
        'Description': 'product_name',
        'Qty': 'qty',
        'Remarks': 'remarks',
        'Created By': 'created_by'
      },
      searchResultsFields: [{ key: 'country_id', label: 'Country' }, { key: 'location_id', label: 'Location' }, { key: 'supplier_name', label: 'Supplier' }, { key: 'gri_date', label: 'Date' }, { key: 'gri_num', label: 'GRI No' }, { key: 'product_code', label: 'SKU' }, { key: 'product_name', label: 'Description' }, { key: 'qty', label: 'Qty' }, { key: 'remarks', label: 'Remarks' }, { key: 'created_by', label: 'Created By' }],
      currentPage: 1,
      perPage: 20,
      totalRows: 0
    }, 'noResults', false);
  },

  methods: {
    print: function print() {
      var rows = [];
      var row = [];
      var date = new Date();
      rows.push(['Country', 'Location', 'Supplier', 'Date', 'GRI No', 'SKU', 'Description', 'Qty', 'Remarks', 'Created By']);

      for (var key in this.searchResults) {
        var data = this.searchResults[key];
        row = [data.country_id, data.location_id, data.supplier_name, data.gri_date, data.gri_num, data.product_code, data.product_name, data.qty, data.remarks, data.created_by];
        rows.push(row);
      }
      var dd = {
        header: { text: 'Goods Return Inwards Details List generated on' + " " + date, margin: [5, 10, 10, 20], alignment: 'center', fontSize: 8 },
        pageSize: 'A4',
        pageOrientation: 'landscape',

        pageMargins: [30, 30, 30, 20],
        defaultStyle: {
          font: 'ukai'
        },
        content: [{
          fontSize: 8,
          layout: 'lightHorizontalLines',
          table: {
            headerRows: 1,
            widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],

            body: rows

          }
        }]
      };

      __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_pdfmake___default.a.createPdf(dd).open();
    },
    getRowCount: function getRowCount(list) {
      return list.length;
    },
    rowClick: function rowClick(item, index) {},
    newGri: function newGri() {
      this.$router.push({ name: 'Goods Return Inwards Entry (GRI)', params: { griNum: '_new' } });
    },
    search: function search() {
      var _this = this;

      this.loading = true;
      this.seen = true;
      var sf = ["gri_num LIKE " + this.filter.gri_num, "country_id = " + this.filter.country_id, "gri_date >= " + this.filter.date_start, "gri_date <= " + this.filter.date_end];
      if (1) {
        __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["k" /* apiGriDetailsSearch */], sf, Object(__WEBPACK_IMPORTED_MODULE_2__functions_common_vue__["_7" /* authHeader */])()).then(function (res) {
          return res;
        }).then(function (data) {
          var resultArray = [];
          var myData = data.data.data;
          for (var key in myData) {
            var date = myData[key].gri_date;
            var date = new Date(date);
            var result = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + (date.getMonth() + 1 > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear();
            myData[key].gri_date = result;
            resultArray.push(myData[key]);
            _this.loading = false;
          }
          _this.searchResults = resultArray;

          if (_this.searchResults.length == 0) {
            _this.loading = false;
            _this.noResults = true;
          }
        }).catch(function (error) {
          return console.log(error);
        });
      }
    },
    setCountry: function setCountry(obj) {
      var id;
      if (obj !== null) {
        id = obj.id;
      } else {
        id = null;
      }
      this.filter.country_id = id;
    }
  }
});

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_pdfmake_build_pdfmake__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_pdfmake_build_pdfmake___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_pdfmake_build_pdfmake__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pdfmake_build_vfs_fonts__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pdfmake_build_vfs_fonts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pdfmake_build_vfs_fonts__);






__WEBPACK_IMPORTED_MODULE_1_pdfmake_build_pdfmake___default.a.vfs = __WEBPACK_IMPORTED_MODULE_2_pdfmake_build_vfs_fonts___default.a.pdfMake.vfs;
__WEBPACK_IMPORTED_MODULE_1_pdfmake_build_pdfmake___default.a.fonts = {
    "ukai": {
        normal: 'ukai.ttf',
        bold: 'ukai.ttf',
        italics: 'ukai.ttf',
        bolditalics: 'ukai.ttf'
    },
    "Garuda": {
        normal: 'Garuda.ttf',
        bold: 'Garuda.ttf',
        italics: 'Garuda.ttf',
        bolditalics: 'Garuda.ttf'
    },
    "Hanumanb": {
        normal: 'Hanumanb.ttf',
        bold: 'Hanumanb.ttf',
        italics: 'Hanumanb.ttf',
        bolditalics: 'Hanumanb.ttf'
    }
};
/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            font: 'ukai',
            country_id: 'OTH',
            countries: ['TH', 'KH', 'OTH']
        };
    },

    methods: {
        printPDF: function printPDF() {

            if (this.country_id == 'TH') {
                this.font = 'Garuda';
            } else if (this.country_id == 'KH') {
                this.font = 'Hanumanb';
            } else {
                this.font = 'ukai';
            }
            var date = new Date();
            var dd = {
                header: { text: 'Test PDF' + " " + date, margin: [5, 10, 10, 30], alignment: 'center', fontSize: 9 },
                pageSize: 'A4',
                pageOrientation: 'portrait',
                defaultStyle: {
                    font: this.font
                },
                pageMargins: [30, 30, 30, 20],
                content: [{
                    fontSize: 9.5,
                    font: 'ukai',
                    text: 'English - Using English Font'
                }, {
                    fontSize: 9.5,
                    font: 'ukai',
                    text: 'Chinese - 漢語 (文章)段 (文章的)段 小新闻 段 段落 短文 短评 节'
                }, {
                    fontSize: 9.5,
                    font: 'Garuda',
                    text: 'Thailand -14000101534 - พระอุดมศักดิ์ ทรัพย์สัณฐิติกุล'
                }, {
                    fontSize: 9.5,
                    font: 'Hanumanb',
                    text: 'Cambodia -  ហ្វ៊ីលនិគ្គហិត'
                }]
            };
            __WEBPACK_IMPORTED_MODULE_1_pdfmake_build_pdfmake___default.a.createPdf(dd).open();
        }
    }
});

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_auth__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__functions_common_vue__ = __webpack_require__(4);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].beforeEach(function (to, from, next) {
  var functionName;
  var authCode;
  var accessToken;

  functionName = to.meta.functionName;
  if (!localStorage.access_token) {
    if (functionName != 'login') {
      next({ path: '/login' });
    } else {
      next();
    }
  } else {
    __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_7__functions_common_vue__["a" /* apiAcl */], {
      accessToken: localStorage.access_token,
      function: functionName
    }, Object(__WEBPACK_IMPORTED_MODULE_7__functions_common_vue__["_7" /* authHeader */])()).then(function (res) {
      var r = res.data;
      if (functionName == 'login') next({ path: '/dashboard' });else {
        if (r.code == "0") {
          localStorage.clear();
          next('/login');
        } else if (r.code == "1") {
          localStorage.setItem("app_role", r.data.app_role);
          next();
        } else if (r.code == "2") {
          alert("You do not have access to selected module " + functionName + "!");
        }
      }
    }).catch(function (error) {
      return alert(error);
    });
  }
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */]
  }
});

/***/ }),
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_input_vue__ = __webpack_require__(73);
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__(380)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_input_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 380 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_file_vue__ = __webpack_require__(74);
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__(388)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_file_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 388 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_modal_vue__ = __webpack_require__(77);
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__(405)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_modal_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 405 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_progress_vue__ = __webpack_require__(82);
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__(427)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_progress_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 427 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_table_vue__ = __webpack_require__(84);
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__(432)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_table_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 432 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(85);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a1bbf32_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(465);
function injectStyle (ssrContext) {
  __webpack_require__(449)
  __webpack_require__(450)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a1bbf32_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 449 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 450 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Full__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Dashboard__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_Login__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_po_pos__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_po_po__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_grn_grns__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_grn_grn__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_gri_gris__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_gri_gri__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_gro_gros__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_gro_gro__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_sm_scm__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_sm_sbr__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_wto_wtos__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_wto_wto__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_wtr_wtrs__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_wtr_wtr__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_wsc_wscs__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_wsc_wsc__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_srf_srfs__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_srf_srf__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__views_srr_srrs__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__views_srr_srr__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__views_san_sans__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__views_san_san__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__views_pod_pods__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__views_wsi_wsis__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__views_wsi_wsi__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__views_wsi_picklistinfo__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__views_stockist_ssrs__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__views_stockist_ssr__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__views_reports_pdr__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__views_reports_pur__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__views_reports_bor__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__views_reports_po_grn_tracking__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__views_reports_srf_do_listing__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__views_reports_sr_usage__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__views_reports_gri_details__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__views_test_pdfTest__ = __webpack_require__(660);































































__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: function scrollBehavior() {
    return { y: 0 };
  },
  routes: [{
    path: '/',
    redirect: '/dashboard',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__containers_Full__["a" /* default */],
    waitForData: true,
    children: [{
      path: 'dashboard',
      name: 'Dashboard',
      component: __WEBPACK_IMPORTED_MODULE_3__views_Dashboard__["a" /* default */],
      meta: { requiresAuth: true, functionName: '' }
    }, {
      path: 'pos',
      name: 'Purchase Orders (POS)',
      component: __WEBPACK_IMPORTED_MODULE_5__views_po_pos__["a" /* default */],
      meta: { requiresAuth: true, functionName: 'po' }

    }, {
      path: '/po/:poNum',
      name: 'Purchase Order (PO)',
      canReuse: false,
      component: __WEBPACK_IMPORTED_MODULE_6__views_po_po__["a" /* default */],
      meta: { requiresAuth: true, functionName: 'po' }
    }, {
      path: 'grns',
      name: 'Goods Receive Note (GRN) With PO',
      component: __WEBPACK_IMPORTED_MODULE_7__views_grn_grns__["a" /* default */],
      meta: { requiresAuth: true, functionName: 'grn' }
    }, {
      path: '/grn/:grnNum',
      name: 'Goods Received Note (GRN)',
      component: __WEBPACK_IMPORTED_MODULE_8__views_grn_grn__["a" /* default */],
      meta: { requiresAuth: true, functionName: 'grn' }
    }, {
      path: '/gro/:groNum',
      name: 'Goods Return Outwards Entry (GRO)',
      component: __WEBPACK_IMPORTED_MODULE_12__views_gro_gro__["a" /* default */],
      meta: { requiresAuth: true, functionName: 'gro' }
    }, {
      path: '/gros',
      name: 'Goods Return Outwards (GROS)',
      component: __WEBPACK_IMPORTED_MODULE_11__views_gro_gros__["a" /* default */],
      meta: { requiresAuth: true, functionName: 'gro' }
    }, {
      path: '/gri/:griNum',
      name: 'Goods Return Inwards Entry (GRI)',
      component: __WEBPACK_IMPORTED_MODULE_10__views_gri_gri__["a" /* default */],
      meta: { requiresAuth: true, functionName: 'gri' }
    }, {
      path: '/gris',
      name: 'Goods Return Inwards (GRIS)',
      component: __WEBPACK_IMPORTED_MODULE_9__views_gri_gris__["a" /* default */],
      meta: { requiresAuth: true, functionName: 'gri' }
    }, {
      path: '/scm',
      name: 'Stock Card Movement (SCM)',
      component: __WEBPACK_IMPORTED_MODULE_13__views_sm_scm__["a" /* default */],
      meta: { requiresAuth: true, functionName: 'scm' }
    }, {
      path: '/sbr',
      name: 'Stock Balance Record (SBR)',
      component: __WEBPACK_IMPORTED_MODULE_14__views_sm_sbr__["a" /* default */],
      meta: { requiresAuth: true, functionName: 'sbr' }
    }, {
      path: '/wto/:wtoNum',
      name: 'Warehouse Transfer Order Entry (WTO)',
      component: __WEBPACK_IMPORTED_MODULE_16__views_wto_wto__["a" /* default */],
      meta: { requiresAuth: true, functionName: 'wto' }
    }, {
      path: 'wtos',
      name: 'Warehouse Transfer Orders (WTOS)',
      component: __WEBPACK_IMPORTED_MODULE_15__views_wto_wtos__["a" /* default */],
      meta: { requiresAuth: true, functionName: 'wto' }
    }, {
      path: 'wtrs',
      name: 'Warehouse Transfer Receivings (WTRS)',
      component: __WEBPACK_IMPORTED_MODULE_17__views_wtr_wtrs__["a" /* default */],
      meta: { requiresAuth: true, functionName: 'wtr' }
    }, {
      path: '/wtr/:wtrNum',
      name: 'Warehouse Transfer Receiving Entry (WTR)',
      component: __WEBPACK_IMPORTED_MODULE_18__views_wtr_wtr__["a" /* default */],
      meta: { requiresAuth: true, functionName: 'wtr' }
    }, {
      path: 'wscs',
      name: 'Sales Cancellations (SCS)',
      component: __WEBPACK_IMPORTED_MODULE_19__views_wsc_wscs__["a" /* default */],
      meta: { requiresAuth: true, functionName: 'wsc' }
    }, {
      path: '/wsc/:wscNum',
      name: 'Sales Cancellation Entry (SC)',
      component: __WEBPACK_IMPORTED_MODULE_20__views_wsc_wsc__["a" /* default */],
      meta: { requiresAuth: true, functionName: 'wsc' }
    }, {
      path: 'srfs',
      name: 'Stock Requisition Forms (SRFS)',
      component: __WEBPACK_IMPORTED_MODULE_21__views_srf_srfs__["a" /* default */],
      meta: { requiresAuth: true, functionName: 'srf' }
    }, {
      path: '/srf/:srfNum',
      name: 'Stock Requisition Form Entry (SRF)',
      component: __WEBPACK_IMPORTED_MODULE_22__views_srf_srf__["a" /* default */],
      meta: { requiresAuth: true, functionName: 'srf' }
    }, {
      path: 'srrs',
      name: 'Stock Requisition Returns (SRRS)',
      component: __WEBPACK_IMPORTED_MODULE_23__views_srr_srrs__["a" /* default */],
      meta: { requiresAuth: true, functionName: 'srr' }
    }, {
      path: '/srr/:srrNum',
      name: 'Stock Requisition Return Entry (SRR)',
      component: __WEBPACK_IMPORTED_MODULE_24__views_srr_srr__["a" /* default */],
      meta: { requiresAuth: true, functionName: 'srr' }
    }, {
      path: 'sans',
      name: 'Stock Adjustment Notes (SANS)',
      component: __WEBPACK_IMPORTED_MODULE_25__views_san_sans__["a" /* default */],
      meta: { requiresAuth: true, functionName: 'san' }
    }, {
      path: '/san/:sanNum',
      name: 'Stock Adjustment Note Entry (SAN)',
      component: __WEBPACK_IMPORTED_MODULE_26__views_san_san__["a" /* default */],
      meta: { requiresAuth: true, functionName: 'san' }
    }, {
      path: 'wsis',
      name: 'Stock Issuance (SI)',
      component: __WEBPACK_IMPORTED_MODULE_28__views_wsi_wsis__["a" /* default */],
      meta: { requiresAuth: true, functionName: 'wsi' }
    }, {
      path: '/wsi/:wsiNum',
      name: 'Stock Issuance Entry',
      component: __WEBPACK_IMPORTED_MODULE_29__views_wsi_wsi__["a" /* default */],
      meta: { requiresAuth: true, functionName: 'wsi' }
    }, {
      path: '/wsi/pickinglist/:picklistNum',
      name: 'Picking List Info',
      component: __WEBPACK_IMPORTED_MODULE_30__views_wsi_picklistinfo__["a" /* default */],
      meta: { requiresAuth: true, functionName: 'wsi' }
    }, {
      path: '/ssrs',
      name: 'Stockist Stock Replenishment',
      component: __WEBPACK_IMPORTED_MODULE_31__views_stockist_ssrs__["a" /* default */],
      meta: { requiresAuth: true, functionName: 'wsi' }
    }, {
      path: '/pods',
      name: 'Proof Of Delivery (POD)',
      component: __WEBPACK_IMPORTED_MODULE_27__views_pod_pods__["a" /* default */],
      meta: { requiresAuth: true, functionName: 'pod' }
    }, {
      path: '/pdr',
      name: 'Product Delivered Report',
      component: __WEBPACK_IMPORTED_MODULE_33__views_reports_pdr__["a" /* default */],
      meta: { requiresAuth: true, functionName: 'pdr' }
    }, {
      path: '/pdf',
      name: 'Generate PDF',
      component: __WEBPACK_IMPORTED_MODULE_40__views_test_pdfTest__["a" /* default */],
      meta: { requiresAuth: true, functionName: 'pdr' }
    }, {
      path: '/pur',
      name: 'Product Un-Delivered Report',
      component: __WEBPACK_IMPORTED_MODULE_34__views_reports_pur__["a" /* default */],
      meta: { requiresAuth: true, functionName: 'pur' }
    }, {
      path: '/bor',
      name: 'Back Order Report',
      component: __WEBPACK_IMPORTED_MODULE_35__views_reports_bor__["a" /* default */],
      meta: { requiresAuth: true, functionName: 'bor' }
    }, {
      path: '/po_grn_tracking',
      name: 'PO & GRN Tracking Report',
      component: __WEBPACK_IMPORTED_MODULE_36__views_reports_po_grn_tracking__["a" /* default */],
      meta: { requiresAuth: true, functionName: 'po_grn_tracking' }
    }, {
      path: '/srf_do_listing',
      name: 'SRF DO Listing Report',
      component: __WEBPACK_IMPORTED_MODULE_37__views_reports_srf_do_listing__["a" /* default */],
      meta: { requiresAuth: true, functionName: 'srf_do_listing' }
    }, {
      path: '/sr_usage',
      name: 'SRF Usage Report',
      component: __WEBPACK_IMPORTED_MODULE_38__views_reports_sr_usage__["a" /* default */],
      meta: { requiresAuth: true, functionName: 'sr_usage' }
    }, {
      path: '/gri_details',
      name: 'GRI Details Report',
      component: __WEBPACK_IMPORTED_MODULE_39__views_reports_gri_details__["a" /* default */],
      meta: { requiresAuth: true, functionName: 'gri_details' }
    }]
  }, {
    path: '/login',
    name: 'login',
    component: __WEBPACK_IMPORTED_MODULE_4__views_Login__["a" /* default */],
    meta: { requiresAuth: false, functionName: 'login' }
  }]
}));

/***/ }),
/* 467 */,
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue__ = __webpack_require__(97);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03c01bc1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Full_vue__ = __webpack_require__(521);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03c01bc1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Full_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  items: [{
    name: 'Dashboard',
    visible: 1,
    url: '/dashboard',
    icon: 'icon-speedometer',
    badge: {
      variant: 'primary'
    }
  }, {
    name: 'Purchase',
    visible: 0,
    icon: 'icon-basket-loaded',
    children: [{
      name: 'Purchase Orders',
      visible: 0,
      url: '/pos'
    }, {
      name: 'Goods Receive Note',
      visible: 0,
      url: '/grns'
    }]
  }, {
    name: 'Warehouse',
    visible: 0,
    icon: 'icon-drawer',
    children: [{
      name: 'Transfer Order',
      visible: 0,
      url: '/wtos'
    }, {
      name: 'Transfer Receiving',
      visible: 0,
      url: '/wtrs'
    }, {
      name: 'Stock Requisition Form',
      visible: 0,
      url: '/srfs'
    }, {
      name: 'Stock Requisition Return',
      visible: 0,
      url: '/srrs'
    }, {
      name: 'Stock Issuance',
      visible: 0,
      url: '/wsis'
    }, {
      name: 'Sales Cancellation',
      visible: 0,
      url: '/wscs'
    }, {
      name: 'Stock Adjustment Note',
      visible: 0,
      url: '/sans'
    }, {
      name: 'Goods Return Outwards',
      visible: 0,
      url: '/gros'
    }, {
      name: 'Goods Return Inwards',
      visible: 0,
      url: '/gris'
    }]
  }, {
    name: 'Stock Enquiry',
    visible: 0,
    icon: 'icon-puzzle',
    children: [{
      name: 'Stock Card Movement',
      visible: 0,
      url: '/scm'
    }, {
      name: 'Stock Balance Record',
      visible: 0,
      url: '/sbr'
    }]
  }, {
    name: 'Proof Of Delivery',
    visible: 0,
    url: '/pods',
    icon: 'icon-wallet'
  }, {
    name: 'Reports',
    visible: 0,
    icon: 'icon-docs',
    children: [{
      name: 'Product Delivered Report',
      visible: 0,
      url: '/pdr'
    }, {
      name: 'Product Un-Delivered Report',
      visible: 0,
      url: '/pur'
    }, {
      name: 'Back Order Report',
      visible: 0,
      url: '/bor'
    }, {
      name: 'PO & GRN Tracking Reports',
      visible: 0,
      url: '/po_grn_tracking'
    }, {
      name: 'SRF DO Listing Report',
      visible: 0,
      url: '/srf_do_listing'
    }, {
      name: 'SR Usage Report',
      visible: 0,
      url: '/sr_usage'
    }, {
      name: 'GRI Details Report',
      visible: 0,
      url: '/gri_details'
    }]
  }]
});

if (localStorage.auth_acl) {
  var acl = localStorage.auth_acl.split(',');
  var items, n, vc;

  items = this.a.items[1];
  items.children[0].visible = acl.indexOf('po') + 1 || acl.indexOf('*') + 1;
  items.children[1].visible = acl.indexOf('grn') + 1 || acl.indexOf('*') + 1;
  for (n = 0, vc = 0; n < items.children.length; n++) {
    if (items.children[n].visible) vc++;
  }items.visible = vc > 0 || acl.indexOf('*') + 1;

  items = this.a.items[2];
  items.children[0].visible = acl.indexOf('wto') + 1 || acl.indexOf('*') + 1;
  items.children[1].visible = acl.indexOf('wtr') + 1 || acl.indexOf('*') + 1;
  items.children[2].visible = acl.indexOf('srf') + 1 || acl.indexOf('*') + 1;
  items.children[3].visible = acl.indexOf('srr') + 1 || acl.indexOf('*') + 1;
  items.children[4].visible = acl.indexOf('wsi') + 1 || acl.indexOf('*') + 1;
  items.children[5].visible = acl.indexOf('wsc') + 1 || acl.indexOf('*') + 1;
  items.children[6].visible = acl.indexOf('san') + 1 || acl.indexOf('*') + 1;
  items.children[7].visible = acl.indexOf('gro') + 1 || acl.indexOf('*') + 1;
  items.children[8].visible = acl.indexOf('gri') + 1 || acl.indexOf('*') + 1;
  for (n = 0, vc = 0; n < items.children.length; n++) {
    if (items.children[n].visible) vc++;
  }items.visible = vc > 0 || acl.indexOf('*') + 1;

  items = this.a.items[3];
  items.children[0].visible = acl.indexOf('scm') + 1 || acl.indexOf('*') + 1;
  items.children[1].visible = acl.indexOf('sbr') + 1 || acl.indexOf('*') + 1;
  for (n = 0, vc = 0; n < items.children.length; n++) {
    if (items.children[n].visible) vc++;
  }items.visible = vc > 0 || acl.indexOf('*') + 1;

  this.a.items[4].visible = acl.indexOf('pod') + 1 || acl.indexOf('*') + 1;

  items = this.a.items[5];
  items.children[0].visible = acl.indexOf('pdr') + 1 || acl.indexOf('*') + 1;
  items.children[1].visible = acl.indexOf('pur') + 1 || acl.indexOf('*') + 1;
  items.children[2].visible = acl.indexOf('bor') + 1 || acl.indexOf('*') + 1;
  items.children[3].visible = acl.indexOf('po_grn_tracking') + 1 || acl.indexOf('*') + 1;
  items.children[4].visible = acl.indexOf('srf_do_listing') + 1 || acl.indexOf('*') + 1;
  items.children[5].visible = acl.indexOf('sr_usage') + 1 || acl.indexOf('*') + 1;
  items.children[6].visible = acl.indexOf('gri_details') + 1 || acl.indexOf('*') + 1;

  for (n = 0, vc = 0; n < items.children.length; n++) {
    if (items.children[n].visible) vc++;
  }items.visible = vc > 0 || acl.indexOf('*') + 1;
}

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aside_vue__ = __webpack_require__(99);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_523945b7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Aside_vue__ = __webpack_require__(473);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Aside_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_523945b7_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Aside_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classList},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:_vm.classList},[_c('input',{staticClass:"switch-input",attrs:{"type":"checkbox"},domProps:{"value":_vm.value,"checked":_vm.isChecked},on:{"change":_vm.handleChange}}),_vm._v(" "),(_vm.isOn)?[_c('span',{staticClass:"switch-label",attrs:{"data-on":_vm.on,"data-off":_vm.off}})]:[_c('span',{staticClass:"switch-label"})],_vm._v(" "),_c('span',{staticClass:"switch-handle"})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"aside-menu"},[_c('b-tabs',[_c('b-tab',{attrs:{"title":"<i class='icon-list'></i>"}},[_c('Callout',{staticClass:"m-0 py-2 text-muted text-center bg-light text-uppercase"},[_c('small',[_c('b',[_vm._v("Today")])])]),_vm._v(" "),_c('hr',{staticClass:"transparent mx-3 my-0"}),_vm._v(" "),_c('Callout',{staticClass:"m-0 py-3",attrs:{"variant":"warning"}},[_c('div',{staticClass:"avatar float-right"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/7.jpg","alt":"admin@bootstrapmaster.com"}})]),_vm._v(" "),_c('div',[_vm._v("Meeting with "),_c('strong',[_vm._v("Lucas")])]),_vm._v(" "),_c('small',{staticClass:"text-muted mr-3"},[_c('i',{staticClass:"icon-calendar"}),_vm._v("  1 - 3pm")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_c('i',{staticClass:"icon-location-pin"}),_vm._v("  Palo Alto, CA ")])]),_vm._v(" "),_c('hr',{staticClass:"mx-3 my-0"}),_vm._v(" "),_c('Callout',{staticClass:"m-0 py-3",attrs:{"variant":"info"}},[_c('div',{staticClass:"avatar float-right"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/4.jpg","alt":"admin@bootstrapmaster.com"}})]),_vm._v(" "),_c('div',[_vm._v("Skype with "),_c('strong',[_vm._v("Megan")])]),_vm._v(" "),_c('small',{staticClass:"text-muted mr-3"},[_c('i',{staticClass:"icon-calendar"}),_vm._v("  4 - 5pm")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_c('i',{staticClass:"icon-social-skype"}),_vm._v("  On-line ")])]),_vm._v(" "),_c('hr',{staticClass:"transparent mx-3 my-0"}),_vm._v(" "),_c('Callout',{staticClass:"m-0 py-2 text-muted text-center bg-light text-uppercase"},[_c('small',[_c('b',[_vm._v("Tomorrow")])])]),_vm._v(" "),_c('hr',{staticClass:"transparent mx-3 my-0"}),_vm._v(" "),_c('Callout',{staticClass:"m-0 py-3",attrs:{"variant":"danger"}},[_c('div',[_vm._v("New UI Project - "),_c('strong',[_vm._v("deadline")])]),_vm._v(" "),_c('small',{staticClass:"text-muted mr-3"},[_c('i',{staticClass:"icon-calendar"}),_vm._v("  10 - 11pm")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_c('i',{staticClass:"icon-home"}),_vm._v("  creativeLabs HQ ")]),_vm._v(" "),_c('div',{staticClass:"avatars-stack mt-2"},[_c('div',{staticClass:"avatar avatar-xs"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/2.jpg","alt":"admin@bootstrapmaster.com"}})]),_vm._v(" "),_c('div',{staticClass:"avatar avatar-xs"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/3.jpg","alt":"admin@bootstrapmaster.com"}})]),_vm._v(" "),_c('div',{staticClass:"avatar avatar-xs"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/4.jpg","alt":"admin@bootstrapmaster.com"}})]),_vm._v(" "),_c('div',{staticClass:"avatar avatar-xs"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/5.jpg","alt":"admin@bootstrapmaster.com"}})]),_vm._v(" "),_c('div',{staticClass:"avatar avatar-xs"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/6.jpg","alt":"admin@bootstrapmaster.com"}})])])]),_vm._v(" "),_c('hr',{staticClass:"mx-3 my-0"}),_vm._v(" "),_c('Callout',{staticClass:"m-0 py-3",attrs:{"variant":"success"}},[_c('div',[_c('strong',[_vm._v("#10 Startups.Garden")]),_vm._v(" Meetup")]),_vm._v(" "),_c('small',{staticClass:"text-muted mr-3"},[_c('i',{staticClass:"icon-calendar"}),_vm._v("  1 - 3pm")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_c('i',{staticClass:"icon-location-pin"}),_vm._v("  Palo Alto, CA ")])]),_vm._v(" "),_c('hr',{staticClass:"mx-3 my-0"}),_vm._v(" "),_c('Callout',{staticClass:"m-0 py-3",attrs:{"variant":"primary"}},[_c('div',[_c('strong',[_vm._v("Team meeting")])]),_vm._v(" "),_c('small',{staticClass:"text-muted mr-3"},[_c('i',{staticClass:"icon-calendar"}),_vm._v("  4 - 6pm")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_c('i',{staticClass:"icon-home"}),_vm._v("  creativeLabs HQ ")]),_vm._v(" "),_c('div',{staticClass:"avatars-stack mt-2"},[_c('div',{staticClass:"avatar avatar-xs"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/2.jpg","alt":"admin@bootstrapmaster.com"}})]),_vm._v(" "),_c('div',{staticClass:"avatar avatar-xs"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/3.jpg","alt":"admin@bootstrapmaster.com"}})]),_vm._v(" "),_c('div',{staticClass:"avatar avatar-xs"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/4.jpg","alt":"admin@bootstrapmaster.com"}})]),_vm._v(" "),_c('div',{staticClass:"avatar avatar-xs"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/5.jpg","alt":"admin@bootstrapmaster.com"}})]),_vm._v(" "),_c('div',{staticClass:"avatar avatar-xs"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/6.jpg","alt":"admin@bootstrapmaster.com"}})]),_vm._v(" "),_c('div',{staticClass:"avatar avatar-xs"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/7.jpg","alt":"admin@bootstrapmaster.com"}})]),_vm._v(" "),_c('div',{staticClass:"avatar avatar-xs"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/8.jpg","alt":"admin@bootstrapmaster.com"}})])])]),_vm._v(" "),_c('hr',{staticClass:"mx-3 my-0"})],1),_vm._v(" "),_c('b-tab',{attrs:{"title":"<i class='icon-speech'></i>"}},[_c('div',{staticClass:"p-3"},[_c('div',{staticClass:"message"},[_c('div',{staticClass:"py-3 pb-5 mr-3 float-left"},[_c('div',{staticClass:"avatar"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/7.jpg","alt":"admin@bootstrapmaster.com"}}),_vm._v(" "),_c('b-badge',{staticClass:"avatar-status",attrs:{"variant":"success"}})],1)]),_vm._v(" "),_c('div',[_c('small',{staticClass:"text-muted"},[_vm._v("Lukasz Holeczek")]),_vm._v(" "),_c('small',{staticClass:"text-muted float-right mt-1"},[_vm._v("1:52 PM")])]),_vm._v(" "),_c('div',{staticClass:"text-truncate font-weight-bold"},[_vm._v("Lorem ipsum dolor sit amet")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"message"},[_c('div',{staticClass:"py-3 pb-5 mr-3 float-left"},[_c('div',{staticClass:"avatar"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/7.jpg","alt":"admin@bootstrapmaster.com"}}),_vm._v(" "),_c('b-badge',{staticClass:"avatar-status",attrs:{"variant":"success"}})],1)]),_vm._v(" "),_c('div',[_c('small',{staticClass:"text-muted"},[_vm._v("Lukasz Holeczek")]),_vm._v(" "),_c('small',{staticClass:"text-muted float-right mt-1"},[_vm._v("1:52 PM")])]),_vm._v(" "),_c('div',{staticClass:"text-truncate font-weight-bold"},[_vm._v("Lorem ipsum dolor sit amet")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"message"},[_c('div',{staticClass:"py-3 pb-5 mr-3 float-left"},[_c('div',{staticClass:"avatar"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/7.jpg","alt":"admin@bootstrapmaster.com"}}),_vm._v(" "),_c('b-badge',{staticClass:"avatar-status",attrs:{"variant":"success"}})],1)]),_vm._v(" "),_c('div',[_c('small',{staticClass:"text-muted"},[_vm._v("Lukasz Holeczek")]),_vm._v(" "),_c('small',{staticClass:"text-muted float-right mt-1"},[_vm._v("1:52 PM")])]),_vm._v(" "),_c('div',{staticClass:"text-truncate font-weight-bold"},[_vm._v("Lorem ipsum dolor sit amet")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"message"},[_c('div',{staticClass:"py-3 pb-5 mr-3 float-left"},[_c('div',{staticClass:"avatar"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/7.jpg","alt":"admin@bootstrapmaster.com"}}),_vm._v(" "),_c('b-badge',{staticClass:"avatar-status",attrs:{"variant":"success"}})],1)]),_vm._v(" "),_c('div',[_c('small',{staticClass:"text-muted"},[_vm._v("Lukasz Holeczek")]),_vm._v(" "),_c('small',{staticClass:"text-muted float-right mt-1"},[_vm._v("1:52 PM")])]),_vm._v(" "),_c('div',{staticClass:"text-truncate font-weight-bold"},[_vm._v("Lorem ipsum dolor sit amet")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...")])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"message"},[_c('div',{staticClass:"py-3 pb-5 mr-3 float-left"},[_c('div',{staticClass:"avatar"},[_c('img',{staticClass:"img-avatar",attrs:{"src":"static/img/avatars/7.jpg","alt":"admin@bootstrapmaster.com"}}),_vm._v(" "),_c('b-badge',{staticClass:"avatar-status",attrs:{"variant":"success"}})],1)]),_vm._v(" "),_c('div',[_c('small',{staticClass:"text-muted"},[_vm._v("Lukasz Holeczek")]),_vm._v(" "),_c('small',{staticClass:"text-muted float-right mt-1"},[_vm._v("1:52 PM")])]),_vm._v(" "),_c('div',{staticClass:"text-truncate font-weight-bold"},[_vm._v("Lorem ipsum dolor sit amet")]),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...")])])])]),_vm._v(" "),_c('b-tab',{attrs:{"title":"<i class='icon-settings'></i>"}},[_c('div',{staticClass:"p-3"},[_c('h6',[_vm._v("Settings")]),_vm._v(" "),_c('div',{staticClass:"aside-options"},[_c('div',{staticClass:"clearfix mt-4"},[_c('small',[_c('b',[_vm._v("Option 1")])]),_vm._v(" "),_c('c-switch',{staticClass:"float-right",attrs:{"type":"text","variant":"success","on":"on","off":"off","pill":true,"size":"sm","checked":true}})],1),_vm._v(" "),_c('div',[_c('small',{staticClass:"text-muted"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.")])])]),_vm._v(" "),_c('div',{staticClass:"aside-options"},[_c('div',{staticClass:"clearfix mt-3"},[_c('small',[_c('b',[_vm._v("Option 2")])]),_vm._v(" "),_c('c-switch',{staticClass:"float-right",attrs:{"type":"text","variant":"success","on":"on","off":"off","pill":true,"size":"sm"}})],1),_vm._v(" "),_c('div',[_c('small',{staticClass:"text-muted"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.")])])]),_vm._v(" "),_c('div',{staticClass:"aside-options"},[_c('div',{staticClass:"clearfix mt-3"},[_c('small',[_c('b',[_vm._v("Option 3")])]),_vm._v(" "),_c('c-switch',{staticClass:"float-right",attrs:{"type":"text","variant":"success","on":"on","off":"off","pill":true,"size":"sm"}})],1)]),_vm._v(" "),_c('div',{staticClass:"aside-options"},[_c('div',{staticClass:"clearfix mt-3"},[_c('small',[_c('b',[_vm._v("Option 4")])]),_vm._v(" "),_c('c-switch',{staticClass:"float-right",attrs:{"type":"text","variant":"success","on":"on","off":"off","pill":true,"size":"sm","checked":true}})],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h6',[_vm._v("System Utilization")]),_vm._v(" "),_c('div',{staticClass:"text-uppercase mb-1 mt-4"},[_c('small',[_c('b',[_vm._v("CPU Usage")])])]),_vm._v(" "),_c('b-progress',{staticClass:"progress-xs",attrs:{"height":"{}","variant":"info","value":25}}),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("348 Processes. 1/4 Cores.")]),_vm._v(" "),_c('div',{staticClass:"text-uppercase mb-1 mt-2"},[_c('small',[_c('b',[_vm._v("Memory Usage")])])]),_vm._v(" "),_c('b-progress',{staticClass:"progress-xs",attrs:{"height":"{}","variant":"warning","value":70}}),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("11444GB/16384MB")]),_vm._v(" "),_c('div',{staticClass:"text-uppercase mb-1 mt-2"},[_c('small',[_c('b',[_vm._v("SSD 1 Usage")])])]),_vm._v(" "),_c('b-progress',{staticClass:"progress-xs",attrs:{"height":"{}","variant":"danger","value":95}}),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("243GB/256GB")]),_vm._v(" "),_c('div',{staticClass:"text-uppercase mb-1 mt-2"},[_c('small',[_c('b',[_vm._v("SSD 2 Usage")])])]),_vm._v(" "),_c('b-progress',{staticClass:"progress-xs",attrs:{"height":"{}","variant":"success","value":10}}),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v("25GB/256GB")])],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__ = __webpack_require__(103);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c62087c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__ = __webpack_require__(475);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c62087c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"breadcrumb"},_vm._l((_vm.list),function(item,index){return _c('li',{staticClass:"breadcrumb-item"},[(_vm.isLast(index))?_c('span',{staticClass:"active"},[_vm._v(_vm._s(_vm.showName(item)))]):_c('router-link',{attrs:{"to":item}},[_vm._v(_vm._s(_vm.showName(item)))])],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__(104);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d7fc8ac_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__(477);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d7fc8ac_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"app-footer"},[_c('span',[_c('a',{attrs:{"href":"http://www.sage9.com/"}},[_vm._v("Sage9 Pte Ltd")]),_vm._v(" © 2018")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__(105);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_df05bafa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__(481);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_df05bafa_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderDropdown_vue__ = __webpack_require__(106);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fd31bcc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderDropdown_vue__ = __webpack_require__(480);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fd31bcc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderDropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding-right":"20px"}},[_c('button',{staticClass:"btn btn-danger",on:{"click":function($event){_vm.logout()}}},[_vm._v("Logout")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"app-header navbar"},[_c('button',{staticClass:"navbar-toggler mobile-sidebar-toggler d-lg-none",attrs:{"type":"button"},on:{"click":_vm.mobileSidebarToggle}},[_c('span',{staticClass:"navbar-toggler-icon"})]),_vm._v(" "),_c('b-link',{staticClass:"navbar-brand",attrs:{"to":"#"}}),_vm._v(" "),_c('button',{staticClass:"navbar-toggler sidebar-toggler d-md-down-none mr-auto",attrs:{"type":"button"},on:{"click":_vm.sidebarToggle}},[_c('span',{staticClass:"navbar-toggler-icon"}),_vm._v(" "),_c('b',[_vm._v(" Elken Inventory Management System")])]),_vm._v(" "),_c('b-navbar-nav',{staticClass:"ml-auto"},[_c('HeaderDropdown')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__(107);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_548f493c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__(520);
function injectStyle (ssrContext) {
  __webpack_require__(483)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_548f493c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 483 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarFooter_vue__ = __webpack_require__(108);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_419727a5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarFooter_vue__ = __webpack_require__(485);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_419727a5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarForm_vue__ = __webpack_require__(109);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bed3424_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarForm_vue__ = __webpack_require__(487);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bed3424_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarHeader_vue__ = __webpack_require__(110);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a0777a52_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarHeader_vue__ = __webpack_require__(489);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a0777a52_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarMinimizer_vue__ = __webpack_require__(111);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a5c6b7ae_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarMinimizer_vue__ = __webpack_require__(491);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarMinimizer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a5c6b7ae_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarMinimizer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"sidebar-minimizer",attrs:{"type":"button"},on:{"click":function($event){_vm.sidebarMinimize();_vm.brandMinimize()}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDivider_vue__ = __webpack_require__(112);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d1c2ccd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDivider_vue__ = __webpack_require__(511);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDivider_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d1c2ccd_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDivider_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDropdown_vue__ = __webpack_require__(114);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_536afe98_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDropdown_vue__ = __webpack_require__(513);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_536afe98_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"nav-item nav-dropdown",attrs:{"tag":"li","to":_vm.url,"disabled":""}},[_c('div',{staticClass:"nav-link nav-dropdown-toggle",on:{"click":_vm.handleClick}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name))]),_vm._v(" "),_c('ul',{staticClass:"nav-dropdown-items"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isExternalLink)?_c('div',[_c('a',{class:_vm.classList,attrs:{"href":_vm.url}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name)+"\n    "),(_vm.badge && _vm.badge.text)?_c('b-badge',{attrs:{"variant":_vm.badge.variant}},[_vm._v(_vm._s(_vm.badge.text))]):_vm._e()],1)]):_c('div',[_c('router-link',{class:_vm.classList,attrs:{"to":_vm.url}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name)+"\n    "),(_vm.badge && _vm.badge.text)?_c('b-badge',{attrs:{"variant":_vm.badge.variant}},[_vm._v(_vm._s(_vm.badge.text))]):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavTitle_vue__ = __webpack_require__(117);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f92ee61_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavTitle_vue__ = __webpack_require__(516);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavTitle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f92ee61_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavTitle_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList},[(_vm.wrapper && _vm.wrapper.element)?[_c(_vm.wrapper.element,_vm._b({tag:"component"},'component',_vm.wrapper.attributes,false),[_vm._v("\n      "+_vm._s(_vm.name)+"\n    ")])]:[_vm._v("\n    "+_vm._s(_vm.name)+"\n  ")]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList,on:{"click":_vm.hideMobile}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLabel_vue__ = __webpack_require__(120);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52cff4be_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLabel_vue__ = __webpack_require__(519);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLabel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52cff4be_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLabel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SidebarNavItem',{attrs:{"classes":_vm.classList.navItem}},[_c('a',{class:_vm.classList.navLink,attrs:{"href":_vm.url}},[_c('i',{class:_vm.classList.icon}),_vm._v(" "+_vm._s(_vm.name))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar"},[_c('SidebarHeader'),_vm._v(" "),_c('SidebarForm'),_vm._v(" "),_c('nav',{staticClass:"sidebar-nav"},[_c('div',{attrs:{"slot":"header"},slot:"header"}),_vm._v(" "),_c('ul',{staticClass:"nav"},[_vm._l((_vm.navItems),function(item,index){return (item.visible)?[(item.title)?[_c('SidebarNavTitle',{attrs:{"name":item.name,"classes":item.class,"wrapper":item.wrapper}})]:(item.divider)?[_c('SidebarNavDivider',{attrs:{"classes":item.class}})]:(item.label)?[_c('SidebarNavLabel',{attrs:{"name":item.name,"url":item.url,"icon":item.icon,"label":item.label,"classes":item.class}})]:[(item.children)?[_c('SidebarNavDropdown',{attrs:{"name":item.name,"url":item.url,"icon":item.icon}},[_vm._l((item.children),function(childL1,index){return (childL1.visible)?[(childL1.children)?[_c('SidebarNavDropdown',{attrs:{"name":childL1.name,"url":childL1.url,"icon":childL1.icon,"toggle":_vm.open}},_vm._l((childL1.children),function(childL2,index){return _c('li',{staticClass:"nav-item"},[_c('SidebarNavLink',{attrs:{"name":childL2.name,"url":childL2.url,"icon":childL2.icon,"badge":childL2.badge,"variant":item.variant}})],1)}))]:[_c('SidebarNavItem',{attrs:{"classes":item.class}},[_c('SidebarNavLink',{attrs:{"name":childL1.name,"url":childL1.url,"icon":childL1.icon,"badge":childL1.badge,"variant":item.variant}})],1)]]:_vm._e()})],2)]:[_c('SidebarNavItem',{attrs:{"classes":item.class}},[_c('SidebarNavLink',{attrs:{"name":item.name,"url":item.url,"icon":item.icon,"badge":item.badge,"variant":item.variant}})],1)]]]:_vm._e()})],2),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),_c('SidebarFooter'),_vm._v(" "),_c('SidebarMinimizer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('AppHeader'),_vm._v(" "),_c('div',{staticClass:"app-body"},[_c('Sidebar',{attrs:{"navItems":_vm.nav}}),_vm._v(" "),_c('main',{staticClass:"main"},[_c('breadcrumb',{attrs:{"list":_vm.list}}),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('router-view')],1)],1),_vm._v(" "),_c('AppAside')],1),_vm._v(" "),_c('AppFooter')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__(121);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_723146c4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__(545);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_723146c4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardLine1ChartExample_vue__ = __webpack_require__(122);
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardLine1ChartExample_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 524 */,
/* 525 */,
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 123,
	"./af.js": 123,
	"./ar": 124,
	"./ar-dz": 125,
	"./ar-dz.js": 125,
	"./ar-kw": 126,
	"./ar-kw.js": 126,
	"./ar-ly": 127,
	"./ar-ly.js": 127,
	"./ar-ma": 128,
	"./ar-ma.js": 128,
	"./ar-sa": 129,
	"./ar-sa.js": 129,
	"./ar-tn": 130,
	"./ar-tn.js": 130,
	"./ar.js": 124,
	"./az": 131,
	"./az.js": 131,
	"./be": 132,
	"./be.js": 132,
	"./bg": 133,
	"./bg.js": 133,
	"./bm": 134,
	"./bm.js": 134,
	"./bn": 135,
	"./bn-bd": 136,
	"./bn-bd.js": 136,
	"./bn.js": 135,
	"./bo": 137,
	"./bo.js": 137,
	"./br": 138,
	"./br.js": 138,
	"./bs": 139,
	"./bs.js": 139,
	"./ca": 140,
	"./ca.js": 140,
	"./cs": 141,
	"./cs.js": 141,
	"./cv": 142,
	"./cv.js": 142,
	"./cy": 143,
	"./cy.js": 143,
	"./da": 144,
	"./da.js": 144,
	"./de": 145,
	"./de-at": 146,
	"./de-at.js": 146,
	"./de-ch": 147,
	"./de-ch.js": 147,
	"./de.js": 145,
	"./dv": 148,
	"./dv.js": 148,
	"./el": 149,
	"./el.js": 149,
	"./en-au": 150,
	"./en-au.js": 150,
	"./en-ca": 151,
	"./en-ca.js": 151,
	"./en-gb": 152,
	"./en-gb.js": 152,
	"./en-ie": 153,
	"./en-ie.js": 153,
	"./en-il": 154,
	"./en-il.js": 154,
	"./en-in": 155,
	"./en-in.js": 155,
	"./en-nz": 156,
	"./en-nz.js": 156,
	"./en-sg": 157,
	"./en-sg.js": 157,
	"./eo": 158,
	"./eo.js": 158,
	"./es": 159,
	"./es-do": 160,
	"./es-do.js": 160,
	"./es-mx": 161,
	"./es-mx.js": 161,
	"./es-us": 162,
	"./es-us.js": 162,
	"./es.js": 159,
	"./et": 163,
	"./et.js": 163,
	"./eu": 164,
	"./eu.js": 164,
	"./fa": 165,
	"./fa.js": 165,
	"./fi": 166,
	"./fi.js": 166,
	"./fil": 167,
	"./fil.js": 167,
	"./fo": 168,
	"./fo.js": 168,
	"./fr": 169,
	"./fr-ca": 170,
	"./fr-ca.js": 170,
	"./fr-ch": 171,
	"./fr-ch.js": 171,
	"./fr.js": 169,
	"./fy": 172,
	"./fy.js": 172,
	"./ga": 173,
	"./ga.js": 173,
	"./gd": 174,
	"./gd.js": 174,
	"./gl": 175,
	"./gl.js": 175,
	"./gom-deva": 176,
	"./gom-deva.js": 176,
	"./gom-latn": 177,
	"./gom-latn.js": 177,
	"./gu": 178,
	"./gu.js": 178,
	"./he": 179,
	"./he.js": 179,
	"./hi": 180,
	"./hi.js": 180,
	"./hr": 181,
	"./hr.js": 181,
	"./hu": 182,
	"./hu.js": 182,
	"./hy-am": 183,
	"./hy-am.js": 183,
	"./id": 184,
	"./id.js": 184,
	"./is": 185,
	"./is.js": 185,
	"./it": 186,
	"./it-ch": 187,
	"./it-ch.js": 187,
	"./it.js": 186,
	"./ja": 188,
	"./ja.js": 188,
	"./jv": 189,
	"./jv.js": 189,
	"./ka": 190,
	"./ka.js": 190,
	"./kk": 191,
	"./kk.js": 191,
	"./km": 192,
	"./km.js": 192,
	"./kn": 193,
	"./kn.js": 193,
	"./ko": 194,
	"./ko.js": 194,
	"./ku": 195,
	"./ku.js": 195,
	"./ky": 196,
	"./ky.js": 196,
	"./lb": 197,
	"./lb.js": 197,
	"./lo": 198,
	"./lo.js": 198,
	"./lt": 199,
	"./lt.js": 199,
	"./lv": 200,
	"./lv.js": 200,
	"./me": 201,
	"./me.js": 201,
	"./mi": 202,
	"./mi.js": 202,
	"./mk": 203,
	"./mk.js": 203,
	"./ml": 204,
	"./ml.js": 204,
	"./mn": 205,
	"./mn.js": 205,
	"./mr": 206,
	"./mr.js": 206,
	"./ms": 207,
	"./ms-my": 208,
	"./ms-my.js": 208,
	"./ms.js": 207,
	"./mt": 209,
	"./mt.js": 209,
	"./my": 210,
	"./my.js": 210,
	"./nb": 211,
	"./nb.js": 211,
	"./ne": 212,
	"./ne.js": 212,
	"./nl": 213,
	"./nl-be": 214,
	"./nl-be.js": 214,
	"./nl.js": 213,
	"./nn": 215,
	"./nn.js": 215,
	"./oc-lnc": 216,
	"./oc-lnc.js": 216,
	"./pa-in": 217,
	"./pa-in.js": 217,
	"./pl": 218,
	"./pl.js": 218,
	"./pt": 219,
	"./pt-br": 220,
	"./pt-br.js": 220,
	"./pt.js": 219,
	"./ro": 221,
	"./ro.js": 221,
	"./ru": 222,
	"./ru.js": 222,
	"./sd": 223,
	"./sd.js": 223,
	"./se": 224,
	"./se.js": 224,
	"./si": 225,
	"./si.js": 225,
	"./sk": 226,
	"./sk.js": 226,
	"./sl": 227,
	"./sl.js": 227,
	"./sq": 228,
	"./sq.js": 228,
	"./sr": 229,
	"./sr-cyrl": 230,
	"./sr-cyrl.js": 230,
	"./sr.js": 229,
	"./ss": 231,
	"./ss.js": 231,
	"./sv": 232,
	"./sv.js": 232,
	"./sw": 233,
	"./sw.js": 233,
	"./ta": 234,
	"./ta.js": 234,
	"./te": 235,
	"./te.js": 235,
	"./tet": 236,
	"./tet.js": 236,
	"./tg": 237,
	"./tg.js": 237,
	"./th": 238,
	"./th.js": 238,
	"./tk": 239,
	"./tk.js": 239,
	"./tl-ph": 240,
	"./tl-ph.js": 240,
	"./tlh": 241,
	"./tlh.js": 241,
	"./tr": 242,
	"./tr.js": 242,
	"./tzl": 243,
	"./tzl.js": 243,
	"./tzm": 244,
	"./tzm-latn": 245,
	"./tzm-latn.js": 245,
	"./tzm.js": 244,
	"./ug-cn": 246,
	"./ug-cn.js": 246,
	"./uk": 247,
	"./uk.js": 247,
	"./ur": 248,
	"./ur.js": 248,
	"./uz": 249,
	"./uz-latn": 250,
	"./uz-latn.js": 250,
	"./uz.js": 249,
	"./vi": 251,
	"./vi.js": 251,
	"./x-pseudo": 252,
	"./x-pseudo.js": 252,
	"./yo": 253,
	"./yo.js": 253,
	"./zh-cn": 254,
	"./zh-cn.js": 254,
	"./zh-hk": 255,
	"./zh-hk.js": 255,
	"./zh-mo": 256,
	"./zh-mo.js": 256,
	"./zh-tw": 257,
	"./zh-tw.js": 257
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 526;

/***/ }),
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */
/***/ (function(module, exports) {

module.exports = {"_from":"vue-chartjs@3.1.0","_id":"vue-chartjs@3.1.0","_inBundle":false,"_integrity":"sha512-cp70zluNJdN57J907hSzjp4jayF6O0ayBJ/alZprHx+BvbVe+nL+QF3TOPSSao3UoenCopYJybmDi/RWYb7afw==","_location":"/vue-chartjs","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"vue-chartjs@3.1.0","name":"vue-chartjs","escapedName":"vue-chartjs","rawSpec":"3.1.0","saveSpec":null,"fetchSpec":"3.1.0"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/vue-chartjs/-/vue-chartjs-3.1.0.tgz","_shasum":"bf29bd940312bfdbbde337e03cb538f2805b184e","_spec":"vue-chartjs@3.1.0","_where":"/home/forge/nibsinventory.elken.com/nibsinventory","author":{"name":"Jakub Juszczak","email":"jakub@posteo.de"},"browserify":{"transform":["babelify"]},"bugs":{"url":"https://github.com/apertureless/vue-chartjs/issues"},"bundleDependencies":false,"contributors":[{"name":"Thorsten Lünborg","url":"https://github.com/LinusBorg"},{"name":"Juan Carlos Alonso","url":"https://github.com/jcalonso"}],"dependencies":{},"deprecated":false,"description":"Vue.js wrapper for chart.js for creating beautiful charts.","devDependencies":{"@babel/cli":"^7.0.0-beta.31","@babel/core":"^7.0.0-beta.31","@babel/preset-env":"^7.0.0-beta.31","@babel/preset-stage-2":"^7.0.0-beta.31","babel-loader":"8.0.0-beta.0","chai":"^3.5.0","chart.js":"2.7.0","chromedriver":"^2.28.0","connect-history-api-fallback":"^1.1.0","cross-env":"^5.1.1","cross-spawn":"^5.1.0","css-loader":"^0.28.0","eslint":"^3.19.0","eslint-config-standard":"^10.2.1","eslint-friendly-formatter":"^2.0.7","eslint-loader":"^1.7.1","eslint-plugin-html":"^2.0.1","eslint-plugin-import":"^2.2.0","eslint-plugin-node":"^4.2.2","eslint-plugin-promise":"^3.5.0","eslint-plugin-standard":"^3.0.1","eventsource-polyfill":"^0.9.6","express":"^4.15.2","extract-text-webpack-plugin":"^3.0.1","file-loader":"^0.10.1","friendly-errors-webpack-plugin":"^1.6.1","function-bind":"^1.0.2","html-webpack-plugin":"^2.28.0","http-proxy-middleware":"^0.17.4","inject-loader":"^3.0.0","isparta":"^4.0.0","jasmine-core":"^2.5.2","json-loader":"^0.5.4","karma":"^1.5.0","karma-coverage":"^1.1.1","karma-jasmine":"^1.0.2","karma-mocha":"^1.2.0","karma-phantomjs-launcher":"^1.0.4","karma-phantomjs-shim":"^1.4.0","karma-sinon-chai":"^1.2.0","karma-sourcemap-loader":"^0.3.7","karma-spec-reporter":"0.0.30","karma-webpack":"2","lolex":"^1.6.0","mocha":"^3.1.0","opn":"^5.1.0","ora":"^1.2.0","phantomjs-prebuilt":"^2.1.13","portfinder":"^1.0.13","selenium-server":"^3.3.1","shelljs":"^0.7.7","sinon":"^2.1.0","sinon-chai":"^2.9.0","url-loader":"^0.5.8","vue":"2.5.2","vue-hot-reload-api":"2.1.0","vue-html-loader":"^1.2.4","vue-loader":"^13.3.0","vue-style-loader":"3.0.1","vue-template-compiler":"2.5.2","webpack":"^3.7.1","webpack-dev-middleware":"^1.10.1","webpack-hot-middleware":"^2.17.1","webpack-merge":"^4.1.0"},"engines":{"node":">=6.9.0","npm":">= 3.0.0"},"files":["src","dist","es"],"greenkeeper":{"ignore":["extract-text-webpack-plugin","karma-webpack","webpack","webpack-merge"]},"homepage":"http://vue-chartjs.org","jsnext:main":"es/index.js","keywords":["ChartJs","Vue","Visualisation","Wrapper","Charts"],"license":"MIT","main":"dist/vue-chartjs.js","maintainers":[{"name":"Jakub Juszczak","email":"jakub@posteo.de","url":"http://www.jakubjuszczak.de"}],"module":"es/index.js","name":"vue-chartjs","peerDependencies":{"chart.js":"2.7.x"},"repository":{"type":"git","url":"git+ssh://git@github.com/apertureless/vue-chartjs.git"},"scripts":{"build":"yarn run release && yarn run build:es","build:es":"cross-env BABEL_ENV=es babel src --out-dir es","dev":"node build/dev-server.js","e2e":"node test/e2e/runner.js","lint":"eslint --ext .js,.vue src test/unit/specs test/e2e/specs","prepublishOnly":"yarn run lint && yarn run test && yarn run build","release":"webpack --progress --hide-modules --config  ./build/webpack.release.js && cross-env NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.min.js","test":"npm run unit","unit":"karma start test/unit/karma.conf.js --single-run"},"unpkg":"dist/vue-chartjs.min.js","version":"3.1.0"}

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardLine2ChartExample_vue__ = __webpack_require__(258);
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardLine2ChartExample_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardLine3ChartExample_vue__ = __webpack_require__(259);
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardLine3ChartExample_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardBarChartExample_vue__ = __webpack_require__(260);
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CardBarChartExample_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainChartExample_vue__ = __webpack_require__(261);
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainChartExample_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SocialBoxChartExample_vue__ = __webpack_require__(262);
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SocialBoxChartExample_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CalloutChartExample_vue__ = __webpack_require__(263);
/* unused harmony namespace reexport */
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CalloutChartExample_vue__["a" /* default */],
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(264);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f298e88c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(566);
function injectStyle (ssrContext) {
  __webpack_require__(547)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f298e88c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 547 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app flex-row align-items-center"},[_c('div',{staticClass:"container"},[_c('b-row',{staticClass:"justify-content-center"},[_c('b-col',{attrs:{"md":"8"}},[_c('b-card-group',[_c('b-card',{staticClass:"p-4",attrs:{"no-body":""}},[_c('b-card-body',[_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.logMeIn($event)}}},[_c('h1',[_vm._v("Login")]),_vm._v(" "),_c('p',{staticClass:"text-muted"},[_vm._v("Log In to your account")]),_vm._v(" "),_c('b-input-group',{staticClass:"mb-3"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"icon-user"})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.credentials.username),expression:"credentials.username"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Username","required":""},domProps:{"value":(_vm.credentials.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.credentials, "username", $event.target.value)}}})]),_vm._v(" "),_c('b-input-group',{staticClass:"mb-4"},[_c('div',{staticClass:"input-group-prepend"},[_c('span',{staticClass:"input-group-text"},[_c('i',{staticClass:"icon-lock"})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.credentials.password),expression:"credentials.password"}],staticClass:"form-control",attrs:{"type":"password","placeholder":"Password","required":""},domProps:{"value":(_vm.credentials.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.credentials, "password", $event.target.value)}}})]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('b-col',{attrs:{"cols":"6"}},[_c('b-form-checkbox',{attrs:{"id":"checkbox1","plain":""},model:{value:(_vm.rememberMe),callback:function ($$v) {_vm.rememberMe=$$v},expression:"rememberMe"}},[_vm._v("\n                          Remember Me\n                        ")])],1)],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('b-button',{staticClass:"px-4",attrs:{"variant":"success","type":"submit"}},[_vm._v("Login")])],1)],1)],1)])],1)],1)],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pos_vue__ = __webpack_require__(271);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_524ae261_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pos_vue__ = __webpack_require__(573);
function injectStyle (ssrContext) {
  __webpack_require__(568)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_524ae261_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 568 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 569 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.lookupValue),expression:"lookupValue"}],staticClass:"form-control",attrs:{"type":"text","disabled":_vm.lockEntry},domProps:{"value":(_vm.lookupValue)},on:{"blur":function($event){_vm.blur()},"input":[function($event){if($event.target.composing){ return; }_vm.lookupValue=$event.target.value},function($event){_vm.search()}],"keydown":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.enter($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"down",40,$event.key)){ return null; }_vm.down($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"up",38,$event.key)){ return null; }_vm.up($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key)){ return null; }_vm.esc($event)}]}}),_vm._v(" "),(_vm.open)?_c('div',{staticClass:"panel-footer",on:{"click":function($event){_vm.click()}}},[_c('ul',{staticClass:"ui-autocomplete ui-menu",on:{"click":function($event){_vm.click()}}},[_vm._l((_vm.list),function(row,index){return (_vm.isBasicLookup)?_c('li',{staticClass:"list-group-item",class:{'active': _vm.isActive(index)},on:{"mouseover":function($event){_vm.MouseOver(index)},"click":function($event){_vm.click()}}},[_vm._v("\n        "+_vm._s(row.id)+"\n      ")]):_vm._e()}),_vm._v(" "),_vm._l((_vm.list),function(row,index){return (!_vm.isBasicLookup)?_c('li',{staticClass:"list-group-item",class:{'active': _vm.isActive(index)},on:{"mouseover":function($event){_vm.MouseOver(index)},"click":function($event){_vm.click()}}},[_vm._v("\n        "+_vm._s(row.name)),_c('br'),_c('small',[_vm._v(_vm._s(row.id))])]):_vm._e()})],2)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 571 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_vm._v("Loading…")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(_vm.loading)?_c('spinner'):_vm._e(),_vm._v(" "),_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Search PO")])]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"po_num"}},[_vm._v("PO No")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","id":"po_num"},on:{"keyup":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.searchPO($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }$event.target.nextElementSibling.focus()}]},model:{value:(_vm.filter.po_num),callback:function ($$v) {_vm.$set(_vm.filter, "po_num", $$v)},expression:"filter.po_num"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"supplier_id"}},[_vm._v("Supplier")]),_vm._v(" "),_c('supplierLookup',{attrs:{"url":_vm.apiUrl,"lookupId":_vm.filter.supplier_id},on:{"selected":function($event){_vm.setSupplierId($event)}}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"date_start"}},[_vm._v("Date Start")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date","id":"date"},model:{value:(_vm.filter.date_start),callback:function ($$v) {_vm.$set(_vm.filter, "date_start", $$v)},expression:"filter.date_start"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"date_end"}},[_vm._v("Date End")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date","id":"date_end"},model:{value:(_vm.filter.date_end),callback:function ($$v) {_vm.$set(_vm.filter, "date_end", $$v)},expression:"filter.date_end"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"1"}},[_c('b-form-group',[_c('label',{attrs:{"for":"po_status"}},[_vm._v("PO Status")]),_vm._v(" "),_c('b-form-select',{attrs:{"id":"po_status","plain":true,"options":['','PENDING', 'APPROVED', 'CANCELLED'],"value":""},model:{value:(_vm.filter.po_status),callback:function ($$v) {_vm.$set(_vm.filter, "po_status", $$v)},expression:"filter.po_status"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"fulfilment_status"}},[_vm._v("Fulfilment Status")]),_vm._v(" "),_c('b-form-select',{attrs:{"id":"fulfilment_status","plain":true,"options":['','PARTIAL', 'FULFILLED', 'MANUAL CLOSED','UNFULFILLED'],"value":""},model:{value:(_vm.filter.fulfilment_status),callback:function ($$v) {_vm.$set(_vm.filter, "fulfilment_status", $$v)},expression:"filter.fulfilment_status"}})],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"primary"},on:{"click":_vm.searchPO}},[_vm._v(" Search")]),_vm._v("\n           \n         "),_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"success"},on:{"click":_vm.newPO}},[_vm._v("New Purchase Order")])],1)],1),_vm._v(" "),(_vm.getRowCount(_vm.searchResults) > 0 && !_vm.loading)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Search Results")])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('b-table',{staticClass:"table-hover",attrs:{"striped":_vm.striped,"bordered":_vm.bordered,"small":_vm.small,"fixed":_vm.fixed,"responsive":"sm","fields":_vm.searchResultsFields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"items":_vm.searchResults},on:{"row-clicked":_vm.rowClick}})],1),_vm._v(" "),_c('nav',[_c('b-pagination',{attrs:{"total-rows":_vm.getRowCount(_vm.searchResults),"per-page":_vm.perPage,"prev-text":"Prev","next-text":"Next","hide-goto-end-buttons":""},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('exportExcel',{staticClass:"btn btn-primary btn-lg",attrs:{"size":"lg","data":_vm.searchResults,"fields":_vm.exportHeaders,"name":"po.xls"}},[_vm._v("\n                        Export to Excel\n                    ")]),_vm._v("\n                      \n                    "),_c('b-button',{attrs:{"type":"button","size":"lg","variant":"success"},on:{"click":_vm.print}},[_vm._v("Print")])],1)])],1)],1):(_vm.noResults)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('div',{attrs:{"align":"center"}},[_c('strong',[_vm._v("No Purchase Order Found")])])])],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_po_vue__ = __webpack_require__(273);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92ff7e74_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_po_vue__ = __webpack_require__(576);
function injectStyle (ssrContext) {
  __webpack_require__(575)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_po_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_92ff7e74_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_po_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 575 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v(_vm._s(_vm.poData.title))])]),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-group',[_c('label',{attrs:{"for":"name"}},[_vm._v("PO Date")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date","id":"name","placeholder":"PO Date","disabled":_vm.lockEntry},model:{value:(_vm.poData.po_date),callback:function ($$v) {_vm.$set(_vm.poData, "po_date", $$v)},expression:"poData.po_date"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',[_vm._v("Supplier")]),_vm._v(" "),_c('supplierLookup',{attrs:{"url":_vm.apiSupplierUrl,"lookupId":_vm.poData.supplier_id,"disabled":_vm.lockEntry},on:{"selected":function($event){_vm.setSupplier($event)}}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',[_vm._v("Receiving Warehouse")]),_vm._v(" "),_c('warehouseLookup',{attrs:{"url":_vm.apiWarehouseUrl,"lookupId":_vm.poData.location_id,"disabled":_vm.lockEntry},on:{"selected":function($event){_vm.setWarehouse($event)}}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',[_vm._v("Type")]),_vm._v(" "),_c('b-form-select',{attrs:{"plain":true,"options":['','TRADE','NON TRADE'],"disabled":""},model:{value:(_vm.poData.po_type),callback:function ($$v) {_vm.$set(_vm.poData, "po_type", $$v)},expression:"poData.po_type"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"po_category"}},[_vm._v("Category")]),_vm._v(" "),_c('b-form-select',{attrs:{"id":"po_category","plain":true,"options":['-','LOCAL','OVERSEAS'],"disabled":""},model:{value:(_vm.poData.po_category),callback:function ($$v) {_vm.$set(_vm.poData, "po_category", $$v)},expression:"poData.po_category"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"estDate"}},[_vm._v("ETA")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date","id":"eta","placeholder":"Est Delivery Date","disabled":_vm.lockEntry},model:{value:(_vm.poData.po_date_eta),callback:function ($$v) {_vm.$set(_vm.poData, "po_date_eta", $$v)},expression:"poData.po_date_eta"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('label',{attrs:{"for":"remarks"}},[_vm._v("Remarks")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.poData.remarks),expression:"poData.remarks"}],staticClass:"form-control",attrs:{"rows":"5","id":"remarks","disabled":_vm.lockEntry},domProps:{"value":(_vm.poData.remarks)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.poData, "remarks", $event.target.value)}}})])],1)],1),_vm._v(" "),(_vm.poData.grns.length > 0)?_c('b-col',{attrs:{"sm":"4"}},[_c('br'),_vm._v(" "),_c('b-card',[_c('div',{staticClass:"table-responsive"},[_c('table',[_c('thead',[_c('th',{staticStyle:{"min-width":"138px","height":"40px"}},[_vm._v("GRN No")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"100px"}},[_vm._v("Date")]),_vm._v(" "),_c('th',[_vm._v("Generated By")])]),_vm._v(" "),_c('tbody',_vm._l((_vm.poData.grns),function(row,index){return _c('tr',{ref:'title',refInFor:true,staticStyle:{"height":"40px"}},[_c('td',[_c('b-button',{attrs:{"type":"submit","size":"md","variant":"primary"},on:{"click":function($event){_vm.printGRN(row)}}},[_vm._v(_vm._s(row.grn_num))])],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.grn_date_friendly))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.author_user_shortname))])])}))])])])],1):_vm._e()],1)],1)],1)],1),_vm._v(" "),(_vm.poData.supplier_id !='' && _vm.poData.location_id != '' && !_vm.noItemsFound)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Purchase Order Items")])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped table-bordered"},[_c('thead',[_c('th',{staticStyle:{"width":"10px"}},[_vm._v("S/N")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"300px"}},[_vm._v("Product")]),_vm._v(" "),_c('th',{attrs:{"width":"150px"}},[_vm._v("SKU")]),_vm._v(" "),_c('th',[_vm._v("UOM")]),_vm._v(" "),_c('th',{attrs:{"width":"150px"}},[_vm._v("Quantity")]),_vm._v(" "),_c('th',{attrs:{"width":"180px"}},[_vm._v("Unit Price ("+_vm._s(_vm.poData.currency_id)+")")]),_vm._v(" "),_c('th',{attrs:{"width":"180px"}},[_vm._v("Amount ("+_vm._s(_vm.poData.currency_id)+")")]),_vm._v(" "),_c('th',{attrs:{"width":"30px"}})]),_vm._v(" "),_c('tbody',[_vm._l((_vm.poData.po_items),function(row,index){return (!_vm.lockEntry)?_c('tr',{ref:'title',refInFor:true},[_c('td',[_vm._v(_vm._s((index*1) +1))]),_vm._v(" "),_c('td',[_c('productLookup',{attrs:{"url":_vm.apiProductUrl,"q2":_vm.poData.location_id,"lookupId":row.product_id,"disabled":_vm.lockEntry},on:{"selected":function($event){_vm.setProduct($event, index)}}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.product_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.uom))]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.qty),expression:"row.qty"}],staticClass:"form-control",attrs:{"type":"number","name":"qty"},domProps:{"value":(row.qty)},on:{"change":function($event){_vm.computeRow($event, index)},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "qty", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.unit_price),expression:"row.unit_price"}],staticClass:"form-control",attrs:{"type":"number","name":"unit_price"},domProps:{"value":(row.unit_price)},on:{"change":function($event){_vm.computeRow($event, index)},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "unit_price", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.amount_total),expression:"row.amount_total"}],staticClass:"form-control",attrs:{"type":"number","name":"amount_total"},domProps:{"value":(row.amount_total)},on:{"change":function($event){_vm.computeRow($event, index)},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "amount_total", $event.target.value)}}})]),_vm._v(" "),_c('td',[(!_vm.lockEntry)?_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.removeRow(index)}}},[_c('i',{staticClass:"fa fa-trash",staticStyle:{"font-size":"25px","color":"red"}})]):_vm._e()])]):_vm._e()}),_vm._v(" "),_vm._l((_vm.poData.po_items),function(row,index){return (_vm.lockEntry)?_c('tr',{ref:'title',refInFor:true},[_c('td',[_vm._v(_vm._s((index*1) +1))]),_vm._v(" "),_c('td',[_c('productLookup',{attrs:{"url":_vm.apiProductUrl,"q2":_vm.poData.location_id,"lookupId":row.product_id,"disabled":_vm.lockEntry},on:{"selected":function($event){_vm.setProduct($event, index)}}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.product_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.uom))]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.qty.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')),expression:"row.qty.toString().replace(/\\B(?=(\\d{3})+(?!\\d))/g, ',')"}],staticClass:"form-control",attrs:{"type":"text","name":"qty","disabled":""},domProps:{"value":(row.qty.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(row.qty.toString(), "replace(/\B(?=(\d{3})+(?!\d))/g, ',')", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.unit_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')),expression:"row.unit_price.toString().replace(/\\B(?=(\\d{3})+(?!\\d))/g, ',')"}],staticClass:"form-control",attrs:{"type":"text","name":"unit_price","disabled":""},domProps:{"value":(row.unit_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(row.unit_price.toString(), "replace(/\B(?=(\d{3})+(?!\d))/g, ',')", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.amount_total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')),expression:"row.amount_total.toString().replace(/\\B(?=(\\d{3})+(?!\\d))/g, ',')"}],staticClass:"form-control",attrs:{"type":"text","name":"amount_total","disabled":""},domProps:{"value":(row.amount_total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(row.amount_total.toString(), "replace(/\B(?=(\d{3})+(?!\d))/g, ',')", $event.target.value)}}})]),_vm._v(" "),_c('td')]):_vm._e()}),_vm._v(" "),(!_vm.lockEntry)?_c('tr',[_c('td',{attrs:{"colspan":"8"}},[_c('b-button',{attrs:{"type":"submit","size":"md","variant":"success"},on:{"click":_vm.addRow}},[_vm._v("Add Product")])],1)]):_vm._e(),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('b',[_vm._v("Amount ($)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.total.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))]),_vm._v(" "),_c('td')]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('b',[_vm._v("Tax (%)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.poData.tax_percent))]),_vm._v(" "),_c('td')]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('b',[_vm._v("Tax Amount ($)")])]),_vm._v(" "),(!_vm.lockEntry)?_c('td',[_vm._v(_vm._s(_vm.gstAmount.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))]):_vm._e(),_vm._v(" "),(_vm.lockEntry)?_c('td',[_vm._v(_vm._s(_vm.poData.amount_tax.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))]):_vm._e(),_vm._v(" "),_c('td')]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('b',[_vm._v("Rounding Amount ($)")])]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.poData.amount_total_rounding),expression:"poData.amount_total_rounding"}],staticClass:"form-control",attrs:{"type":"number","name":"amount_total_rounding","disabled":_vm.lockEntry},domProps:{"value":(_vm.poData.amount_total_rounding)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.poData, "amount_total_rounding", $event.target.value)}}})]),_vm._v(" "),_c('td')]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('b',[_vm._v("Total Amount ($)")])]),_vm._v(" "),(!_vm.lockEntry)?_c('td',[_c('b',[_vm._v(_vm._s(_vm.totalAmount.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))])]):_vm._e(),_vm._v(" "),(_vm.lockEntry)?_c('td',[_c('b',[_vm._v(_vm._s(_vm.poData.amount_total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))])]):_vm._e(),_vm._v(" "),_c('td')])],2)])])])],1)],1):_vm._e(),_vm._v(" "),(_vm.poData.supplier_id !='' && _vm.poData.location_id != '' && !_vm.noItemsFound)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-row',{staticStyle:{"padding":"0px 0px 20px 18px"}},[(_vm.po_status == 'PENDING' && _vm.hideBtn)?_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"primary"},on:{"click":_vm.confirmProcessPO}},[_vm._v(_vm._s(_vm.confirmBtnText))]):_vm._e(),_vm._v("\n                          \n                        "),_c('b-modal',{attrs:{"title":"Confirmation","centered":"","header-bg-variant":"success","no-close-on-backdrop":""},on:{"ok":_vm.processPO},model:{value:(_vm.modalShow),callback:function ($$v) {_vm.modalShow=$$v},expression:"modalShow"}},[_c('p',{staticStyle:{"color":"darkblue"}},[_vm._v("Confirmed "+_vm._s(_vm.confirmMessage)+"?")])]),_vm._v(" "),_c('b-modal',{attrs:{"title":"Confirmation","centered":"","header-bg-variant":"success","no-close-on-backdrop":""},on:{"ok":_vm.cancel},model:{value:(_vm.cancelModalShow),callback:function ($$v) {_vm.cancelModalShow=$$v},expression:"cancelModalShow"}},[_c('p',{staticStyle:{"color":"darkblue"}},[_vm._v("Confirmed "+_vm._s(_vm.confirmMessage)+"?")])]),_vm._v(" "),_c('b-modal',{ref:"myModalRef",attrs:{"hide-header-close":"","hide-footer":"","title":"Purchase Order","centered":"","header-bg-variant":"success","no-close-on-backdrop":"","no-close-on-esc":""}},[_c('div',{staticClass:"d-block text-center"},[_c('p',[_vm._v("Purchase Order "),_c('strong',{staticStyle:{"color":"green"}},[_vm._v(" "+_vm._s(_vm.poDocumentNo))]),_vm._v(" is "+_vm._s(_vm.msgSaved)+"."),_c('br'),_c('br')])]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"variant":"outline-danger"},on:{"click":_vm.hideModal}},[_vm._v("Ok")])],1),_vm._v(" "),_c('b-modal',{ref:"myErrorModalRef",attrs:{"hide-header-close":"","hide-footer":"","title":"Invalid Entries","centered":"","header-bg-variant":"danger","no-close-on-backdrop":""}},[_c('div',{staticClass:"d-block text-center"},[_c('p',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage))])]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"variant":"danger"},on:{"click":_vm.hideErrorModal}},[_vm._v("OK")])],1),_vm._v(" "),_c('b-modal',{ref:"myApproveModalRef",attrs:{"hide-header-close":"","hide-footer":"","title":"Approved","centered":"","header-bg-variant":"primary","no-close-on-backdrop":"","no-close-on-esc":""}},[_c('div',{staticClass:"d-block text-center"},[_c('p',{staticStyle:{"color":"green"}},[_vm._v("Purchase Order "+_vm._s(this.$route.params.poNum)+" has been approved")])]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"variant":"danger"},on:{"click":_vm.hideApproveModal}},[_vm._v("OK")])],1),_vm._v(" "),_c('b-modal',{ref:"msgBox",attrs:{"hide-header-close":"","hide-footer":"","title":_vm.mbTitle,"centered":"","header-bg-variant":"primary","no-close-on-backdrop":"","no-close-on-esc":""}},[_c('div',{staticClass:"d-block text-center"},[_c('p',{staticStyle:{"color":"green"}},[_vm._v(_vm._s(_vm.mbMsg))])]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"variant":"danger"},on:{"click":function($event){_vm.$refs.msgBox.hide()}}},[_vm._v("OK")])],1),_vm._v(" "),_c('b-modal',{ref:"myCancelModalRef",attrs:{"hide-header-close":"","hide-footer":"","title":"Cancelled","centered":"","header-bg-variant":"danger","no-close-on-backdrop":"","no-close-on-esc":""}},[_c('div',{staticClass:"d-block text-center"},[_c('p',{staticStyle:{"color":"red"}},[_vm._v("Purchase Order "+_vm._s(this.$route.params.poNum)+" has been cancelled")])]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"variant":"danger"},on:{"click":_vm.hideCancelModal}},[_vm._v("OK")])],1),_vm._v(" "),_c('b-modal',{ref:"manualCloseModal",attrs:{"id":"modalPrevent","title":"Manual Close PO?","centered":""},on:{"ok":_vm.manualClosePO}},[_c('form',{on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();_vm.handleSubmit($event)}}},[_c('b-form-input',{attrs:{"type":"text","placeholder":"Enter the reason"},model:{value:(_vm.poData.po_fulfilment_remarks),callback:function ($$v) {_vm.$set(_vm.poData, "po_fulfilment_remarks", $$v)},expression:"poData.po_fulfilment_remarks"}})],1)]),_vm._v(" "),(_vm.po_status == 'PENDING')?_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"danger"},on:{"click":_vm.confirmCancel}},[_vm._v(_vm._s(_vm.cancelBtnText))]):_vm._e(),_vm._v(" "),(_vm.po_status == 'APPROVED' && (_vm.po_fulfilment_status =='UNFULFILLED' || _vm.po_fulfilment_status =='PARTIAL'))?_c('b-button',{attrs:{"type":"button","size":"lg","variant":"primary"},on:{"click":_vm.confirmManualClose}},[_vm._v("Manual Close")]):_vm._e(),_vm._v("\n                          \n                        "),(_vm.poData.po_num != '' && _vm.poData.po_status != 'CANCELLED')?_c('b-button',{attrs:{"type":"button","size":"lg","variant":"success"},on:{"click":_vm.print}},[_vm._v("Print")]):_vm._e(),_vm._v("\n                          \n                        "),(_vm.po_status != 'PENDING')?_c('b-button',{attrs:{"type":"button","size":"lg","variant":"danger"},on:{"click":_vm.back}},[_vm._v("Back")]):_vm._e()],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.poData.location_id != '' && _vm.poData.supplier_id !='' && _vm.noItemsFound)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('div',{attrs:{"align":"center"}},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("There is no product listed under the selected Warehouse's Country of Origin.")])])])],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_grns_vue__ = __webpack_require__(274);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b0c7dcae_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_grns_vue__ = __webpack_require__(579);
function injectStyle (ssrContext) {
  __webpack_require__(578)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_grns_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b0c7dcae_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_grns_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 578 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(_vm.loading)?_c('spinner'):_vm._e(),_vm._v(" "),_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Search GRN")])]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"grn_num"}},[_vm._v("GRN No")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","id":"grn_num"},model:{value:(_vm.filter.grn_num),callback:function ($$v) {_vm.$set(_vm.filter, "grn_num", $$v)},expression:"filter.grn_num"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"po_num"}},[_vm._v("PO No")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","id":"po_num"},model:{value:(_vm.filter.po_num),callback:function ($$v) {_vm.$set(_vm.filter, "po_num", $$v)},expression:"filter.po_num"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"grn_date_start"}},[_vm._v("Date Start")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date"},model:{value:(_vm.filter.date_start),callback:function ($$v) {_vm.$set(_vm.filter, "date_start", $$v)},expression:"filter.date_start"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"grn_date_end"}},[_vm._v("Date End")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date"},model:{value:(_vm.filter.date_end),callback:function ($$v) {_vm.$set(_vm.filter, "date_end", $$v)},expression:"filter.date_end"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"fulfilment_status"}},[_vm._v("Fulfilment Status")]),_vm._v(" "),_c('b-form-select',{attrs:{"id":"fulfilment_status","plain":true,"options":['','PARTIAL','UNFULFILLED', 'FULFILLED', 'MANUAL CLOSED'],"value":""},model:{value:(_vm.filter.fulfilment_status),callback:function ($$v) {_vm.$set(_vm.filter, "fulfilment_status", $$v)},expression:"filter.fulfilment_status"}})],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"primary"},on:{"click":_vm.search}},[_vm._v("Search")]),_vm._v("\n           \n         "),_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"success"},on:{"click":_vm.createNew}},[_vm._v("New GRN")])],1)],1),_vm._v(" "),(this.searchResults.length > 0 && !_vm.loading)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Search Results")])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('b-table',{staticClass:"table-hover",attrs:{"hover":_vm.hover,"striped":_vm.striped,"bordered":_vm.bordered,"small":_vm.small,"fixed":_vm.fixed,"responsive":"sm","fields":_vm.searchResultsFields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"items":_vm.searchResults},on:{"row-clicked":_vm.rowClick}})],1),_vm._v(" "),_c('nav',[_c('b-pagination',{attrs:{"total-rows":_vm.getRowCount(_vm.searchResults),"per-page":_vm.perPage,"prev-text":"Prev","next-text":"Next","hide-goto-end-buttons":""},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('exportExcel',{staticClass:"btn btn-primary btn-lg",attrs:{"size":"lg","data":_vm.searchResults,"fields":_vm.exportHeaders,"name":"grn.xls"}},[_vm._v("\n                      Export to Excel\n                  ")]),_vm._v("\n                    \n                  "),_c('b-button',{attrs:{"type":"button","size":"lg","variant":"success"},on:{"click":_vm.print}},[_vm._v("Print")])],1)])],1)],1):(_vm.noResults && !_vm.loading)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('div',{attrs:{"align":"center"}},[_c('strong',[_vm._v("No GRN Found")])])])],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_grn_vue__ = __webpack_require__(275);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_99b40a7c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_grn_vue__ = __webpack_require__(581);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_grn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_99b40a7c_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_grn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn",on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key)){ return null; }_vm.cancelGrn($event)}}},[_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[(!_vm.isPORetrieved)?_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-group',{attrs:{"name":"po","label":"PO No","label-for":"elementsPrependAppend","description":""}},[_c('b-input-group',[_c('poLookup',{ref:"poLookupInput",staticStyle:{"min-width":"300px"},attrs:{"url":_vm.poLookupUrl,"basic":1,"lookupId":_vm.grn.po_num},on:{"selected":function($event){_vm.setPoId($event)}}}),_vm._v("   \n                                "),_c('b-button',{attrs:{"variant":"primary","disabled":_vm.grn.po_num == ''},on:{"click":_vm.retrievePO}},[_vm._v("Retrieve PO")])],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.isPORetrieved)?_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-group',[_c('label',{attrs:{"for":"grn_date"}},[_vm._v("GRN Date")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date","id":"grn_date"},model:{value:(_vm.grn.grn_date),callback:function ($$v) {_vm.$set(_vm.grn, "grn_date", $$v)},expression:"grn.grn_date"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('label',{attrs:{"for":"grn_remarks"}},[_vm._v("GRN Remarks")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.grn.remarks),expression:"grn.remarks"}],staticClass:"form-control",attrs:{"rows":"5","id":"remarks"},domProps:{"value":(_vm.grn.remarks)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.grn, "remarks", $event.target.value)}}})])],1)],1),_vm._v(" "),(_vm.grn.po.grns.length > 0)?_c('b-col',{attrs:{"sm":"6"}},[_c('br'),_vm._v(" "),_c('b-card',[_c('div',{staticClass:"table-responsive"},[_c('table',[_c('thead',[_c('th',{staticStyle:{"min-width":"138px","height":"40px"}},[_vm._v("GRN No")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"100px"}},[_vm._v("Date")]),_vm._v(" "),_c('th',[_vm._v("Generated By")])]),_vm._v(" "),_c('tbody',_vm._l((_vm.grn.po.grns),function(row,index){return _c('tr',{ref:'title',refInFor:true,staticStyle:{"height":"40px"}},[_c('td',[_c('b-button',{attrs:{"type":"submit","size":"md","variant":"primary"},on:{"click":function($event){_vm.printGRN(row)}}},[_vm._v(_vm._s(row.grn_num)+" ")])],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.grn_date_friendly))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.author_user_shortname))])])}))])])])],1):_vm._e()],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('hr'),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"po_num"}},[_vm._v("PO No")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","disabled":""},model:{value:(_vm.grn.po_num),callback:function ($$v) {_vm.$set(_vm.grn, "po_num", $$v)},expression:"grn.po_num"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"po_num"}},[_vm._v("PO Date")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date","disabled":""},model:{value:(_vm.grn.po.po_date),callback:function ($$v) {_vm.$set(_vm.grn.po, "po_date", $$v)},expression:"grn.po.po_date"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"po_type"}},[_vm._v("PO Type")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","disabled":""},model:{value:(_vm.grn.po.po_type),callback:function ($$v) {_vm.$set(_vm.grn.po, "po_type", $$v)},expression:"grn.po.po_type"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"po_type"}},[_vm._v("Fulfilment Status")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","disabled":""},model:{value:(_vm.grn.po.po_fulfilment_status),callback:function ($$v) {_vm.$set(_vm.grn.po, "po_fulfilment_status", $$v)},expression:"grn.po.po_fulfilment_status"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"supplier"}},[_vm._v("Supplier")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","disabled":""},model:{value:(_vm.grn.po.supplier_full),callback:function ($$v) {_vm.$set(_vm.grn.po, "supplier_full", $$v)},expression:"grn.po.supplier_full"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"location"}},[_vm._v("Receiving Warehouse")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","disabled":""},model:{value:(_vm.grn.po.location_full),callback:function ($$v) {_vm.$set(_vm.grn.po, "location_full", $$v)},expression:"grn.po.location_full"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"deliveryDate"}},[_vm._v("Delivery Date")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date","disabled":""},model:{value:(_vm.grn.po.po_date_eta),callback:function ($$v) {_vm.$set(_vm.grn.po, "po_date_eta", $$v)},expression:"grn.po.po_date_eta"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"po_type"}},[_vm._v("PO Status")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","disabled":""},model:{value:(_vm.grn.po.po_status),callback:function ($$v) {_vm.$set(_vm.grn.po, "po_status", $$v)},expression:"grn.po.po_status"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('label',{attrs:{"for":"remarks"}},[_vm._v("PO Remarks")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.grn.po.remarks),expression:"grn.po.remarks"}],staticClass:"form-control",attrs:{"rows":"5","id":"remarks","disabled":""},domProps:{"value":(_vm.grn.po.remarks)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.grn.po, "remarks", $event.target.value)}}})])],1)],1):_vm._e()],1)],1),_vm._v(" "),(_vm.isPORetrieved)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("GRN Items")])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped table-bordered"},[_c('thead',[_c('th',{attrs:{"width":"10px"}},[_vm._v("S/N")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"300px"}},[_vm._v("Product")]),_vm._v(" "),_c('th',{attrs:{"width":"150px"}},[_vm._v("SKU")]),_vm._v(" "),_c('th',{attrs:{"width":"150px"}},[_vm._v("PO Qty")]),_vm._v(" "),_c('th',{attrs:{"width":"180px"}},[_vm._v("Balance")]),_vm._v(" "),_c('th',{attrs:{"width":"180px"}},[_vm._v("Received Qty")]),_vm._v(" "),_c('th',{attrs:{"width":"180px"}},[_vm._v("Update Qty")])]),_vm._v(" "),_c('tbody',_vm._l((_vm.grn.po.po_items),function(row,index){return _c('tr',[_c('td',[_vm._v(_vm._s((index*1) +1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.product_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.product_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.qty*1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.qty - (row.qty_received*1 + row.qty_received_current*1)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s((row.qty_received*1 + row.qty_received_current*1)))]),_vm._v(" "),_c('td',[(row.qty - (row.qty_received *1) > 0 && _vm.grn.po.po_fulfilment_status != 'MANUAL CLOSED' && _vm.grn.po.po_status != 'CANCELLED')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.qty_received_current),expression:"row.qty_received_current"}],staticClass:"form-control",attrs:{"type":"number","name":"update-qty"},domProps:{"value":(row.qty_received_current)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "qty_received_current", $event.target.value)}}}):_vm._e()])])}))])])])],1)],1):_vm._e(),_vm._v(" "),(_vm.isPORetrieved)?_c('b-row',{staticStyle:{"padding":"0px 0px 20px 18px"}},[(_vm.grn.po.po_fulfilment_status != 'FULFILLED' && _vm.grn.po.po_fulfilment_status != 'MANUAL CLOSED' && _vm.grn.po.po_status == 'APPROVED')?_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"primary"},on:{"click":_vm.confirmSave}},[_vm._v("Save GRN ")]):_vm._e(),_vm._v("\n                  \n                "),(_vm.grn.po.po_fulfilment_status != 'FULFILLED' && _vm.grn.po.po_fulfilment_status != 'MANUAL CLOSED' && _vm.grn.po.po_status == 'APPROVED')?_c('b-button',{attrs:{"type":"button","size":"lg","variant":"danger"},on:{"click":_vm.confirmCancel}},[_vm._v("Cancel")]):_vm._e(),_vm._v(" "),(_vm.grn.po.po_fulfilment_status == 'FULFILLED' || _vm.grn.po.po_fulfilment_status == 'MANUAL CLOSED' || _vm.grn.po.po_status == 'PENDING' || _vm.grn.po.po_status == 'CANCELLED')?_c('b-button',{attrs:{"type":"button","size":"lg","variant":"success"},on:{"click":_vm.print}},[_vm._v("Print")]):_vm._e(),_vm._v("  \n                "),(_vm.grn.po.po_fulfilment_status == 'FULFILLED' || _vm.grn.po.po_fulfilment_status == 'MANUAL CLOSED' || _vm.grn.po.po_status == 'PENDING' || _vm.grn.po.po_status == 'CANCELLED')?_c('b-button',{attrs:{"type":"button","size":"lg","variant":"danger"},on:{"click":_vm.back}},[_vm._v("Back")]):_vm._e()],1):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-modal',{attrs:{"title":"Confirmation","centered":"","header-bg-variant":"success","no-close-on-backdrop":""},on:{"ok":_vm.save},model:{value:(_vm.modalShow),callback:function ($$v) {_vm.modalShow=$$v},expression:"modalShow"}},[_c('p',{staticStyle:{"color":"darkblue"}},[_vm._v("Confirmed Save?")])]),_vm._v(" "),_c('b-modal',{attrs:{"title":"Confirmation","centered":"","header-bg-variant":"success","no-close-on-backdrop":""},on:{"ok":_vm.cancel},model:{value:(_vm.modalCancelShow),callback:function ($$v) {_vm.modalCancelShow=$$v},expression:"modalCancelShow"}},[_c('p',{staticStyle:{"color":"darkblue"}},[_vm._v("Confirmed Cancel?")])]),_vm._v(" "),_c('b-modal',{ref:"myModalRef",attrs:{"hide-header-close":"","hide-footer":"","title":"GRN with PO","centered":"","header-bg-variant":"success","no-close-on-backdrop":"","no-close-on-esc":""}},[_c('div',{staticClass:"d-block text-center"},[_c('p',[_vm._v("Goods Receive Note "),_c('strong',{staticStyle:{"color":"green"}},[_vm._v(" "+_vm._s(_vm.grnDocNo))]),_vm._v(" is saved."),_c('br'),_c('br')])]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"variant":"outline-danger"},on:{"click":_vm.hideModal}},[_vm._v("OK")])],1),_vm._v(" "),_c('b-modal',{ref:"myErrorModalRef",attrs:{"hide-header-close":"","hide-footer":"","title":"Invalid Entries","centered":"","header-bg-variant":"danger","no-close-on-backdrop":"","no-close-on-esc":""}},[_c('div',{staticClass:"d-block text-center"},[_c('p',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage))])]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"variant":"danger"},on:{"click":_vm.hideErrorModal}},[_vm._v("OK")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gris_vue__ = __webpack_require__(276);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68416678_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gris_vue__ = __webpack_require__(587);
function injectStyle (ssrContext) {
  __webpack_require__(583)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gris_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68416678_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gris_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 583 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(_vm.loading)?_c('spinner'):_vm._e(),_vm._v(" "),_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Search GRI")])]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"gro_num"}},[_vm._v("GRI No")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","id":"gri_num"},model:{value:(_vm.filter.gri_num),callback:function ($$v) {_vm.$set(_vm.filter, "gri_num", $$v)},expression:"filter.gri_num"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"country_id"}},[_vm._v("Country")]),_vm._v(" "),_c('countryLookup',{attrs:{"url":_vm.apiCountryLookup,"lookupId":_vm.filter.country_id},on:{"selected":function($event){_vm.setCountry($event)}}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',[_vm._v("Date Start")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date"},model:{value:(_vm.filter.date_start),callback:function ($$v) {_vm.$set(_vm.filter, "date_start", $$v)},expression:"filter.date_start"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',[_vm._v("Date End")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date"},model:{value:(_vm.filter.date_end),callback:function ($$v) {_vm.$set(_vm.filter, "date_end", $$v)},expression:"filter.date_end"}})],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"primary"},on:{"click":_vm.search}},[_vm._v("Search")]),_vm._v("\n              \n            "),_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"success"},on:{"click":_vm.newGri}},[_vm._v("New GRI")])],1)],1),_vm._v(" "),(_vm.getRowCount(_vm.searchResults) > 0 && !_vm.loading)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Search Results")])]),_vm._v(" "),_c('b-table',{staticClass:"table-hover",attrs:{"hover":_vm.hover,"striped":_vm.striped,"bordered":_vm.bordered,"small":_vm.small,"fixed":_vm.fixed,"responsive":"sm","fields":_vm.searchResultsFields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"items":_vm.searchResults},on:{"row-clicked":_vm.rowClick}}),_vm._v(" "),_c('nav',[_c('b-pagination',{attrs:{"total-rows":_vm.getRowCount(_vm.searchResults),"per-page":_vm.perPage,"prev-text":"Prev","next-text":"Next","hide-goto-end-buttons":""},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('exportExcel',{staticClass:"btn btn-primary btn-lg",attrs:{"size":"lg","data":_vm.searchResults,"fields":_vm.exportHeaders,"name":"gri.xls"}},[_vm._v("\n              Export to Excel\n          ")]),_vm._v("\n            \n          "),_c('b-button',{attrs:{"type":"button","size":"lg","variant":"success"},on:{"click":_vm.print}},[_vm._v("Print")])],1)],1)],1)],1):(_vm.noResults)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('div',{attrs:{"align":"center"}},[_c('strong',[_vm._v("No GRI Found")])])])],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gri_vue__ = __webpack_require__(277);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_744cd9d5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gri_vue__ = __webpack_require__(590);
function injectStyle (ssrContext) {
  __webpack_require__(589)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gri_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_744cd9d5_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gri_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 589 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',[_vm._v("GRI Date")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date","disabled":_vm.lockEntry},model:{value:(_vm.gri.gri_date),callback:function ($$v) {_vm.$set(_vm.gri, "gri_date", $$v)},expression:"gri.gri_date"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"reference_num"}},[_vm._v("Reference Number")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","disabled":_vm.lockEntry},model:{value:(_vm.gri.reference_num),callback:function ($$v) {_vm.$set(_vm.gri, "reference_num", $$v)},expression:"gri.reference_num"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('label',{attrs:{"for":"location_id"}},[_vm._v("Into Location (Warehouse)")]),_vm._v(" "),_c('warehouseLookup',{attrs:{"url":_vm.apiWarehouseUrl,"lookupId":_vm.gri.location_id,"disabled":_vm.lockEntry},on:{"selected":function($event){_vm.setWarehouse($event)}}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('label',{attrs:{"for":"supplier_name"}},[_vm._v("Supplier")]),_vm._v(" "),_c('supplierLookup',{attrs:{"url":_vm.apiSupplierUrl,"lookupId":_vm.gri.supplier_id,"disabled":_vm.lockEntry},on:{"selected":function($event){_vm.setSupplier($event)}}})],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('label',{attrs:{"for":"remarks"}},[_vm._v("Remarks")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.gri.remarks),expression:"gri.remarks"}],staticClass:"form-control",attrs:{"rows":"5","id":"remarks","disabled":_vm.lockEntry},domProps:{"value":(_vm.gri.remarks)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.gri, "remarks", $event.target.value)}}})])],1)],1)],1)],1),_vm._v(" "),(_vm.gri.location_id != '' && !_vm.noItemsFound)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("GRI Items")])]),_vm._v(" "),_c('table',{staticClass:"table table-striped table-bordered"},[_c('thead',[_c('th',{staticStyle:{"min-width":"300px"}},[_vm._v("Product Name")]),_vm._v(" "),_c('th',{attrs:{"width":"250px"}},[_vm._v("Product Code")]),_vm._v(" "),_c('th',{attrs:{"width":"150px"}},[_vm._v("SOH")]),_vm._v(" "),_c('th',{attrs:{"width":"180px"}},[_vm._v("Receive Qty")]),_vm._v(" "),_c('th',{attrs:{"width":"180px"}},[_vm._v("Unit GMP ("+_vm._s(_vm.gri.currency_id)+")")]),_vm._v(" "),_c('th',{attrs:{"width":"180px"}},[_vm._v("Total Amount ("+_vm._s(_vm.gri.currency_id)+")")]),_vm._v(" "),_c('th',{attrs:{"width":"30px"}})]),_vm._v(" "),_c('tbody',[_vm._l((_vm.gri.gri_items),function(row,index){return _c('tr',[_c('td',[_c('productLookup',{attrs:{"url":_vm.apiLocationProductUrl,"lookupId":row.product_id,"q2":_vm.gri.location_id,"disabled":_vm.lockEntry},on:{"selected":function($event){_vm.setProduct($event, index)}}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.product_id))]),_vm._v(" "),(!_vm.lockEntry)?_c('td',[_vm._v(_vm._s(row.qty_soh*1 + row.qty*1))]):_vm._e(),_vm._v(" "),(_vm.lockEntry)?_c('td',[_vm._v(_vm._s(row.qty_soh*1))]):_vm._e(),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.qty),expression:"row.qty"}],staticClass:"form-control",attrs:{"type":"number","min":"0","name":"qty","disabled":_vm.lockEntry},domProps:{"value":(row.qty)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "qty", $event.target.value)}}})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.unit_gmp))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(((row.qty * 1) * (row.unit_gmp * 1)).toFixed(2)))]),_vm._v(" "),_c('td',[(!_vm.lockEntry)?_c('a',{attrs:{"href":"#","tabindex":"-1"},on:{"click":function($event){_vm.removeRow(index)}}},[_c('i',{staticClass:"fa fa-trash",staticStyle:{"font-size":"25px","color":"red"}})]):_vm._e()])])}),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"7"}},[(!_vm.lockEntry)?_c('b-button',{attrs:{"type":"submit","size":"md","variant":"success"},on:{"click":_vm.addRow}},[_vm._v("Add Product")]):_vm._e()],1)])],2)])])],1)],1):_vm._e(),_vm._v(" "),(_vm.gri.location_id != '' && _vm.noItemsFound)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('div',{attrs:{"align":"center"}},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("No Products Found in the Selected Warehouse! Please Select a Different Warehouse")])])])],1):_vm._e(),_vm._v(" "),(_vm.gri.location_id != '' && !_vm.noItemsFound)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-row',{staticStyle:{"padding":"0px 0px 20px 18px"}},[(!_vm.lockEntry && _vm.hideBtn)?_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"primary"},on:{"click":_vm.save}},[_vm._v("Save GRI")]):_vm._e(),_vm._v("\n                                                                                  \n                        "),(!_vm.lockEntry)?_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"danger"},on:{"click":_vm.closeGri}},[_vm._v("Cancel")]):_vm._e(),_vm._v(" "),(_vm.lockEntry)?_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"success"},on:{"click":_vm.print}},[_vm._v("Print")]):_vm._e(),_vm._v("  \n                        "),(_vm.lockEntry)?_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"danger"},on:{"click":_vm.back}},[_vm._v("Back")]):_vm._e()],1)],1)],1):_vm._e(),_vm._v(" "),_c('b-modal',{attrs:{"title":"Confirmation","centered":"","header-bg-variant":"success","no-close-on-backdrop":""},on:{"ok":_vm.handleOk},model:{value:(_vm.modalShow),callback:function ($$v) {_vm.modalShow=$$v},expression:"modalShow"}},[_c('p',{staticStyle:{"color":"darkblue"}},[_vm._v("Confirmed Save GRI?")])]),_vm._v(" "),_c('b-modal',{attrs:{"title":"Confirmation","centered":"","header-bg-variant":"success","no-close-on-backdrop":""},on:{"ok":_vm.handleCancelOk},model:{value:(_vm.modalCancelShow),callback:function ($$v) {_vm.modalCancelShow=$$v},expression:"modalCancelShow"}},[_c('p',{staticStyle:{"color":"darkblue"}},[_vm._v("Confirmed Cancel GRI?")])]),_vm._v(" "),_c('b-modal',{ref:"myModalRef",attrs:{"hide-header-close":"","hide-footer":"","title":"Good Return Outwards","centered":"","header-bg-variant":"success","no-close-on-backdrop":"","no-close-on-esc":""}},[_c('div',{staticClass:"d-block text-center"},[_c('p',[_vm._v("Goods Return Inwards "),_c('strong',{staticStyle:{"color":"green"}},[_vm._v(" "+_vm._s(_vm.griDocNo))]),_vm._v(" is saved."),_c('br'),_c('br')])]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"variant":"outline-danger"},on:{"click":_vm.hideModal}},[_vm._v("Ok")])],1),_vm._v(" "),_c('b-modal',{ref:"myErrorModalRef",attrs:{"hide-header-close":"","hide-footer":"","title":"Invalid Entries","centered":"","header-bg-variant":"danger","no-close-on-backdrop":"","no-close-on-esc":""}},[_c('div',{staticClass:"d-block text-center"},[_c('p',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage))])]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"variant":"danger"},on:{"click":_vm.hideErrorModal}},[_vm._v("OK")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gros_vue__ = __webpack_require__(278);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fb00a98_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gros_vue__ = __webpack_require__(593);
function injectStyle (ssrContext) {
  __webpack_require__(592)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gros_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fb00a98_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gros_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 592 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(_vm.loading)?_c('spinner'):_vm._e(),_vm._v(" "),_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Search GRO")])]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"gro_num"}},[_vm._v("GRO No")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","id":"gro_num"},model:{value:(_vm.filter.gro_num),callback:function ($$v) {_vm.$set(_vm.filter, "gro_num", $$v)},expression:"filter.gro_num"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"country_id"}},[_vm._v("Country")]),_vm._v(" "),_c('countryLookup',{attrs:{"url":_vm.apiCountryLookup,"lookupId":_vm.filter.country_id},on:{"selected":function($event){_vm.setCountry($event)}}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"gro_date_start"}},[_vm._v("Date Start")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date"},model:{value:(_vm.filter.date_start),callback:function ($$v) {_vm.$set(_vm.filter, "date_start", $$v)},expression:"filter.date_start"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"gro_date_end"}},[_vm._v("Date End")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date"},model:{value:(_vm.filter.date_end),callback:function ($$v) {_vm.$set(_vm.filter, "date_end", $$v)},expression:"filter.date_end"}})],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"primary"},on:{"click":_vm.search}},[_vm._v("Search")]),_vm._v("\r\n              \r\n            "),_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"success"},on:{"click":_vm.newGro}},[_vm._v("New GRO")])],1)],1),_vm._v(" "),(_vm.getRowCount(_vm.searchResults) > 0 && !_vm.loading)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Search Results")])]),_vm._v(" "),_c('b-table',{staticClass:"table-hover",attrs:{"hover":_vm.hover,"striped":_vm.striped,"bordered":_vm.bordered,"small":_vm.small,"fixed":_vm.fixed,"responsive":"sm","fields":_vm.searchResultsFields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"items":_vm.searchResults},on:{"row-clicked":_vm.rowClick}}),_vm._v(" "),_c('nav',[_c('b-pagination',{attrs:{"total-rows":_vm.getRowCount(_vm.searchResults),"per-page":_vm.perPage,"prev-text":"Prev","next-text":"Next","hide-goto-end-buttons":""},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('exportExcel',{staticClass:"btn btn-primary btn-lg",attrs:{"size":"lg","data":_vm.searchResults,"fields":_vm.exportHeaders,"name":"gro.xls"}},[_vm._v("\r\n              Export to Excel\r\n          ")]),_vm._v("\r\n            \r\n          "),_c('b-button',{attrs:{"type":"button","size":"lg","variant":"success"},on:{"click":_vm.print}},[_vm._v("Print")])],1)],1)],1)],1):(_vm.noResults)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('div',{attrs:{"align":"center"}},[_c('strong',[_vm._v("No GRN Found")])])])],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gro_vue__ = __webpack_require__(279);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5df6461f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gro_vue__ = __webpack_require__(596);
function injectStyle (ssrContext) {
  __webpack_require__(595)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gro_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5df6461f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gro_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 595 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"gro_date"}},[_vm._v("GRO Date")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date","disabled":_vm.lockEntry},model:{value:(_vm.gro.gro_date),callback:function ($$v) {_vm.$set(_vm.gro, "gro_date", $$v)},expression:"gro.gro_date"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"reference_num"}},[_vm._v("Reference Number")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","disabled":_vm.lockEntry},model:{value:(_vm.gro.reference_num),callback:function ($$v) {_vm.$set(_vm.gro, "reference_num", $$v)},expression:"gro.reference_num"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('label',{attrs:{"for":"location_id"}},[_vm._v("Location From (Warehouse)")]),_vm._v(" "),_c('warehouseLookup',{attrs:{"url":_vm.apiWarehouseUrl,"lookupId":_vm.gro.location_id,"disabled":_vm.lockEntry},on:{"selected":function($event){_vm.setWarehouse($event)}}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('label',{attrs:{"for":"supplier_name"}},[_vm._v("Supplier")]),_vm._v(" "),_c('supplierLookup',{attrs:{"url":_vm.apiSupplierUrl,"lookupId":_vm.gro.supplier_id,"disabled":_vm.lockEntry},on:{"selected":function($event){_vm.setSupplier($event)}}})],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('label',{attrs:{"for":"remarks"}},[_vm._v("Remarks")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.gro.remarks),expression:"gro.remarks"}],staticClass:"form-control",attrs:{"rows":"5","id":"remarks","disabled":_vm.lockEntry},domProps:{"value":(_vm.gro.remarks)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.gro, "remarks", $event.target.value)}}})])],1)],1)],1)],1),_vm._v(" "),(_vm.gro.location_id != '' && !_vm.noItemsFound)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("GRO Items")])]),_vm._v(" "),_c('table',{staticClass:"table table-striped table-bordered"},[_c('thead',[_c('th',{staticStyle:{"min-width":"300px"}},[_vm._v("Product Name")]),_vm._v(" "),_c('th',{attrs:{"width":"250px"}},[_vm._v("Product Code")]),_vm._v(" "),_c('th',{attrs:{"width":"150px"}},[_vm._v("SOH")]),_vm._v(" "),_c('th',{attrs:{"width":"180px"}},[_vm._v("Return Qty")]),_vm._v(" "),_c('th',{attrs:{"width":"180px"}},[_vm._v("Unit GMP ("+_vm._s(_vm.gro.currency_id)+")")]),_vm._v(" "),_c('th',{attrs:{"width":"180px"}},[_vm._v("Total Amount ("+_vm._s(_vm.gro.currency_id)+")")]),_vm._v(" "),_c('th',{attrs:{"width":"30px"}})]),_vm._v(" "),_c('tbody',[_vm._l((_vm.gro.gro_items),function(row,index){return _c('tr',[_c('td',[_c('productLookup',{attrs:{"url":_vm.apiLocationProductUrl,"lookupId":row.product_id,"q2":_vm.gro.location_id,"get":1,"disabled":_vm.lockEntry},on:{"selected":function($event){_vm.setProduct($event, index)}}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.product_id))]),_vm._v(" "),(!_vm.lockEntry)?_c('td',[_vm._v(_vm._s(row.qty_soh*1 - row.qty*1))]):_vm._e(),_vm._v(" "),(_vm.lockEntry)?_c('td',[_vm._v(_vm._s(row.qty_soh*1))]):_vm._e(),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.qty),expression:"row.qty"}],staticClass:"form-control",attrs:{"type":"number","min":"0","name":"qty","disabled":_vm.lockEntry},domProps:{"value":(row.qty)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "qty", $event.target.value)}}})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.unit_gmp))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(((row.qty * 1) * (row.unit_gmp * 1)).toFixed(2)))]),_vm._v(" "),_c('td',[(!_vm.lockEntry)?_c('a',{attrs:{"href":"#","tabindex":"-1"},on:{"click":function($event){_vm.removeRow(index)}}},[_c('i',{staticClass:"fa fa-trash",staticStyle:{"font-size":"25px","color":"red"}})]):_vm._e()])])}),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"7"}},[(!_vm.lockEntry)?_c('b-button',{attrs:{"type":"submit","size":"md","variant":"success"},on:{"click":_vm.addRow}},[_vm._v("Add Product")]):_vm._e()],1)])],2)])])],1)],1):_vm._e(),_vm._v(" "),(_vm.gro.location_id != '' && _vm.noItemsFound)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('div',{attrs:{"align":"center"}},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("No Products Found in the Selected Warehouse! Please Select a Different Warehouse")])])])],1):_vm._e(),_vm._v(" "),(_vm.gro.location_id != '' && !_vm.noItemsFound)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-row',{staticStyle:{"padding":"0px 0px 20px 18px"}},[(!_vm.lockEntry && _vm.hideBtn)?_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"primary"},on:{"click":_vm.save}},[_vm._v("Save GRO")]):_vm._e(),_vm._v("\n                          \n                        "),(!_vm.lockEntry)?_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"danger"},on:{"click":_vm.closeGro}},[_vm._v("Cancel")]):_vm._e(),_vm._v(" "),(_vm.lockEntry)?_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"success"},on:{"click":_vm.print}},[_vm._v("Print")]):_vm._e(),_vm._v("  \n                        "),(_vm.lockEntry)?_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"danger"},on:{"click":_vm.back}},[_vm._v("Back")]):_vm._e()],1)],1)],1):_vm._e(),_vm._v(" "),_c('b-modal',{attrs:{"title":"Confirmation","centered":"","header-bg-variant":"success","no-close-on-backdrop":""},on:{"ok":_vm.handleOk},model:{value:(_vm.modalShow),callback:function ($$v) {_vm.modalShow=$$v},expression:"modalShow"}},[_c('p',{staticStyle:{"color":"darkblue"}},[_vm._v("Confirmed Save GRO?")])]),_vm._v(" "),_c('b-modal',{attrs:{"title":"Confirmation","centered":"","header-bg-variant":"success","no-close-on-backdrop":""},on:{"ok":_vm.handleCancelOk},model:{value:(_vm.modalCancelShow),callback:function ($$v) {_vm.modalCancelShow=$$v},expression:"modalCancelShow"}},[_c('p',{staticStyle:{"color":"darkblue"}},[_vm._v("Confirmed Cancel GRO?")])]),_vm._v(" "),_c('b-modal',{ref:"myModalRef",attrs:{"hide-header-close":"","hide-footer":"","title":"Goods Return Outwards","centered":"","header-bg-variant":"success","no-close-on-backdrop":"","no-close-on-esc":""}},[_c('div',{staticClass:"d-block text-center"},[_c('p',[_vm._v("Goods Return Outwards "),_c('strong',{staticStyle:{"color":"green"}},[_vm._v(" "+_vm._s(_vm.groDocNo))]),_vm._v(" is saved."),_c('br'),_c('br')])]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"variant":"outline-danger"},on:{"click":_vm.hideModal}},[_vm._v("Ok")])],1),_vm._v(" "),_c('b-modal',{ref:"myErrorModalRef",attrs:{"hide-header-close":"","hide-footer":"","title":"Invalid Entries","centered":"","header-bg-variant":"danger","no-close-on-backdrop":"","no-close-on-esc":""}},[_c('div',{staticClass:"d-block text-center"},[_c('p',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage))])]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"variant":"danger"},on:{"click":_vm.hideErrorModal}},[_vm._v("OK")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_scm_vue__ = __webpack_require__(280);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b6a5abcc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_scm_vue__ = __webpack_require__(599);
function injectStyle (ssrContext) {
  __webpack_require__(598)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_scm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b6a5abcc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_scm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 598 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(_vm.loading)?_c('spinner'):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Stock Card Movement")])]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"location_id"}},[_vm._v("Stock Location")]),_vm._v(" "),_c('warehouseLookup',{attrs:{"url":_vm.apiWarehouseLookup,"lookupId":_vm.filter.location_id,"disabled":_vm.lockEntry},on:{"selected":function($event){_vm.setWarehouse($event)}}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"5"}},[_c('b-form-group',[_c('label',{attrs:{"for":"product_id"}},[_vm._v("Product")]),_vm._v(" "),_c('productLookup',{attrs:{"url":_vm.apiLocationProductUrl,"lookupId":_vm.filter.product_id,"q2":_vm.filter.location_id,"disabled":_vm.lockEntry},on:{"selected":function($event){_vm.setProduct($event)}}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"date_start"}},[_vm._v("Date Start")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date","disabled":_vm.lockEntry},model:{value:(_vm.filter.date_start),callback:function ($$v) {_vm.$set(_vm.filter, "date_start", $$v)},expression:"filter.date_start"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('label',{attrs:{"for":"date_end"}},[_vm._v("Date End")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date","disabled":_vm.lockEntry},model:{value:(_vm.filter.date_end),callback:function ($$v) {_vm.$set(_vm.filter, "date_end", $$v)},expression:"filter.date_end"}})],1)],1),_vm._v(" "),(_vm.getRowCount(_vm.searchResults) <= 0)?_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"primary","disabled":_vm.filter.product_id == '' || _vm.filter.location_id == ''},on:{"click":_vm.search}},[_vm._v("Search")]),_vm._v("\n                      \n                ")],1):_vm._e()],1),_vm._v(" "),(_vm.getRowCount(_vm.searchResults) > 0 && !_vm.loading)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Summary")])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped table-bordered"},[_c('thead',[_c('th'),_vm._v(" "),_c('th',{staticStyle:{"text-align":"center"}},[_vm._v("DO")]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"center"}},[_vm._v("GRN")]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"center"}},[_vm._v("GRO")]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"center"}},[_vm._v("GRI")]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"center"}},[_vm._v("WTO")]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"center"}},[_vm._v("WTR")]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"center"}},[_vm._v("SAN")]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"center"}},[_vm._v("SRF")]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"center"}},[_vm._v("SRR")]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"center"}},[_vm._v("WSC")]),_vm._v(" "),_c('th',{staticStyle:{"text-align":"center"}},[_vm._v("Total Qty")])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_vm._v("Qty Out")]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.searchSummary[0]["DO"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.searchSummary[0]["GRN"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.searchSummary[0]["GRO"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.searchSummary[0]["GRI"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.searchSummary[0]["WTO"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.searchSummary[0]["WTR"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.searchSummary[0]["SAN"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.searchSummary[0]["SRF"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.searchSummary[0]["SRR"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.searchSummary[0]["WSC"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.searchSummary[0]["TOTAL"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Qty In")]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.searchSummary[1]["DO"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.searchSummary[1]["GRN"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.searchSummary[1]["GRO"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.searchSummary[1]["GRI"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.searchSummary[1]["WTO"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.searchSummary[1]["WTR"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.searchSummary[1]["SAN"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.searchSummary[1]["SRF"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.searchSummary[1]["SRR"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.searchSummary[1]["WSC"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.searchSummary[1]["TOTAL"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Total Trans")]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.searchSummary[2]["DO"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.searchSummary[2]["GRN"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.searchSummary[2]["GRO"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.searchSummary[2]["GRI"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.searchSummary[2]["WTO"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.searchSummary[2]["WTR"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.searchSummary[2]["SAN"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.searchSummary[2]["SRF"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.searchSummary[2]["SRR"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.searchSummary[2]["WSC"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.searchSummary[2]["TOTAL"].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))])])])])])])],1)],1):_vm._e(),_vm._v(" "),(_vm.getRowCount(_vm.searchResults) > 0 && !_vm.loading)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Stock Movement Transactions")])]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"opening_balance"}},[_vm._v("Opening Balance")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","disabled":""},model:{value:(_vm.opening_balance),callback:function ($$v) {_vm.opening_balance=$$v},expression:"opening_balance"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"closing_balance"}},[_vm._v("Closing Balance")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","disabled":""},model:{value:(_vm.closing_balance),callback:function ($$v) {_vm.closing_balance=$$v},expression:"closing_balance"}})],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"calss":"table-responsive"}},[_c('b-table',{staticClass:"table-hover",attrs:{"hover":_vm.hover,"striped":_vm.striped,"bordered":_vm.bordered,"small":_vm.small,"fixed":_vm.fixed,"responsive":"sm","fields":_vm.searchResultsFields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"items":_vm.searchResults}})],1),_vm._v(" "),_c('nav',[_c('b-pagination',{attrs:{"total-rows":_vm.getRowCount(_vm.searchResults),"per-page":_vm.perPage,"prev-text":"Prev","next-text":"Next","hide-goto-end-buttons":""},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('exportExcel',{staticClass:"btn btn-primary btn-lg",attrs:{"size":"lg","data":_vm.searchResults,"fields":_vm.exportHeaders,"name":"scm.xls"}},[_vm._v("\n                                Export to Excel\n                            ")]),_vm._v("\n                              \n                            "),_c('b-button',{attrs:{"type":"button","size":"lg","variant":"success"},on:{"click":_vm.print}},[_vm._v("Print")]),_vm._v("\n                                  \n                            "),_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"danger"},on:{"click":_vm.back}},[_vm._v("Back")])],1)],1)],1)],1):(_vm.noResults && !_vm.loading)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('div',{attrs:{"align":"center"}},[_c('strong',[_vm._v("No Stock Movement Transactions Found")])])])],1):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sbr_vue__ = __webpack_require__(281);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37a69220_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sbr_vue__ = __webpack_require__(603);
function injectStyle (ssrContext) {
  __webpack_require__(601)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sbr_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37a69220_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sbr_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 601 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 602 */,
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(_vm.loading)?_c('spinner'):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[(_vm.getRowCount(_vm.searchResults) <=0)?_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Stock Balance Record")])]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',[_vm._v("Country")]),_vm._v(" "),_c('countryLookup',{attrs:{"url":_vm.apiCountryLookup,"lookupId":_vm.filter.country_id},on:{"selected":function($event){_vm.setCountry($event)}}})],1)],1)],1),_vm._v(" "),(_vm.filter.country_id != '' && _vm.warehouses.length > 0)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-group',[_c('label',{staticClass:"checkcontainer"},[_vm._v(_vm._s(_vm.allSelected ? 'Un-select All Warehouses' : 'Select All Warehouses')+"\r\n                                    "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.allSelected),expression:"allSelected"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.allSelected)?_vm._i(_vm.allSelected,null)>-1:(_vm.allSelected)},on:{"click":_vm.selectAll,"change":function($event){var $$a=_vm.allSelected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.allSelected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.allSelected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.allSelected=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})]),_vm._v(" "),_vm._l((_vm.warehouses),function(option){return _c('b-form-checkbox-group',[_c('label',{staticClass:"checkcontainer"},[_vm._v(_vm._s(option)+"\r\n                                    "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedLocations),expression:"selectedLocations"}],attrs:{"type":"checkbox"},domProps:{"value":option,"checked":Array.isArray(_vm.selectedLocations)?_vm._i(_vm.selectedLocations,option)>-1:(_vm.selectedLocations)},on:{"click":_vm.select,"change":function($event){var $$a=_vm.selectedLocations,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=option,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectedLocations=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectedLocations=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectedLocations=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])])})],2)],1)],1):_vm._e(),_vm._v(" "),(_vm.filter.country_id!='' && _vm.warehouses.length <= 0)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('div',{attrs:{"align":"left"}},[_vm._v("No Warehouses Found in the selected Country!Please Select Different Country.")]),_vm._v(" "),_c('br')])],1):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('b-form-group',[_c('label',[_vm._v("As At Date")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date","disabled":_vm.lockEntry},model:{value:(_vm.filter.asof_date),callback:function ($$v) {_vm.$set(_vm.filter, "asof_date", $$v)},expression:"filter.asof_date"}})],1)],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"primary"},on:{"click":_vm.search}},[_vm._v("Search")])],1)],1):_vm._e()],1)],1),_vm._v(" "),(_vm.getRowCount(_vm.searchResults) > 0 && !_vm.loading)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Stock Balance Record")])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('b-table',{staticClass:"table-hover",attrs:{"hover":_vm.hover,"striped":_vm.striped,"bordered":_vm.bordered,"small":_vm.small,"fixed":_vm.fixed,"responsive":"sm","fields":_vm.searchResultsFields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"items":_vm.searchResults}})],1),_vm._v(" "),_c('nav',[_c('b-pagination',{attrs:{"total-rows":_vm.getRowCount(_vm.searchResults),"per-page":_vm.perPage,"prev-text":"Prev","next-text":"Next","hide-goto-end-buttons":""},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('exportExcel',{staticClass:"btn btn-primary btn-lg",attrs:{"size":"lg","data":_vm.searchResults,"fields":_vm.exportHeaders,"name":"sbr.xls"}},[_vm._v("\r\n                            Export to Excel\r\n                        ")]),_vm._v("\r\n                          \r\n                    "),_c('b-button',{attrs:{"type":"button","size":"lg","variant":"success"},on:{"click":_vm.print}},[_vm._v("Print")]),_vm._v("\r\n                      \r\n                    "),_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"danger"},on:{"click":_vm.back}},[_vm._v("Back")])],1)])],1)],1):(_vm.noResults && !_vm.loading)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('div',{attrs:{"align":"center"}},[_c('strong',[_vm._v("No Stock Balance Records Found")])])])],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wtos_vue__ = __webpack_require__(282);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_305f069a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_wtos_vue__ = __webpack_require__(605);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wtos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_305f069a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_wtos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(_vm.loading)?_c('spinner'):_vm._e(),_vm._v(" "),_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Search WTO")])]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"wto_num"}},[_vm._v("WTO No")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","id":"wto_num"},model:{value:(_vm.filter.wto_num),callback:function ($$v) {_vm.$set(_vm.filter, "wto_num", $$v)},expression:"filter.wto_num"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"country_id"}},[_vm._v("Country")]),_vm._v(" "),_c('countryLookup',{attrs:{"url":_vm.apiCountryLookup,"lookupId":_vm.filter.country_id},on:{"selected":function($event){_vm.setCountry($event)}}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"date_start"}},[_vm._v("Date Start")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date"},model:{value:(_vm.filter.date_start),callback:function ($$v) {_vm.$set(_vm.filter, "date_start", $$v)},expression:"filter.date_start"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"date_end"}},[_vm._v("Date End")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date"},model:{value:(_vm.filter.date_end),callback:function ($$v) {_vm.$set(_vm.filter, "date_end", $$v)},expression:"filter.date_end"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"status"}},[_vm._v("Status")]),_vm._v(" "),_c('b-form-select',{attrs:{"id":"status","plain":true,"options":['','OPEN', 'CLOSE', 'MANUAL-CLOSED'],"value":""},model:{value:(_vm.filter.status),callback:function ($$v) {_vm.$set(_vm.filter, "status", $$v)},expression:"filter.status"}})],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"primary"},on:{"click":_vm.search}},[_vm._v("Search")]),_vm._v("\n            \n          "),_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"success"},on:{"click":_vm.newWTO}},[_vm._v("New WTO")])],1)],1),_vm._v(" "),(_vm.getRowCount(_vm.searchResults) > 0 && !_vm.loading )?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Search Results")])]),_vm._v(" "),_c('b-table',{staticClass:"table-hover",attrs:{"hover":_vm.hover,"striped":_vm.striped,"bordered":_vm.bordered,"small":_vm.small,"fixed":_vm.fixed,"responsive":"sm","fields":_vm.searchResultsFields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"items":_vm.searchResults},on:{"row-clicked":_vm.rowClick}}),_vm._v(" "),_c('nav',[_c('b-pagination',{attrs:{"total-rows":_vm.getRowCount(_vm.searchResults),"per-page":_vm.perPage,"prev-text":"Prev","next-text":"Next","hide-goto-end-buttons":""},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('exportExcel',{staticClass:"btn btn-primary btn-lg",attrs:{"size":"lg","data":_vm.searchResults,"fields":_vm.exportHeaders,"name":"wto.xls"}},[_vm._v("\n                  Export to Excel\n              ")]),_vm._v("\n               \n            "),_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"success"},on:{"click":_vm.print}},[_vm._v("Print")])],1)],1)],1)],1):(_vm.noResults)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('div',{attrs:{"align":"center"}},[_c('strong',[_vm._v("No WTO Found")])])])],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wto_vue__ = __webpack_require__(283);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_452093c6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_wto_vue__ = __webpack_require__(608);
function injectStyle (ssrContext) {
  __webpack_require__(607)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wto_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_452093c6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_wto_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 607 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[(_vm.wto.status)?_c('strong',[_vm._v(_vm._s(_vm.title)+" - "+_vm._s(_vm.wto.status))]):_c('strong',[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"wto_date"}},[_vm._v("WTO Date")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date","disabled":_vm.lockEntry},model:{value:(_vm.wto.wto_date),callback:function ($$v) {_vm.$set(_vm.wto, "wto_date", $$v)},expression:"wto.wto_date"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('label',{attrs:{"for":"location_id"}},[_vm._v("Country")]),_vm._v(" "),_c('countryLookup',{attrs:{"url":_vm.apiCountryLookup,"lookupId":_vm.wto.country_id,"disabled":_vm.lockEntry},on:{"selected":function($event){_vm.setCountry($event)}}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('label',{attrs:{"for":"location_id"}},[_vm._v("Location From (Warehouse)")]),_vm._v(" "),_c('warehouseLookup',{ref:"warehouseFrom",attrs:{"url":_vm.apiWarehouseUrl,"lookupId":_vm.wto.from_location_id,"q2":_vm.wto.country_id,"disabled":_vm.wto.country_id =='' || _vm.lockEntry},on:{"selected":function($event){_vm.setWarehouseFrom($event)}}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('label',{attrs:{"for":"location_id"}},[_vm._v("Location To (Warehouse)")]),_vm._v(" "),_c('warehouseLookup',{ref:"warehouseTo",attrs:{"url":_vm.apiWarehouseUrl,"lookupId":_vm.wto.to_location_id,"q2":_vm.wto.country_id,"disabled":_vm.wto.country_id == '' || _vm.lockEntry},on:{"selected":function($event){_vm.setWarehouseTo($event)}}})],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"reason"}},[_vm._v("Reason")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","disabled":_vm.lockEntry,"maxlength":"255"},model:{value:(_vm.wto.reason),callback:function ($$v) {_vm.$set(_vm.wto, "reason", $$v)},expression:"wto.reason"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"reference_num"}},[_vm._v("Reference Num")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","disabled":_vm.lockEntry,"maxlength":"255"},model:{value:(_vm.wto.reference_num),callback:function ($$v) {_vm.$set(_vm.wto, "reference_num", $$v)},expression:"wto.reference_num"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('label',{attrs:{"for":"remarks"}},[_vm._v("Remarks")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.wto.remarks),expression:"wto.remarks"}],staticClass:"form-control",attrs:{"rows":"5","id":"remarks","disabled":_vm.lockEntry},domProps:{"value":(_vm.wto.remarks)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.wto, "remarks", $event.target.value)}}})])],1)],1)],1)],1),_vm._v(" "),_c('b-row',[(_vm.checkValue())?_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("WTO Items")])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped table-bordered"},[_c('thead',[_c('th',{attrs:{"width":"10px"}},[_vm._v("S/N")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"300px"}},[_vm._v("Product Name")]),_vm._v(" "),_c('th',{attrs:{"width":"250px"}},[_vm._v("Product Code")]),_vm._v(" "),_c('th',{attrs:{"width":"150px"}},[_vm._v("SOH")]),_vm._v(" "),_c('th',{attrs:{"width":"180px"}},[_vm._v("Transfer Qty")]),_vm._v(" "),_c('th',{attrs:{"width":"30px"}})]),_vm._v(" "),_c('tbody',[_vm._l((_vm.wto.wto_items),function(row,index){return _c('tr',[_c('td',[_vm._v(_vm._s((index*1)+1))]),_vm._v(" "),_c('td',[_c('productLookup',{attrs:{"url":_vm.apiLocationProductUrl,"lookupId":row.product_id,"q2":_vm.wto.from_location_id,"get":0,"disabled":_vm.lockEntry},on:{"selected":function($event){_vm.setProduct($event,index)}}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.product_id))]),_vm._v(" "),(!_vm.lockEntry)?_c('td',[_vm._v(_vm._s(row.qty_soh*1 - row.qty*1))]):_vm._e(),_vm._v(" "),(_vm.lockEntry)?_c('td',[_vm._v(_vm._s(row.qty_soh*1))]):_vm._e(),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.qty),expression:"row.qty"}],staticClass:"form-control",attrs:{"type":"number","name":"qty","disabled":_vm.lockEntry},domProps:{"value":(row.qty)},on:{"change":function($event){_vm.validateQty(index)},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "qty", $event.target.value)}}})]),_vm._v(" "),_c('td',[(!_vm.lockEntry)?_c('a',{attrs:{"href":"#","tabindex":"-1"},on:{"click":function($event){_vm.removeRow(index)}}},[_c('i',{staticClass:"fa fa-trash",staticStyle:{"font-size":"25px","color":"red"}})]):_vm._e()])])}),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"7"}},[(!_vm.lockEntry)?_c('b-button',{attrs:{"type":"submit","size":"md","variant":"success"},on:{"click":_vm.addRow}},[_vm._v("Add Product")]):_vm._e()],1)])],2)])])])],1):_vm._e()],1),_vm._v(" "),_c('b-row',[(_vm.checkValue())?_c('b-col',{attrs:{"sm":"12"}},[_c('b-row',{staticStyle:{"padding":"0px 0px 20px 18px"}},[(!_vm.lockEntry)?_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"primary"},on:{"click":_vm.confirmSave}},[_vm._v("Save WTO")]):_vm._e(),_vm._v("\n                           \n                    "),(!_vm.lockEntry)?_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"danger"},on:{"click":_vm.confirmCancel}},[_vm._v("Cancel")]):_vm._e(),_vm._v(" "),(_vm.lockEntry && !_vm.hideBtns)?_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"primary"},on:{"click":_vm.confirmManualClose}},[_vm._v("Manual-Close")]):_vm._e(),_vm._v("\n                      \n                    "),(_vm.lockEntry)?_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"success"},on:{"click":_vm.print}},[_vm._v("Print")]):_vm._e(),_vm._v("\n                      \n                    "),(_vm.lockEntry)?_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"danger"},on:{"click":_vm.back}},[_vm._v("Back")]):_vm._e()],1)],1):_vm._e()],1),_vm._v(" "),_c('b-row',[_c('b-modal',{attrs:{"title":"Confirmation","centered":"","header-bg-variant":"success","no-close-on-backdrop":""},on:{"ok":_vm.save},model:{value:(_vm.modalShow),callback:function ($$v) {_vm.modalShow=$$v},expression:"modalShow"}},[_c('p',{staticStyle:{"color":"darkblue"}},[_vm._v("Confirmed Save WTO?")])]),_vm._v(" "),_c('b-modal',{attrs:{"title":"Confirmation","centered":"","header-bg-variant":"success","no-close-on-backdrop":""},on:{"ok":_vm.manualClose},model:{value:(_vm.modalManualCloseShow),callback:function ($$v) {_vm.modalManualCloseShow=$$v},expression:"modalManualCloseShow"}},[_c('p',{staticStyle:{"color":"darkblue"}},[_vm._v("Confirmed Manual Close?")])]),_vm._v(" "),_c('b-modal',{attrs:{"title":"Confirmation","centered":"","header-bg-variant":"success","no-close-on-backdrop":""},on:{"ok":_vm.cancel},model:{value:(_vm.modalCancelShow),callback:function ($$v) {_vm.modalCancelShow=$$v},expression:"modalCancelShow"}},[_c('p',{staticStyle:{"color":"darkblue"}},[_vm._v("Confirmed Cancel WTO?")])]),_vm._v(" "),_c('b-modal',{ref:"myModalRef",attrs:{"hide-header-close":"","hide-footer":"","title":"Warehouse Transfer Order","centered":"","header-bg-variant":"success","no-close-on-backdrop":"","no-close-on-esc":""}},[_c('div',{staticClass:"d-block text-center"},[_c('p',[_vm._v("Warehouse Transfer Order "),_c('strong',{staticStyle:{"color":"green"}},[_vm._v(" "+_vm._s(_vm.wtoDocNo))]),_vm._v(" is "+_vm._s(_vm.displayTxt)+"."),_c('br'),_c('br')])]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"variant":"outline-danger"},on:{"click":_vm.hideModal}},[_vm._v("Ok")])],1),_vm._v(" "),_c('b-modal',{ref:"myErrorModalRef",attrs:{"hide-header-close":"","hide-footer":"","title":"Invalid Entries","centered":"","header-bg-variant":"danger","no-close-on-backdrop":"","no-close-on-esc":""}},[_c('div',{staticClass:"d-block text-center"},[_c('p',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage))])]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"variant":"danger"},on:{"click":_vm.hideErrorModal}},[_vm._v("OK")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wtrs_vue__ = __webpack_require__(284);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_118e71f6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_wtrs_vue__ = __webpack_require__(610);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wtrs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_118e71f6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_wtrs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(_vm.loading)?_c('spinner'):_vm._e(),_vm._v(" "),_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Search WTR")])]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"wto_num"}},[_vm._v("WTO No")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","id":"wto_num"},model:{value:(_vm.filter.wto_num),callback:function ($$v) {_vm.$set(_vm.filter, "wto_num", $$v)},expression:"filter.wto_num"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"gro_num"}},[_vm._v("WTR No")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","id":"wtr_num"},model:{value:(_vm.filter.wtr_num),callback:function ($$v) {_vm.$set(_vm.filter, "wtr_num", $$v)},expression:"filter.wtr_num"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"country_id"}},[_vm._v("Country")]),_vm._v(" "),_c('countryLookup',{attrs:{"url":_vm.apiCountryLookup,"lookupId":_vm.filter.country_id},on:{"selected":function($event){_vm.setCountry($event)}}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"date_start"}},[_vm._v("Date Start")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date"},model:{value:(_vm.filter.date_start),callback:function ($$v) {_vm.$set(_vm.filter, "date_start", $$v)},expression:"filter.date_start"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"date_end"}},[_vm._v("Date End")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date"},model:{value:(_vm.filter.date_end),callback:function ($$v) {_vm.$set(_vm.filter, "date_end", $$v)},expression:"filter.date_end"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"status"}},[_vm._v("Status")]),_vm._v(" "),_c('b-form-select',{attrs:{"id":"status","plain":true,"options":['','OPEN', 'CLOSE', 'MANUAL-CLOSED'],"value":""},model:{value:(_vm.filter.status),callback:function ($$v) {_vm.$set(_vm.filter, "status", $$v)},expression:"filter.status"}})],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"primary"},on:{"click":_vm.search}},[_vm._v("Search")]),_vm._v("\n            \n          "),(_vm.isWtrAdmin)?_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"success"},on:{"click":_vm.newWTR}},[_vm._v("New WTR")]):_vm._e()],1)],1),_vm._v(" "),(_vm.getRowCount(_vm.searchResults) > 0 && !_vm.loading)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Search Results")])]),_vm._v(" "),_c('b-table',{staticClass:"table-hover",attrs:{"hover":_vm.hover,"striped":_vm.striped,"bordered":_vm.bordered,"small":_vm.small,"fixed":_vm.fixed,"responsive":"sm","fields":_vm.searchResultsFields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"items":_vm.searchResults},on:{"row-clicked":_vm.rowClick}}),_vm._v(" "),_c('nav',[_c('b-pagination',{attrs:{"total-rows":_vm.getRowCount(_vm.searchResults),"per-page":_vm.perPage,"prev-text":"Prev","next-text":"Next","hide-goto-end-buttons":""},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('exportExcel',{staticClass:"btn btn-primary btn-lg",attrs:{"size":"lg","data":_vm.searchResults,"fields":_vm.exportHeaders,"name":"wtr.xls"}},[_vm._v("\n                  Export to Excel\n              ")]),_vm._v("\n               \n              "),_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"success"},on:{"click":_vm.print}},[_vm._v("Print")])],1)],1)],1)],1):(_vm.noResults && !_vm.loading)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('div',{attrs:{"align":"center"}},[_c('strong',[_vm._v("No WTR Found")])])])],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wtr_vue__ = __webpack_require__(285);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a5e4c89a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_wtr_vue__ = __webpack_require__(612);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wtr_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a5e4c89a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_wtr_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn",on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"esc",27,$event.key)){ return null; }_vm.cancelWto($event)}}},[_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[(!_vm.isWTORetrieved)?_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-group',{attrs:{"name":"wto","label":"WTO No","label-for":"elementsPrependAppend","description":""}},[_c('b-input-group',[_c('wtoLookup',{ref:"wtoLookupInput",staticStyle:{"min-width":"300px"},attrs:{"url":_vm.apiWtoLookup,"basic":1,"lookupId":_vm.wtr.wto_num},on:{"selected":function($event){_vm.setWtoId($event)}}}),_vm._v("   \n                                "),_c('b-button',{attrs:{"variant":"primary","disabled":_vm.wtr.wto_num ==''},on:{"click":_vm.retrieveWTO}},[_vm._v("Retrieve WTO")])],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.isWTORetrieved)?_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-group',[_c('label',{attrs:{"for":"wtr_date"}},[_vm._v("WTR Date")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date","id":"wtr_date"},model:{value:(_vm.wtr.wtr_date),callback:function ($$v) {_vm.$set(_vm.wtr, "wtr_date", $$v)},expression:"wtr.wtr_date"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('label',{attrs:{"for":"remarks"}},[_vm._v("WTR Remarks")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.wtr.remarks),expression:"wtr.remarks"}],staticClass:"form-control",attrs:{"rows":"5","id":"remarks"},domProps:{"value":(_vm.wtr.remarks)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.wtr, "remarks", $event.target.value)}}})])],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('label',{attrs:{"for":"reference_num"}},[_vm._v("Reference Number")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","id":"reference_num"},model:{value:(_vm.wtr.reference_num),callback:function ($$v) {_vm.$set(_vm.wtr, "reference_num", $$v)},expression:"wtr.reference_num"}})],1)],1)],1),_vm._v(" "),(_vm.wtr.wto.wtrs.length > 0)?_c('b-col',{attrs:{"sm":"6"}},[_c('br'),_vm._v(" "),_c('b-card',[_c('div',{staticClass:"table-responsive"},[_c('table',[_c('thead',[_c('th',{staticStyle:{"min-width":"138px","height":"40px"}},[_vm._v("WTR No")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"100px"}},[_vm._v("Date")]),_vm._v(" "),_c('th',[_vm._v("Generated By")])]),_vm._v(" "),_c('tbody',_vm._l((_vm.wtr.wto.wtrs),function(row,index){return _c('tr',{ref:'title',refInFor:true,staticStyle:{"height":"40px"}},[_c('td',[_c('b-button',{attrs:{"type":"submit","size":"md","variant":"primary"},on:{"click":function($event){_vm.printWTR(row)}}},[_vm._v(_vm._s(row.wtr_num)+" ")])],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.wtr_date_friendly))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.author_user_shortname))])])}))])])])],1):_vm._e()],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('hr'),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"wto_num"}},[_vm._v("WTO No")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","disabled":""},model:{value:(_vm.wtr.wto_num),callback:function ($$v) {_vm.$set(_vm.wtr, "wto_num", $$v)},expression:"wtr.wto_num"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"wto_date"}},[_vm._v("WTO Date")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date","disabled":""},model:{value:(_vm.wtr.wto.wto_date),callback:function ($$v) {_vm.$set(_vm.wtr.wto, "wto_date", $$v)},expression:"wtr.wto.wto_date"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"status"}},[_vm._v("Status")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","disabled":""},model:{value:(_vm.wtr.wto.status),callback:function ($$v) {_vm.$set(_vm.wtr.wto, "status", $$v)},expression:"wtr.wto.status"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"reason"}},[_vm._v("Reason")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","disabled":""},model:{value:(_vm.wtr.wto.reason),callback:function ($$v) {_vm.$set(_vm.wtr.wto, "reason", $$v)},expression:"wtr.wto.reason"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"location_from"}},[_vm._v("Location From (Warehouse)")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","disabled":""},model:{value:(_vm.wtr.wto.from_location_full),callback:function ($$v) {_vm.$set(_vm.wtr.wto, "from_location_full", $$v)},expression:"wtr.wto.from_location_full"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"location"}},[_vm._v("Receiving Warehouse")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","disabled":""},model:{value:(_vm.wtr.wto.to_location_full),callback:function ($$v) {_vm.$set(_vm.wtr.wto, "to_location_full", $$v)},expression:"wtr.wto.to_location_full"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('label',{attrs:{"for":"remarks"}},[_vm._v("WTO Remarks")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.wtr.wto.remarks),expression:"wtr.wto.remarks"}],staticClass:"form-control",attrs:{"rows":"5","id":"remarks","disabled":""},domProps:{"value":(_vm.wtr.wto.remarks)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.wtr.wto, "remarks", $event.target.value)}}})])],1)],1):_vm._e()],1)],1),_vm._v(" "),(_vm.isWTORetrieved)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("WTR Items")])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped table-bordered"},[_c('thead',[_c('th',{staticStyle:{"width":"10px"}},[_vm._v("S/N")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"300px"}},[_vm._v("Product Name")]),_vm._v(" "),_c('th',{attrs:{"width":"150px"}},[_vm._v("Product Code")]),_vm._v(" "),_c('th',{attrs:{"width":"150px"}},[_vm._v("SOH")]),_vm._v(" "),_c('th',{attrs:{"width":"180px"}},[_vm._v("Requested Qty")]),_vm._v(" "),_c('th',{attrs:{"width":"180px"}},[_vm._v("Received Qty")]),_vm._v(" "),_c('th',{attrs:{"width":"180px"}},[_vm._v("Update Qty")])]),_vm._v(" "),_c('tbody',_vm._l((_vm.wtr.wto.wto_items),function(row,index){return _c('tr',[_c('td',[_vm._v(_vm._s((index*1) + 1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.product_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.product_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s((row.qty_to_soh*1) + (row.qty_received_current*1)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.qty*1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.qty_received*1))]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.qty_received_current),expression:"row.qty_received_current"}],staticClass:"form-control",attrs:{"type":"number","name":"received_qty","disabled":_vm.wtr.wto.status != 'OPEN' || (row.qty * 1) - (row.qty_received * 1) <= 0},domProps:{"value":(row.qty_received_current)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "qty_received_current", $event.target.value)}}})])])}))])])])],1)],1):_vm._e(),_vm._v(" "),(_vm.isWTORetrieved)?_c('b-row',{staticStyle:{"padding":"0px 0px 20px 18px"}},[(_vm.wtr.wto.status == 'OPEN' && _vm.isWtrAdmin)?_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"primary"},on:{"click":_vm.confirmSave}},[_vm._v("Save WTR")]):_vm._e(),_vm._v(" "),_c('b-modal',{attrs:{"title":"Confirmation","centered":"","header-bg-variant":"success","no-close-on-backdrop":""},on:{"ok":_vm.save},model:{value:(_vm.modalShow),callback:function ($$v) {_vm.modalShow=$$v},expression:"modalShow"}},[_c('p',{staticStyle:{"color":"darkblue"}},[_vm._v("Confirmed Save?")])]),_vm._v(" "),_c('b-modal',{attrs:{"title":"Confirmation","centered":"","header-bg-variant":"success","no-close-on-backdrop":""},on:{"ok":_vm.cancel},model:{value:(_vm.modalCancelShow),callback:function ($$v) {_vm.modalCancelShow=$$v},expression:"modalCancelShow"}},[_c('p',{staticStyle:{"color":"darkblue"}},[_vm._v("Confirmed Cancel?")])]),_vm._v(" "),_c('b-modal',{ref:"myModalRef",attrs:{"hide-header-close":"","hide-footer":"","title":"Warehouse Transfer Receiving","centered":"","header-bg-variant":"success","no-close-on-backdrop":"","no-close-on-esc":""}},[_c('div',{staticClass:"d-block text-center"},[_c('p',[_vm._v("Warehouse Transfer Receiving "),_c('strong',{staticStyle:{"color":"green"}},[_vm._v(" "+_vm._s(_vm.wtrDocNo))]),_vm._v(" is saved."),_c('br'),_c('br')])]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"variant":"outline-danger"},on:{"click":_vm.hideModal}},[_vm._v("Ok")])],1),_vm._v(" "),_c('b-modal',{ref:"myErrorModalRef",attrs:{"hide-header-close":"","hide-footer":"","title":"Invalid Entries","centered":"","header-bg-variant":"danger","no-close-on-backdrop":"","no-close-on-esc":""}},[_c('div',{staticClass:"d-block text-center"},[_c('p',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage))])]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"variant":"danger"},on:{"click":_vm.hideErrorModal}},[_vm._v("OK")])],1),_vm._v("\n              \n            "),(_vm.wtr.wto.status == 'OPEN')?_c('b-button',{attrs:{"type":"button","size":"lg","variant":"danger"},on:{"click":_vm.confirmCancel}},[_vm._v("Cancel")]):_vm._e(),_vm._v(" "),(_vm.wtr.wto.status == 'CLOSE' || _vm.wtr.wto.status == 'MANUAL-CLOSED')?_c('b-button',{attrs:{"type":"button","size":"lg","variant":"success"},on:{"click":_vm.print}},[_vm._v("Print")]):_vm._e(),_vm._v("  \n            "),(_vm.wtr.wto.status == 'CLOSE' || _vm.wtr.wto.status == 'MANUAL-CLOSED')?_c('b-button',{attrs:{"type":"button","size":"lg","variant":"danger"},on:{"click":_vm.back}},[_vm._v("Back")]):_vm._e()],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wscs_vue__ = __webpack_require__(286);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66214c84_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_wscs_vue__ = __webpack_require__(614);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wscs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66214c84_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_wscs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(_vm.loading)?_c('spinner'):_vm._e(),_vm._v(" "),_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Search Sales Cancellation")])]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',[_vm._v("Credit Note No")]),_vm._v(" "),_c('wscLookup',{attrs:{"url":_vm.apiWscLookUp,"lookupId":_vm.filter.credit_note_number},on:{"selected":function($event){_vm.setWsc($event)}}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"country_id"}},[_vm._v("Country")]),_vm._v(" "),_c('countryLookup',{attrs:{"url":_vm.apiCountryLookup,"lookupId":_vm.filter.country_id},on:{"selected":function($event){_vm.setCountry($event)}}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"date_start"}},[_vm._v("Date Start")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date"},model:{value:(_vm.filter.from_date),callback:function ($$v) {_vm.$set(_vm.filter, "from_date", $$v)},expression:"filter.from_date"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"date_end"}},[_vm._v("Date End")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date"},model:{value:(_vm.filter.to_date),callback:function ($$v) {_vm.$set(_vm.filter, "to_date", $$v)},expression:"filter.to_date"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"status"}},[_vm._v("Status")]),_vm._v(" "),_c('b-form-select',{attrs:{"id":"status","plain":true,"options":['','PENDING', 'COMPLETED'],"value":""},model:{value:(_vm.filter.cancellation_status_name),callback:function ($$v) {_vm.$set(_vm.filter, "cancellation_status_name", $$v)},expression:"filter.cancellation_status_name"}})],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"primary"},on:{"click":_vm.search}},[_vm._v("Search")]),_vm._v("\n            \n          "),_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"success"},on:{"click":_vm.newWSC}},[_vm._v("New Sales Cancellation")])],1)],1),_vm._v(" "),(_vm.getRowCount(_vm.searchResults) > 0 && !_vm.loading)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Search Results")])]),_vm._v(" "),_c('b-table',{staticClass:"table-hover",attrs:{"hover":_vm.hover,"striped":_vm.striped,"bordered":_vm.bordered,"small":_vm.small,"fixed":_vm.fixed,"responsive":"sm","fields":_vm.searchResultsFields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"items":_vm.searchResults},on:{"row-clicked":_vm.rowClick}}),_vm._v(" "),_c('nav',[_c('b-pagination',{attrs:{"total-rows":_vm.getRowCount(_vm.searchResults),"per-page":_vm.perPage,"prev-text":"Prev","next-text":"Next","hide-goto-end-buttons":""},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('exportExcel',{staticClass:"btn btn-primary btn-lg",attrs:{"size":"lg","data":_vm.searchResults,"fields":_vm.exportHeaders,"name":"srr.xls"}},[_vm._v("\n                  Export to Excel\n              ")]),_vm._v("\n               \n              "),_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"success"},on:{"click":_vm.print}},[_vm._v("Print")])],1)],1)],1)],1):(_vm.noResults && !_vm.loading)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('div',{attrs:{"align":"center"}},[_c('strong',[_vm._v("No Sales Cancellation Found")])])])],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wsc_vue__ = __webpack_require__(287);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea6c5c48_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_wsc_vue__ = __webpack_require__(616);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wsc_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea6c5c48_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_wsc_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[(!_vm.isWscRetrieved)?_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-group',{attrs:{"name":"invoice","label":"Credit Note No","label-for":"elementsPrependAppend","description":""}},[_c('b-input-group',[_c('wscLookup',{ref:"wscLookupInput",staticStyle:{"min-width":"300px"},attrs:{"url":_vm.apiWscUrl,"lookupId":_vm.wsc.credit_note_number,"basic":1},on:{"selected":function($event){_vm.setWsc($event)}}}),_vm._v("   \n                                "),_c('b-button',{attrs:{"variant":"primary","disabled":_vm.wsc.credit_note_number == ''},on:{"click":_vm.retrieveSalesDoc}},[_vm._v("Retrieve Cancellation Document")])],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.isWscRetrieved)?_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-group',[_c('label',{attrs:{"for":"receiving_date"}},[_vm._v("Receiving Date")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date","disabled":_vm.lockEntry},model:{value:(_vm.wsc.wsc_date),callback:function ($$v) {_vm.$set(_vm.wsc, "wsc_date", $$v)},expression:"wsc.wsc_date"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-group',[_c('label',{attrs:{"for":"remarks"}},[_vm._v("Remarks")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.wsc.remarks),expression:"wsc.remarks"}],staticClass:"form-control",attrs:{"rows":"5","id":"remarks","disabled":_vm.lockEntry},domProps:{"value":(_vm.wsc.remarks)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.wsc, "remarks", $event.target.value)}}})])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_c('label',{attrs:{"for":"status"}},[_vm._v("Sales Cancellation Approval Status")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","disabled":""},model:{value:(_vm.wsc.cancellation_status_name),callback:function ($$v) {_vm.$set(_vm.wsc, "cancellation_status_name", $$v)},expression:"wsc.cancellation_status_name"}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('label',{attrs:{"for":"status"}},[_vm._v("Receiving Status")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","disabled":""},model:{value:(_vm.wsc.receiving_status),callback:function ($$v) {_vm.$set(_vm.wsc, "receiving_status", $$v)},expression:"wsc.receiving_status"}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"location_id"}},[_vm._v("Receiving Location (Warehouse)")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","disabled":""},model:{value:(_vm.wsc.stock_location_name),callback:function ($$v) {_vm.$set(_vm.wsc, "stock_location_name", $$v)},expression:"wsc.stock_location_name"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('label',[_vm._v("Transaction Type")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","disabled":""},model:{value:(_vm.wsc.cancellation_reason_name),callback:function ($$v) {_vm.$set(_vm.wsc, "cancellation_reason_name", $$v)},expression:"wsc.cancellation_reason_name"}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_c('label',{attrs:{"for":"credit_note_number"}},[_vm._v("Credit Note No")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","disabled":""},model:{value:(_vm.wsc.credit_note_number),callback:function ($$v) {_vm.$set(_vm.wsc, "credit_note_number", $$v)},expression:"wsc.credit_note_number"}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('label',{attrs:{"for":"transaction_date"}},[_vm._v("Cancellation Date")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date","disabled":""},model:{value:(_vm.wsc.transaction_date),callback:function ($$v) {_vm.$set(_vm.wsc, "transaction_date", $$v)},expression:"wsc.transaction_date"}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"customer_id"}},[_vm._v("IBO/Stockist ID")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","disabled":""},model:{value:(_vm.wsc.old_member_id),callback:function ($$v) {_vm.$set(_vm.wsc, "old_member_id", $$v)},expression:"wsc.old_member_id"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('label',[_vm._v("IBO/Stockist Name")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","disabled":""},model:{value:(_vm.wsc.member_name),callback:function ($$v) {_vm.$set(_vm.wsc, "member_name", $$v)},expression:"wsc.member_name"}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"cancellation_doc_num"}},[_vm._v("Buy Back Amount ("+_vm._s(_vm.wsc.currency_code)+")")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","disabled":""},model:{value:(_vm.wsc.amount_buy_back),callback:function ($$v) {_vm.$set(_vm.wsc, "amount_buy_back", $$v)},expression:"wsc.amount_buy_back"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',[_vm._v("Cancellation Amount ("+_vm._s(_vm.wsc.currency_code)+")")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","disabled":""},model:{value:(_vm.wsc.amount_cancellation),callback:function ($$v) {_vm.$set(_vm.wsc, "amount_cancellation", $$v)},expression:"wsc.amount_cancellation"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',[_vm._v("Confirmed Return Amount ("+_vm._s(_vm.wsc.currency_code)+")")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","value":_vm.confirm_return_amount,"disabled":""}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',[_vm._v("Tax Invoice Number")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","disabled":""},model:{value:(_vm.wsc.tax_invoice_number),callback:function ($$v) {_vm.$set(_vm.wsc, "tax_invoice_number", $$v)},expression:"wsc.tax_invoice_number"}})],1)],1)],1)],1):_vm._e()],1)],1),_vm._v(" "),(_vm.isWscRetrieved)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Sales Cancellation Items")])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped table-bordered"},[_c('thead',[_c('th',{staticStyle:{"min-width":"300px"}},[_vm._v("Product Name")]),_vm._v(" "),_c('th',{attrs:{"width":"250px"}},[_vm._v("SKU")]),_vm._v(" "),_c('th',{attrs:{"width":"200px"}},[_vm._v("Cancellation Qty")]),_vm._v(" "),_c('th',{attrs:{"width":"250px"}},[_vm._v("Cancellation Amount ("+_vm._s(_vm.wsc.currency_code)+")")]),_vm._v(" "),_c('th',{attrs:{"width":"200px"}},[_vm._v("Returned Qty")]),_vm._v(" "),_c('th',{attrs:{"width":"200px"}},[_vm._v("Receiving Qty")]),_vm._v(" "),_c('th',{attrs:{"width":"250px"}},[_vm._v("Receiving Amount ("+_vm._s(_vm.wsc.currency_code)+")")])]),_vm._v(" "),_c('tbody',_vm._l((_vm.wsc.items),function(row,index){return _c('tr',[_c('td',[_vm._v(_vm._s(row.product_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.product_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.cancellation_amount_friendly))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.qty_returned))]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.qty_allocated),expression:"row.qty_allocated"}],staticClass:"form-control",attrs:{"type":"number","min":"0","name":"qty_returned","disabled":row.qty_returned == row.quantity},domProps:{"value":(row.qty_allocated)},on:{"change":function($event){_vm.validateQtyAllocated(row)},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "qty_allocated", $event.target.value)}}})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(((((row.cancellation_amount*1)/(row.quantity*1)))*(row.qty_allocated*1)).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")))])])}))])])])],1)],1):_vm._e(),_vm._v(" "),(_vm.isWscRetrieved)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-row',{staticStyle:{"padding":"0px 0px 20px 18px"}},[(!_vm.isVisible)?_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"primary"},on:{"click":_vm.save}},[_vm._v("Save WSC")]):_vm._e(),_vm._v("   \n                "),(_vm.isVisible)?_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"success"},on:{"click":_vm.print}},[_vm._v("Print")]):_vm._e(),_vm._v("                                                        \n                "),_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"danger"},on:{"click":_vm.closeWSC}},[_vm._v("Back")])],1)],1)],1):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-modal',{ref:"myModalRef",attrs:{"hide-header-close":"","hide-footer":"","title":"Sales Cancellation","centered":"","header-bg-variant":"success","no-close-on-backdrop":"","no-close-on-esc":""}},[_c('div',{staticClass:"d-block text-center"},[_c('p',[_vm._v("Sales Cancellation "),_c('strong',{staticStyle:{"color":"green"}},[_vm._v(" "+_vm._s(_vm.wscDocNo))]),_vm._v(" is saved."),_c('br'),_c('br')])]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"variant":"outline-danger"},on:{"click":_vm.hideModal}},[_vm._v("Ok")])],1),_vm._v(" "),_c('b-modal',{ref:"myErrorModalRef",attrs:{"hide-header-close":"","hide-footer":"","title":"Invalid Entries","centered":"","header-bg-variant":"danger","no-close-on-backdrop":"","no-close-on-esc":""}},[_c('div',{staticClass:"d-block text-center"},[_c('p',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage))])]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"variant":"danger"},on:{"click":_vm.hideErrorModal}},[_vm._v("OK")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_srfs_vue__ = __webpack_require__(288);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ab69b4a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_srfs_vue__ = __webpack_require__(618);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_srfs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ab69b4a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_srfs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(_vm.loading)?_c('spinner'):_vm._e(),_vm._v(" "),_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Search SRF")])]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',[_vm._v("SRF Num")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","id":"wto_num"},model:{value:(_vm.filter.srf_num),callback:function ($$v) {_vm.$set(_vm.filter, "srf_num", $$v)},expression:"filter.srf_num"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"country_id"}},[_vm._v("Country")]),_vm._v(" "),_c('countryLookup',{attrs:{"url":_vm.apiCountryLookup,"lookupId":_vm.filter.country_id},on:{"selected":function($event){_vm.setCountry($event)}}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"date_start"}},[_vm._v("Date Start")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date"},model:{value:(_vm.filter.date_start),callback:function ($$v) {_vm.$set(_vm.filter, "date_start", $$v)},expression:"filter.date_start"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"date_end"}},[_vm._v("Date End")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date"},model:{value:(_vm.filter.date_end),callback:function ($$v) {_vm.$set(_vm.filter, "date_end", $$v)},expression:"filter.date_end"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"status"}},[_vm._v("Status")]),_vm._v(" "),_c('b-form-select',{attrs:{"id":"status","plain":true,"options":['','OPEN', 'PARTIAL', 'RETURN DUE','CLOSED'],"value":""},model:{value:(_vm.filter.status),callback:function ($$v) {_vm.$set(_vm.filter, "status", $$v)},expression:"filter.status"}})],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"primary"},on:{"click":_vm.search}},[_vm._v("Search")]),_vm._v("\n            \n          "),_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"success"},on:{"click":_vm.newSRF}},[_vm._v("New SRF")])],1)],1),_vm._v(" "),(_vm.getRowCount(_vm.searchResults) > 0 && !_vm.loading)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Search Results")])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('b-table',{staticClass:"table-hover",attrs:{"hover":_vm.hover,"striped":_vm.striped,"bordered":_vm.bordered,"small":_vm.small,"fixed":_vm.fixed,"responsive":"sm","fields":_vm.searchResultsFields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"items":_vm.searchResults},on:{"row-clicked":_vm.rowClick}})],1),_vm._v(" "),_c('nav',[_c('b-pagination',{attrs:{"total-rows":_vm.getRowCount(_vm.searchResults),"per-page":_vm.perPage,"prev-text":"Prev","next-text":"Next","hide-goto-end-buttons":""},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('exportExcel',{staticClass:"btn btn-primary btn-lg",attrs:{"size":"lg","data":_vm.searchResults,"fields":_vm.exportHeaders,"name":"srf.xls"}},[_vm._v("\n                  Export to Excel\n              ")]),_vm._v("\n               \n              "),_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"success"},on:{"click":_vm.print}},[_vm._v("Print")])],1)])],1)],1):(_vm.noResults && !_vm.loading)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('div',{attrs:{"align":"center"}},[_c('strong',[_vm._v("No SRF Found")])])])],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_srf_vue__ = __webpack_require__(289);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_780c0e71_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_srf_vue__ = __webpack_require__(620);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_srf_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_780c0e71_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_srf_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',[_vm._v("SRF Date")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date","disabled":_vm.lockEntry},model:{value:(_vm.srf.srf_date),callback:function ($$v) {_vm.$set(_vm.srf, "srf_date", $$v)},expression:"srf.srf_date"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',[_vm._v("Requestor")]),_vm._v(" "),_c('employeeLookup',{attrs:{"url":_vm.apiEmployeeLookup,"lookupId":_vm.srf.requestor_user_id,"disabled":_vm.lockEntry},on:{"selected":function($event){_vm.setEmployee($event)}}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('label',{attrs:{"for":"location_id"}},[_vm._v("Location From (Warehouse)")]),_vm._v(" "),_c('warehouseLookup',{attrs:{"url":_vm.apiWarehouseUrl,"lookupId":_vm.srf.location_id,"disabled":_vm.lockEntry},on:{"selected":function($event){_vm.setWarehouse($event)}}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',[_vm._v("Event Start Date")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date","disabled":_vm.lockEntry},model:{value:(_vm.srf.event_start_date),callback:function ($$v) {_vm.$set(_vm.srf, "event_start_date", $$v)},expression:"srf.event_start_date"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',[_vm._v("Event End Date")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date","disabled":_vm.lockEntry},model:{value:(_vm.srf.event_end_date),callback:function ($$v) {_vm.$set(_vm.srf, "event_end_date", $$v)},expression:"srf.event_end_date"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',[_vm._v("Reference No")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","disabled":_vm.lockEntry},model:{value:(_vm.srf.reference_num),callback:function ($$v) {_vm.$set(_vm.srf, "reference_num", $$v)},expression:"srf.reference_num"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',[_vm._v("Reason")]),_vm._v(" "),_c('b-form-select',{attrs:{"id":"reason","disabled":_vm.lockEntry,"plain":true,"options":_vm.srf_reason_list_items},model:{value:(_vm.srf.reason),callback:function ($$v) {_vm.$set(_vm.srf, "reason", $$v)},expression:"srf.reason"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',[_vm._v("Returning Type")]),_vm._v(" "),_c('b-form-select',{attrs:{"id":"returning_type","plain":true,"options":['RETURNABLE','NON RETURNABLE'],"disabled":_vm.lockEntry},model:{value:(_vm.srf.returning_type),callback:function ($$v) {_vm.$set(_vm.srf, "returning_type", $$v)},expression:"srf.returning_type"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',[_vm._v("Return Date")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date","value":_vm.returnDate,"disabled":""}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('label',{attrs:{"for":"remarks"}},[_vm._v("Remarks")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.srf.remarks),expression:"srf.remarks"}],staticClass:"form-control",attrs:{"rows":"5","id":"remarks","disabled":_vm.lockEntry},domProps:{"value":(_vm.srf.remarks)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.srf, "remarks", $event.target.value)}}})])],1),_vm._v(" "),(_vm.srf.status == 'CLOSED')?_c('b-row',{staticClass:"mt-2 p-2"},[_c('b-col',{staticClass:"bg-info p-2",attrs:{"sm":"3"}},[_c('span',[_vm._v("Closed by: "+_vm._s(_vm.srf.closed_by_user_id))]),_c('br'),_vm._v(" "),_c('span',[_vm._v("Closed at: "+_vm._s(_vm.srf.closed_at))]),_c('br')])],1):_vm._e(),_vm._v(" "),(_vm.srf.approval_status == 'APPROVED')?_c('b-row',{staticClass:"mt-2 p-2"},[_c('b-col',{staticClass:"bg-success p-2",attrs:{"sm":"3"}},[_c('span',[_vm._v("Approved by: "+_vm._s(_vm.srf.approver_user_id))]),_c('br'),_vm._v(" "),_c('span',[_vm._v("Approved at: "+_vm._s(_vm.srf.approved_at))])])],1):_vm._e(),_vm._v(" "),(_vm.srf.approval_status == 'REJECTED')?_c('b-row',{staticClass:"mt-2 p-2"},[_c('b-col',{staticClass:"bg-danger p-2",attrs:{"sm":"3"}},[_c('span',[_vm._v("Rejected by: "+_vm._s(_vm.srf.rejecter_user_id))]),_c('br'),_vm._v(" "),_c('span',[_vm._v("Rejected at: "+_vm._s(_vm.srf.rejected_at))]),_c('br'),_vm._v(" "),_c('span',[_vm._v("Reason: "+_vm._s(_vm.srf.rejected_reason))])])],1):_vm._e()],1)],1)],1),_vm._v(" "),(_vm.srf.location_id != '' && !_vm.noItemsFound || _vm.lockEntry)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("SRF Items")])]),_vm._v(" "),(0)?_c('b-row',[_c('b-col',{attrs:{"sm":"2"}},[_c('label',[_vm._v("SRF No")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","id":"total_amount"},model:{value:(_vm.srf.amount_total),callback:function ($$v) {_vm.$set(_vm.srf, "amount_total", $$v)},expression:"srf.amount_total"}})],1)],1):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped table-bordered"},[_c('thead',[_c('th',{staticStyle:{"width":"10px"}},[_vm._v("S/N")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"300px"}},[_vm._v("Product Name")]),_vm._v(" "),_c('th',{attrs:{"width":"230px"}},[_vm._v("Product Code")]),_vm._v(" "),_c('th',{attrs:{"width":"150px"}},[_vm._v("SOH")]),_vm._v(" "),_c('th',{attrs:{"width":"250px"}},[_vm._v("SRF Qty")]),_vm._v(" "),_c('th',{attrs:{"width":"180px"}},[_vm._v("Unit GMP ("+_vm._s(_vm.srf.currency_id)+")")]),_vm._v(" "),_c('th',{attrs:{"width":"180px"}},[_vm._v("Total GMP ("+_vm._s(_vm.srf.currency_id)+")")]),_vm._v(" "),_c('th',{attrs:{"width":"30px"}})]),_vm._v(" "),_c('tbody',[_vm._l((_vm.srf.srf_items),function(row,index){return _c('tr',[_c('td',[_vm._v(_vm._s((index*1) + 1))]),_vm._v(" "),_c('td',[_c('productLookup',{attrs:{"url":_vm.apiLocationProductUrl,"lookupId":row.product_id,"q2":_vm.srf.location_id,"disabled":_vm.lockEntry},on:{"selected":function($event){_vm.setProduct($event, index)}}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.product_id))]),_vm._v(" "),(!_vm.lockEntry)?_c('td',[_vm._v(_vm._s(row.qty_soh*1 - row.qty*1))]):_vm._e(),_vm._v(" "),(_vm.lockEntry)?_c('td',[_vm._v(_vm._s(row.qty_soh*1))]):_vm._e(),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.qty),expression:"row.qty"}],staticClass:"form-control",attrs:{"type":"number","min":"0","name":"qty","disabled":_vm.lockEntry},domProps:{"value":(row.qty)},on:{"change":function($event){_vm.validateQty(index)},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "qty", $event.target.value)}}})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.unit_gmp))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(((row.qty * 1) * (row.unit_gmp * 1)).toFixed(2)))]),_vm._v(" "),_c('td',[(!_vm.lockEntry)?_c('a',{attrs:{"href":"#","tabindex":"-1"},on:{"click":function($event){_vm.removeRow(index)}}},[(!_vm.lockEntry)?_c('i',{staticClass:"fa fa-trash",staticStyle:{"font-size":"25px","color":"red"}}):_vm._e()]):_vm._e()])])}),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"8"}},[(!_vm.lockEntry)?_c('b-button',{attrs:{"type":"submit","size":"md","variant":"success"},on:{"click":_vm.addRow}},[_vm._v("Add Product")]):_vm._e()],1)])],2)])])])],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.srf.location_id != '' && !_vm.noItemsFound || _vm.lockEntry)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-row',{staticStyle:{"padding":"0px 0px 20px 18px"}},[(!_vm.lockEntry)?_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"primary"},on:{"click":_vm.confirmSave}},[_vm._v("Save SRF")]):_vm._e(),_vm._v(" "),_c('b-modal',{attrs:{"title":"Confirmation","centered":"","header-bg-variant":"success","no-close-on-backdrop":""},on:{"ok":_vm.save},model:{value:(_vm.modalShow),callback:function ($$v) {_vm.modalShow=$$v},expression:"modalShow"}},[_c('p',{staticStyle:{"color":"darkblue"}},[_vm._v("Confirmed Save SRF?")])]),_vm._v(" "),_c('b-modal',{attrs:{"title":"Confirmation","centered":"","header-bg-variant":"success","no-close-on-backdrop":""},on:{"ok":_vm.cancel},model:{value:(_vm.modalCancelShow),callback:function ($$v) {_vm.modalCancelShow=$$v},expression:"modalCancelShow"}},[_c('p',{staticStyle:{"color":"darkblue"}},[_vm._v("Confirmed Cancel?")])]),_vm._v(" "),_c('b-modal',{ref:"myModalRef",attrs:{"hide-header-close":"","hide-footer":"","title":"Stock Requisition Form","centered":"","header-bg-variant":"success","no-close-on-backdrop":"","no-close-on-esc":""}},[_c('div',{staticClass:"d-block text-center"},[_c('p',[_vm._v("Stock Requisition Form"),_c('strong',{staticStyle:{"color":"green"}},[_vm._v(" "+_vm._s(_vm.srfDocNo))]),_vm._v(" is saved."),_c('br'),_c('br')])]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"variant":"outline-danger"},on:{"click":_vm.hideModal}},[_vm._v("Ok")])],1),_vm._v(" "),_c('b-modal',{ref:"myErrorModalRef",attrs:{"hide-header-close":"","hide-footer":"","title":"Invalid Entries","centered":"","header-bg-variant":"danger","no-close-on-backdrop":"","no-close-on-esc":""}},[_c('div',{staticClass:"d-block text-center"},[_c('p',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage))])]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"variant":"danger"},on:{"click":_vm.hideErrorModal}},[_vm._v("OK")])],1),_vm._v(" "),_c('b-modal',{attrs:{"title":"Error","centered":"","header-bg-variant":"success","no-close-on-backdrop":""},model:{value:(_vm.modalErrorShow),callback:function ($$v) {_vm.modalErrorShow=$$v},expression:"modalErrorShow"}},[_c('p',{staticStyle:{"color":"darkblue"}},[_vm._v(_vm._s(_vm.errorMessage))])]),_vm._v("\n                              \n                        "),(!_vm.lockEntry)?_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"danger"},on:{"click":_vm.confirmCancel}},[_vm._v("Cancel")]):_vm._e(),_vm._v(" "),(_vm.btnVisible && _vm.srf.status != 'CLOSED' )?_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"primary"},on:{"click":_vm.confirmClose}},[_vm._v("Close")]):_vm._e(),_vm._v(" \n                        "),_c('b-modal',{attrs:{"title":"Close","centered":"","header-bg-variant":"success","no-close-on-backdrop":""},on:{"ok":_vm.close},model:{value:(_vm.closeModalShow),callback:function ($$v) {_vm.closeModalShow=$$v},expression:"closeModalShow"}},[_c('p',{staticStyle:{"color":"darkblue"}},[_vm._v("Confirmed Close SRF?")])]),_vm._v(" "),(_vm.btnVisible && _vm.srf.status != 'CLOSED' && _vm.srf.approval_status == 'NEW' )?_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"primary"},on:{"click":_vm.confirmApprove}},[_vm._v("Approve")]):_vm._e(),_vm._v(" \n                        "),_c('b-modal',{attrs:{"title":"Confirmation","centered":"","header-bg-variant":"success","no-close-on-backdrop":""},on:{"ok":_vm.approve},model:{value:(_vm.approveModalShow),callback:function ($$v) {_vm.approveModalShow=$$v},expression:"approveModalShow"}},[_c('p',{staticStyle:{"color":"darkblue"}},[_vm._v("Confirmed Approve SRF?")])]),_vm._v(" "),(_vm.btnVisible && _vm.srf.status != 'CLOSED' && _vm.srf.approval_status == 'NEW')?_c('b-button',{attrs:{"type":"button","size":"lg","variant":"danger"},on:{"click":_vm.confirmReject}},[_vm._v("Reject")]):_vm._e(),_vm._v(" \n                        "),_c('b-modal',{ref:"rejectModal",attrs:{"id":"modalPrevent","title":"Reject SRF?","centered":""},on:{"ok":_vm.reject}},[_c('form',{on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();_vm.handleSubmit($event)}}},[_c('b-form-input',{attrs:{"type":"text","placeholder":"Enter the reason"},model:{value:(_vm.srf.rejected_reason),callback:function ($$v) {_vm.$set(_vm.srf, "rejected_reason", $$v)},expression:"srf.rejected_reason"}})],1)]),_vm._v(" "),(_vm.lockEntry)?_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"success"},on:{"click":_vm.print}},[_vm._v("Print")]):_vm._e(),_vm._v(" \n                        "),(_vm.lockEntry)?_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"danger"},on:{"click":_vm.back}},[_vm._v("Back")]):_vm._e(),_vm._v(" "),_c('b-modal',{ref:"msgBox",attrs:{"hide-header-close":"","hide-footer":"","title":_vm.mbTitle,"centered":"","header-bg-variant":"primary","no-close-on-backdrop":"","no-close-on-esc":""}},[_c('div',{staticClass:"d-block text-center"},[_c('p',{staticStyle:{"color":"green"}},[_vm._v(_vm._s(_vm.mbMsg))])]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"variant":"danger"},on:{"click":function($event){_vm.$refs.msgBox.hide()}}},[_vm._v("OK")])],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.srf.location_id != '' && _vm.noItemsFound && !_vm.lockEntry)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('div',{attrs:{"align":"center"}},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("No Products Found in the Selected Warehouse! Please Select a Different Warehouse")])])])],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_srrs_vue__ = __webpack_require__(290);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6dff74ce_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_srrs_vue__ = __webpack_require__(622);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_srrs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6dff74ce_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_srrs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(_vm.loading)?_c('spinner'):_vm._e(),_vm._v(" "),_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Search SRR")])]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"wto_num"}},[_vm._v("SRF No")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","id":"wto_num"},model:{value:(_vm.filter.srf_num),callback:function ($$v) {_vm.$set(_vm.filter, "srf_num", $$v)},expression:"filter.srf_num"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"gro_num"}},[_vm._v("SRR No")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","id":"wtr_num"},model:{value:(_vm.filter.srr_num),callback:function ($$v) {_vm.$set(_vm.filter, "srr_num", $$v)},expression:"filter.srr_num"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"country_id"}},[_vm._v("Country")]),_vm._v(" "),_c('countryLookup',{attrs:{"url":_vm.apiCountryLookup,"lookupId":_vm.filter.country_id},on:{"selected":function($event){_vm.setCountry($event)}}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"date_start"}},[_vm._v("Date Start")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date"},model:{value:(_vm.filter.date_start),callback:function ($$v) {_vm.$set(_vm.filter, "date_start", $$v)},expression:"filter.date_start"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"date_end"}},[_vm._v("Date End")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date"},model:{value:(_vm.filter.date_end),callback:function ($$v) {_vm.$set(_vm.filter, "date_end", $$v)},expression:"filter.date_end"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',[_vm._v("Returning Type")]),_vm._v(" "),_c('b-form-select',{attrs:{"id":"returning_type","plain":true,"options":['','RETURNABLE','NON RETURNABLE']},model:{value:(_vm.filter.returning_type),callback:function ($$v) {_vm.$set(_vm.filter, "returning_type", $$v)},expression:"filter.returning_type"}})],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"primary"},on:{"click":_vm.search}},[_vm._v("Search")]),_vm._v("\n            \n          "),_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"success"},on:{"click":_vm.newSRR}},[_vm._v("New SRR")])],1)],1),_vm._v(" "),(_vm.getRowCount(_vm.searchResults) > 0 && !_vm.loading)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Search Results")])]),_vm._v(" "),_c('b-table',{staticClass:"table-hover",attrs:{"hover":_vm.hover,"striped":_vm.striped,"bordered":_vm.bordered,"small":_vm.small,"fixed":_vm.fixed,"responsive":"sm","fields":_vm.searchResultsFields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"items":_vm.searchResults},on:{"row-clicked":_vm.rowClick}}),_vm._v(" "),_c('nav',[_c('b-pagination',{attrs:{"total-rows":_vm.getRowCount(_vm.searchResults),"per-page":_vm.perPage,"prev-text":"Prev","next-text":"Next","hide-goto-end-buttons":""},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('exportExcel',{staticClass:"btn btn-primary btn-lg",attrs:{"size":"lg","data":_vm.searchResults,"fields":_vm.exportHeaders,"name":"srr.xls"}},[_vm._v("\n                  Export to Excel\n              ")]),_vm._v("\n               \n              "),_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"success"},on:{"click":_vm.print}},[_vm._v("Print")])],1)],1)],1)],1):(_vm.noResults && !_vm.loading)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('div',{attrs:{"align":"center"}},[_c('strong',[_vm._v("No SRR Found")])])])],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_srr_vue__ = __webpack_require__(291);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f0512b2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_srr_vue__ = __webpack_require__(624);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_srr_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f0512b2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_srr_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[(!_vm.isSrfRetrieved)?_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v(_vm._s(_vm.title)+" ")])]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-group',{attrs:{"name":"srf","label":"SRF No","label-for":"elementsPrependAppend","description":""}},[_c('b-input-group',[_c('srfLookup',{ref:"srfLookupInput",staticStyle:{"min-width":"300px"},attrs:{"url":_vm.apiSrfLookup,"basic":1,"lookupId":_vm.srr.srf_num},on:{"selected":function($event){_vm.setSrfId($event)}}}),_vm._v("   \n                                "),_c('b-button',{attrs:{"variant":"primary","disabled":_vm.srr.srf_num == ''},on:{"click":_vm.retrieveSRF}},[_vm._v("Retrieve SRF")])],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.isSrfRetrieved)?_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v(_vm._s(_vm.title)+" - "+_vm._s(_vm.srr.srf.returning_type))])]),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-group',[_c('label',[_vm._v("SRR Date")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date","id":"srr_date"},model:{value:(_vm.srr.srr_date),callback:function ($$v) {_vm.$set(_vm.srr, "srr_date", $$v)},expression:"srr.srr_date"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('label',{attrs:{"for":"remarks"}},[_vm._v("Remarks")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.srr.remarks),expression:"srr.remarks"}],staticClass:"form-control",attrs:{"rows":"5","id":"remarks"},domProps:{"value":(_vm.srr.remarks)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.srr, "remarks", $event.target.value)}}})])],1)],1),_vm._v(" "),(_vm.srr.srf.srrs.length > 0)?_c('b-col',{attrs:{"sm":"6"}},[_c('br'),_vm._v(" "),_c('b-card',[_c('div',{staticClass:"table-responsive"},[_c('table',[_c('thead',[_c('th',{staticStyle:{"min-width":"138px","height":"40px"}},[_vm._v("SRR No")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"100px"}},[_vm._v("Date")]),_vm._v(" "),_c('th',[_vm._v("Generated By")])]),_vm._v(" "),_c('tbody',_vm._l((_vm.srr.srf.srrs),function(row,index){return _c('tr',{ref:'title',refInFor:true,staticStyle:{"height":"40px"}},[_c('td',[_c('b-button',{attrs:{"type":"submit","size":"md","variant":"primary"},on:{"click":function($event){_vm.printSRR(row)}}},[_vm._v(_vm._s(row.srr_num)+" ")])],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.srr_date))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.author_user_shortname))])])}))])])])],1):_vm._e()],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('hr'),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"srf_num"}},[_vm._v("SRF No")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","disabled":""},model:{value:(_vm.srr.srf_num),callback:function ($$v) {_vm.$set(_vm.srr, "srf_num", $$v)},expression:"srr.srf_num"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"srf_date"}},[_vm._v("SRF Date")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date","disabled":""},model:{value:(_vm.srr.srf.srf_date),callback:function ($$v) {_vm.$set(_vm.srr.srf, "srf_date", $$v)},expression:"srr.srf.srf_date"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"status"}},[_vm._v("Status")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","disabled":""},model:{value:(_vm.srr.srf.status),callback:function ($$v) {_vm.$set(_vm.srr.srf, "status", $$v)},expression:"srr.srf.status"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"location_from"}},[_vm._v("Location")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","disabled":""},model:{value:(_vm.srr.srf.location_full),callback:function ($$v) {_vm.$set(_vm.srr.srf, "location_full", $$v)},expression:"srr.srf.location_full"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"location_from"}},[_vm._v("Requestor")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","disabled":""},model:{value:(_vm.srr.srf.requestor_user_shortname),callback:function ($$v) {_vm.$set(_vm.srr.srf, "requestor_user_shortname", $$v)},expression:"srr.srf.requestor_user_shortname"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"reason"}},[_vm._v("Reason")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","disabled":""},model:{value:(_vm.srr.srf.reason),callback:function ($$v) {_vm.$set(_vm.srr.srf, "reason", $$v)},expression:"srr.srf.reason"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"location"}},[_vm._v("Event Start Date")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date","disabled":""},model:{value:(_vm.srr.srf.event_start_date),callback:function ($$v) {_vm.$set(_vm.srr.srf, "event_start_date", $$v)},expression:"srr.srf.event_start_date"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"location"}},[_vm._v("Event End Date")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date","disabled":""},model:{value:(_vm.srr.srf.event_start_date),callback:function ($$v) {_vm.$set(_vm.srr.srf, "event_start_date", $$v)},expression:"srr.srf.event_start_date"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('b-form-group',[_c('label',{attrs:{"for":"location"}},[_vm._v("Est Return Date")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date","disabled":""},model:{value:(_vm.srr.srf.return_date),callback:function ($$v) {_vm.$set(_vm.srr.srf, "return_date", $$v)},expression:"srr.srf.return_date"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('label',{attrs:{"for":"remarks"}},[_vm._v("SRF Remarks")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.srr.srf.remarks),expression:"srr.srf.remarks"}],staticClass:"form-control",attrs:{"rows":"5","id":"remarks","disabled":""},domProps:{"value":(_vm.srr.srf.remarks)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.srr.srf, "remarks", $event.target.value)}}})])],1)],1):_vm._e()],1)],1),_vm._v(" "),(_vm.isSrfRetrieved)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("SRR Items")])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped table-bordered"},[_c('thead',[_c('th',{attrs:{"width":"10px"}},[_vm._v("S/N")]),_vm._v(" "),_c('th',[_vm._v("Product Code")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"280px"}},[_vm._v("Product Name")]),_vm._v(" "),_c('th',{attrs:{"width":"80px"}},[_vm._v("SRF Qty")]),_vm._v(" "),_c('th',{attrs:{"width":"130px"}},[_vm._v("Unit GMP ("+_vm._s(_vm.srr.srf.currency_id)+")")]),_vm._v(" "),_c('th',{attrs:{"width":"130px"}},[_vm._v("Total GMP ("+_vm._s(_vm.srr.srf.currency_id)+")")]),_vm._v(" "),_c('th',{attrs:{"width":"110px"}},[_vm._v("SRR Qty")]),_vm._v(" "),_c('th',[_vm._v("Returned GMP ("+_vm._s(_vm.srr.srf.currency_id)+")")]),_vm._v(" "),_c('th',[_vm._v("Utilized Qty")]),_vm._v(" "),_c('th',[_vm._v("Utilized GMP ("+_vm._s(_vm.srr.srf.currency_id)+")")])]),_vm._v(" "),_c('tbody',_vm._l((_vm.srr.srf.srf_items),function(row,index){return _c('tr',[_c('td',[_vm._v(_vm._s((index*1) + 1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.product_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.product_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.qty*1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.unit_gmp))]),_vm._v(" "),_c('td',[_vm._v(_vm._s((1 * row.qty * 1 * row.unit_gmp).toFixed(2)))]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.qty_received_current),expression:"row.qty_received_current"}],staticClass:"form-control",attrs:{"type":"number","name":"returned_qty","disabled":(row.qty*1)- row.qty_returned <= 0 || _vm.srr.srf.returning_type != 'RETURNABLE'},domProps:{"value":(row.qty_received_current)},on:{"change":function($event){_vm.validateQty(index)},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "qty_received_current", $event.target.value)}}})]),_vm._v(" "),_c('td',[_vm._v(_vm._s((row.unit_gmp*1* row.qty_received_current*1).toFixed(2)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(((row.qty * 1) - ((row.qty_returned * 1) + (row.qty_received_current * 1)))))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(((row.unit_gmp*1) *((row.qty * 1) - ((row.qty_returned * 1) + (row.qty_received_current * 1)))).toFixed(2)))])])}))])])])],1)],1):_vm._e(),_vm._v(" "),(_vm.isSrfRetrieved)?_c('b-row',{staticStyle:{"padding":"0px 0px 20px 18px"}},[((_vm.srr.srf.status == 'OPEN' || _vm.srr.srf.status == 'PARTIAL') && _vm.srr.srf.returning_type == 'RETURNABLE')?_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"primary"},on:{"click":_vm.confirmSave}},[_vm._v("Save SRR")]):_vm._e(),_vm._v("   \n        "),((_vm.srr.srf.status == 'OPEN' || _vm.srr.srf.status == 'PARTIAL') && _vm.srr.srf.returning_type == 'RETURNABLE')?_c('b-button',{attrs:{"type":"button","size":"lg","variant":"danger"},on:{"click":_vm.confirmCancel}},[_vm._v("Cancel")]):_vm._e(),_vm._v("   \n        "),(_vm.srr.srf.status != 'OPEN' || _vm.srr.srf.returning_type != 'RETURNABLE')?_c('b-button',{attrs:{"type":"button","size":"lg","variant":"success"},on:{"click":_vm.print}},[_vm._v("Print")]):_vm._e(),_vm._v("   \n        "),(_vm.srr.srf.status != 'OPEN' || _vm.srr.srf.returning_type != 'RETURNABLE')?_c('b-button',{attrs:{"type":"button","size":"lg","variant":"danger"},on:{"click":_vm.back}},[_vm._v("Back")]):_vm._e()],1):_vm._e(),_vm._v(" "),_c('div',[_c('b-modal',{attrs:{"title":"Confirmation","centered":"","header-bg-variant":"success","no-close-on-backdrop":""},on:{"ok":_vm.save},model:{value:(_vm.modalShow),callback:function ($$v) {_vm.modalShow=$$v},expression:"modalShow"}},[_c('p',{staticStyle:{"color":"darkblue"}},[_vm._v("Confirmed Save SRR?")])]),_vm._v(" "),_c('b-modal',{attrs:{"title":"Confirmation","centered":"","header-bg-variant":"success","no-close-on-backdrop":""},on:{"ok":_vm.cancel},model:{value:(_vm.modalCancelShow),callback:function ($$v) {_vm.modalCancelShow=$$v},expression:"modalCancelShow"}},[_c('p',{staticStyle:{"color":"darkblue"}},[_vm._v("Confirmed Cancel?")])]),_vm._v(" "),_c('b-modal',{ref:"myModalRef",attrs:{"hide-header-close":"","hide-footer":"","title":"Stock Requisiton Return","centered":"","header-bg-variant":"success","no-close-on-backdrop":"","no-close-on-esc":""}},[_c('div',{staticClass:"d-block text-center"},[_c('p',[_vm._v("Stock Requisition Return "),_c('strong',{staticStyle:{"color":"green"}},[_vm._v(" "+_vm._s(_vm.srrDocNo))]),_vm._v(" is saved."),_c('br'),_c('br')])]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"variant":"outline-danger"},on:{"click":_vm.hideModal}},[_vm._v("Ok")])],1),_vm._v(" "),_c('b-modal',{ref:"myErrorModalRef",attrs:{"hide-header-close":"","hide-footer":"","title":"Invalid Entries","centered":"","header-bg-variant":"danger","no-close-on-backdrop":"","no-close-on-esc":""}},[_c('div',{staticClass:"d-block text-center"},[_c('p',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage))])]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"variant":"danger"},on:{"click":_vm.hideErrorModal}},[_vm._v("OK")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sans_vue__ = __webpack_require__(292);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_255b317a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sans_vue__ = __webpack_require__(626);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sans_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_255b317a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sans_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(_vm.loading)?_c('spinner'):_vm._e(),_vm._v(" "),_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Search SAN")])]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"san_num"}},[_vm._v("SAN No")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","id":"wto_num"},model:{value:(_vm.filter.san_num),callback:function ($$v) {_vm.$set(_vm.filter, "san_num", $$v)},expression:"filter.san_num"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"country_id"}},[_vm._v("Country")]),_vm._v(" "),_c('countryLookup',{attrs:{"url":_vm.apiCountryLookup,"lookupId":_vm.filter.country_id},on:{"selected":function($event){_vm.setCountry($event)}}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"date_start"}},[_vm._v("Date Start")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date"},model:{value:(_vm.filter.date_start),callback:function ($$v) {_vm.$set(_vm.filter, "date_start", $$v)},expression:"filter.date_start"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"date_end"}},[_vm._v("Date End")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date"},model:{value:(_vm.filter.date_end),callback:function ($$v) {_vm.$set(_vm.filter, "date_end", $$v)},expression:"filter.date_end"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"status"}},[_vm._v("Status")]),_vm._v(" "),_c('b-form-select',{attrs:{"id":"status","plain":true,"options":['','NEW', 'APPROVED', 'REJECTED'],"value":""},model:{value:(_vm.filter.status),callback:function ($$v) {_vm.$set(_vm.filter, "status", $$v)},expression:"filter.status"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"reson"}},[_vm._v("Reason")]),_vm._v(" "),_c('b-form-select',{attrs:{"id":"reason","plain":true,"options":_vm.reasonsList,"value":""},model:{value:(_vm.filter.reason),callback:function ($$v) {_vm.$set(_vm.filter, "reason", $$v)},expression:"filter.reason"}})],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"primary"},on:{"click":_vm.search}},[_vm._v("Search")]),_vm._v("\n              \n            "),_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"success"},on:{"click":_vm.newSAN}},[_vm._v("New Stock Adjustment Note")])],1)],1),_vm._v(" "),(_vm.getRowCount(_vm.searchResults) > 0 && !_vm.loading)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Search Results")])]),_vm._v(" "),_c('b-table',{staticClass:"table-hover",attrs:{"hover":_vm.hover,"striped":_vm.striped,"bordered":_vm.bordered,"small":_vm.small,"fixed":_vm.fixed,"responsive":"sm","fields":_vm.searchResultsFields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"items":_vm.searchResults},on:{"row-clicked":_vm.rowClick}}),_vm._v(" "),_c('nav',[_c('b-pagination',{attrs:{"total-rows":_vm.getRowCount(_vm.searchResults),"per-page":_vm.perPage,"prev-text":"Prev","next-text":"Next","hide-goto-end-buttons":""},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('exportExcel',{staticClass:"btn btn-primary btn-lg",attrs:{"size":"lg","data":_vm.searchResults,"fields":_vm.exportHeaders,"name":"san.xls"}},[_vm._v("\n              Export to Excel\n            ")]),_vm._v("\n             \n            "),_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"success"},on:{"click":_vm.print}},[_vm._v("Print")])],1)],1)],1)],1):(_vm.noResults)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('div',{attrs:{"align":"center"}},[_c('strong',[_vm._v("No SAN Found")])])])],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_san_vue__ = __webpack_require__(293);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ccdcce8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_san_vue__ = __webpack_require__(628);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_san_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ccdcce8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_san_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[(_vm.san.status)?_c('strong',[_vm._v(_vm._s(_vm.title)+" - "+_vm._s(_vm.san.status))]):_c('strong',[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"san_date"}},[_vm._v("SAN Date")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date","disabled":_vm.lockEntry},model:{value:(_vm.san.san_date),callback:function ($$v) {_vm.$set(_vm.san, "san_date", $$v)},expression:"san.san_date"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"reference_num"}},[_vm._v("Reference Num")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","disabled":_vm.lockEntry},model:{value:(_vm.san.reference_num),callback:function ($$v) {_vm.$set(_vm.san, "reference_num", $$v)},expression:"san.reference_num"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"6"}},[_c('label',{attrs:{"for":"location_id"}},[_vm._v("Location (Warehouse)")]),_vm._v(" "),_c('warehouseLookup',{attrs:{"url":_vm.apiWarehouseUrl,"lookupId":_vm.san.location_id,"disabled":_vm.lockEntry},on:{"selected":function($event){_vm.setWarehouse($event)}}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',{attrs:{"for":"reson"}},[_vm._v("Reason")]),_vm._v(" "),_c('b-form-select',{attrs:{"id":"reason","plain":true,"options":_vm.reasonsList,"value":"","disabled":_vm.lockEntry},model:{value:(_vm.san.reason),callback:function ($$v) {_vm.$set(_vm.san, "reason", $$v)},expression:"san.reason"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('label',{attrs:{"for":"remarks"}},[_vm._v("Remarks")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.san.remarks),expression:"san.remarks"}],staticClass:"form-control",attrs:{"rows":"5","id":"remarks","disabled":_vm.lockEntry},domProps:{"value":(_vm.san.remarks)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.san, "remarks", $event.target.value)}}})])],1)],1)],1)],1),_vm._v(" "),(_vm.san.location_id != '' && !_vm.noItemsFound)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("SAN Items")])]),_vm._v(" "),_c('table',{staticClass:"table table-striped table-bordered"},[_c('thead',[_c('th',{staticStyle:{"min-width":"300px"}},[_vm._v("Product Name")]),_vm._v(" "),_c('th',{attrs:{"width":"250px"}},[_vm._v("Product Code")]),_vm._v(" "),_c('th',{attrs:{"width":"150px"}},[_vm._v("SOH")]),_vm._v(" "),_c('th',{attrs:{"width":"180px"}},[_vm._v("Adjust Qty")]),_vm._v(" "),_c('th',{attrs:{"width":"150px"}},[_vm._v("Unit GMP")]),_vm._v(" "),_c('th',{attrs:{"width":"180px"}},[_vm._v("Total GMP")]),_vm._v(" "),_c('th',{attrs:{"width":"30px"}})]),_vm._v(" "),_c('tbody',[_vm._l((_vm.san.san_items),function(row,index){return _c('tr',[_c('td',[_c('productLookup',{attrs:{"url":_vm.apiLocationProductUrl,"lookupId":row.product_id,"q2":_vm.san.location_id,"disabled":_vm.lockEntry},on:{"selected":function($event){_vm.setProduct($event, index)}}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.product_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.qty_soh))]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.qty),expression:"row.qty"}],staticClass:"form-control",attrs:{"type":"number","min":"0","name":"qty","disabled":_vm.lockEntry},domProps:{"value":(row.qty)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "qty", $event.target.value)}}})]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.unit_gmp))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.total_gmp))]),_vm._v(" "),_c('td',[(!_vm.lockEntry)?_c('a',{attrs:{"href":"#","tabindex":"-1"},on:{"click":function($event){_vm.removeRow(index)}}},[_c('i',{staticClass:"fa fa-trash",staticStyle:{"font-size":"25px","color":"red"}})]):_vm._e()])])}),_vm._v(" "),_c('tr',[_c('td',{attrs:{"colspan":"7"}},[(!_vm.lockEntry)?_c('b-button',{attrs:{"type":"submit","size":"md","variant":"success"},on:{"click":_vm.addRow}},[_vm._v("Add Product")]):_vm._e()],1)])],2)])])],1)],1):_vm._e(),_vm._v(" "),(_vm.san.location_id != '' && _vm.noItemsFound)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('div',{attrs:{"align":"center"}},[_c('strong',{staticStyle:{"color":"red"}},[_vm._v("No Products Found in the Selected Warehouse! Please Select a Different Warehouse")])])])],1):_vm._e(),_vm._v(" "),(_vm.san.location_id != '' && !_vm.noItemsFound )?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-row',{staticStyle:{"padding":"0px 0px 20px 18px"}},[(!_vm.lockEntry)?_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"primary"},on:{"click":_vm.confirmSave}},[_vm._v("Save SAN")]):_vm._e(),_vm._v("\n                               \n                        "),(!_vm.lockEntry)?_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"danger"},on:{"click":_vm.confirmCancel}},[_vm._v("Cancel")]):_vm._e(),_vm._v(" "),(_vm.btnVisible && _vm.san.status == 'NEW' )?_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"primary"},on:{"click":_vm.confirmApprove}},[_vm._v("Approve")]):_vm._e(),_vm._v("\n                         \n                        "),(_vm.btnVisible && _vm.san.status == 'NEW')?_c('b-button',{attrs:{"type":"button","size":"lg","variant":"danger"},on:{"click":_vm.confirmReject}},[_vm._v("Reject")]):_vm._e(),_vm._v("\n                         \n                        "),(_vm.lockEntry)?_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"success"},on:{"click":_vm.print}},[_vm._v("Print")]):_vm._e(),_vm._v("  \n                        "),(_vm.lockEntry)?_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"danger"},on:{"click":_vm.back}},[_vm._v("Back")]):_vm._e()],1)],1)],1):_vm._e(),_vm._v(" "),_c('b-modal',{attrs:{"title":"Confirmation","centered":"","header-bg-variant":"success","no-close-on-backdrop":""},on:{"ok":_vm.save},model:{value:(_vm.modalShow),callback:function ($$v) {_vm.modalShow=$$v},expression:"modalShow"}},[_c('p',{staticStyle:{"color":"darkblue"}},[_vm._v("Confirmed Save SAN?")])]),_vm._v(" "),_c('b-modal',{attrs:{"title":"Confirmation","centered":"","header-bg-variant":"success","no-close-on-backdrop":""},on:{"ok":_vm.approve},model:{value:(_vm.approveModalShow),callback:function ($$v) {_vm.approveModalShow=$$v},expression:"approveModalShow"}},[_c('p',{staticStyle:{"color":"darkblue"}},[_vm._v("Confirmed Approve SAN?")])]),_vm._v(" "),_c('b-modal',{attrs:{"title":"Confirmation","centered":"","header-bg-variant":"success","no-close-on-backdrop":""},on:{"ok":_vm.cancel},model:{value:(_vm.modalCancelShow),callback:function ($$v) {_vm.modalCancelShow=$$v},expression:"modalCancelShow"}},[_c('p',{staticStyle:{"color":"darkblue"}},[_vm._v("Confirmed Cancel?")])]),_vm._v(" "),_c('b-modal',{ref:"myModalRef",attrs:{"hide-header-close":"","hide-footer":"","title":"Stock Adjustment Note","centered":"","header-bg-variant":"success","no-close-on-backdrop":"","no-close-on-esc":""}},[_c('div',{staticClass:"d-block text-center"},[_c('p',[_vm._v("Stock Adjustment Note"),_c('strong',{staticStyle:{"color":"green"}},[_vm._v(" "+_vm._s(_vm.sanDocNo))]),_vm._v(" is "+_vm._s(_vm.confirmTxt)+"."),_c('br'),_c('br')])]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"variant":"outline-danger"},on:{"click":_vm.hideModal}},[_vm._v("Ok")])],1),_vm._v(" "),_c('b-modal',{ref:"myErrorModalRef",attrs:{"hide-header-close":"","hide-footer":"","title":"Invalid Entries","centered":"","header-bg-variant":"danger","no-close-on-backdrop":"","no-close-on-esc":""}},[_c('div',{staticClass:"d-block text-center"},[_c('p',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage))])]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"variant":"danger"},on:{"click":_vm.hideErrorModal}},[_vm._v("OK")])],1),_vm._v(" "),_c('b-modal',{ref:"msgBox",attrs:{"hide-header-close":"","hide-footer":"","title":_vm.mbTitle,"centered":"","header-bg-variant":"primary","no-close-on-backdrop":"","no-close-on-esc":""}},[_c('div',{staticClass:"d-block text-center"},[_c('p',{staticStyle:{"color":"green"}},[_vm._v(_vm._s(_vm.mbMsg))])]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"variant":"danger"},on:{"click":function($event){_vm.$refs.msgBox.hide()}}},[_vm._v("OK")])],1),_vm._v(" "),_c('b-modal',{ref:"rejectModal",attrs:{"id":"modalPrevent","title":"Reject SAN?","centered":""},on:{"ok":_vm.reject}},[_c('form',{on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();_vm.handleSubmit($event)}}},[_c('b-form-input',{attrs:{"type":"text","placeholder":"Enter the reason"},model:{value:(_vm.san.san_reject_remarks),callback:function ($$v) {_vm.$set(_vm.san, "san_reject_remarks", $$v)},expression:"san.san_reject_remarks"}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pods_vue__ = __webpack_require__(294);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ebd2170_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pods_vue__ = __webpack_require__(630);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pods_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9ebd2170_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pods_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(_vm.loading)?_c('spinner'):_vm._e(),_vm._v(" "),_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Search Delivery Orders")])]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"country_id"}},[_vm._v("Country")]),_vm._v(" "),_c('countryLookup',{attrs:{"url":_vm.apiCountryLookup,"lookupId":_vm.filter.country_id},on:{"selected":function($event){_vm.setCountry($event)}}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"warehiuse_id"}},[_vm._v("Stock Location")]),_vm._v(" "),_c('countryLookup',{attrs:{"url":_vm.apiWarehouseLookup,"q2":_vm.filter.country_id,"lookupId":_vm.filter.from_location_id},on:{"selected":function($event){_vm.setWarehouse($event)}}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',[_vm._v("Sales Document Number")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text"},model:{value:(_vm.filter.sales_doc_num),callback:function ($$v) {_vm.$set(_vm.filter, "sales_doc_num", $$v)},expression:"filter.sales_doc_num"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"date_start"}},[_vm._v("Date Start")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date"},model:{value:(_vm.filter.date_start),callback:function ($$v) {_vm.$set(_vm.filter, "date_start", $$v)},expression:"filter.date_start"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"date_end"}},[_vm._v("Date End")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date"},model:{value:(_vm.filter.date_end),callback:function ($$v) {_vm.$set(_vm.filter, "date_end", $$v)},expression:"filter.date_end"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"status"}},[_vm._v("Status")]),_vm._v(" "),_c('b-form-select',{attrs:{"id":"status","plain":true,"options":['','PENDING','IN-TRANSIT','DELIVERED','UNDELIVERED'],"value":""},model:{value:(_vm.filter.delivery_status_name),callback:function ($$v) {_vm.$set(_vm.filter, "delivery_status_name", $$v)},expression:"filter.delivery_status_name"}})],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"primary"},on:{"click":_vm.search}},[_vm._v("Search")])],1)],1),_vm._v(" "),(_vm.getRowCount(_vm.searchResults) > 0 && !_vm.loading)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Search Results")])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('b-table',{staticClass:"table-hover",attrs:{"hover":_vm.hover,"striped":_vm.striped,"bordered":_vm.bordered,"small":_vm.small,"fixed":_vm.fixed,"responsive":"sm","fields":_vm.searchResultsFields,"items":_vm.searchResults},scopedSlots:_vm._u([{key:"courier_company",fn:function(row){return [_c('b-form-group',[_c('b-form-select',{attrs:{"plain":true,"options":_vm.courierlist},model:{value:(row.item.courier_company),callback:function ($$v) {_vm.$set(row.item, "courier_company", $$v)},expression:"row.item.courier_company"}})],1)]}},{key:"delivery_number",fn:function(row){return [_c('b-form-group',[_c('b-form-input',{attrs:{"type":"text"},model:{value:(row.item.delivery_number),callback:function ($$v) {_vm.$set(row.item, "delivery_number", $$v)},expression:"row.item.delivery_number"}})],1)]}},{key:"delivery_status_name",fn:function(row){return [(row.item.current_status == 'PENDING')?_c('b-form-group',[_c('b-form-select',{attrs:{"plain":true,"options":_vm.pstatusList},model:{value:(row.item.delivery_status_name),callback:function ($$v) {_vm.$set(row.item, "delivery_status_name", $$v)},expression:"row.item.delivery_status_name"}})],1):_vm._e(),_vm._v(" "),(row.item.current_status == 'IN-TRANSIT')?_c('b-form-group',[_c('b-form-select',{attrs:{"plain":true,"options":_vm.istatusList},model:{value:(row.item.delivery_status_name),callback:function ($$v) {_vm.$set(row.item, "delivery_status_name", $$v)},expression:"row.item.delivery_status_name"}})],1):_vm._e(),_vm._v(" "),(row.item.current_status == 'DELIVERED')?_c('b-form-group',[_c('b-form-select',{attrs:{"plain":true,"options":_vm.dstatusList},model:{value:(row.item.delivery_status_name),callback:function ($$v) {_vm.$set(row.item, "delivery_status_name", $$v)},expression:"row.item.delivery_status_name"}})],1):_vm._e(),_vm._v(" "),(row.item.current_status == 'UNDELIVERED')?_c('b-form-group',[_c('b-form-select',{attrs:{"plain":true,"options":_vm.ustatusList},model:{value:(row.item.delivery_status_name),callback:function ($$v) {_vm.$set(row.item, "delivery_status_name", $$v)},expression:"row.item.delivery_status_name"}})],1):_vm._e()]}},{key:"pod_date",fn:function(row){return [_c('b-form-group',[_c('b-form-input',{attrs:{"type":"date"},model:{value:(row.item.pod_date),callback:function ($$v) {_vm.$set(row.item, "pod_date", $$v)},expression:"row.item.pod_date"}})],1)]}}])})],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"primary"},on:{"click":_vm.confirmUpate}},[_vm._v("Update")]),_vm._v("\n               \n              "),_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"danger"},on:{"click":_vm.confirmCancel}},[_vm._v("Cancel")])],1)])],1)],1):(_vm.noResults)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('div',{attrs:{"align":"center"}},[_c('strong',[_vm._v("No Delivery Orders Found")])])])],1):_vm._e(),_vm._v(" "),_c('b-modal',{attrs:{"title":"Confirmation","centered":"","header-bg-variant":"success","no-close-on-backdrop":""},on:{"ok":_vm.update},model:{value:(_vm.modalShow),callback:function ($$v) {_vm.modalShow=$$v},expression:"modalShow"}},[_c('p',{staticStyle:{"color":"darkblue"}},[_vm._v("Confirmed Update?")])]),_vm._v(" "),_c('b-modal',{attrs:{"title":"Confirmation","centered":"","header-bg-variant":"success","no-close-on-backdrop":""},on:{"ok":_vm.cancel},model:{value:(_vm.modalCancelShow),callback:function ($$v) {_vm.modalCancelShow=$$v},expression:"modalCancelShow"}},[_c('p',{staticStyle:{"color":"darkblue"}},[_vm._v("Confirmed Cancel?")])]),_vm._v(" "),_c('b-modal',{ref:"myModalRef",attrs:{"hide-header-close":"","hide-footer":"","title":"POD Update","centered":"","header-bg-variant":"success","no-close-on-backdrop":"","no-close-on-esc":""}},[_c('div',{staticClass:"d-block text-center"},[_c('p',[_vm._v("Status Updated.")])]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"variant":"outline-danger"},on:{"click":_vm.hideModal}},[_vm._v("Ok")])],1),_vm._v(" "),_c('b-modal',{ref:"myErrorModalRef",attrs:{"hide-header-close":"","hide-footer":"","title":"Invalid Entries","centered":"","header-bg-variant":"danger","no-close-on-backdrop":"","no-close-on-esc":""}},[_c('div',{staticClass:"d-block text-center"},[_c('p',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage))])]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"variant":"danger"},on:{"click":_vm.hideErrorModal}},[_vm._v("OK")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wsis_vue__ = __webpack_require__(295);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2221f268_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_wsis_vue__ = __webpack_require__(633);
function injectStyle (ssrContext) {
  __webpack_require__(632)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wsis_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2221f268_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_wsis_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 632 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(_vm.loading)?_c('spinner'):_vm._e(),_vm._v(" "),_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Search IBO / Stockist")])]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',[_vm._v("Warehouse")]),_vm._v(" "),_c('warehouseLookup',{attrs:{"url":_vm.apiWarehouseUrl,"lookupId":_vm.from_location_id},on:{"selected":function($event){_vm.setWarehouse($event)}}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"customer"}},[_vm._v("IBO / Stockist")]),_vm._v(" "),_c('memberLookup',{attrs:{"url":_vm.apiMemberLookupUrl,"lookupId":_vm.filter.customer_id},on:{"selected":function($event){_vm.setMember($event)}}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"date_start"}},[_vm._v("Date Start")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date"},model:{value:(_vm.filter.date_start),callback:function ($$v) {_vm.$set(_vm.filter, "date_start", $$v)},expression:"filter.date_start"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"date_end"}},[_vm._v("Date End")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date"},model:{value:(_vm.filter.date_end),callback:function ($$v) {_vm.$set(_vm.filter, "date_end", $$v)},expression:"filter.date_end"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"1"}},[_c('b-form-group',[_c('label',{attrs:{"for":"delivery method"}},[_vm._v("Delivery Method")]),_vm._v(" "),_c('b-form-select',{attrs:{"id":"status","plain":true,"options":['','DELIVERY', 'SELF PICK-UP']},model:{value:(_vm.filter.delivery_method),callback:function ($$v) {_vm.$set(_vm.filter, "delivery_method", $$v)},expression:"filter.delivery_method"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"status"}},[_vm._v("Delivery Status")]),_vm._v(" "),_c('b-form-select',{attrs:{"id":"status","plain":true,"options":['','PENDING', 'PICKING', 'PARTIAL-IN-TRANSIT','IN-TRANSIT','DELIVERED'],"value":""},model:{value:(_vm.filter.delivery_status),callback:function ($$v) {_vm.$set(_vm.filter, "delivery_status", $$v)},expression:"filter.delivery_status"}})],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"primary","disabled":_vm.from_location_id == ''},on:{"click":_vm.search}},[_vm._v("Search")])],1)],1),_vm._v(" "),(_vm.pickListInfo.length > 0 && !_vm.loading)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Picking List Info")])]),_vm._v(" "),_c('b-table',{staticClass:"table-hover",attrs:{"hover":_vm.hover,"striped":_vm.striped,"bordered":_vm.bordered,"small":_vm.small,"fixed":_vm.fixed,"responsive":"sm","fields":_vm.pickListInfoFields,"current-page":_vm.currentPickPage,"per-page":_vm.perPage,"items":_vm.pickListInfo},on:{"row-clicked":_vm.pickListDetails}}),_vm._v(" "),_c('nav',[_c('b-pagination',{attrs:{"total-rows":_vm.getRowCount(_vm.pickListInfo),"per-page":_vm.perPage,"prev-text":"Prev","next-text":"Next","hide-goto-end-buttons":""},model:{value:(_vm.currentPickPage),callback:function ($$v) {_vm.currentPickPage=$$v},expression:"currentPickPage"}})],1)],1),_vm._v(" "),(0)?_c('div',[_vm._v("\n                "+_vm._s(_vm.pickListInfo)+"\n            ")]):_vm._e()],1)],1):_vm._e(),_vm._v(" "),(_vm.searchResults.length > 0 && !_vm.loading)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Sales Invoices")])]),_vm._v(" "),(0)?_c('b-row',[_c('b-col',{attrs:{"sm":"8"}},[_c('b-form-group',{attrs:{"label":"Generate Picking List From (Warehouse)","label-for":"horizEmail","label-cols":4,"horizontal":true}},[_c('warehouseLookup',{attrs:{"url":_vm.apiWarehouseUrl,"lookupId":_vm.from_location_id},on:{"selected":function($event){_vm.setWarehouse($event)}}})],1)],1)],1):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped"},[_c('thead',[_c('th',[_vm._v("Trans Date")]),_vm._v(" "),_c('th',[_vm._v("Sales Docs No")]),_vm._v(" "),_c('th',[_vm._v("Invoice No")]),_vm._v(" "),_c('th',[_vm._v("IBO/Stockist No")]),_vm._v(" "),_c('th',[_vm._v("IBO/Stockist Name")]),_vm._v(" "),_c('th',[_vm._v("Channel")]),_vm._v(" "),_c('th',[_vm._v("Trans. Loc")]),_vm._v(" "),_c('th',[_vm._v("Delivery Method")]),_vm._v(" "),_c('th',[_vm._v("Delivery Town")]),_vm._v(" "),_c('th',[_vm._v("Status")]),_vm._v(" "),(_vm.sales_transactions.length >0)?_c('th',{staticStyle:{"padding":"20px"}},[_c('label',{staticClass:"checkContainer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectAll),expression:"selectAll"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.selectAll)?_vm._i(_vm.selectAll,null)>-1:(_vm.selectAll)},on:{"click":_vm.select,"change":function($event){var $$a=_vm.selectAll,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectAll=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectAll=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectAll=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})])]):_vm._e(),_vm._v(" "),_c('th')]),_vm._v(" "),_c('tbody',_vm._l((_vm.searchResults),function(row,index){return _c('tr',[_c('td',[_vm._v(_vm._s(row.trans_date))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.sales_doc_num))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.inv_number))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.customer_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.customer_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.channel))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.trans_loc))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.delivery_method))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.delivery_town))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.status))]),_vm._v(" "),_c('td',{staticStyle:{"padding":"20px"}},[(row.status == 'PENDING' && _vm.from_location_id != '')?_c('label',{staticClass:"checkContainer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedSalesDoc),expression:"selectedSalesDoc"}],attrs:{"type":"checkbox"},domProps:{"value":row.sales_doc_num,"checked":Array.isArray(_vm.selectedSalesDoc)?_vm._i(_vm.selectedSalesDoc,row.sales_doc_num)>-1:(_vm.selectedSalesDoc)},on:{"change":function($event){var $$a=_vm.selectedSalesDoc,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=row.sales_doc_num,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectedSalesDoc=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectedSalesDoc=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectedSalesDoc=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})]):_vm._e()])])}))])])])],1),_vm._v(" "),(0)?_c('div',{staticClass:"table-responsive"},[_c('b-table',{staticClass:"table-hover",attrs:{"hover":_vm.hover,"striped":_vm.striped,"bordered":_vm.bordered,"small":_vm.small,"fixed":_vm.fixed,"responsive":"sm","fields":_vm.searchResultsFields,"items":_vm.searchResults},scopedSlots:_vm._u([{key:"check_box",fn:function(row){return [(row.item.status == 'PENDING' && _vm.from_location_id != '')?_c('label',{staticClass:"checkContainer"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedSalesDoc),expression:"selectedSalesDoc"}],attrs:{"type":"checkbox"},domProps:{"value":row.item.sale_id,"checked":Array.isArray(_vm.selectedSalesDoc)?_vm._i(_vm.selectedSalesDoc,row.item.sale_id)>-1:(_vm.selectedSalesDoc)},on:{"change":function($event){var $$a=_vm.selectedSalesDoc,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=row.item.sale_id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectedSalesDoc=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectedSalesDoc=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectedSalesDoc=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"checkmark"})]):_vm._e()]}},{key:"wsi_entry",fn:function(row){return [_c('b-button',{attrs:{"size":"md","variant":"success","disabled":row.item.delivery_status_name != 'PENDING'},on:{"click":function($event){_vm.rowClick(row.item)}}},[_vm._v(" >> ")])]}}])}),_vm._v(" "),(0)?_c('nav',[_c('b-pagination',{attrs:{"total-rows":_vm.getRowCount(_vm.searchResults),"per-page":_vm.perPage,"prev-text":"Prev","next-text":"Next","hide-goto-end-buttons":""},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1):_vm._e()],1):_vm._e(),_vm._v(" "),(0)?_c('div',[_vm._v(_vm._s(_vm.selectedSalesDoc))]):_vm._e(),_vm._v(" "),_c('b-row',[(_vm.selectedSalesDoc.length > 0 )?_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"primary"},on:{"click":_vm.confirmGeneratePickingList}},[_vm._v("Generate Picking List")]):_vm._e(),_vm._v(" "),_c('b-modal',{attrs:{"hide-header-close":"","title":"Confirm Generate Picking List","centered":"","header-bg-variant":"success","no-close-on-backdrop":"","no-close-on-esc":""},on:{"ok":_vm.generatePickingList,"cancel":_vm.handleCancel},model:{value:(_vm.modalShow),callback:function ($$v) {_vm.modalShow=$$v},expression:"modalShow"}},[_vm._v("\n                    Confirmed Generate?\n                ")])],1)],1)],1)],1):(_vm.noResults && !_vm.loading)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('div',{attrs:{"align":"center"}},[_c('strong',[_vm._v("No Records Found")])])])],1):_vm._e(),_vm._v(" "),_c('div',[_c('b-modal',{attrs:{"hide-header-close":"","title":"Alert","ok-only":"","ok-variant":"secondary","centered":"","header-bg-variant":"danger","no-close-on-backdrop":"","no-close-on-esc":""},model:{value:(_vm.errorModal),callback:function ($$v) {_vm.errorModal=$$v},expression:"errorModal"}},[_vm._v("\n           The number of invoices allowed for one pickinglist is up to "),_c('b',[_vm._v("10")]),_vm._v(".\n        ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wsi_vue__ = __webpack_require__(296);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a63d921_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_wsi_vue__ = __webpack_require__(635);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wsi_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a63d921_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_wsi_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v(_vm._s(_vm.title)+" ")])]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('label',[_vm._v("Self Pick Up")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text"},model:{value:(_vm.wsi.location_full),callback:function ($$v) {_vm.$set(_vm.wsi, "location_full", $$v)},expression:"wsi.location_full"}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('label',{attrs:{"for":"remarks"}},[_vm._v("Remarks")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.wsi.remarks),expression:"wsi.remarks"}],staticClass:"form-control",attrs:{"rows":"5","id":"remarks"},domProps:{"value":(_vm.wsi.remarks)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.wsi, "remarks", $event.target.value)}}})])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('label',[_vm._v("Location From (Warehouse)")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","disabled":""},model:{value:(_vm.wsi.location_full),callback:function ($$v) {_vm.$set(_vm.wsi, "location_full", $$v)},expression:"wsi.location_full"}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('label',{attrs:{"for":"invoive"}},[_vm._v("Tax Invoice")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","disabled":""},model:{value:(_vm.wsi.invoice_num),callback:function ($$v) {_vm.$set(_vm.wsi, "invoice_num", $$v)},expression:"wsi.invoice_num"}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('label',{attrs:{"for":"trans_date"}},[_vm._v("Transaction Date")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date","disabled":""},model:{value:(_vm.wsi.trans_date),callback:function ($$v) {_vm.$set(_vm.wsi, "trans_date", $$v)},expression:"wsi.trans_date"}})],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('label',{attrs:{"for":"trans_loc"}},[_vm._v("Transaction Location")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","disabled":""},model:{value:(_vm.wsi.trans_loc),callback:function ($$v) {_vm.$set(_vm.wsi, "trans_loc", $$v)},expression:"wsi.trans_loc"}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('label',{attrs:{"for":"status"}},[_vm._v("Status")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","disabled":""},model:{value:(_vm.wsi.status),callback:function ($$v) {_vm.$set(_vm.wsi, "status", $$v)},expression:"wsi.status"}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('label',{attrs:{"for":"customer"}},[_vm._v("IBO/Stockist")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","disabled":""},model:{value:(_vm.wsi.customer_full),callback:function ($$v) {_vm.$set(_vm.wsi, "customer_full", $$v)},expression:"wsi.customer_full"}})],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('label',{attrs:{"for":"customer"}},[_vm._v("Shipping Method")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","disabled":""},model:{value:(_vm.wsi.shipping_method),callback:function ($$v) {_vm.$set(_vm.wsi, "shipping_method", $$v)},expression:"wsi.shipping_method"}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('label',{attrs:{"for":"contact"}},[_vm._v("Contact Number")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","disabled":""},model:{value:(_vm.wsi.contact_num),callback:function ($$v) {_vm.$set(_vm.wsi, "contact_num", $$v)},expression:"wsi.contact_num"}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[(1)?_c('label',[_vm._v("Shipping Address")]):_vm._e(),_vm._v(" "),(0)?_c('label',[_vm._v("Pick Up Location")]):_vm._e(),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.wsi.shipping_address),expression:"wsi.shipping_address"}],staticClass:"form-control",attrs:{"rows":"3","disabled":""},domProps:{"value":(_vm.wsi.shipping_address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.wsi, "shipping_address", $event.target.value)}}})])],1)],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Stock Issuance Items")])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped table-bordered"},[_c('thead',[_c('th',[_vm._v("Product Name")]),_vm._v(" "),_c('th',[_vm._v("Product Code")]),_vm._v(" "),_c('th',[_vm._v("SOH")]),_vm._v(" "),_c('th',[_vm._v("Order Qty")]),_vm._v(" "),_c('th',[_vm._v("Update Alloc. Qty")]),_vm._v(" "),_c('th',[_vm._v("O/S Qty")]),_vm._v(" "),_c('th',[_vm._v("Delivered Qty")])]),_vm._v(" "),_c('tbody',_vm._l((_vm.wsi.wsi_items),function(row,index){return _c('tr',[_c('td',{attrs:{"width":"300px"}},[_vm._v(_vm._s(row.prodct_name))]),_vm._v(" "),_c('td',{attrs:{"width":"250px"}},[_vm._v(_vm._s(row.product_id))]),_vm._v(" "),_c('td',{attrs:{"width":"200px"}},[_vm._v(_vm._s(row.qty_soh))]),_vm._v(" "),_c('td',{attrs:{"width":"180px"}},[_vm._v(_vm._s(row.order_qty))]),_vm._v(" "),_c('td',{attrs:{"width":"180px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.qty),expression:"row.qty"}],staticClass:"form-control",attrs:{"type":"number","min":"0","name":"qty"},domProps:{"value":(row.qty)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "qty", $event.target.value)}}})]),_vm._v(" "),_c('td',{attrs:{"width":"180px"}},[_vm._v(_vm._s(row.os_qty))]),_vm._v(" "),_c('td',{attrs:{"width":"180"}},[_vm._v(_vm._s(row.delivered_qty))])])}))])]),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[(!_vm.showIssuanceRecord)?_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"primary"},on:{"click":_vm.confirmGenerateDO}},[_vm._v("Generate DO")]):_vm._e()],1),_vm._v(" "),_c('b-modal',{attrs:{"hide-header-close":"","title":"Confirm Generate DO","centered":"","header-bg-variant":"success","no-close-on-backdrop":"","no-close-on-esc":""},on:{"ok":_vm.generateDO,"cancel":_vm.handleCancel},model:{value:(_vm.modalShow),callback:function ($$v) {_vm.modalShow=$$v},expression:"modalShow"}},[_c('p',{staticStyle:{"color":"darkblue"}},[_vm._v("Confirmed Generate?")])])],1)],1)],1),_vm._v(" "),(_vm.showIssuanceRecord)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Stock Issuance Records")])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-striped table-bordered"},[_c('thead',[_c('th',[_vm._v("PickList Date")]),_vm._v(" "),_c('th',[_vm._v("PickList No")]),_vm._v(" "),_c('th',[_vm._v("Created By")]),_vm._v(" "),_c('th',[_vm._v("Do Date")]),_vm._v(" "),_c('th',[_vm._v("Do No")]),_vm._v(" "),_c('th',[_vm._v("Created By")]),_vm._v(" "),_c('th',[_vm._v("Courier Company")]),_vm._v(" "),_c('th',[_vm._v("Courier No")])]),_vm._v(" "),_c('tbody',_vm._l((_vm.wsi.pickListInfo),function(row,index){return _c('tr',[_c('td',{attrs:{"width":"300px"}},[_vm._v(_vm._s(row.picklist_date))]),_vm._v(" "),_c('td',{attrs:{"width":"250px"}},[_vm._v(_vm._s(row.picklist_num))]),_vm._v(" "),_c('td',{attrs:{"width":"200px"}},[_vm._v(_vm._s(row.pl_author_user_shortname))]),_vm._v(" "),_c('td',{attrs:{"width":"180px"}},[_vm._v(_vm._s(row.do_date))]),_vm._v(" "),_c('td',{attrs:{"width":"180px"}},[_vm._v(_vm._s(row.do_num))]),_vm._v(" "),_c('td',{attrs:{"width":"180px"}},[_vm._v(_vm._s(row.do_author_user_shortname))]),_vm._v(" "),_c('td',{attrs:{"width":"180px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.courier_company_id),expression:"row.courier_company_id"}],staticClass:"form-control",attrs:{"type":"text","min":"0","name":"courier_company_id"},domProps:{"value":(row.courier_company_id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "courier_company_id", $event.target.value)}}})]),_vm._v(" "),_c('td',{attrs:{"width":"180px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.courier_num),expression:"row.courier_num"}],staticClass:"form-control",attrs:{"type":"text","min":"0","name":"courier_num"},domProps:{"value":(row.courier_num)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "courier_num", $event.target.value)}}})])])}))])])])],1)],1):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-row',{staticStyle:{"padding":"0px 0px 20px 18px"}},[_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"primary"}},[_vm._v("Save")]),_vm._v("\n                  \n                "),_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"danger"}},[_vm._v("Cancel")]),_vm._v("\n                  \n                "),_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"danger"},on:{"click":_vm.back}},[_vm._v("Back")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_picklistinfo_vue__ = __webpack_require__(297);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36b35686_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_picklistinfo_vue__ = __webpack_require__(639);
function injectStyle (ssrContext) {
  __webpack_require__(637)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_picklistinfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36b35686_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_picklistinfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 637 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 638 */,
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(_vm.loading)?_c('spinner'):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Consolidated Picking List "+_vm._s(_vm.picklist_ref))])]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"4"}},[_c('label',[_vm._v("Picking List No")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","disabled":""},model:{value:(_vm.pList.picklist_num),callback:function ($$v) {_vm.$set(_vm.pList, "picklist_num", $$v)},expression:"pList.picklist_num"}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('label',[_vm._v("Picking List Date")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","disabled":""},model:{value:(_vm.pList.picklist_date),callback:function ($$v) {_vm.$set(_vm.pList, "picklist_date", $$v)},expression:"pList.picklist_date"}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('label',[_vm._v("Location From ( Warehouse )")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","disabled":""},model:{value:(_vm.pList.from_location_id),callback:function ($$v) {_vm.$set(_vm.pList, "from_location_id", $$v)},expression:"pList.from_location_id"}})],1)],1),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('div',{staticClass:"table-responsive"},[_c('b-table',{staticClass:"table-hover",attrs:{"hover":_vm.hover,"striped":_vm.striped,"bordered":_vm.bordered,"small":_vm.small,"fixed":_vm.fixed,"responsive":"sm","fields":_vm.picking_list_items_fields,"items":_vm.pList.picklist_items}})],1)])],1),_vm._v(" "),((_vm.dosLength*1) > 0)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('label',[_c('strong',[_vm._v("Delivery Orders")])])])],1):_vm._e(),_vm._v(" "),_c('b-row',_vm._l((_vm.pList.dos),function(d){return _c('b-col',{attrs:{"sm":"2"}},[_c('b-button',{staticClass:"btn btn-block",attrs:{"type":"submit","size":"lg","variant":"secondary"},on:{"click":function($event){_vm.printDO(d)}}},[_vm._v(_vm._s(d.do_num))]),_vm._v(" "),_c('br')],1)})),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-row',[(_vm.showPickListHeader == false)?_c('b-col',{attrs:{"sm":"2"}},[_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"success"},on:{"click":_vm.printWithoutConsolidatedPickList}},[_vm._v("Print Picking List")])],1):_vm._e(),_vm._v(" "),(_vm.showPickListHeader == true)?_c('b-col',{attrs:{"sm":"2"}},[_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"success"},on:{"click":_vm.printWithConsolidatedPickList}},[_vm._v("Print Picking List")])],1):_vm._e(),_vm._v(" "),_c('b-col',{attrs:{"sm":"4"}},[_c('label',[_vm._v("Print Consolidated Picking List")]),_vm._v("  \n                                "),_c('toggle-button',{attrs:{"sync":true,"labels":true,"height":29,"width":58},model:{value:(_vm.showPickListHeader),callback:function ($$v) {_vm.showPickListHeader=$$v},expression:"showPickListHeader"}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},_vm._l((_vm.pList.packlists),function(data){return _c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v(_vm._s(data.delivery_method_name))]),_vm._v(" "),_c('span',{staticStyle:{"float":"right"}},[_c('strong',[_vm._v(_vm._s(data.member_full))])])]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-group',[_c('label',[_vm._v("Sales Doc Nos.")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","disabled":""},model:{value:(data.invoice_num_list),callback:function ($$v) {_vm.$set(data, "invoice_num_list", $$v)},expression:"data.invoice_num_list"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-group',[_c('label',[_vm._v("Invoices No")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","disabled":""},model:{value:(data.tax_invoices_nums),callback:function ($$v) {_vm.$set(data, "tax_invoices_nums", $$v)},expression:"data.tax_invoices_nums"}})],1)],1)],1),_vm._v(" "),(data.delivery_method_name =='DELIVERY')?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-group',[_c('label',[_vm._v("Delivery Address")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(data.delivery_address),expression:"data.delivery_address"}],staticClass:"form-control",attrs:{"rows":"5","disabled":""},domProps:{"value":(data.delivery_address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(data, "delivery_address", $event.target.value)}}})])],1)],1):_vm._e(),_vm._v(" "),(data.delivery_method_name =='SELF PICK-UP')?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-group',[_c('label',[_vm._v("Pickup Location")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","disabled":""},model:{value:(data.from_location_id),callback:function ($$v) {_vm.$set(data, "from_location_id", $$v)},expression:"data.from_location_id"}})],1)],1)],1):_vm._e(),_vm._v(" "),_c('b-row',[(data.delivery_method_name == 'DELIVERY')?_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"reson"}},[_vm._v("Courier Company")]),_vm._v(" "),_c('b-form-select',{attrs:{"id":"courier","plain":true,"options":_vm.courier_list},model:{value:(data.courier_company),callback:function ($$v) {_vm.$set(data, "courier_company", $$v)},expression:"data.courier_company"}})],1)],1):_vm._e(),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',[_vm._v("Delivery Number")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text"},model:{value:(data.delivery_number),callback:function ($$v) {_vm.$set(data, "delivery_number", $$v)},expression:"data.delivery_number"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"6"}},[_c('b-form-group',[_c('label',[_vm._v("Remarks")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(data.remarks),expression:"data.remarks"}],staticClass:"form-control",attrs:{"rows":"3"},domProps:{"value":(data.remarks)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(data, "remarks", $event.target.value)}}})])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('div',{staticClass:"btn pull-right"},[(!data.isCompleted)?_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"primary"},on:{"click":function($event){_vm.packAll(data.items)}}},[_vm._v("Pack All")]):_vm._e(),_vm._v(" \n                            "),(!data.isCompleted)?_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"danger"},on:{"click":function($event){_vm.clearAll(data.items)}}},[_vm._v("Clear")]):_vm._e()],1)])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table"},[_c('thead',[_c('th',{attrs:{"width":"10px"}},[_vm._v("S/N")]),_vm._v(" "),_c('th',{attrs:{"width":"150px"}},[_vm._v("Product Code")]),_vm._v(" "),_c('th',{staticStyle:{"min-width":"300px"}},[_vm._v("Product Name")]),_vm._v(" "),_c('th',{attrs:{"width":"150px"}},[_vm._v("Qty")]),_vm._v(" "),_c('th',{attrs:{"width":"150px"}},[_vm._v("Qty Delivered")]),_vm._v(" "),_c('th',{attrs:{"width":"180px"}},[_vm._v("Qty Balance")]),_vm._v(" "),_c('th',{attrs:{"width":"180px"}},[_vm._v("Qty Allocate")])]),_vm._v(" "),_c('tbody',_vm._l((data.items),function(row,index){return _c('tr',{style:([((row.qty*1)-(row.qty_allocated*1)-(row.qty_delivered*1)) > 0 ? {color:_vm.activeColor, fontWeight:'bold'} :'',((row.qty*1)-(row.qty_allocated*1)-(row.qty_delivered*1)) == 0 ? {color:_vm.otherColor} :'',(((row.qty*1)-(row.qty_allocated*1)-(row.qty_delivered*1)) < (row.qty * 1) && ((row.qty*1)-(row.qty_allocated*1)-(row.qty_delivered*1)) > 0 )? {color:'green',fontWeight:'bold'} :''])},[_c('td',[_vm._v(_vm._s((index*1) +1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.product_code))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.product_name))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.qty))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(row.qty_delivered))]),_vm._v(" "),_c('td',[_vm._v(_vm._s((row.qty*1)-(row.qty_allocated*1)-(row.qty_delivered*1)))]),_vm._v(" "),_c('td',[((row.qty_delivered*1) != (row.qty*1))?_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.qty_allocated),expression:"row.qty_allocated"}],staticClass:"form-control",attrs:{"type":"number","min":"1"},domProps:{"value":(row.qty_allocated)},on:{"change":function($event){_vm.computePickingListQty(row)},"focus":function($event){_vm.getValue(row)},"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "qty_allocated", $event.target.value)}}}):_vm._e()])])}))])])])],1)],1)}))],1),_vm._v(" "),_c('b-row',{staticStyle:{"padding":"0px 0px 20px 18px"}},[_c('b-col',{attrs:{"sm":"12"}},[_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"primary","disabled":_vm.showGenerateDo},on:{"click":_vm.confirmGenerateDO}},[_vm._v("Generate DO")]),_vm._v("\n                  \n            "),_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"danger"},on:{"click":_vm.back}},[_vm._v("Back")])],1)],1),_vm._v(" "),_c('div',[_c('b-modal',{attrs:{"title":"Confirmation","centered":"","header-bg-variant":"success","no-close-on-backdrop":""},on:{"ok":_vm.generateDO},model:{value:(_vm.modalShow),callback:function ($$v) {_vm.modalShow=$$v},expression:"modalShow"}},[_c('p',{staticStyle:{"color":"darkblue"}},[_vm._v("Confirmed Generate DO?")])]),_vm._v(" "),_c('b-modal',{ref:"myModalRef",attrs:{"hide-header-close":"","hide-footer":"","title":"Delivery Order","centered":"","header-bg-variant":"success","no-close-on-backdrop":"","no-close-on-esc":""}},[_c('div',{staticClass:"d-block text-center"},[_c('p',[_vm._v("Delivery Order(s)"),_c('strong',{staticStyle:{"color":"green"}},[_vm._v(" "+_vm._s(_vm.DoNum))]),_vm._v(" has been generated."),_c('br'),_c('br')])]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"variant":"outline-danger"},on:{"click":_vm.hideModal}},[_vm._v("Ok")])],1),_vm._v(" "),_c('b-modal',{ref:"myErrorModalRef",attrs:{"hide-header-close":"","hide-footer":"","title":"Invalid Entries","centered":"","header-bg-variant":"danger","no-close-on-backdrop":"","no-close-on-esc":""}},[_c('div',{staticClass:"d-block text-center"},[_c('p',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(_vm.errorMessage))])]),_vm._v(" "),_c('b-btn',{staticClass:"float-right",attrs:{"variant":"danger"},on:{"click":_vm.hideErrorModal}},[_vm._v("OK")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ssrs_vue__ = __webpack_require__(298);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01036e8b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ssrs_vue__ = __webpack_require__(641);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ssrs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01036e8b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ssrs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(_vm.loading)?_c('spinner'):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Search Stockist")])]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_c('label',[_vm._v("Stockist")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text"},model:{value:(_vm.filter.stockist_id),callback:function ($$v) {_vm.$set(_vm.filter, "stockist_id", $$v)},expression:"filter.stockist_id"}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('label',[_vm._v("Date From")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date"},model:{value:(_vm.filter.date_start),callback:function ($$v) {_vm.$set(_vm.filter, "date_start", $$v)},expression:"filter.date_start"}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('label',[_vm._v("Date To")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date"},model:{value:(_vm.filter.date_to),callback:function ($$v) {_vm.$set(_vm.filter, "date_to", $$v)},expression:"filter.date_to"}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('label',{attrs:{"for":"status"}},[_vm._v("Status")]),_vm._v(" "),_c('b-form-group',[_c('b-form-select',{attrs:{"id":"status","plain":true,"options":['','PENDING', 'PICKING', 'PARTIAL-IN-TRANSIT','IN-TRANSIT','DELIVERED'],"value":""},model:{value:(_vm.filter.status),callback:function ($$v) {_vm.$set(_vm.filter, "status", $$v)},expression:"filter.status"}})],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"primary"},on:{"click":_vm.search}},[_vm._v("Search")])],1)],1)],1)],1),_vm._v(" "),(_vm.searchResults.length > 0 && !_vm.loading || 1)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Search Result")])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('b-table',{staticClass:"table-hover",attrs:{"hover":_vm.hover,"striped":_vm.striped,"bordered":_vm.bordered,"small":_vm.small,"fixed":_vm.fixed,"responsive":"sm","fields":_vm.searchResultsFields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"items":_vm.searchResults},scopedSlots:_vm._u([{key:"check_box",fn:function(row){return [_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selectedSalesDoc),expression:"selectedSalesDoc"}],attrs:{"type":"checkbox"},domProps:{"value":row.item.sale_id,"checked":Array.isArray(_vm.selectedSalesDoc)?_vm._i(_vm.selectedSalesDoc,row.item.sale_id)>-1:(_vm.selectedSalesDoc)},on:{"change":function($event){var $$a=_vm.selectedSalesDoc,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=row.item.sale_id,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selectedSalesDoc=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selectedSalesDoc=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selectedSalesDoc=$$c}}}})]}}])})],1),_vm._v(" "),_c('nav',[_c('b-pagination',{attrs:{"total-rows":_vm.getRowCount(_vm.searchResults),"per-page":_vm.perPage,"prev-text":"Prev","next-text":"Next","hide-goto-end-buttons":""},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1),_vm._v(" "),_c('b-row',[(_vm.selectedSalesDoc.length > 0)?_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"primary"},on:{"click":_vm.previewPickingList}},[_vm._v("Generate Pick List")]):_vm._e()],1)],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ssr_vue__ = __webpack_require__(299);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c6025b6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ssr_vue__ = __webpack_require__(643);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ssr_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c6025b6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ssr_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pdr_vue__ = __webpack_require__(300);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b729ce8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pdr_vue__ = __webpack_require__(645);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pdr_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b729ce8_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pdr_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(_vm.loading)?_c('spinner'):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Search Stock Delivered")])]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"country"}},[_vm._v("Country")]),_vm._v(" "),_c('countryLookup',{attrs:{"url":_vm.apiCountryLookup,"lookupId":_vm.filter.country},on:{"selected":function($event){_vm.setCountry($event)}}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('label',{attrs:{"for":"country"}},[_vm._v("Location")]),_vm._v(" "),_c('warehouseLookup',{attrs:{"url":_vm.apiWarehouseLookup,"lookupId":_vm.filter.warehouse,"q2":_vm.filter.country},on:{"selected":function($event){_vm.setWarehouse($event)}}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',[_vm._v("Transaction Date")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date"},model:{value:(_vm.filter.invoice_date),callback:function ($$v) {_vm.$set(_vm.filter, "invoice_date", $$v)},expression:"filter.invoice_date"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',[_vm._v("Invoice No")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text"},model:{value:(_vm.filter.invoice_number),callback:function ($$v) {_vm.$set(_vm.filter, "invoice_number", $$v)},expression:"filter.invoice_number"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',[_vm._v("Goods Issued Date")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date"},model:{value:(_vm.filter.goods_issued_date),callback:function ($$v) {_vm.$set(_vm.filter, "goods_issued_date", $$v)},expression:"filter.goods_issued_date"}})],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"primary"},on:{"click":_vm.search}},[_vm._v("Search")])],1)],1)],1)],1),_vm._v(" "),(_vm.searchResults.length >0 && !_vm.loading)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Stock Delivered Details")])]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('div',{staticClass:"table-responsive"},[_c('b-table',{staticClass:"table-hover",attrs:{"hover":_vm.hover,"striped":_vm.striped,"bordered":_vm.bordered,"small":_vm.small,"fixed":_vm.fixed,"responsive":"sm","fields":_vm.searchResultsFields,"items":_vm.searchResults,"current-page":_vm.currentPage,"per-page":_vm.perPage}})],1),_vm._v(" "),_c('nav',[_c('b-pagination',{attrs:{"total-rows":_vm.getRowCount(_vm.searchResults),"per-page":_vm.perPage,"prev-text":"Prev","next-text":"Next","hide-goto-end-buttons":""},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)])],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('exportExcel',{staticClass:"btn btn-primary btn-lg",attrs:{"size":"lg","data":_vm.searchResults,"fields":_vm.exportHeaders,"name":"delivered_products.xls"}},[_vm._v("\n                        Export to Excel\n                    ")]),_vm._v(" "),_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"success"},on:{"click":_vm.print}},[_vm._v("Print")])],1)],1)],1)],1):(_vm.noResults && !_vm.loading)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('div',{attrs:{"align":"center"}},[_c('strong',[_vm._v("No Records Found")])])])],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pur_vue__ = __webpack_require__(301);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f45607e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pur_vue__ = __webpack_require__(647);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pur_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f45607e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pur_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(_vm.loading)?_c('spinner'):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Search Outstanding Orders")])]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"country"}},[_vm._v("Country")]),_vm._v(" "),_c('countryLookup',{attrs:{"url":_vm.apiCountryLookup,"lookupId":_vm.filter.country},on:{"selected":function($event){_vm.setCountry($event)}}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('label',{attrs:{"for":"country"}},[_vm._v("Location")]),_vm._v(" "),_c('warehouseLookup',{attrs:{"url":_vm.apiWarehouseLookup,"lookupId":_vm.filter.warehouse,"q2":_vm.filter.country},on:{"selected":function($event){_vm.setWarehouse($event)}}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',[_vm._v("Transaction Date")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date"},model:{value:(_vm.filter.invoice_date),callback:function ($$v) {_vm.$set(_vm.filter, "invoice_date", $$v)},expression:"filter.invoice_date"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',[_vm._v("Invoice No")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text"},model:{value:(_vm.filter.invoice_number),callback:function ($$v) {_vm.$set(_vm.filter, "invoice_number", $$v)},expression:"filter.invoice_number"}})],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"primary"},on:{"click":_vm.search}},[_vm._v("Search")])],1)],1)],1)],1),_vm._v(" "),(_vm.searchResults.length >0 && !_vm.loading)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Outstanding Orders")])]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('div',{staticClass:"table-responsive"},[_c('b-table',{staticClass:"table-hover",attrs:{"hover":_vm.hover,"striped":_vm.striped,"bordered":_vm.bordered,"small":_vm.small,"fixed":_vm.fixed,"responsive":"sm","fields":_vm.searchResultsFields,"items":_vm.searchResults,"per-page":_vm.perPage,"current-page":_vm.currentPage}})],1),_vm._v(" "),_c('nav',[_c('b-pagination',{attrs:{"total-rows":_vm.getRowCount(_vm.searchResults),"per-page":_vm.perPage,"prev-text":"Prev","next-text":"Next","hide-goto-end-buttons":""},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)])],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('exportExcel',{staticClass:"btn btn-primary btn-lg",attrs:{"size":"lg","data":_vm.searchResults,"fields":_vm.exportHeaders,"name":"undelivered_orders.xls"}},[_vm._v("\n                        Export to Excel\n                    ")]),_vm._v(" "),_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"success"},on:{"click":_vm.print}},[_vm._v("Print")])],1)],1)],1)],1):(_vm.noResults && !_vm.loading)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('div',{attrs:{"align":"center"}},[_c('strong',[_vm._v("No Records Found")])])])],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bor_vue__ = __webpack_require__(302);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f6cca38_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bor_vue__ = __webpack_require__(649);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f6cca38_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(_vm.loading)?_c('spinner'):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Search Back Orders")])]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"country_id"}},[_vm._v("Country")]),_vm._v(" "),_c('countryLookup',{attrs:{"url":_vm.apiCountryLookup,"lookupId":_vm.filter.country_id},on:{"selected":function($event){_vm.setCountry($event)}}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('label',{attrs:{"for":"country_id"}},[_vm._v("Location")]),_vm._v(" "),_c('warehouseLookup',{attrs:{"url":_vm.apiWarehouseLookup,"lookupId":_vm.filter.location_id,"q2":_vm.filter.country_id},on:{"selected":function($event){_vm.setWarehouse($event)}}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('label',[_vm._v("Back Order No")]),_vm._v(" "),_c('b-form-group',[_c('b-form-input',{attrs:{"type":"text"},model:{value:(_vm.filter.back_order_num),callback:function ($$v) {_vm.$set(_vm.filter, "back_order_num", $$v)},expression:"filter.back_order_num"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',[_vm._v("Transaction Date")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date"},model:{value:(_vm.filter.transaction_date),callback:function ($$v) {_vm.$set(_vm.filter, "transaction_date", $$v)},expression:"filter.transaction_date"}})],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"primary"},on:{"click":_vm.search}},[_vm._v("Search")])],1)],1)],1)],1),_vm._v(" "),(_vm.searchResults.length >0 && !_vm.loading)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Back Orders")])]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('div',{staticClass:"table-responsive"},[_c('b-table',{staticClass:"table-hover",attrs:{"hover":_vm.hover,"striped":_vm.striped,"bordered":_vm.bordered,"small":_vm.small,"fixed":_vm.fixed,"responsive":"sm","fields":_vm.searchResultsFields,"items":_vm.searchResults,"per-page":_vm.perPage,"current-page":_vm.currentPage}})],1),_vm._v(" "),_c('nav',[_c('b-pagination',{attrs:{"total-rows":_vm.getRowCount(_vm.searchResults),"per-page":_vm.perPage,"prev-text":"Prev","next-text":"Next","hide-goto-end-buttons":""},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)])],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('exportExcel',{staticClass:"btn btn-primary btn-lg",attrs:{"size":"lg","data":_vm.searchResults,"fields":_vm.exportHeaders,"name":"back_orders.xls"}},[_vm._v("\n                        Export to Excel\n                    ")]),_vm._v("\n                      \n                    "),_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"success"},on:{"click":_vm.print}},[_vm._v("Print")])],1)],1)],1)],1):(_vm.noResults && !_vm.loading)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('div',{attrs:{"align":"center"}},[_c('strong',[_vm._v("No Records Found")])])])],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_po_grn_tracking_vue__ = __webpack_require__(303);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66beae76_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_po_grn_tracking_vue__ = __webpack_require__(652);
function injectStyle (ssrContext) {
  __webpack_require__(651)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_po_grn_tracking_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66beae76_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_po_grn_tracking_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 651 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(_vm.loading)?_c('spinner'):_vm._e(),_vm._v(" "),_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Search PO")])]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"po_num"}},[_vm._v("PO No")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","id":"po_num"},on:{"keyup":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.search($event)},function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }$event.target.nextElementSibling.focus()}]},model:{value:(_vm.filter.po_num),callback:function ($$v) {_vm.$set(_vm.filter, "po_num", $$v)},expression:"filter.po_num"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"supplier_id"}},[_vm._v("Supplier")]),_vm._v(" "),_c('supplierLookup',{attrs:{"url":_vm.apiUrl,"lookupId":_vm.filter.supplier_id},on:{"selected":function($event){_vm.setSupplierId($event)}}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',[_vm._v("GRN No")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text"},model:{value:(_vm.filter.grn_num),callback:function ($$v) {_vm.$set(_vm.filter, "grn_num", $$v)},expression:"filter.grn_num"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',[_vm._v("PO Date")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text"},model:{value:(_vm.filter.po_date),callback:function ($$v) {_vm.$set(_vm.filter, "po_date", $$v)},expression:"filter.po_date"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"po_status"}},[_vm._v("PO Status")]),_vm._v(" "),_c('b-form-select',{attrs:{"id":"po_status","plain":true,"options":['','PENDING', 'APPROVED', 'CANCELLED'],"value":""},model:{value:(_vm.filter.po_status),callback:function ($$v) {_vm.$set(_vm.filter, "po_status", $$v)},expression:"filter.po_status"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',{attrs:{"for":"po_fulfilment_status"}},[_vm._v("Fulfilment Status")]),_vm._v(" "),_c('b-form-select',{attrs:{"id":"po_fulfilment_status","plain":true,"options":['','PARTIAL', 'FULFILLED', 'MANUAL CLOSED','UNFULFILLED'],"value":""},model:{value:(_vm.filter.po_fulfilment_status),callback:function ($$v) {_vm.$set(_vm.filter, "po_fulfilment_status", $$v)},expression:"filter.po_fulfilment_status"}})],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"primary"},on:{"click":_vm.search}},[_vm._v(" Search")])],1)],1),_vm._v(" "),(_vm.getRowCount(_vm.searchResults) > 0 && !_vm.loading)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Search Results")])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('b-table',{staticClass:"table-hover",attrs:{"striped":_vm.striped,"bordered":_vm.bordered,"small":_vm.small,"fixed":_vm.fixed,"responsive":"sm","fields":_vm.searchResultsFields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"items":_vm.searchResults}})],1),_vm._v(" "),_c('nav',[_c('b-pagination',{attrs:{"total-rows":_vm.getRowCount(_vm.searchResults),"per-page":_vm.perPage,"prev-text":"Prev","next-text":"Next","hide-goto-end-buttons":""},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('exportExcel',{staticClass:"btn btn-primary btn-lg",attrs:{"size":"lg","data":_vm.searchResults,"fields":_vm.exportHeaders,"name":"po.xls"}},[_vm._v("\n                        Export to Excel\n                    ")]),_vm._v("\n                      \n                    "),_c('b-button',{attrs:{"type":"button","size":"lg","variant":"success"},on:{"click":_vm.print}},[_vm._v("Print")])],1)])],1)],1):(_vm.noResults)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('div',{attrs:{"align":"center"}},[_c('strong',[_vm._v("No Data Found")])])])],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_srf_do_listing_vue__ = __webpack_require__(304);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c5cb231_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_srf_do_listing_vue__ = __webpack_require__(654);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_srf_do_listing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c5cb231_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_srf_do_listing_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(_vm.loading)?_c('spinner'):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("SRF DO Listings")])]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_c('label',[_vm._v("Doc. No")]),_vm._v(" "),_c('b-form-group',[_c('b-form-input',{attrs:{"type":"text"},model:{value:(_vm.filter.doc_num),callback:function ($$v) {_vm.$set(_vm.filter, "doc_num", $$v)},expression:"filter.doc_num"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',[_vm._v("Doc. Date")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date"},model:{value:(_vm.filter.doc_date),callback:function ($$v) {_vm.$set(_vm.filter, "doc_date", $$v)},expression:"filter.doc_date"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',[_vm._v("From Date")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date"},model:{value:(_vm.filter.from_date),callback:function ($$v) {_vm.$set(_vm.filter, "from_date", $$v)},expression:"filter.from_date"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',[_vm._v("To Date")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date"},model:{value:(_vm.filter.to_date),callback:function ($$v) {_vm.$set(_vm.filter, "to_date", $$v)},expression:"filter.to_date"}})],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"primary"},on:{"click":_vm.search}},[_vm._v("Search")])],1)],1)],1)],1),_vm._v(" "),(_vm.searchResults.length >0 && !_vm.loading)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("SRF Listings")])]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('div',{staticClass:"table-responsive"},[_c('b-table',{staticClass:"table-hover",attrs:{"hover":_vm.hover,"striped":_vm.striped,"bordered":_vm.bordered,"small":_vm.small,"fixed":_vm.fixed,"responsive":"sm","fields":_vm.searchResultsFields,"items":_vm.searchResults}})],1),_vm._v(" "),_c('nav',[_c('b-pagination',{attrs:{"total-rows":_vm.getRowCount(_vm.searchResults),"per-page":_vm.perPage,"prev-text":"Prev","next-text":"Next","hide-goto-end-buttons":""},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)])],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('exportExcel',{staticClass:"btn btn-primary btn-lg",attrs:{"size":"lg","data":_vm.searchResults,"fields":_vm.exportHeaders,"name":"back_orders.xls"}},[_vm._v("\n                        Export to Excel\n                    ")]),_vm._v("\n                      \n                    "),_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"success"},on:{"click":_vm.print}},[_vm._v("Print")])],1)],1)],1)],1):(_vm.noResults && !_vm.loading)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('div',{attrs:{"align":"center"}},[_c('strong',[_vm._v("No Records Found")])])])],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sr_usage_vue__ = __webpack_require__(305);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2290c251_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sr_usage_vue__ = __webpack_require__(656);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sr_usage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2290c251_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sr_usage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(_vm.loading)?_c('spinner'):_vm._e(),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Search SR Usage")])]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"2"}},[_c('label',[_vm._v("Doc. No")]),_vm._v(" "),_c('b-form-group',[_c('b-form-input',{attrs:{"type":"text"},model:{value:(_vm.filter.doc_num),callback:function ($$v) {_vm.$set(_vm.filter, "doc_num", $$v)},expression:"filter.doc_num"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',[_vm._v("From Doc. Date")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date"},model:{value:(_vm.filter.from_doc_date),callback:function ($$v) {_vm.$set(_vm.filter, "from_doc_date", $$v)},expression:"filter.from_doc_date"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"2"}},[_c('b-form-group',[_c('label',[_vm._v("To Doc. Date")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date"},model:{value:(_vm.filter.to_doc_date),callback:function ($$v) {_vm.$set(_vm.filter, "to_doc_date", $$v)},expression:"filter.to_doc_date"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('label',{attrs:{"for":"country_id"}},[_vm._v("Location")]),_vm._v(" "),_c('warehouseLookup',{attrs:{"url":_vm.apiWarehouseLookup,"lookupId":_vm.filter.location_id,"q2":_vm.filter.country_id},on:{"selected":function($event){_vm.setWarehouse($event)}}})],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',[_vm._v("SRF No")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text"},model:{value:(_vm.filter.srf_num),callback:function ($$v) {_vm.$set(_vm.filter, "srf_num", $$v)},expression:"filter.srf_num"}})],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"primary"},on:{"click":_vm.search}},[_vm._v("Search")])],1)],1)],1)],1),_vm._v(" "),(_vm.searchResults.length >0 && !_vm.loading)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("SR Usage Listings")])]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('div',{staticClass:"table-responsive"},[_c('b-table',{staticClass:"table-hover",attrs:{"hover":_vm.hover,"striped":_vm.striped,"bordered":_vm.bordered,"small":_vm.small,"fixed":_vm.fixed,"responsive":"sm","fields":_vm.searchResultsFields,"items":_vm.searchResults}})],1),_vm._v(" "),_c('nav',[_c('b-pagination',{attrs:{"total-rows":_vm.getRowCount(_vm.searchResults),"per-page":_vm.perPage,"prev-text":"Prev","next-text":"Next","hide-goto-end-buttons":""},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1)])],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('exportExcel',{staticClass:"btn btn-primary btn-lg",attrs:{"size":"lg","data":_vm.searchResults,"fields":_vm.exportHeaders,"name":"back_orders.xls"}},[_vm._v("\n                            Export to Excel\n                        ")]),_vm._v("\n                          \n")],1)],1)],1)],1):(_vm.noResults && !_vm.loading)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('div',{attrs:{"align":"center"}},[_c('strong',[_vm._v("No Records Found")])])])],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gri_details_vue__ = __webpack_require__(306);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69e578eb_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gri_details_vue__ = __webpack_require__(659);
function injectStyle (ssrContext) {
  __webpack_require__(658)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gri_details_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69e578eb_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gri_details_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 658 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(_vm.loading)?_c('spinner'):_vm._e(),_vm._v(" "),_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Search GRI")])]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"gro_num"}},[_vm._v("GRI No")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text","id":"gri_num"},model:{value:(_vm.filter.gri_num),callback:function ($$v) {_vm.$set(_vm.filter, "gri_num", $$v)},expression:"filter.gri_num"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',{attrs:{"for":"country_id"}},[_vm._v("Country")]),_vm._v(" "),_c('countryLookup',{attrs:{"url":_vm.apiCountryLookup,"lookupId":_vm.filter.country_id},on:{"selected":function($event){_vm.setCountry($event)}}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',[_vm._v("Date Start")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date"},model:{value:(_vm.filter.date_start),callback:function ($$v) {_vm.$set(_vm.filter, "date_start", $$v)},expression:"filter.date_start"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"3"}},[_c('b-form-group',[_c('label',[_vm._v("Date End")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"date"},model:{value:(_vm.filter.date_end),callback:function ($$v) {_vm.$set(_vm.filter, "date_end", $$v)},expression:"filter.date_end"}})],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"primary"},on:{"click":_vm.search}},[_vm._v("Search")])],1)],1),_vm._v(" "),(_vm.getRowCount(_vm.searchResults) > 0 && !_vm.loading)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Search Results")])]),_vm._v(" "),_c('b-table',{staticClass:"table-hover",attrs:{"hover":_vm.hover,"striped":_vm.striped,"bordered":_vm.bordered,"small":_vm.small,"fixed":_vm.fixed,"responsive":"sm","fields":_vm.searchResultsFields,"current-page":_vm.currentPage,"per-page":_vm.perPage,"items":_vm.searchResults}}),_vm._v(" "),_c('nav',[_c('b-pagination',{attrs:{"total-rows":_vm.getRowCount(_vm.searchResults),"per-page":_vm.perPage,"prev-text":"Prev","next-text":"Next","hide-goto-end-buttons":""},model:{value:(_vm.currentPage),callback:function ($$v) {_vm.currentPage=$$v},expression:"currentPage"}})],1),_vm._v(" "),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('exportExcel',{staticClass:"btn btn-primary btn-lg",attrs:{"size":"lg","data":_vm.searchResults,"fields":_vm.exportHeaders,"name":"gri.xls"}},[_vm._v("\n              Export to Excel\n          ")]),_vm._v("\n            \n          "),_c('b-button',{attrs:{"type":"button","size":"lg","variant":"success"},on:{"click":_vm.print}},[_vm._v("Print")])],1)],1)],1)],1):(_vm.noResults)?_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('div',{attrs:{"align":"center"}},[_c('strong',[_vm._v("No GRI Found")])])])],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pdfTest_vue__ = __webpack_require__(307);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95126596_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pdfTest_vue__ = __webpack_require__(661);
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pdfTest_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95126596_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pdfTest_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('strong',[_vm._v("Generate PDF")])]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-form-group',[_c('label',[_vm._v("Countries")]),_vm._v(" "),_c('b-form-select',{staticClass:"mb-3",attrs:{"options":_vm.countries},model:{value:(_vm.country_id),callback:function ($$v) {_vm.country_id=$$v},expression:"country_id"}})],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12"}},[_c('b-button',{attrs:{"type":"submit","size":"lg","variant":"primary"},on:{"click":_vm.printPDF}},[_vm._v("Generate PDF")])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var API_URL = 'http://elken.sage9.com/api/';
var LOGIN_URL = API_URL + 'user/login';
var ACL_URL = API_URL + 'user/acl';

/* unused harmony default export */ var _unused_webpack_default_export = ({
  user: {
    authenticated: false
  },

  login: function login(context, creds, redirect) {
    var _this = this;

    console.log(LOGIN_URL);
    console.log(context);

    this.$http.post(LOGIN_URL, creds, function (data) {
      localStorage.setItem('id_token', data.id_token);
      localStorage.setItem('access_token', data.access_token);

      _this.user.authenticated = true;

      if (redirect) {
        router.go(redirect);
      }
    }).error(function (err) {
      context.error = err;
    });
  },
  signup: function signup(context, creds, redirect) {
    var _this2 = this;

    context.$http.post(SIGNUP_URL, creds, function (data) {
      localStorage.setItem('id_token', data.id_token);
      localStorage.setItem('access_token', data.access_token);

      _this2.user.authenticated = true;

      if (redirect) {
        router.go(redirect);
      }
    }).error(function (err) {
      context.error = err;
    });
  },
  logout: function logout() {
    localStorage.removeItem('id_token');
    localStorage.removeItem('access_token');
    this.user.authenticated = false;
  },
  checkAuth: function checkAuth() {
    var jwt = localStorage.getItem('id_token');
    if (jwt) {
      this.user.authenticated = true;
    } else {
      this.user.authenticated = false;
    }
  },
  getAuthHeader: function getAuthHeader() {
    return {
      'Authorization': 'Bearer ' + localStorage.getItem('access_token')
    };
  }
});

/***/ }),
/* 663 */,
/* 664 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[308]);


// WEBPACK FOOTER //
// static/js/app.22c808774f829b2d984f.js